// Build450: whole template cards are native buttons; shared editor interaction states.
// Build448: labelled NFC background choice and restrained switch motion.
// Build445: compact two-icon background mirror controls.
// Build444: background translation and rotation.
// Build442: consistent layer selection marks, compact controls and explicit unavailable states.
// Build437: filename modal owns Escape while editor selections remain unchanged.
// Build435: saved groups are atomic layout and selection units.
// Build432: justified paragraphs, shared whitespace advances.
// Build431: persisted paragraph alignment for standard and additional straight text.
// Build430: mobile toolbar with labelled More popover.
// Build429: Cmd/Ctrl+Z uses the toolbar history; native text undo remains available.
// Build427: retain combobox focus on mouse-down so Safari cannot blur-close before click-toggle.
// Build426: shared Google font category dropdown and theme-aware font library.
// Build424: editable attached arrow labels; NFC supplies defaults, not a visibility lock.
// Build420: small scrollable mobile panels without a size toggle.
// Build419: mobile workspace with visible preview and expandable controls.
// Build418: shared percentage fields use the existing percentage-readout alignment.
// Build417: solid multi-selection, dashed saved groups, no inner group member outlines.
// Build416: group bounds anchor and shared spacing/opacity using existing owners.
// Build415: multi-selection uses existing panel rows, colour editor and stepper styling.
// Build414: coordinated multi-selection; historical predecessor retained.
// Build413: clearer scope note for applying a font to all text fields.
// Build412: apply the selected font to all existing text fields on the active surface.
// Build411: shared 360-degree help copy and a visible, variant-aware tour anchor.
// Build409: template navigation shares the layer header back/close layout.
// Build408: template language steps use the shared forward/back panel slide.
// Build407: preserve template language IDs across all UI locales.
// Build405: Italian editor localization; historical predecessor retained.
// Build377: consistent control families and explicit navigation/action/state semantics.
// Build376: font styles use the shared custom dropdown, preserving owner/selection contracts.
// Build375: shared custom category combobox with keyboard and touch support.
// Build374: shared styled category selects for templates and pictograms.
// Build373: fade More out before removing its rendering box.
// Build372: compact horizontal continuation next to its list.
// Build371: shared, list-bound scroll fade and More, without a divider.
// Build369: keep the classic More footer attached to its motif list.
// Build368: align the pictogram More footer with the shared panel edge.
// Build367: use the established More affordance for pictogram results.
// Build365: searchable full-width pictogram subview; deferred add.
// Build363: stable text-shape anchor and property order.
// Build362: customer login for production downloads, including laser SVG.
// Build 20260912-354: finish live percentage drafts before touch stepper actions.
// Build 20260912-353: retain panel selection during legacy control actions.
// Build 348: shared toolbar clearance and available panel height.
// Build 20260911-342: rich text ranges.
// Build 338: shared panel navigation and subtle anchors.
// Build 20260911-337: reversible raster-logo crop.
// Build 20260910-335: unified font library and separate upload action.
// Build 20260910-334: direct custom-font upload entry for every text owner.
// Build 20260910-333: rotate text, pill and persisted output together.
// Build 20260910-327: grouped original-colour brand variants.
(() => {
  const match = location.pathname.match(/\/products\/([^/?#]+)/);
  const handle = match ? match[1] : '';
  const params = new URLSearchParams(location.search);
  if (!window.SmoofProductProfiles?.isTestProfile?.(handle) || params.get('smoof_ui') === 'off') return;
  if (window.__smoofModernUiShellBuild369) return;
  window.__smoofModernUiShellBuild369 = true;
  window.__smoofModernUiShellBuild362 = true;
  window.__smoofModernUiShellBuild360 = true;
  window.__smoofModernUiShellBuild358 = true;
  window.__smoofModernUiShellBuild354 = true;
  window.__smoofModernUiShellBuild353 = true;
  window.__smoofModernUiShellBuild350 = true;
  window.__smoofModernUiShellBuild349 = true;
  window.__smoofModernUiShellBuild348 = true;
  window.__smoofModernUiShellBuild347 = true;
  window.__smoofModernUiShellBuild346 = true;
  window.__smoofModernUiShellV45Build342 = true;
  window.__smoofModernUiShellV45 = true;
  window.__smoofModernUiShellV44 = true;
  window.__smoofModernUiShellV41 = true;
  window.__smoofModernUiShellV40 = true;
  window.__smoofModernUiShellV39 = true;
  window.__smoofModernUiShellV38 = true;
  window.__smoofModernUiShellV37 = true;
  window.__smoofModernUiShellV36 = true;
  window.__smoofModernUiShellV35 = true;
  window.__smoofModernUiShellV34 = true;
  window.__smoofModernUiShellV33 = true;
  window.__smoofModernUiShellV32 = true;
  window.__smoofModernUiShellV31 = true;
  window.__smoofModernUiShellV30 = true;
  window.__smoofModernUiShellV29 = true;
  window.__smoofModernUiShellV28 = true;
  window.__smoofModernUiShellV27 = true;
  window.__smoofModernUiShellV26 = true;
  window.__smoofModernUiShellV25 = true;
  window.__smoofModernUiShellV24 = true;
  window.__smoofModernUiShellV23 = true;
  window.__smoofModernUiShellV22 = true;
  window.__smoofModernUiShellV21 = true;
  window.__smoofModernUiShellV20 = true;
  window.__smoofModernUiShellV19 = true;

  const root = document.documentElement;
  root.dataset.smoofThemeUiRuntime = 'v2-114-editor-hover-20261009-450';
  const profile = window.SmoofProductProfiles?.current || null;
  const backgroundLocked = profile?.editorPolicy?.backgroundLocked === true;
  const laserMonochromeActive = () => {
    const policyState = window.SmoofDotMePolicy?.isMonochromeActive?.();
    if (typeof policyState === 'boolean') return policyState;
    return profile?.editorPolicy?.forceMonochromeLaser === true &&
      window.SmoofProductVariant?.get?.()?.printProcess === 'laser';
  };
  const laserVectorLogoRequired = laserMonochromeActive;
  const mobile = window.matchMedia('(max-width: 749px)');
  const SELECT_EVENT = 'smoof:editor-select';
  let panelActionDepth = 0;
  let selectedId = '';
  let keyboardMove = false;
  let keyboardPanelReturnTimer = 0;
  const heldArrows = new Set();
  const heldPointers = new Set();
  let source = null;
  let commandbar = null;
  let commandbarHost = null;
  let commandbarFlowParent = null;
  let helpWasOpenOnPointerDown = false;
  let resetWasOpenOnPointerDown = false;
  let context = null;
  let layers = null;
  let layersOpen = false;
  let layersPage = 'list';
  let layersTransitionTimer = 0;
  let suppressSelectionRenderId = '';
  let suppressSelectionRenderUntil = 0;
  let addShortcutPointerHandledUntil = 0;
  let mobileCanvasPointer = null;
  let historyCurrent = null;
  let historyCurrentKey = '';
  let historyPast = [];
  let historyFuture = [];
  let historyTimer = 0;
  let historyBaselineTimer = 0;
  let historyRestoring = false;
  let fontPickerTarget = '';
  let fontPickerInitialFamily = '';
  let templateCategory = '';
  let pictogramPickerOpenFor = '';
  const pictogramPickerCategory = { left: 'arrows', right: 'arrows' };
  const pictogramCategoryScroll = Object.create(null);
  let templateCoachmark = null;
  let templateCoachmarkTimer = 0;
  let templateCoachmarkAcknowledged = false;
  const panelScrollCleanups = new WeakMap();
  const categoryDropdowns = new Map();
  let activeCategoryDropdown = null;
  let categoryDropdownSequence = 0;
  const TEMPLATE_COACHMARK_KEY = 'smoof-template-coachmark-v1';
  const DESIGN_OPTION_ID = '3474d16c-f4b6-4517-8f74-f88c27e5c914';
  const PERSONALIZED_VALUE_ID = '29cd05e6-2ef9-4956-89ef-35326fccfd1c';
  const FONT_OPTION_ID = '052c068b-772b-4d04-af0d-56214e55cce3';
  const HISTORY_LIMIT = 40;
  const HISTORY_OPTION_IDS = [
    '052c068b-772b-4d04-af0d-56214e55cce3',
    '2375ec9f-695e-489a-ae63-4dc66fbcbb3f',
    '8cbb313f-ef10-40a4-a711-b894c8c15c2f',
    '1b10591e-29cb-455c-a22f-5d534a275702',
    '5f47cc89-1d8f-4089-9919-514d4d1d3640',
    '999ff02f-9bc5-4ddf-996d-98459628780d',
    'f9b38c60-cd0d-4740-94a4-5b235d7ab60c',
    'aa1edcda-2cc3-4d6f-affd-d2db797ab684',
    'c3b03f1a-c9a4-495e-b138-51bde4cfcbe8',
    'dace7c47-c686-47bc-8580-4444848e6190',
    'dcde59d1-5fef-4e99-8d22-30e2ec19197e',
    '331a45ae-bd3d-4b85-8c7f-a8cbf014b032',
    '1f69ffa6-f179-46de-8ee6-5a90ac70558f',
    '3d6f15f5-b6a7-44d8-8e66-d80fe15b7603',
    '45b6444d-2b8c-431d-9594-91a6ab688d18',
    'f0b04c23-daf0-420c-9572-6d05e339241e',
    '5e5d6fe5-7f13-4891-9903-9ad8949dbb95',
    '3f615f11-8440-41a9-af77-fe79452d77f1'
  ];

  function richSelectionRow(id) {
    const selection=window.SmoofRichText?.selectedStyle?.(id);
    if(!selection)return `<div data-smoof-ui-text-scope data-active="false"><div data-smoof-ui-scope-copy><span data-smoof-ui-scope-label>${t('Gesamter Text','Whole text')}</span><span data-smoof-ui-scope-hint>${t('Für einzelne Zeichen direkt im Text markieren.','Select characters in the text to format them.')}</span></div></div>`;
    return `<div data-smoof-ui-text-scope data-smoof-ui-rich-selection data-active="true"><div data-smoof-ui-scope-copy><span data-smoof-ui-scope-label>${t('Textauswahl','Text selection')}${selection.mixed?` · ${t('Gemischt','Mixed')}`:''}</span><strong data-smoof-ui-rich-preview title="${escapeHtml(selection.text)}">${escapeHtml(selection.text)}</strong></div><button type="button" data-smoof-ui-action="rich-clear" data-smoof-ui-scope-clear aria-label="${t('Auswahl aufheben und gesamten Text formatieren','Clear selection and format whole text')}">${t('Gesamter Text','Whole text')}<span aria-hidden="true">↗</span></button></div>`;
  }
  function textRotationRow(value) {
    return row(t('Drehung', 'Rotation'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="text-rotation-minus" aria-label="${t('Nach links drehen', 'Rotate left')}">−</button><span data-smoof-ui-text-rotation>${Math.round(Number(value) || 0)}°</span><button type="button" data-smoof-ui-action="text-rotation-plus" aria-label="${t('Nach rechts drehen', 'Rotate right')}">+</button></div>`);
  }

  function optionRoot(id) {
    const roots = Array.from(document.querySelectorAll(`[data-option-id="${id}"]`));
    return roots.find(candidate => candidate.offsetParent !== null) || roots[0] || null;
  }

  function cleanFontFamily(value) {
    return String(value || '')
      .replace(/["']/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 100);
  }

  function selectedGoogleFont() {
    const option = optionRoot(FONT_OPTION_ID);
    return cleanFontFamily(
      option?.querySelector('select')?.value ||
      option?.querySelector('input[type="hidden"]')?.value ||
      option?.querySelector('button[aria-haspopup="listbox"]')?.innerText ||
      ''
    );
  }

  function rawFontForItem(itemId) {
    if(/^arrow-(left|right)$/.test(itemId)) return window.SmoofArrowLabels.resolve(window.SmoofArrowTools.getState(itemId.split('-')[1]),itemId.split('-')[1]).fontFamily;
    const selectedFont=window.SmoofRichText?.selectedStyle?.(itemId)?.fontFamily;
    if(selectedFont)return selectedFont;
    if (/^custom-text-[1-3]$/.test(itemId)) {
      return window.SmoofCustomTextTools?.getState?.(itemId)?.fontFamily || selectedGoogleFont() || 'Roboto';
    }
    if (/^text-[0-2]$/.test(itemId)) {
      return window.SmoofTextTools?.getFont?.(Number(itemId.split('-')[1])) || selectedGoogleFont() || 'Roboto';
    }
    if (itemId === 'table-number') {
      return window.SmoofNumberHistory?.getFont?.() || selectedGoogleFont() || 'Roboto';
    }
    return selectedGoogleFont() || 'Roboto';
  }

  function fontForItem(itemId) {
    if(window.SmoofRichText?.selectedStyle?.(itemId)?.mixedFont)return t('Gemischt','Mixed');
    const family = rawFontForItem(itemId);
    return window.SmoofCustomFontRegistry?.labelFor?.(family) || family;
  }

  function customFontSelected(itemId) {
    return Boolean(
      window.SmoofCustomFontRegistry?.isCustomFamily?.(
        rawFontForItem(itemId)
      )
    );
  }

  function setNativeValue(input, value, commit = false) {
    if (!input) return false;
    const prototype = input instanceof HTMLSelectElement
      ? HTMLSelectElement.prototype
      : input instanceof HTMLTextAreaElement
      ? HTMLTextAreaElement.prototype
      : HTMLInputElement.prototype;
    const descriptor = Object.getOwnPropertyDescriptor(prototype, 'value');
    if (descriptor && descriptor.set) descriptor.set.call(input, value);
    else input.value = value;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    if (commit) input.dispatchEvent(new Event('change', { bubbles: true }));
    return true;
  }

  function personalizedDesignSelected() {
    const roots = Array.from(document.querySelectorAll(`[data-option-id="${DESIGN_OPTION_ID}"]`));
    const checked = roots
      .flatMap(option => Array.from(option.querySelectorAll('input[type="checkbox"], input[type="radio"]')))
      .find(input => input.checked);
    if (!checked) return false;
    if (checked.value === PERSONALIZED_VALUE_ID) return true;
    const label = checked.closest('label')?.textContent || checked.parentElement?.textContent || '';
    return /Personalisiertes Design|Personalized Design/i.test(label);
  }

  function captureOptionState(id) {
    const rootNode = optionRoot(id);
    if (!rootNode) return null;

    const choices = Array.from(rootNode.querySelectorAll('input[type="radio"], input[type="checkbox"]'));
    if (choices.length) {
      return {
        kind: 'choice',
        values: choices.filter(input => input.checked).map(input => input.value)
      };
    }

    const control = rootNode.querySelector('input[type="color"]') || rootNode.querySelector([
      'select',
      'textarea',
      'input[type="color"]',
      'input[type="text"]',
      'input[type="search"]'
    ].join(',')) || rootNode.querySelector('input[type="hidden"]');

    return control
      ? { kind: control.tagName.toLowerCase(), type: control.type || '', value: control.value }
      : null;
  }

  function captureHistorySnapshot() {
    const options = {};
    HISTORY_OPTION_IDS.forEach(id => {
      const value = captureOptionState(id);
      if (value) options[id] = value;
    });

    return {
      options,
      groups: multiGroupSnapshot(),
      textLayout: window.SmoofTextTools?.getHistoryState?.() || null,
      textVisibility: window.SmoofTextVisibility
        ? [0, 1, 2].map(index => window.SmoofTextVisibility.isVisible(index) !== false)
        : null,
      logo: window.SmoofLogoHistory?.getState?.() || null,
      logoCopy: window.SmoofLogoCopyTools?.getHistoryState?.() || null,
      logoDuplicate: window.SmoofLogoDuplicateTools?.getHistoryState?.() || null,
      logoInversion: window.SmoofLogoInvertTools?.getHistoryState?.() || null,
      logoColours: window.SmoofLogoColourTools?.getHistoryState?.() || null,
      logoBackgrounds: window.SmoofLogoBackgroundTools?.getHistoryState?.() || null,
      number: window.SmoofNumberHistory?.getState?.() || null,
      branding: window.SmoofBrandTools?.getHistoryState?.() || null,
      arrows: window.SmoofArrowTools?.getHistoryState?.() || null,
      payments: window.SmoofPaymentTools?.getHistoryState?.() || null,
      socialPlatforms: window.SmoofSocialPlatformTools?.getHistoryState?.() || null,
      customTexts: window.SmoofCustomTextTools?.getHistoryState?.() || null,
      customPictograms: window.SmoofCustomPictogramTools?.getHistoryState?.() || null,
      qrGeometry: window.SmoofQrGeometryTools?.getHistoryState?.() || null,
      nfc: window.SmoofNfcTools?.getHistoryState?.() || null,
      backgroundImage: window.SmoofBackgroundImageBridge?.getHistoryState?.() ||
        window.SmoofBackgroundImageBridge?.getState?.() || null,
      layerOpacity: window.SmoofLayerOpacityTools?.getHistoryState?.() || null,
      backgroundGradient: window.SmoofBackgroundGradientTools?.getHistoryState?.() || null
    };
  }

  function historySignature(snapshot) {
    if (!snapshot) return '';
    const logo = snapshot.logo || {};
    const dataUrl = String(logo.dataUrl || '');
    return JSON.stringify({
      ...snapshot,
      logo: {
        ...logo,
        dataUrl: dataUrl
          ? `${dataUrl.length}:${dataUrl.slice(0, 36)}:${dataUrl.slice(-36)}`
          : ''
      }
    });
  }

  function syncHistoryButtons() {
    if (!commandbar) return;
    const undo = commandbar.querySelector('[data-smoof-ui-command-action="undo"]');
    const redo = commandbar.querySelector('[data-smoof-ui-command-action="redo"]');
    if (undo) undo.disabled = historyPast.length === 0 || historyRestoring;
    if (redo) redo.disabled = historyFuture.length === 0 || historyRestoring;
  }

  function clearHistory() {
    fontBatchHistory = null;
    clearTimeout(historyTimer);
    clearTimeout(historyBaselineTimer);
    historyBaselineTimer = 0;
    historyCurrent = null;
    historyCurrentKey = '';
    historyPast = [];
    historyFuture = [];
    syncHistoryButtons();
  }

  // Font metrics may settle after the first render and constrain text positions again.
  // Merge only those derived geometry updates until the next user gesture.
  let fontBatchHistory = null;
  function fontBatchSignature(snapshot) {
    const geometryFree = value => {
      if (!value) return value;
      const {x, y, fitScale, ...rest} = value;
      return rest;
    };
    return historySignature({
      ...snapshot,
      textLayout: snapshot.textLayout?.map(geometryFree),
      customTexts: snapshot.customTexts ? {...snapshot.customTexts, states: snapshot.customTexts.states?.map(geometryFree)} : null,
      number: geometryFree(snapshot.number)
    });
  }
  function finishFontBatchHistory() {
    if (!fontBatchHistory) return;
    commitHistorySnapshot();
    fontBatchHistory = null;
  }
  document.addEventListener('pointerdown', finishFontBatchHistory, true);
  document.addEventListener('keydown', finishFontBatchHistory, true);

  function commitHistorySnapshot() {
    if (multiBusy || keyboardMove || historyRestoring || !personalizedDesignSelected()) return;
    const next = captureHistorySnapshot();
    if (!next) return;
    const nextKey = historySignature(next);

    if (!historyCurrent) {
      historyCurrent = next;
      historyCurrentKey = nextKey;
      syncHistoryButtons();
      return;
    }

    if (nextKey === historyCurrentKey) return;
    if (fontBatchHistory) {
      if (fontBatchSignature(next) !== fontBatchHistory.key) fontBatchHistory = null;
      else if (fontBatchHistory.committed) {
        historyCurrent = next;
        historyCurrentKey = nextKey;
        syncHistoryButtons();
        return;
      } else fontBatchHistory.committed = true;
    }
    historyPast.push(historyCurrent);
    if (historyPast.length > HISTORY_LIMIT) historyPast.shift();
    historyCurrent = next;
    historyCurrentKey = nextKey;
    historyFuture = [];
    syncHistoryButtons();
  }

  function scheduleHistoryCapture(delay = 320) {
    if (multiBusy || keyboardMove || historyRestoring) return;
    clearTimeout(historyTimer);
    historyTimer = setTimeout(commitHistorySnapshot, delay);
  }

  function setNativeChecked(input, checked) {
    const descriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'checked');
    if (descriptor?.set) descriptor.set.call(input, checked);
    else input.checked = checked;
  }

  function applyOptionState(id, saved) {
    const rootNode = optionRoot(id);
    if (!rootNode || !saved) return;

    if (saved.kind === 'choice') {
      const wanted = new Set(saved.values || []);
      rootNode.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(input => {
        const checked = wanted.has(input.value);
        if (input.checked === checked) return;
        setNativeChecked(input, checked);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      return;
    }

    const control = rootNode.querySelector('input[type="color"]') || rootNode.querySelector([
      'select',
      'textarea',
      'input[type="color"]',
      'input[type="text"]',
      'input[type="search"]'
    ].join(',')) || rootNode.querySelector('input[type="hidden"]');
    if (control && control.value !== saved.value) setNativeValue(control, saved.value, true);
  }

  function applyHistorySnapshot(snapshot) {
    if (!snapshot) return;
    window.SmoofRichText?.clear?.();
    historyRestoring = true;
    clearTimeout(historyTimer);
    syncHistoryButtons();

    Object.entries(snapshot.options || {}).forEach(([id, value]) => applyOptionState(id, value));

    const applyLayouts = () => {
      if (snapshot.textLayout) window.SmoofTextTools?.applyHistoryState?.(snapshot.textLayout);
      if (snapshot.logo) window.SmoofLogoHistory?.applyState?.(snapshot.logo);
      if (snapshot.logoCopy) window.SmoofLogoCopyTools?.applyHistoryState?.(snapshot.logoCopy);
      if (snapshot.logoDuplicate) window.SmoofLogoDuplicateTools?.applyHistoryState?.(snapshot.logoDuplicate);
      if (snapshot.logoInversion) window.SmoofLogoInvertTools?.applyHistoryState?.(snapshot.logoInversion);
      window.SmoofLogoColourTools?.applyHistoryState?.(snapshot.logoColours || {});
      if (snapshot.logoBackgrounds) window.SmoofLogoBackgroundTools?.applyHistoryState?.(snapshot.logoBackgrounds);
      if (snapshot.number) window.SmoofNumberHistory?.applyState?.(snapshot.number);
      if (snapshot.arrows) window.SmoofArrowTools?.applyHistoryState?.(snapshot.arrows);
      if (snapshot.payments) window.SmoofPaymentTools?.applyHistoryState?.(snapshot.payments);
      if (snapshot.socialPlatforms) window.SmoofSocialPlatformTools?.applyHistoryState?.(snapshot.socialPlatforms);
      if (snapshot.branding) window.SmoofBrandTools?.applyHistoryState?.(snapshot.branding);
      if (snapshot.customTexts) window.SmoofCustomTextTools?.applyHistoryState?.(snapshot.customTexts);
      if (snapshot.customPictograms) window.SmoofCustomPictogramTools?.applyHistoryState?.(snapshot.customPictograms);
      if (snapshot.qrGeometry) window.SmoofQrGeometryTools?.applyHistoryState?.(snapshot.qrGeometry);
      if (snapshot.nfc) window.SmoofNfcTools?.applyHistoryState?.(snapshot.nfc);
      if (snapshot.backgroundImage) window.SmoofBackgroundImageBridge?.applyHistoryState?.(snapshot.backgroundImage);
      if (snapshot.layerOpacity) window.SmoofLayerOpacityTools?.applyHistoryState?.(snapshot.layerOpacity);
      if (snapshot.backgroundGradient) window.SmoofBackgroundGradientTools?.applyHistoryState?.(snapshot.backgroundGradient);
      multiRestoreGroups(snapshot.groups || []);
      (Array.isArray(snapshot.textVisibility) ? snapshot.textVisibility : []).forEach((visible, index) => {
        if (!window.SmoofTextVisibility) return;
        if (window.SmoofTextVisibility.isVisible(index) !== visible) {
          window.SmoofTextVisibility.toggle(index);
        }
      });
    };

    applyLayouts();
    requestAnimationFrame(() => requestAnimationFrame(applyLayouts));
    setTimeout(() => {
      applyLayouts();
      historyRestoring = false;
      historyCurrent=captureHistorySnapshot();historyCurrentKey=historySignature(historyCurrent);
      syncHistoryButtons();
      multiSchedulePaint();
      if (layersOpen && layersPage === 'detail') renderLayers();
      else if (selectedId) renderContext();
    }, 220);
  }

  function undoHistory() {
    if (historyRestoring) return;
    clearTimeout(historyTimer);
    commitHistorySnapshot();
    if (!historyPast.length || !historyCurrent) return;
    historyFuture.push(historyCurrent);
    const target = historyPast.pop();
    historyCurrent = target;
    historyCurrentKey = historySignature(target);
    applyHistorySnapshot(target);
  }

  function redoHistory() {
    if (historyRestoring || !historyFuture.length || !historyCurrent) return;
    historyPast.push(historyCurrent);
    const target = historyFuture.pop();
    historyCurrent = target;
    historyCurrentKey = historySignature(target);
    applyHistorySnapshot(target);
  }

  function syncPersonalizationGate() {
    const enabled = personalizedDesignSelected();
    root.dataset.smoofUiEnabled = String(enabled);
    if(!enabled&&(multiMode||multiIds.size))multiClear(false);
    if (!enabled) {
      closeMoreTools(false);
      keyboardMove = false; heldArrows.clear(); setKeyboardPanelMoving(false, true);
      dismissTemplateCoachmark(false);
      if (historyCurrent) clearHistory();
      layersOpen = false;
      layersPage = 'list';
      selectedId = '';
      if (context) context.dataset.open = 'false';
      if (layers) layers.dataset.open = 'false';
    } else if (!historyCurrent && !historyBaselineTimer) {
      historyBaselineTimer = setTimeout(() => {
        historyBaselineTimer = 0;
        commitHistorySnapshot();
      }, 420);
    }
    return enabled;
  }

  const t = (de, en) => window.SmoofI18n.copy(de, en);
  const escapeHtml = value => String(value ?? '').replace(/[&<>"']/g, character => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  })[character]);
  const icon = name => {
    const common = 'viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';
    const paths = {
      editor: '<path d="m4 16-1 5 5-1L19 9l-4-4L4 16Z"></path><path d="m13.5 6.5 4 4"></path>',
      templates: '<rect x="4" y="3.5" width="16" height="17" rx="3"></rect><path d="M4 9.5h16M10.5 9.5v11"></path>',
      layers: '<path d="m12 3 9 5-9 5-9-5 9-5Z"></path><path d="m3 12 9 5 9-5"></path><path d="m3 16 9 5 9-5"></path>',
      ruler: '<path d="M3 7h18v10H3z"></path><path d="M7 7v4M11 7v2M15 7v4M19 7v2"></path>',
      reset: '<path d="M4 4v6h6"></path><path d="M5.5 16a8 8 0 1 0 .5-9l-2 3"></path>',
      undo: '<path d="M9 7 4 12l5 5"></path><path d="M5 12h8a6 6 0 0 1 6 6"></path>',
      redo: '<path d="m15 7 5 5-5 5"></path><path d="M19 12h-8a6 6 0 0 0-6 6"></path>',
      save: '<path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2Z"></path><path d="M17 21v-8H7v8M7 3v5h8"></path>',
      open: '<path d="M3 6h6l2 3h7a2 2 0 0 1 2 2v1"></path><path d="M3 6v13h16l2-7H6l-3 7Z"></path>',
      help: '<circle cx="12" cy="12" r="9"></circle><path d="M9.7 9a2.5 2.5 0 1 1 4 2c-1 .7-1.7 1.2-1.7 2.5"></path><path d="M12 17h.01"></path>',
      close: '<path d="m6 6 12 12M18 6 6 18"></path>',
      forward: '<path d="m9 6 6 6-6 6"></path>',
      download: '<path d="M12 3v12m-5-5 5 5 5-5M4 16v5h16v-5"></path>',
      upload: '<path d="M12 16V4m-5 5 5-5 5 5M4 16v5h16v-5"></path>',
      back: '<path d="m15 18-6-6 6-6"></path>',
      eye: '<path d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z"></path><circle cx="12" cy="12" r="2.7"></circle>',
      eyeOff: '<path d="M3 3l18 18"></path><path d="M10.6 6.1A9 9 0 0 1 12 6c6 0 9.5 6 9.5 6a15 15 0 0 1-2.1 2.8M6.2 6.2C3.8 8 2.5 12 2.5 12s3.5 6 9.5 6a9 9 0 0 0 3.2-.6"></path>',
      lock: '<rect x="5" y="10" width="14" height="10" rx="2"></rect><path d="M8 10V7a4 4 0 0 1 8 0v3"></path>',
      text: '<path d="M5 5h14M12 5v14M8 19h8"></path>',
      arrows: '<path d="m3 8 4 4-4 4M9 8l4 4-4 4M15 8l4 4-4 4"></path>',
      nfc: '<path d="M5.2 8.1a9.7 9.7 0 0 1 13.6 0"></path><path d="M7.9 10.9a5.8 5.8 0 0 1 8.2 0"></path><path d="M10.6 13.6a2 2 0 0 1 2.8 0"></path><circle cx="12" cy="17" r=".8" fill="currentColor" stroke="none"></circle>',
      image: '<rect x="3" y="4" width="18" height="16" rx="2"></rect><circle cx="9" cy="10" r="2"></circle><path d="m21 16-5-5L5 20"></path>',
      number: '<path d="M9 3 7 21M17 3l-2 18M4 9h16M3 15h16"></path>',
      dot: '<circle cx="12" cy="12" r="7"></circle>',
      background: '<path d="M12 3a9 9 0 1 0 0 18c1.3 0 2-1.4 1.2-2.4-.7-.9-.1-2.2 1.1-2.2H17a4 4 0 0 0 4-4C21 7.2 17 3 12 3Z"></path><circle cx="7.5" cy="10" r=".8" fill="currentColor"></circle><circle cx="11" cy="7" r=".8" fill="currentColor"></circle><circle cx="15" cy="8" r=".8" fill="currentColor"></circle>',
      qr: '<path d="M4 4h6v6H4zM14 4h6v6h-6zM4 14h6v6H4zM14 14h2v2h-2zM18 14h2v6h-4v-2M14 20v-2"></path>',
      payment: '<rect x="3" y="6" width="18" height="13" rx="2"></rect><path d="M3 10h18M7 15h3"></path>',
      social: '<circle cx="7" cy="7" r="3"></circle><circle cx="17" cy="7" r="3"></circle><circle cx="12" cy="17" r="3"></circle><path d="m9.5 8.5 2 5M14.5 8.5l-2 5M10 7h4"></path>',
      add: '<path d="M12 5v14M5 12h14"></path>',
      trash: '<path d="M4 7h16M9 7V4h6v3M7 7l1 13h8l1-13M10 11v5M14 11v5"></path>'
    };
    return `<svg ${common}>${paths[name] || paths.text}</svg>`;
  };

  const descriptors = () => {
    const map = {
    'text-0': { symbol: 'text', title: t('Textzeile 1', 'Text line 1'), copy: t('Schrift, Schnitt, Farbe und Größe', 'Font, style, colour and size'), kind: 'text', hideable: true },
    'text-1': { symbol: 'text', title: t('Textzeile 2', 'Text line 2'), copy: t('Schrift, Schnitt, Farbe und Größe', 'Font, style, colour and size'), kind: 'text', hideable: true },
    'text-2': { symbol: 'text', title: t('Textzeile 3', 'Text line 3'), copy: t('Schrift, Schnitt, Farbe und Größe', 'Font, style, colour and size'), kind: 'text', hideable: true },
    'arrow-left': { symbol: 'arrows', title: t('Piktogramm links', 'Left pictogram'), copy: t('Motiv, Drehung, Farben und Text', 'Symbol, rotation, colours and label'), kind: 'arrow', hideable: true },
    'arrow-right': { symbol: 'arrows', title: t('Piktogramm rechts', 'Right pictogram'), copy: t('Motiv, Drehung, Farben und Text', 'Symbol, rotation, colours and label'), kind: 'arrow', hideable: true },
    logo: { symbol: 'image', title: 'Logo', copy: t('Position, Größe, Datei und Sichtbarkeit', 'Position, size, file and visibility'), kind: 'logo', hideable: true },
    'logo-copy': { symbol: 'image', title: t('Logo-1-Duplikat', 'Logo 1 duplicate'), copy: t('Verknüpftes Duplikat von Logo 1', 'Linked duplicate of logo 1'), kind: 'logo-copy', hideable: true },
    'logo-2': { symbol: 'image', title: t('Logo 2', 'Logo 2'), copy: t('Eigenständige Logodatei, Position und Größe', 'Independent logo file, position and size'), kind: 'logo-duplicate', hideable: true },
    'table-number': { symbol: 'number', title: t('Tisch-/Zimmernummer', 'Table/room number'), copy: t('Optionales Textelement', 'Optional text element'), kind: 'number', hideable: true },
    'branding-dot': { symbol: 'dot', title: t('Branding-Kreis', 'Branding circle'), copy: t('Farbe und Sichtbarkeit', 'Colour and visibility'), kind: 'brand', hideable: true },
    nfc: { symbol: 'nfc', title: 'NFC', copy: t('Symbol, Kreisfarbe und Position', 'Icon, circle colour and position'), kind: 'nfc', hideable: true },
    payments: { symbol: 'payment', title: t('Zahlungsanbieter', 'Payment providers'), copy: t('Mehrfachauswahl, Farbe und Größe', 'Multiple selection, colour and size'), kind: 'payments', hideable: true },
    'social-library': { symbol: 'social', title: t('Social Media & Plattformen', 'Social media & platforms'), copy: t('Bewertungen, Social Media und Plattformen', 'Reviews, social media and platforms'), kind: 'social-library' },
    add: { symbol: 'add', title: t('Hinzufügen', 'Add'), copy: t('Weitere Elemente ergänzen', 'Add more elements'), kind: 'add' },
    guides: { symbol: 'ruler', title: t('Bemaßung & Ausrichtung', 'Measurements & alignment'), copy: t('Maße anzeigen und Fanglinien einstellen', 'Show measurements and set snapping guides'), kind: 'guides' },
    downloads: { symbol: 'save', title: t('Uploads & Downloads', 'Uploads & Downloads'), copy: t('Design- und Druckdateien', 'Design and print files'), kind: 'downloads' },
    templates: { symbol: 'templates', title: t('Vorlagen', 'Templates'), copy: window.SmoofTemplateLibrary?.languageSelectionEnabled ? t('Sprache wählen, dann Vorlage entdecken', 'Choose a language, then explore templates') : t('Nach Anwendungsfall auswählen', 'Choose by use case'), kind: 'templates' },
    qr: { symbol: 'qr', title: t('QR-Code', 'QR code'), copy: t('Sichtbarkeit, Position, Größe und Hintergrundfläche', 'Visibility, position, size and backing panel'), kind: 'qr', locked: false, hideable: true },
      background: {
        symbol: 'background',
        title: t('Hintergrund', 'Background'),
        copy: backgroundLocked
          ? t('Edelstahloberfläche ist fest vorgegeben', 'Stainless-steel surface is fixed')
          : t('Farbe, Verlauf und optionales Bild', 'Colour, gradient and optional image'),
        kind: 'background',
        locked: true
      }
    };
    (window.SmoofCustomTextTools?.getStates?.() || []).filter(state => state.enabled).forEach(state => {
      const number = Number(String(state.id || '').split('-').pop()) || 1;
      map[state.id] = {
        symbol: 'text',
        title: t(`Zusatztext ${number}`, `Additional text ${number}`),
        copy: t('Schrift, Schnitt, Farbe und Größe', 'Font, style, colour and size'),
        kind: 'custom-text',
        hideable: true
      };
    });
    (window.SmoofCustomPictogramTools?.getStates?.() || []).filter(state => state.enabled).forEach(state => {
      const number = Number(String(state.id || '').split('-').pop()) || 1;
      map[state.id] = {
        symbol: 'arrows',
        title: t(`Zusatzpiktogramm ${number}`, `Additional pictogram ${number}`),
        copy: t('Motiv, Drehung, Farbe und Größe', 'Symbol, rotation, colour and size'),
        kind: 'custom-pictogram',
        hideable: true
      };
    });
    Object.keys(window.SmoofSocialPlatformTools?.getState?.().objects || {}).forEach(id => {
      const definition = window.SmoofSocialPlatformLibrary?.get?.(id);
      if (!definition) return;
      map[`social-platform-${id}`] = {
        symbol: 'social', title: window.SmoofI18n.legacy(definition.label),
        copy: t('Position, Farbe und Größe', 'Position, colour and size'),
        kind: 'social-platform', hideable: true
      };
    });
    return map;
  };

  function sourceFor(id) {
    if (id === 'downloads' || id === 'templates' || id === 'add') return commandbar;
    if (id === 'social-library') return commandbar;
    if (/^social-platform-/.test(id)) {
      return document.querySelector(`[data-smoof-social-platform-frame="${id.replace(/^social-platform-/, '')}"]`);
    }
    if (/^custom-text-[1-3]$/.test(id)) {
      return document.querySelector(`[data-smoof-editor-item="${id}"]`);
    }
    if (/^custom-pictogram-[1-3]$/.test(id)) {
      return document.querySelector(`[data-smoof-custom-pictogram-frame="${id}"]`);
    }
    if (/^text-[0-2]$/.test(id)) {
      const frames = Array.from(document.querySelectorAll(`[data-smoof-text-frame="${id.split('-')[1]}"]`));
      const frame = frames.find(candidate => candidate.dataset.active === 'true') || frames.find(candidate => {
        const rect = candidate.getBoundingClientRect();
        const style = getComputedStyle(candidate);
        return style.display !== 'none' && rect.width > 2 && rect.height > 2;
      }) || frames[0];
      return frame ? frame.querySelector('[data-smoof-text-controls]') : null;
    }
    const selectors = {
      logo: '[data-smoof-logo-editor-frame]:not([data-smoof-logo-instance]) [data-smoof-logo-controls]',
      'logo-copy': '[data-smoof-logo-copy-controls]',
      'logo-2': '[data-smoof-logo-duplicate-controls]',
      'arrow-left': '[data-smoof-arrow-controls]',
      'arrow-right': '[data-smoof-arrow-controls]',
      'table-number': '[data-smoof-number-controls]',
      'branding-dot': '[data-smoof-brand-controls]',
      nfc: '[data-smoof-nfc-frame]',
      payments: '[data-smoof-payment-frame]',
      background: '[data-smoof-background-controls]',
      qr: '[data-smoof-qr-frame]'
    };
    return selectors[id] ? document.querySelector(selectors[id]) : null;
  }

  function visibleItemFor(id) {
    return Array.from(document.querySelectorAll(`[data-smoof-editor-item="${id}"]`)).find(el => {
      if (el.closest('[data-smoof-ui-context], [data-smoof-ui-layers], [data-smoof-ui-commandbar]')) return false;
      if (el.matches('[data-smoof-text-controls], [data-smoof-logo-controls], [data-smoof-arrow-controls], [data-smoof-number-controls], [data-smoof-brand-controls]')) return false;
      const rect = el.getBoundingClientRect();
      const style = getComputedStyle(el);
      return !el.hidden && style.display !== 'none' && rect.width > 2 && rect.height > 2;
    }) || null;
  }

  function visibilitySource(id) {
    const controls = sourceFor(id);
    if (!controls) return null;
    if (/^text-/.test(id)) return controls.querySelector('[data-smoof-text-control-button="visibility"]');
    if (id === 'table-number') return controls.querySelector('[data-smoof-number-control-button="visibility"]');
    return null;
  }

  function isVisible(id) {
    if (/^custom-pictogram-[1-3]$/.test(id)) {
      return window.SmoofCustomPictogramTools?.isVisible?.(id) !== false;
    }
    if (/^custom-text-[1-3]$/.test(id)) {
      return window.SmoofCustomTextTools?.isVisible?.(id) !== false;
    }
    if (id === 'logo' && window.SmoofLogoTools?.isVisible) {
      return window.SmoofLogoTools.isVisible();
    }
    if (id === 'logo-2' && window.SmoofLogoDuplicateTools?.isVisible) {
      return window.SmoofLogoDuplicateTools.isVisible();
    }
    if (id === 'logo-copy' && window.SmoofLogoCopyTools?.isVisible) {
      return window.SmoofLogoCopyTools.isVisible();
    }
    if (id === 'nfc' && window.SmoofNfcTools?.isVisible) {
      return window.SmoofNfcTools.isVisible();
    }
    if (id === 'payments' && window.SmoofPaymentTools?.isVisible) {
      return window.SmoofPaymentTools.isVisible();
    }
    if (/^social-platform-/.test(id) && window.SmoofSocialPlatformTools?.isVisible) {
      return window.SmoofSocialPlatformTools.isVisible(id);
    }
    if (/^arrow-(left|right)$/.test(id) && window.SmoofArrowTools?.isVisible) {
      return window.SmoofArrowTools.isVisible(id.split('-')[1]);
    }
    if (id === 'branding-dot') {
      if (window.SmoofBrandTools?.isVisible) {
        return window.SmoofBrandTools.isVisible();
      }
      const dot = document.querySelector('[data-smoof-brand-dot]');
      const stored = dot?.dataset.smoofBrandVisible;
      if (stored === 'true' || stored === 'false') return stored === 'true';
      return dot ? !dot.hidden : true;
    }
    if (/^text-[0-2]$/.test(id) && window.SmoofTextVisibility) {
      return window.SmoofTextVisibility.isVisible(Number(id.split('-')[1]));
    }
    if (id === 'table-number' && window.SmoofNumberVisibilityTools?.isVisible) {
      return window.SmoofNumberVisibilityTools.isVisible();
    }
    if (id === 'qr' && window.SmoofQrGeometryTools?.isVisible) {
      return window.SmoofQrGeometryTools.isVisible();
    }
    const control = visibilitySource(id);
    if (control) {
      if (control.dataset.visible) return control.dataset.visible !== 'false';
      const pressed = control.getAttribute('aria-pressed');
      if (pressed !== null) return pressed !== 'true';
    }
    if (/^text-/.test(id)) {
      const index = id.split('-')[1];
      const frame = document.querySelector(`[data-smoof-text-frame="${index}"]`);
      return !frame || frame.dataset.visible !== 'false';
    }
    if (id === 'table-number') return Boolean(visibleItemFor(id));
    return true;
  }

  function toggleVisibility(id) {
    if (/^custom-pictogram-[1-3]$/.test(id)) {
      window.SmoofCustomPictogramTools?.toggleVisibility?.(id);
      return;
    }
    if (/^custom-text-[1-3]$/.test(id)) {
      window.SmoofCustomTextTools?.toggleVisibility?.(id);
      return;
    }
    if (id === 'logo' && window.SmoofLogoTools?.toggleVisibility) {
      window.SmoofLogoTools.toggleVisibility();
      return;
    }
    if (id === 'logo-2' && window.SmoofLogoDuplicateTools?.toggleVisibility) {
      window.SmoofLogoDuplicateTools.toggleVisibility();
      return;
    }
    if (id === 'logo-copy' && window.SmoofLogoCopyTools?.toggleVisibility) {
      window.SmoofLogoCopyTools.toggleVisibility();
      return;
    }
    if (id === 'nfc' && window.SmoofNfcTools?.toggleVisibility) {
      window.SmoofNfcTools.toggleVisibility();
      return;
    }
    if (id === 'payments' && window.SmoofPaymentTools?.toggleVisibility) {
      window.SmoofPaymentTools.toggleVisibility();
      return;
    }
    if (/^social-platform-/.test(id) && window.SmoofSocialPlatformTools?.toggleVisibility) {
      window.SmoofSocialPlatformTools.toggleVisibility(id);
      return;
    }
    if (/^arrow-(left|right)$/.test(id) && window.SmoofArrowTools?.toggleVisibility) {
      window.SmoofArrowTools.toggleVisibility(id.split('-')[1]);
      return;
    }
    if (id === 'branding-dot') {
      if (window.SmoofBrandTools?.toggleVisibility) {
        window.SmoofBrandTools.toggleVisibility();
        return;
      }

      /*
       * Sicherheitsnetz fuer Themes, in denen noch der alte Branding-Block
       * aktiv ist. Der eigentliche Fix wird mit v2.18.4 ebenfalls geliefert,
       * aber das Auge darf bei einem Versions-Mix nicht erneut wirkungslos
       * bleiben.
       */
      const visible = !isVisible(id);
      document.querySelectorAll('[data-smoof-brand-dot]').forEach(dot => {
        dot.hidden = !visible;
        dot.dataset.smoofBrandVisible = String(visible);
        dot.setAttribute('aria-hidden', String(!visible));
      });
      document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
        let input = form.querySelector('input[name="properties[_SMOOF Branding sichtbar]"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'properties[_SMOOF Branding sichtbar]';
          form.appendChild(input);
        }
        input.value = visible ? 'Ja' : 'Nein';
      });
      window.SmoofDesignRenderer?.scheduleRender?.();
      window.dispatchEvent(new CustomEvent('smoof:branding-visibility-changed', {
        detail: { visible }
      }));
      return;
    }
    if (/^text-[0-2]$/.test(id) && window.SmoofTextVisibility) {
      window.SmoofTextVisibility.toggle(Number(id.split('-')[1]));
      return;
    }
    if (id === 'table-number' && window.SmoofNumberVisibilityTools?.toggleVisibility) {
      window.SmoofNumberVisibilityTools.toggleVisibility();
      return;
    }
    if (id === 'qr' && window.SmoofQrGeometryTools?.toggleVisibility) {
      window.SmoofQrGeometryTools.toggleVisibility();
      return;
    }
    const control = visibilitySource(id);
    if (control && !control.disabled) control.click();
  }

  function dispatchSelection(id, options = {}) {
    window.dispatchEvent(new CustomEvent(SELECT_EVENT, {
      detail: {
        id: String(id || ''),
        openContext: options.openContext === true
      }
    }));
  }

  function row(label, body) {
    return `<div data-smoof-ui-row><span data-smoof-ui-row-label>${label}</span><div>${body}</div></div>`;
  }

  const controlIcon = name => `<span data-smoof-ui-control-icon aria-hidden="true">${icon(name)}</span>`;
  function stateButton(action, label, checked, on, off, disabled = false, note = '') {
    const accessibleLabel = note ? `${label}: ${note}` : label;
    return `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="${action}" role="switch" aria-label="${escapeHtml(accessibleLabel)}" aria-checked="${Boolean(checked)}"${disabled ? ' disabled' : ''}><span>${checked ? on : off}</span><span data-smoof-ui-state-switch aria-hidden="true"><span data-smoof-switch-knob></span></span></button>${note ? `<small data-smoof-ui-control-note>${escapeHtml(note)}</small>` : ''}`;
  }

  function nfcBackgroundChoice(coloured) {
    const labels = window.SmoofI18n.label;
    const transparent = labels({de:'Transparent',en:'Transparent',it:'Trasparente'});
    const colour = labels({de:'Farbig',en:'Coloured',it:'Colorato'});
    return `<button type="button" data-smoof-ui-action="nfc-transparency" data-smoof-nfc-choice role="switch" aria-label="${escapeHtml(labels({de:'NFC-Hintergrund farbig',en:'Coloured NFC background',it:'Sfondo NFC colorato'}))}" aria-checked="${Boolean(coloured)}"><span data-smoof-choice-indicator aria-hidden="true"></span><span data-smoof-choice-label="off">${transparent}</span><span data-smoof-choice-label="on">${colour}</span></button>`;
  }

  function fontButton(family) {
    const safeFamily = escapeHtml(family);
    const actionLabel = t('Schrift auswählen', 'Choose font');
    return `<button type="button" data-smoof-ui-wide-button data-smoof-ui-font-button data-smoof-ui-action="text-font" aria-label="${actionLabel}: ${safeFamily}" title="${safeFamily}"><span>${safeFamily}</span>${controlIcon('forward')}</button><div data-smoof-ui-actions data-single="true"><button type="button" data-smoof-ui-wide-button data-smoof-ui-action="text-font-all"${window.SmoofRichText?.selectedStyle?.(selectedId)?.mixedFont ? ' disabled' : ''}>${escapeHtml(window.SmoofI18n.label({de:'Auf alle Textfelder anwenden',en:'Apply to all text fields',it:'Applica a tutti i campi di testo'}))}</button></div><small data-smoof-ui-control-note>${escapeHtml(window.SmoofI18n.label({de:'Gilt für alle Textfelder und die Tischnummer auf der aktuellen Seite.',en:'Applies to all text fields and the table number on the current side.',it:'Si applica a tutti i campi di testo e al numero del tavolo sul lato attuale.'}))}</small>`;
  }

  // Use the canonical owners so history, files and output retain the same font source.
  function applyFontToAll(itemId) {
    if (!/^(text-[0-2]|custom-text-[1-3]|table-number)$/.test(itemId) ||
        window.SmoofRichText?.selectedStyle?.(itemId)?.mixedFont) return false;
    const family = cleanFontFamily(rawFontForItem(itemId));
    if (!family || !/^[a-z0-9 ._-]+$/i.test(family)) return false;
    finishFontBatchHistory();
    commitHistorySnapshot(); // Keep a preceding font choice separate from this bulk action.
    window.getSelection()?.removeAllRanges();
    window.SmoofRichText?.clear?.();
    const custom = window.SmoofCustomFontRegistry?.isCustomFamily?.(family);
    for (let index = 0; index < 3; index++) {
      window.SmoofTextTools?.setFont?.(index, family);
      if (custom) window.SmoofTextTools?.setStyle?.(index, 'Normal');
    }
    for (const state of window.SmoofCustomTextTools?.getStates?.() || []) {
      if (!state.enabled) continue;
      window.SmoofCustomTextTools.setFont(state.id, family);
      if (custom) window.SmoofCustomTextTools.setStyle(state.id, 'Normal');
    }
    window.SmoofNumberHistory?.setFont?.(family);
    selectedId = itemId;
    dispatchSelection(itemId);
    fontBatchHistory = {key: fontBatchSignature(captureHistorySnapshot()), committed: false};
    scheduleHistoryCapture(320);
    setTimeout(() => {
      if (layersOpen) renderLayers(); else renderContext();
      const panel = layersOpen ? layers : context;
      panel?.querySelector('[data-smoof-ui-action="text-font-all"]')?.focus({preventScroll:true});
    }, 80);
    return true;
  }

  function colorRow(label, proxy, selector) {
    const input = source ? source.querySelector(selector) : null;
    const locked = laserMonochromeActive();
    const value = locked ? '#000000' : (input?.value || '#000000');
    const disabled = locked ? ' disabled aria-disabled="true"' : '';
    return row(label, `<label data-smoof-ui-color-wrap${locked ? ' data-smoof-ui-laser-colour-locked="true"' : ''}><span data-smoof-ui-color-swatch style="background-color:${value}"></span><span data-smoof-ui-color-value>${value.toUpperCase()}</span><input data-smoof-ui-color="${proxy}" type="color" value="${value}" aria-label="${label}"${disabled}></label>`);
  }

  function colorRowValue(label, proxy, value) {
    const locked = laserMonochromeActive();
    const safe = locked
      ? '#000000'
      : (/^#[0-9a-f]{6}$/i.test(String(value)) ? value : '#000000');
    const disabled = locked ? ' disabled aria-disabled="true"' : '';
    return row(label, `<label data-smoof-ui-color-wrap${locked ? ' data-smoof-ui-laser-colour-locked="true"' : ''}><span data-smoof-ui-color-swatch style="background-color:${safe}"></span><span data-smoof-ui-color-value>${safe.toUpperCase()}</span><input data-smoof-ui-color="${proxy}" type="color" value="${safe}" aria-label="${label}"${disabled}></label>`);
  }

  function normalizeHexColor(value, allowShort = true) {
    const compact = String(value || '').trim().replace(/^#/, '');
    if (allowShort && /^[0-9a-f]{3}$/i.test(compact)) {
      return `#${compact.split('').map(character => character + character).join('')}`.toUpperCase();
    }
    return /^[0-9a-f]{6}$/i.test(compact)
      ? `#${compact}`.toUpperCase()
      : '';
  }

  function hexColorRow(label, proxy, rawValue, locked = false) {
    const effectiveLocked = locked || laserMonochromeActive();
    const value = effectiveLocked ? '#000000' : (normalizeHexColor(rawValue) || '#000000');
    const disabled = effectiveLocked ? ' disabled aria-disabled="true"' : '';
    return row(
      label,
      `<div data-smoof-ui-hex-color-editor${effectiveLocked ? ' data-smoof-ui-laser-colour-locked="true"' : ''}>` +
        `<label data-smoof-ui-color-wrap data-smoof-ui-hex-color-swatch title="${t('Farbe auswählen', 'Choose colour')}">` +
          `<span data-smoof-ui-color-swatch style="background-color:${value}"></span>` +
          `<span data-smoof-ui-color-value>${value}</span>` +
          `<input data-smoof-ui-color="${proxy}" type="color" value="${value}" aria-label="${label}"${disabled}>` +
        `</label>` +
        `<input data-smoof-ui-hex-color="${proxy}" type="text" value="${value}" maxlength="7" inputmode="text" autocomplete="off" autocapitalize="characters" spellcheck="false" aria-label="${label} ${t('als Hexcode', 'as hex code')}" aria-invalid="false"${disabled}>` +
      `</div>`
    );
  }

  function sourceHexColorRow(label, proxy, selector) {
    const input = source ? source.querySelector(selector) : null;
    return hexColorRow(label, proxy, input?.value || '#000000');
  }

  // Match the existing segmented icon controls and active 3D/multi-selection state.
  function backgroundFlipRow(image) {
    const label = mt('Spiegeln', 'Flip', 'Rifletti');
    const axes = [
      ['x', 'Horizontal spiegeln', 'Flip horizontally', 'Rifletti orizzontalmente'],
      ['y', 'Vertikal spiegeln', 'Flip vertically', 'Rifletti verticalmente']
    ];
    return row(label, `<div data-smoof-background-flip role="group" aria-label="${label}">${axes.map(([axis, de, en, it]) => {
      const title = mt(de, en, it);
      const active = image[axis === 'x' ? 'flipX' : 'flipY'] === true;
      return `<button type="button" data-smoof-ui-icon-button data-smoof-ui-action="background-image-flip-${axis}" aria-label="${title}" title="${title}" aria-pressed="${active}"><svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><g${axis === 'y' ? ' transform="rotate(90 12 12)"' : ''}><path d="M12 3v18" stroke-dasharray="2 2"/><path d="M3 6v12h6Z" fill="currentColor" fill-opacity=".18"/><path d="M21 6v12h-6Z"/></g></svg></button>`;
    }).join('')}</div>`);
  }

  function textAlignRow(state) {
    if (state?.textShape?.mode && state.textShape.mode !== 'straight') return '';
    const label=mt('Textausrichtung','Text alignment','Allineamento del testo');
    const values=[['left','Linksbündig','Align left','Allinea a sinistra'],['center','Zentriert','Align centre','Centra'],['right','Rechtsbündig','Align right','Allinea a destra'],['justify','Blocksatz','Justify','Giustifica']];
    return row(label,`<div data-smoof-text-align role="group" aria-label="${label}">${values.map(([value,de,en,it])=>{
      const start=value==='left'||value==='justify'?4:value==='right'?10:7, short=value==='justify'?16:10, title=mt(de,en,it);
      return `<button type="button" data-smoof-ui-icon-button data-smoof-ui-action="text-align:${value}" aria-label="${title}" title="${title}" aria-pressed="${(state?.textAlign||'center')===value}"><svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M4 5h16M${start} 10h${short}M4 15h16M${start} 20h${short}"/></svg></button>`;
    }).join('')}</div>`);
  }

  function letterSpacingRow(value) {
    const spacing = Number.isFinite(Number(value)) ? Number(value) : 0;
    return row(
      t('Laufweite', 'Letter spacing'),
      `<div data-smoof-ui-stepper>` +
        `<button type="button" data-smoof-ui-action="letter-spacing-minus" aria-label="${t('Laufweite verringern', 'Decrease letter spacing')}">−</button>` +
        `<span data-smoof-ui-letter-spacing>${Math.round(spacing * 100)}%</span>` +
        `<button type="button" data-smoof-ui-action="letter-spacing-plus" aria-label="${t('Laufweite erhöhen', 'Increase letter spacing')}">+</button>` +
      `</div>`
    );
  }

  function backgroundColorRow(label) {
    const input = source ? source.querySelector('input[type="color"]') : null;
    return hexColorRow(label, 'background-color', input?.value);
  }

  function styleRow(proxy, selector, locked = false) {
    const select = source ? source.querySelector(selector) : null;
    const options = locked
      ? '<option value="Normal" selected>' + window.SmoofI18n.fontStyle('Normal') + '</option>'
      : select ? Array.from(select.options).map(option => `<option value="${option.value}"${option.selected ? ' selected' : ''}${option.disabled ? ' disabled' : ''}>${escapeHtml(option.textContent)}</option>`).join('') : '';
    return row(t('Schnitt', 'Style'), `<select data-smoof-ui-select="${proxy}" aria-label="${t('Schriftschnitt', 'Font style')}"${locked ? ' disabled title="' + t('Dieser Upload enthält nur den Schnitt Normal.', 'This upload contains only the Normal style.') + '"' : ''}>${options}</select>`);
  }

  function sharedFontStyleOptions(selectedValue = 'Normal', locked = false, family = 'Roboto') {
    if (locked) return '<option value="Normal" selected>' + window.SmoofI18n.fontStyle('Normal') + '</option>';
    const values = Array.from(window.SmoofTextTools?.styleOptions || ['Extra light', 'Extra light & Kursiv', 'Light', 'Light & Kursiv', 'Normal', 'Kursiv', 'Fett', 'Fett & Kursiv', 'Extra fett', 'Extra fett & Kursiv']);
    const selected = window.SmoofTextTools?.normalizeStyle?.(selectedValue) || selectedValue || 'Normal';
    const mixed=window.SmoofRichText?.selectedStyle?.(selectedId)?.mixedStyle;
    return (mixed?`<option value="" disabled selected>${t('Gemischt','Mixed')}</option>`:'') + values.map(value => {
      const spec = window.SmoofTextTools?.styleOption?.(family, value) || { label: value, disabled: value.startsWith('Extra') };
      if(window.SmoofRichText?.styleAvailable?.(selectedId,value)===false){spec.disabled=true;spec.label+=t(' (nicht für gesamte Auswahl verfügbar)',' (not available for entire selection)');}
      return `<option value="${escapeHtml(value)}"${!mixed && selected === value ? ' selected' : ''}${spec.disabled ? ' disabled' : ''}>${escapeHtml(spec.label)}</option>`;
    }).join('');
  }

  // Build423: exact dot geometry from the standard arrow owner, without its separate NFC label.
  const standardPictogramPreviews = Object.fromEntries(Object.entries({"left": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 85.01 31.42\" fill=\"black\"><path d=\"M60.5,12.3c0-.98-.8-1.78-1.78-1.78s-1.78.79-1.78,1.78.8,1.78,1.78,1.78,1.78-.79,1.78-1.78\"/><path d=\"M74.55,12.3c0-1.2-.98-2.18-2.18-2.18s-2.18.98-2.18,2.18.98,2.18,2.18,2.18,2.18-.98,2.18-2.18\"/><path d=\"M81.6,12.3c0-1.34-1.08-2.42-2.42-2.42s-2.42,1.08-2.42,2.42,1.08,2.42,2.42,2.42,2.42-1.08,2.42-2.42\"/><path d=\"M39.57,12.3c0-.72-.59-1.31-1.31-1.31s-1.31.59-1.31,1.31.59,1.31,1.31,1.31,1.31-.59,1.31-1.31\"/><path d=\"M53.51,12.3c0-.89-.72-1.6-1.6-1.6s-1.6.72-1.6,1.6.72,1.6,1.6,1.6,1.6-.72,1.6-1.6\"/><path d=\"M32.62,12.3c0-.65-.53-1.18-1.18-1.18s-1.18.53-1.18,1.18.53,1.18,1.18,1.18,1.18-.53,1.18-1.18\"/><path d=\"M78.07,8.89c0-1.27-1.03-2.29-2.3-2.29s-2.3,1.03-2.3,2.29,1.03,2.3,2.3,2.3,2.3-1.03,2.3-2.3\"/><path d=\"M71.03,8.89c0-.71-.36-1.35-.91-1.72-.33-.22-.73-.35-1.16-.35-.14,0-.28.01-.42.04-.94.19-1.66,1.03-1.66,2.03s.71,1.84,1.66,2.03c.14.03.27.04.42.04.43,0,.83-.13,1.16-.35.55-.37.91-1,.91-1.72\"/><path d=\"M11.84,12.3c0-.48-.39-.87-.87-.87s-.87.39-.87.87.39.87.87.87.87-.39.87-.87\"/><path d=\"M18.76,12.3c0-.53-.43-.96-.96-.96s-.96.43-.96.96.43.96.96.96.96-.43.96-.96\"/><path d=\"M11.84,19.12c0-.48-.39-.87-.87-.87s-.87.39-.87.87.39.87.87.87.87-.39.87-.87\"/><path d=\"M53.51,19.12c0-.89-.72-1.6-1.6-1.6s-1.6.72-1.6,1.6.72,1.6,1.6,1.6,1.6-.72,1.6-1.6\"/><path d=\"M18.76,19.12c0-.53-.43-.96-.96-.96s-.96.43-.96.96.43.96.96.96.96-.43.96-.96\"/><path d=\"M60.5,19.12c0-.98-.8-1.78-1.78-1.78s-1.78.8-1.78,1.78.8,1.78,1.78,1.78,1.78-.8,1.78-1.78\"/><path d=\"M39.57,19.12c0-.72-.59-1.31-1.31-1.31s-1.31.58-1.31,1.31.59,1.31,1.31,1.31,1.31-.59,1.31-1.31\"/><path d=\"M32.62,19.12c0-.65-.53-1.18-1.18-1.18s-1.18.53-1.18,1.18.53,1.18,1.18,1.18,1.18-.53,1.18-1.18\"/><path d=\"M35.99,16.2c.06-.15.1-.31.1-.48,0-.68-.56-1.24-1.24-1.24s-1.24.55-1.24,1.24c0,.17.04.33.1.48.06.15.15.28.27.39.22.23.53.36.88.36s.65-.14.88-.36c.11-.11.2-.25.27-.39\"/><path d=\"M22.14,16.11c.05-.12.08-.25.08-.39,0-.56-.45-1.01-1.01-1.01s-1.01.45-1.01,1.01c0,.14.03.27.08.39.05.12.13.23.22.32.18.18.44.3.71.3s.53-.11.71-.3c.09-.09.17-.2.22-.32\"/><path d=\"M42.81,16.48c.05-.07.09-.15.13-.23.07-.17.11-.35.11-.53,0-.28-.09-.55-.23-.77-.25-.37-.66-.61-1.14-.61-.1,0-.19,0-.28.03-.27.05-.51.19-.7.37-.06.06-.12.13-.17.2-.1.15-.17.31-.21.49-.02.09-.03.18-.03.28s0,.19.03.28c.02.09.05.17.08.26.04.08.08.16.13.23s.11.14.17.2c.19.19.43.32.7.37.09.02.18.03.28.03.38,0,.72-.15.97-.4.06-.06.12-.13.17-.2\"/><path d=\"M15.14,16.22s.06-.1.08-.15c.05-.11.07-.23.07-.35,0-.19-.06-.36-.16-.51-.16-.24-.44-.4-.76-.4-.06,0-.12,0-.18.02-.18.04-.34.13-.46.25-.04.04-.08.09-.11.14-.07.1-.11.21-.14.33-.01.06-.02.12-.02.18s0,.12.02.18c.01.06.03.12.05.17.02.05.05.11.08.15.03.05.07.09.11.14.12.12.28.21.46.25.06.01.12.02.18.02.25,0,.48-.1.64-.27.04-.04.08-.09.11-.14\"/><path d=\"M84.82,16.65c.12-.29.19-.61.19-.94,0-1.33-1.08-2.42-2.42-2.42s-2.42,1.08-2.42,2.42c0,.33.07.65.19.94.12.29.3.55.52.77.44.44,1.04.71,1.71.71s1.27-.27,1.71-.71c.22-.22.4-.48.52-.77\"/><path d=\"M56.71,16.66c.06-.09.11-.19.15-.29.09-.2.13-.42.13-.66,0-.35-.11-.67-.29-.94-.3-.45-.82-.74-1.4-.74-.12,0-.23.01-.34.03-.33.07-.62.23-.85.46-.08.08-.15.16-.21.25-.12.18-.21.38-.25.6-.02.11-.03.22-.03.34s.01.23.03.34c.02.11.06.22.1.32.04.1.1.2.16.29.06.09.13.17.21.25.23.23.52.39.85.46.11.02.22.03.34.03.47,0,.89-.19,1.19-.49.08-.08.15-.16.21-.25\"/><path d=\"M77.89,16.61c.12-.27.18-.58.18-.89,0-1.27-1.03-2.29-2.3-2.29s-2.3,1.03-2.3,2.29c0,.32.06.62.18.89.12.28.28.52.49.73.42.42.99.67,1.62.67s1.21-.26,1.62-.67c.21-.21.38-.45.49-.73\"/><path d=\"M63.86,16.44c.09-.22.15-.47.15-.73,0-1.03-.84-1.87-1.87-1.87s-1.87.84-1.87,1.87c0,.26.05.5.15.73.09.22.23.43.4.59.34.34.81.55,1.32.55s.98-.21,1.32-.55c.17-.17.31-.37.4-.59\"/><path d=\"M74.55,19.12c0-1.2-.98-2.18-2.18-2.18s-2.18.98-2.18,2.18.98,2.18,2.18,2.18,2.18-.98,2.18-2.18\"/><path d=\"M63.97,2.45c.03-.12.04-.25.04-.38,0-1.03-.84-1.87-1.87-1.87s-1.87.84-1.87,1.87c0,.13.01.26.04.38.17.85.93,1.49,1.83,1.49s1.66-.64,1.83-1.49\"/><path d=\"M49.98,2.38c.02-.1.03-.2.03-.31,0-.84-.68-1.52-1.52-1.52s-1.52.68-1.52,1.52c0,.11.01.21.03.31.14.69.76,1.22,1.49,1.22s1.35-.52,1.49-1.22\"/><path d=\"M70.98,2.49c.03-.14.04-.27.04-.42,0-.71-.36-1.35-.91-1.72-.33-.22-.73-.35-1.16-.35-.14,0-.28.01-.42.04-.94.19-1.66,1.03-1.66,2.03,0,.14.01.28.04.42.17.81.8,1.45,1.61,1.61.13.03.27.04.42.04.43,0,.83-.13,1.16-.35.44-.3.76-.76.87-1.3\"/><path d=\"M42.81,2.84c.1-.15.17-.31.21-.49.02-.09.03-.18.03-.28,0-.28-.09-.55-.23-.77-.25-.37-.66-.61-1.14-.61-.1,0-.19,0-.28.03-.27.05-.51.19-.7.37-.06.06-.12.13-.17.2-.1.15-.17.31-.21.49-.02.09-.03.18-.03.28s0,.19.03.28c.04.18.11.34.21.49.05.07.11.14.17.2.19.19.43.32.7.37.09.02.18.03.28.03.48,0,.89-.24,1.14-.61\"/><path d=\"M22.2,2.28c.01-.07.02-.13.02-.2,0-.56-.45-1.01-1.01-1.01s-1.01.45-1.01,1.01c0,.07,0,.14.02.2.1.46.5.81.99.81s.9-.35.99-.81\"/><path d=\"M29.12,2.3c.01-.07.02-.15.02-.23,0-.39-.2-.73-.49-.93-.18-.12-.39-.19-.63-.19-.08,0-.15,0-.23.02-.51.1-.89.56-.89,1.1,0,.08,0,.15.02.23.09.44.43.78.87.87.07.02.15.02.23.02.23,0,.45-.07.63-.19.24-.16.41-.41.47-.7\"/><path d=\"M1.36,2.49c.05-.08.09-.17.11-.27.01-.05.02-.1.02-.15,0-.15-.05-.3-.13-.41-.13-.2-.36-.33-.62-.33-.05,0-.1,0-.15.01-.15.03-.28.1-.38.2-.03.03-.06.07-.09.11-.05.08-.09.17-.11.26,0,.05-.01.1-.01.15s0,.1.01.15c.02.1.06.19.11.27.03.04.06.08.09.11.1.1.23.17.38.2.05.01.1.02.15.02.26,0,.48-.13.62-.33\"/><path d=\"M8.37,2.24c.01-.05.02-.11.02-.17,0-.45-.37-.82-.82-.82s-.82.37-.82.82c0,.06,0,.11.02.17.08.37.41.66.81.66s.73-.28.81-.66\"/><path d=\"M56.71,9.84c.18-.27.29-.59.29-.94s-.11-.67-.29-.94c-.3-.45-.82-.74-1.4-.74-.12,0-.23.01-.34.03-.33.07-.62.23-.85.46-.08.08-.15.16-.21.25-.12.18-.21.38-.25.6-.02.11-.03.22-.03.34s.01.23.03.34c.05.22.13.42.25.6.06.09.13.17.21.25.23.23.52.39.85.46.11.02.22.03.34.03.58,0,1.1-.3,1.4-.74\"/><path d=\"M29.15,8.89c0-.39-.2-.73-.49-.93-.18-.12-.39-.19-.63-.19-.08,0-.15,0-.23.02-.51.1-.89.56-.89,1.1s.38.99.89,1.1c.07.01.15.02.23.02.23,0,.45-.07.63-.19.3-.2.49-.54.49-.93\"/><path d=\"M36.09,8.89c0-.68-.55-1.24-1.24-1.24s-1.24.56-1.24,1.24.55,1.24,1.24,1.24,1.24-.56,1.24-1.24\"/><path d=\"M50.01,8.89c0-.84-.68-1.52-1.52-1.52s-1.52.68-1.52,1.52.68,1.52,1.52,1.52,1.52-.68,1.52-1.52\"/><path d=\"M15.14,9.4c.1-.15.16-.32.16-.51s-.06-.36-.16-.51c-.16-.24-.44-.4-.76-.4-.06,0-.12,0-.18.02-.18.04-.34.13-.46.25-.04.04-.08.09-.11.14-.07.1-.11.21-.14.33-.01.06-.02.12-.02.18s0,.12.02.18c.02.12.07.23.14.33.03.05.07.09.11.14.12.12.28.21.46.25.06.01.12.02.18.02.32,0,.59-.16.76-.4\"/><path d=\"M8.39,8.89c0-.45-.37-.82-.82-.82s-.82.37-.82.82.37.82.82.82.82-.37.82-.82\"/><path d=\"M32.62,5.48c0-.65-.53-1.18-1.18-1.18s-1.18.53-1.18,1.18.53,1.18,1.18,1.18,1.18-.53,1.18-1.18\"/><path d=\"M4.94,5.48c0-.43-.35-.78-.78-.78s-.78.35-.78.78.35.78.78.78.78-.35.78-.78\"/><path d=\"M25.68,5.48c0-.59-.48-1.06-1.06-1.06s-1.06.48-1.06,1.06.48,1.06,1.06,1.06,1.06-.48,1.06-1.06\"/><path d=\"M11.84,5.48c0-.48-.39-.87-.87-.87s-.87.39-.87.87.39.87.87.87.87-.39.87-.87\"/><path d=\"M74.55,5.48c0-1.2-.98-2.18-2.18-2.18s-2.18.98-2.18,2.18.98,2.18,2.18,2.18,2.18-.98,2.18-2.18\"/><path d=\"M67.51,5.48c0-1.09-.88-1.97-1.97-1.97s-1.97.88-1.97,1.97.88,1.97,1.97,1.97,1.97-.88,1.97-1.97\"/><path d=\"M46.53,5.48c0-.8-.65-1.45-1.45-1.45s-1.45.65-1.45,1.45.65,1.45,1.45,1.45,1.45-.65,1.45-1.45\"/><path d=\"M53.51,5.48c0-.89-.72-1.6-1.6-1.6s-1.6.72-1.6,1.6.72,1.6,1.6,1.6,1.6-.72,1.6-1.6\"/><path d=\"M25.68,25.95c0-.59-.48-1.06-1.06-1.06s-1.06.48-1.06,1.06.48,1.06,1.06,1.06,1.06-.48,1.06-1.06\"/><path d=\"M81.6,19.12c0-1.33-1.08-2.42-2.42-2.42s-2.42,1.08-2.42,2.42,1.08,2.42,2.42,2.42,2.42-1.08,2.42-2.42\"/><path d=\"M78.07,22.53c0-1.27-1.03-2.29-2.3-2.29s-2.3,1.03-2.3,2.29,1.03,2.3,2.3,2.3,2.3-1.03,2.3-2.3\"/><path d=\"M50.01,22.53c0-.84-.68-1.52-1.52-1.52s-1.52.68-1.52,1.52.68,1.52,1.52,1.52,1.52-.68,1.52-1.52\"/><path d=\"M56.71,23.48c.18-.27.29-.59.29-.94s-.11-.67-.29-.94c-.3-.45-.82-.74-1.4-.74-.12,0-.23.01-.34.03-.33.07-.62.23-.85.46-.08.08-.15.16-.21.25-.12.18-.21.38-.25.6-.02.11-.03.22-.03.34s.01.23.03.34c.05.22.13.42.25.6.06.09.13.17.21.25.23.23.52.39.85.46.11.02.22.03.34.03.58,0,1.1-.3,1.4-.74\"/><path d=\"M71.03,22.53c0-.71-.36-1.35-.91-1.72-.33-.22-.73-.35-1.16-.35-.14,0-.28.01-.42.04-.94.19-1.66,1.03-1.66,2.03s.71,1.84,1.66,2.03c.14.03.27.04.42.04.43,0,.83-.13,1.16-.35.55-.37.91-1,.91-1.72\"/><path d=\"M8.39,22.54c0-.45-.37-.82-.82-.82s-.82.37-.82.82.37.82.82.82.82-.37.82-.82\"/><path d=\"M15.14,23.04c.1-.15.16-.32.16-.51s-.06-.36-.16-.51c-.16-.24-.44-.4-.76-.4-.06,0-.12,0-.18.02-.18.04-.34.13-.46.25-.04.04-.08.09-.11.14-.07.1-.11.21-.14.33-.01.06-.02.12-.02.18s0,.12.02.18c.02.12.07.23.14.33.03.05.07.09.11.14.12.12.28.21.46.25.06.01.12.02.18.02.32,0,.59-.16.76-.4\"/><path d=\"M29.15,22.53c0-.39-.2-.73-.49-.93-.18-.12-.39-.19-.63-.19-.08,0-.15,0-.23.02-.51.1-.89.56-.89,1.1s.38.99.89,1.1c.07.01.15.02.23.02.23,0,.45-.07.63-.19.3-.2.49-.54.49-.93\"/><path d=\"M36.09,22.53c0-.68-.55-1.24-1.24-1.24s-1.24.56-1.24,1.24.55,1.24,1.24,1.24,1.24-.56,1.24-1.24\"/><path d=\"M4.94,25.95c0-.43-.35-.78-.78-.78s-.78.35-.78.78.35.78.78.78.78-.35.78-.78\"/><path d=\"M8.32,29.68c.04-.1.06-.21.06-.32,0-.45-.37-.82-.82-.82s-.82.37-.82.82c0,.11.02.22.06.32.04.1.1.19.18.26.15.15.35.24.58.24s.43-.09.58-.24c.07-.08.14-.16.18-.26\"/><path d=\"M22.14,29.75c.05-.12.08-.25.08-.39,0-.56-.45-1.01-1.01-1.01s-1.01.45-1.01,1.01c0,.14.03.27.08.39.05.12.13.23.22.32.18.18.44.3.71.3s.53-.11.71-.3c.09-.09.17-.2.22-.32\"/><path d=\"M63.86,30.08c.09-.22.15-.47.15-.73,0-1.03-.84-1.87-1.87-1.87s-1.87.84-1.87,1.87c0,.26.05.5.15.73.09.22.23.43.4.59.34.34.81.55,1.32.55s.98-.21,1.32-.55c.17-.17.31-.37.4-.59\"/><path d=\"M70.42,30.82c.19-.19.34-.41.44-.66.1-.25.16-.52.16-.81,0-.71-.36-1.35-.91-1.72-.33-.22-.73-.35-1.16-.35-.14,0-.28.01-.42.04-.94.19-1.66,1.03-1.66,2.03,0,.29.06.56.16.81.1.25.26.47.44.66.28.28.64.48,1.05.57.14.03.27.04.42.04.43,0,.83-.13,1.16-.35.11-.07.21-.16.31-.25\"/><path d=\"M28.82,30.15c.1-.1.18-.22.24-.36s.09-.28.09-.44c0-.39-.2-.73-.49-.93-.18-.12-.39-.19-.63-.19-.08,0-.15,0-.23.02-.51.1-.9.56-.9,1.1,0,.15.03.3.09.44s.14.25.24.36c.15.15.35.26.57.31.07.01.15.02.23.02.23,0,.45-.07.63-.19.06-.04.12-.09.17-.14\"/><path d=\"M49.89,29.95c.08-.18.12-.38.12-.59,0-.84-.68-1.52-1.52-1.52s-1.52.68-1.52,1.52c0,.21.04.41.12.59.08.18.19.35.33.48.28.28.66.45,1.08.45s.8-.17,1.08-.45c.14-.14.25-.3.33-.48\"/><path d=\"M42.81,30.12c.05-.07.09-.15.13-.23.07-.17.11-.35.11-.53,0-.28-.09-.55-.23-.77-.25-.37-.66-.61-1.14-.61-.1,0-.19,0-.28.03-.27.05-.51.19-.7.37-.06.06-.12.13-.17.2-.1.15-.17.31-.21.49-.02.09-.03.18-.03.28s0,.19.03.28c.02.09.05.17.08.26.04.08.08.16.13.23s.11.14.17.2c.19.19.43.32.7.37.09.02.18.03.28.03.38,0,.72-.15.97-.4.06-.06.12-.13.17-.2\"/><path d=\"M1.36,29.77s.05-.08.07-.13c.04-.09.06-.19.06-.29,0-.15-.05-.3-.13-.41-.13-.2-.36-.33-.62-.33-.05,0-.1,0-.15.01-.15.03-.28.1-.38.2-.03.03-.06.07-.09.11-.05.08-.09.17-.11.26,0,.05-.01.1-.01.15s0,.1.01.15c.01.05.03.1.04.14.02.04.04.09.07.13.03.04.06.08.09.11.1.1.23.17.38.2.05.01.1.01.15.01.21,0,.39-.08.53-.22.03-.03.06-.07.09-.11\"/><path d=\"M46.53,25.95c0-.8-.65-1.45-1.45-1.45s-1.45.65-1.45,1.45.65,1.45,1.45,1.45,1.45-.65,1.45-1.45\"/><path d=\"M32.62,25.95c0-.65-.53-1.18-1.18-1.18s-1.18.53-1.18,1.18.53,1.18,1.18,1.18,1.18-.53,1.18-1.18\"/><path d=\"M11.84,25.95c0-.48-.39-.87-.87-.87s-.87.39-.87.87.39.87.87.87.87-.39.87-.87\"/><path d=\"M53.51,25.95c0-.89-.72-1.6-1.6-1.6s-1.6.72-1.6,1.6.72,1.6,1.6,1.6,1.6-.72,1.6-1.6\"/><path d=\"M74.55,25.95c0-1.2-.98-2.18-2.18-2.18s-2.18.98-2.18,2.18.98,2.18,2.18,2.18,2.18-.98,2.18-2.18\"/><path d=\"M67.51,25.95c0-1.09-.88-1.97-1.97-1.97s-1.97.88-1.97,1.97.88,1.97,1.97,1.97,1.97-.88,1.97-1.97\"/></svg>", "right": "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 85.01 31.42\" fill=\"black\"><path d=\"M24.51,19.12c0,.98.8,1.78,1.78,1.78s1.78-.79,1.78-1.78-.8-1.78-1.78-1.78-1.78.79-1.78,1.78\"/><path d=\"M10.47,19.12c0,1.2.98,2.18,2.18,2.18s2.18-.98,2.18-2.18-.98-2.18-2.18-2.18-2.18.98-2.18,2.18\"/><path d=\"M3.41,19.12c0,1.34,1.08,2.42,2.42,2.42s2.42-1.08,2.42-2.42-1.08-2.42-2.42-2.42-2.42,1.08-2.42,2.42\"/><path d=\"M45.45,19.12c0,.72.59,1.31,1.31,1.31s1.31-.59,1.31-1.31-.59-1.31-1.31-1.31-1.31.59-1.31,1.31\"/><path d=\"M31.51,19.12c0,.89.72,1.6,1.6,1.6s1.6-.72,1.6-1.6-.72-1.6-1.6-1.6-1.6.72-1.6,1.6\"/><path d=\"M52.4,19.12c0,.65.53,1.18,1.18,1.18s1.18-.53,1.18-1.18-.53-1.18-1.18-1.18-1.18.53-1.18,1.18\"/><path d=\"M6.94,22.54c0,1.27,1.03,2.29,2.3,2.29s2.3-1.03,2.3-2.29-1.03-2.3-2.3-2.3-2.3,1.03-2.3,2.3\"/><path d=\"M13.99,22.54c0,.71.36,1.35.91,1.72.33.22.73.35,1.16.35.14,0,.28-.01.42-.04.94-.19,1.66-1.03,1.66-2.03s-.71-1.84-1.66-2.03c-.14-.03-.27-.04-.42-.04-.43,0-.83.13-1.16.35-.55.37-.91,1-.91,1.72\"/><path d=\"M73.17,19.12c0,.48.39.87.87.87s.87-.39.87-.87-.39-.87-.87-.87-.87.39-.87.87\"/><path d=\"M66.26,19.12c0,.53.43.96.96.96s.96-.43.96-.96-.43-.96-.96-.96-.96.43-.96.96\"/><path d=\"M73.17,12.3c0,.48.39.87.87.87s.87-.39.87-.87-.39-.87-.87-.87-.87.39-.87.87\"/><path d=\"M31.51,12.3c0,.89.72,1.6,1.6,1.6s1.6-.72,1.6-1.6-.72-1.6-1.6-1.6-1.6.72-1.6,1.6\"/><path d=\"M66.26,12.3c0,.53.43.96.96.96s.96-.43.96-.96-.43-.96-.96-.96-.96.43-.96.96\"/><path d=\"M24.51,12.3c0,.98.8,1.78,1.78,1.78s1.78-.8,1.78-1.78-.8-1.78-1.78-1.78-1.78.8-1.78,1.78\"/><path d=\"M45.45,12.3c0,.72.59,1.31,1.31,1.31s1.31-.58,1.31-1.31-.59-1.31-1.31-1.31-1.31.59-1.31,1.31\"/><path d=\"M52.4,12.3c0,.65.53,1.18,1.18,1.18s1.18-.53,1.18-1.18-.53-1.18-1.18-1.18-1.18.53-1.18,1.18\"/><path d=\"M49.02,15.23c-.06.15-.1.31-.1.48,0,.68.56,1.24,1.24,1.24s1.24-.55,1.24-1.24c0-.17-.04-.33-.1-.48s-.15-.28-.27-.39c-.23-.23-.53-.36-.88-.36s-.65.14-.88.36c-.11.11-.2.25-.27.39\"/><path d=\"M62.88,15.32c-.05.12-.08.25-.08.39,0,.56.45,1.01,1.01,1.01s1.01-.45,1.01-1.01c0-.14-.03-.27-.08-.39-.05-.12-.13-.23-.22-.32-.18-.18-.44-.3-.71-.3s-.53.11-.71.3c-.09.09-.17.2-.22.32\"/><path d=\"M42.2,14.95c-.05.07-.09.15-.13.23-.07.17-.11.35-.11.53,0,.28.09.55.23.77.25.37.66.61,1.14.61.1,0,.19,0,.28-.03.27-.05.51-.19.7-.37.06-.06.12-.13.17-.2.1-.15.17-.31.21-.49.02-.09.03-.18.03-.28s0-.19-.03-.28c-.02-.09-.05-.18-.08-.26-.04-.08-.08-.16-.13-.23-.05-.07-.11-.14-.17-.2-.19-.19-.43-.32-.7-.37-.09-.02-.18-.03-.28-.03-.38,0-.72.15-.97.4-.06.06-.12.13-.17.2\"/><path d=\"M69.87,15.2s-.06.1-.08.15c-.05.11-.07.23-.07.35,0,.19.06.36.16.51.16.24.44.4.76.4.06,0,.12,0,.18-.02.18-.04.34-.13.46-.25.04-.04.08-.09.11-.14.07-.1.11-.21.14-.33.01-.06.02-.12.02-.18s0-.12-.02-.18-.03-.12-.05-.17c-.02-.05-.05-.11-.08-.15-.03-.05-.07-.09-.11-.14-.12-.12-.28-.21-.46-.25-.06-.01-.12-.02-.18-.02-.25,0-.48.1-.64.27-.04.04-.08.09-.11.14\"/><path d=\"M.19,14.77c-.12.29-.19.61-.19.94,0,1.33,1.08,2.42,2.42,2.42s2.42-1.08,2.42-2.42c0-.33-.07-.65-.19-.94-.12-.29-.3-.55-.52-.77-.44-.44-1.04-.71-1.71-.71s-1.27.27-1.71.71c-.22.22-.4.48-.52.77\"/><path d=\"M28.3,14.77c-.06.09-.11.19-.15.29-.09.2-.13.42-.13.66,0,.35.11.67.29.94.3.45.82.74,1.4.74.12,0,.23-.01.34-.03.33-.07.62-.23.85-.46.08-.08.15-.16.21-.25.12-.18.21-.38.25-.6.02-.11.03-.22.03-.34s-.01-.23-.03-.34c-.02-.11-.06-.22-.1-.32-.04-.1-.1-.2-.16-.29-.06-.09-.13-.17-.21-.25-.23-.23-.52-.39-.85-.46-.11-.02-.22-.03-.34-.03-.47,0-.89.19-1.19.49-.08.08-.15.16-.21.25\"/><path d=\"M7.12,14.82c-.12.27-.18.58-.18.89,0,1.27,1.03,2.29,2.3,2.29s2.3-1.03,2.3-2.29c0-.32-.06-.62-.18-.89-.12-.28-.28-.52-.49-.73-.42-.42-.99-.67-1.62-.67s-1.21.26-1.62.67c-.21.21-.38.45-.49.73\"/><path d=\"M21.16,14.99c-.09.22-.15.47-.15.73,0,1.03.84,1.87,1.87,1.87s1.87-.84,1.87-1.87c0-.26-.05-.5-.15-.73-.09-.22-.23-.43-.4-.59-.34-.34-.81-.55-1.32-.55s-.98.21-1.32.55c-.17.17-.31.37-.4.59\"/><path d=\"M10.47,12.3c0,1.2.98,2.18,2.18,2.18s2.18-.98,2.18-2.18-.98-2.18-2.18-2.18-2.18.98-2.18,2.18\"/><path d=\"M21.05,28.98c-.03.12-.04.25-.04.38,0,1.03.84,1.87,1.87,1.87s1.87-.84,1.87-1.87c0-.13-.01-.26-.04-.38-.17-.85-.93-1.49-1.83-1.49s-1.66.64-1.83,1.49\"/><path d=\"M35.03,29.05c-.02.1-.03.2-.03.31,0,.84.68,1.52,1.52,1.52s1.52-.68,1.52-1.52c0-.11-.01-.21-.03-.31-.14-.69-.76-1.22-1.49-1.22s-1.35.52-1.49,1.22\"/><path d=\"M14.03,28.94c-.03.14-.04.27-.04.42,0,.71.36,1.35.91,1.72.33.22.73.35,1.16.35.14,0,.28-.01.42-.04.94-.19,1.66-1.03,1.66-2.03,0-.14-.01-.28-.04-.42-.17-.81-.8-1.45-1.61-1.61-.13-.03-.27-.04-.42-.04-.43,0-.83.13-1.16.35-.44.3-.76.76-.87,1.3\"/><path d=\"M42.2,28.59c-.1.15-.17.31-.21.49-.02.09-.03.18-.03.28,0,.28.09.55.23.77.25.37.66.61,1.14.61.1,0,.19,0,.28-.03.27-.05.51-.19.7-.37.06-.06.12-.13.17-.2.1-.15.17-.31.21-.49.02-.09.03-.18.03-.28s0-.19-.03-.28c-.04-.18-.11-.34-.21-.49-.05-.07-.11-.14-.17-.2-.19-.19-.43-.32-.7-.37-.09-.02-.18-.03-.28-.03-.48,0-.89.24-1.14.61\"/><path d=\"M62.82,29.15c-.01.07-.02.13-.02.2,0,.56.45,1.01,1.01,1.01s1.01-.45,1.01-1.01c0-.07,0-.14-.02-.2-.1-.46-.5-.81-.99-.81s-.9.35-.99.81\"/><path d=\"M55.89,29.13c-.01.07-.02.15-.02.23,0,.39.2.73.49.93.18.12.39.19.63.19.08,0,.15,0,.23-.02.51-.1.89-.56.89-1.1,0-.08,0-.15-.02-.23-.09-.44-.43-.78-.87-.87-.07-.02-.15-.02-.23-.02-.23,0-.45.07-.63.19-.24.16-.41.41-.47.7\"/><path d=\"M83.65,28.94c-.05.08-.09.17-.11.27-.01.05-.02.1-.02.15,0,.15.05.3.13.41.13.2.36.33.62.33.05,0,.1,0,.15-.01.15-.03.28-.1.38-.2.03-.03.06-.07.09-.11.05-.08.09-.17.11-.26,0-.05.01-.1.01-.15s0-.1-.01-.15c-.02-.1-.06-.19-.11-.27-.03-.04-.06-.08-.09-.11-.1-.1-.23-.17-.38-.2-.05-.01-.1-.02-.15-.02-.26,0-.48.13-.62.33\"/><path d=\"M76.64,29.19c-.01.05-.02.11-.02.17,0,.45.37.82.82.82s.82-.37.82-.82c0-.06,0-.11-.02-.17-.08-.37-.41-.66-.81-.66s-.73.28-.81.66\"/><path d=\"M28.3,21.59c-.18.27-.29.59-.29.94s.11.67.29.94c.3.45.82.74,1.4.74.12,0,.23-.01.34-.03.33-.07.62-.23.85-.46.08-.08.15-.16.21-.25.12-.18.21-.38.25-.6.02-.11.03-.22.03-.34s-.01-.23-.03-.34c-.05-.22-.13-.42-.25-.6-.06-.09-.13-.17-.21-.25-.23-.23-.52-.39-.85-.46-.11-.02-.22-.03-.34-.03-.58,0-1.1.3-1.4.74\"/><path d=\"M55.87,22.54c0,.39.2.73.49.93.18.12.39.19.63.19.08,0,.15,0,.23-.02.51-.1.89-.56.89-1.1s-.38-.99-.89-1.1c-.07-.01-.15-.02-.23-.02-.23,0-.45.07-.63.19-.3.2-.49.54-.49.93\"/><path d=\"M48.92,22.54c0,.68.55,1.24,1.24,1.24s1.24-.56,1.24-1.24-.55-1.24-1.24-1.24-1.24.56-1.24,1.24\"/><path d=\"M35,22.54c0,.84.68,1.52,1.52,1.52s1.52-.68,1.52-1.52-.68-1.52-1.52-1.52-1.52.68-1.52,1.52\"/><path d=\"M69.87,22.03c-.1.15-.16.32-.16.51s.06.36.16.51c.16.24.44.4.76.4.06,0,.12,0,.18-.02.18-.04.34-.13.46-.25.04-.04.08-.09.11-.14.07-.1.11-.21.14-.33.01-.06.02-.12.02-.18s0-.12-.02-.18c-.02-.12-.07-.23-.14-.33-.03-.05-.07-.09-.11-.14-.12-.12-.28-.21-.46-.25-.06-.01-.12-.02-.18-.02-.32,0-.59.16-.76.4\"/><path d=\"M76.63,22.53c0,.45.37.82.82.82s.82-.37.82-.82-.37-.82-.82-.82-.82.37-.82.82\"/><path d=\"M52.4,25.95c0,.65.53,1.18,1.18,1.18s1.18-.53,1.18-1.18-.53-1.18-1.18-1.18-1.18.53-1.18,1.18\"/><path d=\"M80.08,25.95c0,.43.35.78.78.78s.78-.35.78-.78-.35-.78-.78-.78-.78.35-.78.78\"/><path d=\"M59.33,25.95c0,.59.48,1.06,1.06,1.06s1.06-.48,1.06-1.06-.48-1.06-1.06-1.06-1.06.48-1.06,1.06\"/><path d=\"M73.17,25.95c0,.48.39.87.87.87s.87-.39.87-.87-.39-.87-.87-.87-.87.39-.87.87\"/><path d=\"M10.47,25.95c0,1.2.98,2.18,2.18,2.18s2.18-.98,2.18-2.18-.98-2.18-2.18-2.18-2.18.98-2.18,2.18\"/><path d=\"M17.5,25.95c0,1.09.88,1.97,1.97,1.97s1.97-.88,1.97-1.97-.88-1.97-1.97-1.97-1.97.88-1.97,1.97\"/><path d=\"M38.49,25.95c0,.8.65,1.45,1.45,1.45s1.45-.65,1.45-1.45-.65-1.45-1.45-1.45-1.45.65-1.45,1.45\"/><path d=\"M31.51,25.95c0,.89.72,1.6,1.6,1.6s1.6-.72,1.6-1.6-.72-1.6-1.6-1.6-1.6.72-1.6,1.6\"/><path d=\"M59.33,5.48c0,.59.48,1.06,1.06,1.06s1.06-.48,1.06-1.06-.48-1.06-1.06-1.06-1.06.48-1.06,1.06\"/><path d=\"M3.41,12.3c0,1.33,1.08,2.42,2.42,2.42s2.42-1.08,2.42-2.42-1.08-2.42-2.42-2.42-2.42,1.08-2.42,2.42\"/><path d=\"M6.94,8.89c0,1.27,1.03,2.29,2.3,2.29s2.3-1.03,2.3-2.29-1.03-2.3-2.3-2.3-2.3,1.03-2.3,2.3\"/><path d=\"M35,8.89c0,.84.68,1.52,1.52,1.52s1.52-.68,1.52-1.52-.68-1.52-1.52-1.52-1.52.68-1.52,1.52\"/><path d=\"M28.3,7.95c-.18.27-.29.59-.29.94s.11.67.29.94c.3.45.82.74,1.4.74.12,0,.23-.01.34-.03.33-.07.62-.23.85-.46.08-.08.15-.16.21-.25.12-.18.21-.38.25-.6.02-.11.03-.22.03-.34s-.01-.23-.03-.34c-.05-.22-.13-.42-.25-.6-.06-.09-.13-.17-.21-.25-.23-.23-.52-.39-.85-.46-.11-.02-.22-.03-.34-.03-.58,0-1.1.3-1.4.74\"/><path d=\"M13.99,8.89c0,.71.36,1.35.91,1.72.33.22.73.35,1.16.35.14,0,.28-.01.42-.04.94-.19,1.66-1.03,1.66-2.03s-.71-1.84-1.66-2.03c-.14-.03-.27-.04-.42-.04-.43,0-.83.13-1.16.35-.55.37-.91,1-.91,1.72\"/><path d=\"M76.63,8.89c0,.45.37.82.82.82s.82-.37.82-.82-.37-.82-.82-.82-.82.37-.82.82\"/><path d=\"M69.87,8.38c-.1.15-.16.32-.16.51s.06.36.16.51c.16.24.44.4.76.4.06,0,.12,0,.18-.02.18-.04.34-.13.46-.25.04-.04.08-.09.11-.14.07-.1.11-.21.14-.33.01-.06.02-.12.02-.18s0-.12-.02-.18c-.02-.12-.07-.23-.14-.33-.03-.05-.07-.09-.11-.14-.12-.12-.28-.21-.46-.25-.06-.01-.12-.02-.18-.02-.32,0-.59.16-.76.4\"/><path d=\"M55.87,8.89c0,.39.2.73.49.93.18.12.39.19.63.19.08,0,.15,0,.23-.02.51-.1.89-.56.89-1.1s-.38-.99-.89-1.1c-.07-.01-.15-.02-.23-.02-.23,0-.45.07-.63.19-.3.2-.49.54-.49.93\"/><path d=\"M48.92,8.89c0,.68.55,1.24,1.24,1.24s1.24-.56,1.24-1.24-.55-1.24-1.24-1.24-1.24.56-1.24,1.24\"/><path d=\"M80.08,5.48c0,.43.35.78.78.78s.78-.35.78-.78-.35-.78-.78-.78-.78.35-.78.78\"/><path d=\"M76.69,1.75c-.04.1-.06.21-.06.32,0,.45.37.82.82.82s.82-.37.82-.82c0-.11-.02-.22-.06-.32-.04-.1-.1-.19-.18-.26-.15-.15-.35-.24-.58-.24s-.43.09-.58.24c-.07.08-.14.16-.18.26\"/><path d=\"M62.88,1.68c-.05.12-.08.25-.08.39,0,.56.45,1.01,1.01,1.01s1.01-.45,1.01-1.01c0-.14-.03-.27-.08-.39-.05-.12-.13-.23-.22-.32-.18-.18-.44-.3-.71-.3s-.53.11-.71.3c-.09.09-.17.2-.22.32\"/><path d=\"M21.16,1.35c-.09.22-.15.47-.15.73,0,1.03.84,1.87,1.87,1.87s1.87-.84,1.87-1.87c0-.26-.05-.5-.15-.73-.09-.22-.23-.43-.4-.59-.34-.34-.81-.55-1.32-.55s-.98.21-1.32.55c-.17.17-.31.37-.4.59\"/><path d=\"M14.59.61c-.19.19-.34.41-.44.66-.1.25-.16.52-.16.81,0,.71.36,1.35.91,1.72.33.22.73.35,1.16.35.14,0,.28-.01.42-.04.94-.19,1.66-1.03,1.66-2.03,0-.29-.06-.56-.16-.81-.1-.25-.26-.47-.44-.66-.28-.28-.64-.48-1.05-.57-.14-.03-.27-.04-.42-.04-.43,0-.83.13-1.16.35-.11.07-.21.16-.31.25\"/><path d=\"M56.19,1.28c-.1.1-.18.22-.24.36s-.09.28-.09.44c0,.39.19.73.49.93.18.12.39.19.63.19.08,0,.15,0,.23-.02.51-.1.9-.56.9-1.1,0-.15-.03-.3-.09-.44s-.14-.25-.24-.36c-.15-.15-.35-.26-.57-.31-.07-.01-.15-.02-.23-.02-.23,0-.45.07-.63.19-.06.04-.12.09-.17.14\"/><path d=\"M35.12,1.48c-.08.18-.12.38-.12.59,0,.84.68,1.52,1.52,1.52s1.52-.68,1.52-1.52c0-.21-.04-.41-.12-.59-.08-.18-.19-.35-.33-.48-.28-.28-.66-.45-1.08-.45s-.8.17-1.08.45c-.14.14-.25.3-.33.48\"/><path d=\"M42.2,1.3c-.05.07-.09.15-.13.23-.07.17-.11.35-.11.53,0,.28.09.55.23.77.25.37.66.61,1.14.61.1,0,.19,0,.28-.03.27-.05.51-.19.7-.37.06-.06.12-.13.17-.2.1-.15.17-.31.21-.49.02-.09.03-.18.03-.28s0-.19-.03-.28c-.02-.09-.05-.17-.08-.26-.04-.08-.08-.16-.13-.23-.05-.07-.11-.14-.17-.2-.19-.19-.43-.32-.7-.37-.09-.02-.18-.03-.28-.03-.38,0-.72.15-.97.4-.06.06-.12.13-.17.2\"/><path d=\"M83.65,1.66s-.05.08-.07.13c-.04.09-.06.19-.06.29,0,.15.05.3.13.41.13.2.36.33.62.33.05,0,.1,0,.15-.01.15-.03.28-.1.38-.2.03-.03.06-.07.09-.11.05-.08.09-.17.11-.26,0-.05.01-.1.01-.15s0-.1-.01-.15c-.01-.05-.03-.1-.04-.14-.02-.04-.04-.09-.07-.13-.03-.04-.06-.08-.09-.11-.1-.1-.23-.17-.38-.2-.05-.01-.1-.01-.15-.01-.21,0-.39.08-.53.22-.03.03-.06.07-.09.11\"/><path d=\"M38.49,5.48c0,.8.65,1.45,1.45,1.45s1.45-.65,1.45-1.45-.65-1.45-1.45-1.45-1.45.65-1.45,1.45\"/><path d=\"M52.4,5.48c0,.65.53,1.18,1.18,1.18s1.18-.53,1.18-1.18-.53-1.18-1.18-1.18-1.18.53-1.18,1.18\"/><path d=\"M73.17,5.48c0,.48.39.87.87.87s.87-.39.87-.87-.39-.87-.87-.87-.87.39-.87.87\"/><path d=\"M31.51,5.48c0,.89.72,1.6,1.6,1.6s1.6-.72,1.6-1.6-.72-1.6-1.6-1.6-1.6.72-1.6,1.6\"/><path d=\"M10.47,5.48c0,1.2.98,2.18,2.18,2.18s2.18-.98,2.18-2.18-.98-2.18-2.18-2.18-2.18.98-2.18,2.18\"/><path d=\"M17.5,5.48c0,1.09.88,1.97,1.97,1.97s1.97-.88,1.97-1.97-.88-1.97-1.97-1.97-1.97.88-1.97,1.97\"/></svg>"}).map(([side, svg]) => [side, `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`]));

  function pictogramPreview(iconRecord, side, selected = false) {
    const library = window.SmoofPictogramLibrary;
    const previewUrl = iconRecord?.id === 'dots'
      ? standardPictogramPreviews[side === 'right' ? 'right' : 'left']
      : library?.dataUrl?.(iconRecord?.id, side) || '';
    const style = previewUrl
      ? ` style="--smoof-pictogram-image:url(&quot;${escapeHtml(previewUrl)}&quot;)"`
      : '';
    return `<span data-smoof-ui-pictogram-preview data-selected="${String(selected)}" data-raster="${String(iconRecord?.raster === true)}"${style}></span>`;
  }

  function alignActivePictogramCategory(container) {
    requestAnimationFrame(() => {
      const active = container?.querySelector?.('[data-smoof-ui-pictogram-category][data-active="true"]');
      active?.scrollIntoView?.({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    });
  }

  function rememberPictogramCategoryScroll(container, key) {
    const tabs = container?.querySelector?.('[data-smoof-ui-pictogram-tabs]');
    if (!tabs) return;
    pictogramCategoryScroll[key] = Math.max(0, Number(tabs.scrollLeft) || 0);
  }

  function restorePictogramCategoryScroll(container, key) {
    const saved = Number(pictogramCategoryScroll[key]);
    requestAnimationFrame(() => {
      const tabs = container?.querySelector?.('[data-smoof-ui-pictogram-tabs]');
      if (!tabs || !Number.isFinite(saved)) return;
      tabs.scrollLeft = Math.max(0, saved);
    });
  }

  function availablePictogramCategories(side) {
    const library = window.SmoofPictogramLibrary;
    if (!library?.icons?.length) return [];
    const state = window.SmoofArrowTools?.getState?.(side);
    const current = library.get?.(state?.symbol);
    return Object.keys(library.categories).filter(id => {
      if (id === 'custom') return Boolean(current?.custom);
      return library.icons.some(iconRecord => iconRecord.category === id);
    });
  }

  // UI-only preferences; never part of design/history or per-surface state.
  const pictogramBrowse = new Map();
  function pictogramSummary(state, side, action) {
    const library=window.SmoofPictogramLibrary;
    const current=library?.get(state?.symbol);
    if(!current)return '';
    const name=window.SmoofI18n.label(current);
    return row(t('Motiv','Symbol'),`<button type="button" data-smoof-ui-pictogram-current data-smoof-ui-action="${action}" aria-label="${escapeHtml(t('Motiv auswählen','Choose symbol') + ': ' + name)}">${pictogramPreview(current,side,true)}<span><strong>${escapeHtml(name)}</strong></span>${controlIcon('forward')}</button>`);
  }
  function arrowLabelRows(state,side) {
    const label=window.SmoofArrowLabels.resolve(state,side);
    let html=row(t('Beschriftung','Label'),stateButton('arrow-label',t('Beschriftung sichtbar','Label visible'),label.visible,t('Sichtbar','Visible'),t('Ausgeblendet','Hidden')));
    if(!label.visible)return html;
    const step=(field,value,min,max,step)=>`<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="arrow-label-${field}-minus" aria-label="${t('Verringern','Decrease')}">−</button><span data-smoof-arrow-label-value><input type="number" data-smoof-arrow-label-field="${field}" aria-label="${field==='size'?t('Schriftgröße in Prozent','Font size percent'):t('Laufweite in Prozent','Letter spacing percent')}" min="${min}" max="${max}" step="${step}" value="${Math.round(value*100)}"><small>%</small></span><button type="button" data-smoof-ui-action="arrow-label-${field}-plus" aria-label="${t('Erhöhen','Increase')}">+</button></div>`;
    const custom=window.SmoofCustomFontRegistry?.isCustomFamily?.(label.fontFamily);
    html+=row(t('Text','Text'),`<input type="text" data-smoof-arrow-label-field="text" maxlength="120" aria-label="${t('Pfeilbeschriftung','Arrow label')}" value="${escapeHtml(label.text)}">`);
    html+=row(t('Schrift','Font'),`<button type="button" data-smoof-ui-wide-button data-smoof-ui-font-button data-smoof-ui-action="text-font"><span>${escapeHtml(window.SmoofCustomFontRegistry?.labelFor?.(label.fontFamily)||label.fontFamily)}</span>${controlIcon('forward')}</button>`);
    html+=row(t('Schnitt','Style'),`<select data-smoof-ui-select="arrow-label-style" data-smoof-arrow-label-field="style" aria-label="${t('Schriftschnitt','Font style')}"${custom?' disabled':''}>${sharedFontStyleOptions(label.style,custom,label.fontFamily)}</select>`);
    html+=row(t('Schriftgröße','Font size'),step('size',label.size,50,200,5));
    html+=row(t('Laufweite','Letter spacing'),step('letterSpacing',label.letterSpacing,-10,50,1));
    html+=hexColorRow(t('Textfarbe','Text colour'),'arrow-label-color',state.labelColor);
    html+=`<small data-smoof-ui-control-note>${t('Die Beschriftung bleibt am Pfeil. Bei Platzmangel wird sie passend verkleinert.','The label stays attached to the arrow and is reduced to fit when necessary.')}</small>`;
    html+=`<small role="status" data-smoof-arrow-label-status></small>`;
    return html;
  }
  window.addEventListener('smoof:arrow-label-status',event=>{
    if(selectedId!==`arrow-${event.detail.side}`)return;
    for(const node of document.querySelectorAll('[data-smoof-arrow-label-status]'))node.textContent=event.detail.status==='error'?t('Schrift konnte nicht geladen werden. Bitte Verbindung prüfen oder eine andere Schrift wählen.','Could not load font. Check your connection or choose another font.'):event.detail.status==='loading'?t('Schrift wird geladen …','Loading font …'):'';
  });
  function pictogramRow(state,side){return pictogramSummary(state,side,'pictogram-picker-toggle');}
  function customPictogramRow(state,itemId){return pictogramSummary(state,state.mirrored?'right':'left','custom-pictogram-picker-toggle');}

  function openPictogramPicker(itemId, adding=false) {
    const library=window.SmoofPictogramLibrary;
    if(!library?.icons?.length)return;
    const primary=/^arrow-(left|right)$/.test(itemId);
    const side=primary?itemId.split('-')[1]:'left';
    const tools=primary?window.SmoofArrowTools:window.SmoofCustomPictogramTools;
    const current=adding?null:tools?.getState?.(primary?side:itemId);
    if(!tools||(!adding&&!current))return;
    const currentIcon=library.get(current?.symbol);
    const language=window.SmoofI18n.locale();
    const prefKey=adding?'add':itemId;
    const pref=pictogramBrowse.get(prefKey)||{query:'',category:adding?'all':currentIcon?.category||'all',scroll:0};
    pictogramBrowse.set(prefKey,pref);
    const element=document.createElement('section');element.dataset.smoofPictoPicker='';
    element.innerHTML=`<div data-smoof-picto-filters><label>${t('Suche','Search')}<input type="search" data-smoof-picto-search placeholder="${t('z. B. WLAN, Essen, Pfeil','e.g. Wi-Fi, food, arrow')}" aria-label="${t('Piktogramme suchen','Search pictograms')}" autocomplete="off"></label><label>${t('Kategorie','Category')}<span data-smoof-ui-select-wrap><select data-smoof-ui-select data-smoof-picto-category aria-label="${t('Kategorie','Category')}"></select><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m6 9 6 6 6-6"/></svg></span></label><p data-smoof-picto-count role="status"></p></div><div data-smoof-picto-results><div data-smoof-picto-grid></div><p data-smoof-picto-empty hidden>${t('Keine passenden Motive. Versuchen Sie einen anderen Suchbegriff oder eine andere Kategorie.','No matching symbols. Try another search or category.')}</p></div><div data-smoof-picto-footer><button type="button" data-smoof-picto-upload>${t('Eigenes Piktogramm hochladen','Upload custom pictogram')}</button><input type="file" accept=".svg,.png,image/svg+xml,image/png" data-smoof-picto-file hidden><p data-smoof-picto-status role="status">${t('SVG bis 600 KB · PNG bis 500 KB und 1.000 × 1.000 px.','SVG up to 600 KB · PNG up to 500 KB and 1,000 × 1,000 px.')}</p></div>`;
    const search=element.querySelector('[data-smoof-picto-search]'),category=element.querySelector('select'),grid=element.querySelector('[data-smoof-picto-grid]'),scroller=element.querySelector('[data-smoof-picto-results]'),status=element.querySelector('[data-smoof-picto-status]'),upload=element.querySelector('[data-smoof-picto-upload]'),fileInput=element.querySelector('[data-smoof-picto-file]');
    const fold=value=>String(value||'').toLocaleLowerCase(language).normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/ß/g,'ss');
    const synonyms={arrows:'pfeil arrow richtung direction',underlines:'unterstreichen underline linie strich line schwung',digital:'handy smartphone qr scan',payment:'bezahlen zahlung payment',order:'bestellen abholen order pickup',food:'essen trinken food drinks restaurant gastronomie',hospitality:'hotel hotellerie hospitality',reviews:'bewertung rating sterne stars',decoration:'deko dekoration decoration schmuck',highlights:'hervorhebung betonung highlight akzent',lettering:'schriftzug schrift wort lettering',custom:'eigene upload custom'};
    const aliases={wifi:'wifi wi-fi internet wlan',contactless:'nfc kontaktlos',receipt:'rechnung quittung beleg', 'room-key':'zimmer schluessel schlüssel', 'smoof-fork-left':'essen food besteck restaurant','smoof-knife-right':'trinken drinks besteck restaurant','handdrawn-element-emoji':'smiley smile gesicht','handdrawn-element-love':'liebe love herz'};
    const title=record=>window.SmoofI18n.label(record)||record.id;
    const records=[...library.icons,...(library.listCustom?.(current?.symbol)||[])].map(record=>({record,text:fold([record.de,record.en,record.it,record.keywords,aliases[record.id],synonyms[record.category],library.categories[record.category]?.de,library.categories[record.category]?.en,library.categories[record.category]?.it].join(' '))}));
    const names=Object.keys(library.categories).filter(id=>records.some(x=>x.record.category===id));
    if(!names.includes(pref.category))pref.category='all';
    category.innerHTML=`<option value="all">${t('Alle Kategorien','All categories')}</option>`+names.map(id=>`<option value="${escapeHtml(id)}">${escapeHtml(library.categories[id][language]||id)}</option>`).join('');
    category.value=pref.category;search.value=pref.query;
    let alive=true,busy=false,leave=null,viewportPanel=null,scrollCleanup=null;
    const viewport=window.visualViewport;
    const syncViewport=()=>{if(!alive||!viewportPanel||!viewport||viewport.scale!==1)return;element.toggleAttribute('data-smoof-picto-compact',viewport.height<520);viewportPanel.style.setProperty('--smoof-picto-viewport-height',`${Math.max(0,viewport.height-12)}px`);viewportPanel.style.setProperty('--smoof-picto-keyboard-bottom',`${Math.max(0,innerHeight-viewport.offsetTop-viewport.height)}px`);};
    const cleanup=()=>{alive=false;pref.scroll=scroller.scrollTop;scrollCleanup?.();viewport?.removeEventListener('resize',syncViewport);viewport?.removeEventListener('scroll',syncViewport);viewportPanel?.style.removeProperty('--smoof-picto-viewport-height');viewportPanel?.style.removeProperty('--smoof-picto-keyboard-bottom');return true;};
    const valid=()=>alive&&element.isConnected&&selectedId===itemId&&personalizedDesignSelected();
    const setBusy=value=>{busy=value;element.setAttribute('aria-busy',String(value));upload.disabled=value;grid.querySelectorAll('button').forEach(b=>b.disabled=value);};
    const strictVector=source=>{try{const doc=new DOMParser().parseFromString(source,'image/svg+xml');return doc.documentElement.localName==='svg'&&!doc.querySelector('parsererror,image,text,tspan,foreignObject,script,video,canvas,iframe')&&!/url\(\s*["']?(?!#)/i.test(source)&&![...doc.querySelectorAll('*')].some(n=>[...n.attributes].some(a=>(/^(?:href|xlink:href)$/i.test(a.name)&&a.value&&!a.value.startsWith('#'))||/^on/i.test(a.name)));}catch(_){return false;}};
    const choose=record=>{
      if(!valid()||busy)return false;
      if(laserMonochromeActive()&&(record.raster||(record.custom&&!strictVector(record.source)))){status.textContent=t('Für Laser verwenden Sie bitte ein reines Vektor-SVG.','Please use a vector-only SVG for laser engraving.');return false;}
      let applied;
      if(adding){applied=tools.add(record.id);if(!applied){status.textContent=t('Alle drei zusätzlichen Piktogramme sind bereits belegt.','All three additional pictogram slots are in use.');return false;}}
      else if(record.custom)applied=primary?tools.setCustomSymbol(side,record.source,title(record)):tools.setCustomSymbol(itemId,record.source,title(record));
      else applied=tools.setSymbol(primary?side:itemId,record.id);
      if(!applied){status.textContent=t('Dieses Motiv konnte nicht übernommen werden.','This symbol could not be applied.');return false;}
      const prior={id:itemId,layers:layersOpen,page:layersPage,scroll:0};
      cleanup();leave?.();
      if(adding){selectedId=applied.id;if(layersOpen)layersPage='detail';panelRouteStack.push({...prior,to:selectedId});routingPanel=true;dispatchSelection(selectedId,{openContext:true,forceContext:true});routingPanel=false;if(layersOpen)renderLayers();else renderContext();}
      scheduleHistoryCapture(120);
      return true;
    };
    const render=()=>{
      pref.query=search.value;pref.category=category.value;
      const terms=fold(pref.query).split(/\s+/).filter(Boolean);
      const matches=records.filter(x=>(pref.category==='all'||x.record.category===pref.category)&&terms.every(term=>x.text.includes(term))).map(x=>x.record).sort((a,b)=>title(a).localeCompare(title(b),language,{numeric:true}));
      grid.innerHTML=matches.map(record=>`<button type="button" data-smoof-picto-choice="${escapeHtml(record.id)}" aria-pressed="${String(record.id===current?.symbol)}"${busy?' disabled':''}>${pictogramPreview(record,primary?side:current?.mirrored?'right':'left',record.id===current?.symbol)}<span>${escapeHtml(title(record))}</span></button>`).join('');
      element.querySelector('[data-smoof-picto-empty]').hidden=matches.length>0;
      element.querySelector('[data-smoof-picto-count]').textContent=`${matches.length} ${t(matches.length===1?'Motiv':'Motive',matches.length===1?'symbol':'symbols')}`;
    };
    search.addEventListener('input',()=>{pref.scroll=0;render();scroller.scrollTop=0;});category.addEventListener('change',()=>{pref.scroll=0;render();scroller.scrollTop=0;});
    grid.addEventListener('click',event=>{const button=event.target.closest('[data-smoof-picto-choice]');if(button){event.stopPropagation();choose(library.get(button.dataset.smoofPictoChoice));}});
    upload.addEventListener('click',()=>{fileInput.value='';fileInput.click();});
    fileInput.addEventListener('change',async()=>{
      const file=fileInput.files?.[0];if(!file||!valid())return;
      const png=/\.png$/i.test(file.name)||file.type==='image/png',svg=/\.svg$/i.test(file.name)||file.type==='image/svg+xml';
      if((!svg&&!png)||file.size>(png?500000:600000)){status.textContent=t('Bitte ein SVG bis 600 KB oder PNG bis 500 KB auswählen.','Please choose an SVG up to 600 KB or PNG up to 500 KB.');return;}
      if(png&&laserMonochromeActive()){status.textContent=t('Für Laser verwenden Sie bitte ein reines Vektor-SVG.','Please use a vector-only SVG for laser engraving.');return;}
      setBusy(true);status.textContent=t('Datei wird geprüft …','Checking file …');
      try{
        const name=file.name.replace(/\.(svg|png)$/i,'');let record;
        if(png){
          const data=await new Promise((resolve,reject)=>{const reader=new FileReader();reader.onload=()=>resolve(String(reader.result));reader.onerror=reject;reader.readAsDataURL(file);});
          const image=await new Promise((resolve,reject)=>{const image=new Image();image.onload=()=>resolve(image);image.onerror=reject;image.src=data;});
          if(!valid())return;
          if(image.naturalWidth>1000||image.naturalHeight>1000)throw new Error(t('Das PNG darf maximal 1.000 × 1.000 Pixel groß sein.','PNG dimensions must not exceed 1,000 × 1,000 pixels.'));
          if(laserMonochromeActive())throw new Error(t('Für Laser verwenden Sie bitte ein reines Vektor-SVG.','Please use a vector-only SVG for laser engraving.'));
          record=library.registerRaster(data,name,image.naturalWidth,image.naturalHeight);
        }else{
          const text=await file.text();if(!valid())return;
          if(laserMonochromeActive()&&!strictVector(text))throw new Error(t('Für Laser verwenden Sie bitte ein reines Vektor-SVG.','Please use a vector-only SVG for laser engraving.'));
          record=library.registerCustom(text,name);
        }
        if(!record)throw new Error(t('Diese Datei konnte nicht als Piktogramm verwendet werden.','This file could not be used as a pictogram.'));
        setBusy(false);pref.category='custom';pref.query='';pref.scroll=0;choose(record);
      }catch(error){if(valid())status.textContent=error?.message||t('Die Datei konnte nicht gelesen werden.','The file could not be read.');}
      finally{if(valid())setBusy(false);fileInput.value='';}
    });
    render();
    leave=mountPanelSubview({element,title:adding?t('Piktogramm hinzufügen','Add pictogram'):t('Motiv auswählen','Choose symbol'),kind:'pictogram',onBack:cleanup});
    if(!leave){cleanup();return;}
    viewportPanel=element.closest('[data-smoof-ui-subview]');
    scrollCleanup=installPanelScrollAffordance(element,{scroller,collapseWhenContentFits:true,label:t('Weitere Motive anzeigen','Show more symbols')});
    element.querySelector('[data-smoof-picto-footer]').before(element.querySelector('[data-smoof-ui-scroll-affordance]'));
    viewport?.addEventListener('resize',syncViewport);viewport?.addEventListener('scroll',syncViewport);syncViewport();
    requestAnimationFrame(()=>{if(!valid())return;scroller.scrollTop=pref.scroll;focusCategorySelect(category);});
  }
  function scalePropertyName(itemId) {
    if (/^text-[0-2]$/.test(itemId)) {
      return `properties[_SMOOF Text ${Number(itemId.split('-')[1]) + 1} Skalierung]`;
    }
    if (itemId === 'logo') return 'properties[_SMOOF Logo Skalierung]';
    if (itemId === 'logo-copy') return 'properties[_SMOOF Logo 1 Duplikat Skalierung]';
    if (itemId === 'logo-2') return 'properties[_SMOOF Logo 2 Skalierung]';
    if (itemId === 'arrow-left') return 'properties[_SMOOF Piktogramm links Skalierung]';
    if (itemId === 'arrow-right') return 'properties[_SMOOF Piktogramm rechts Skalierung]';
    if (itemId === 'table-number') return 'properties[_SMOOF Nummer Skalierung]';
    if (itemId === 'qr') return 'properties[_SMOOF QR Skalierung]';
    return '';
  }

  function currentScalePercent(itemId = selectedId) {
    if (/^custom-pictogram-[1-3]$/.test(itemId)) {
      const scale = Number(window.SmoofCustomPictogramTools?.getState?.(itemId)?.scale);
      return Math.round((Number.isFinite(scale) ? scale : 1) * 100);
    }
    if (/^custom-text-[1-3]$/.test(itemId)) {
      const scale = Number(window.SmoofCustomTextTools?.getState?.(itemId)?.scale);
      return Math.round((Number.isFinite(scale) ? scale : 1) * 100);
    }
    const propertyName = scalePropertyName(itemId);
    const productForm = Array.from(document.querySelectorAll('form[action*="/cart/add"]'))
      .find(form => form.querySelector('button[type="submit"]'));
    const values = propertyName
      ? Array.from((productForm || document).querySelectorAll('input')).filter(input => input.name === propertyName)
      : [];
    const value = values.map(input => Number.parseFloat(input.value)).find(Number.isFinite);
    return Math.round((Number.isFinite(value) ? value : 1) * 100);
  }

  function syncScaleReadout(panel, itemId) {
    const output = panel?.querySelector('[data-smoof-ui-scale-value]');
    if (output) output.textContent = `${currentScalePercent(itemId)}%`;
  }

  function sizeRow(kind) {
    return row(t('Größe', 'Size'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="${kind}-minus" aria-label="${t('Verkleinern', 'Decrease')}">−</button><span data-smoof-ui-scale-value>${currentScalePercent()}%</span><button type="button" data-smoof-ui-action="${kind}-plus" aria-label="${t('Vergrößern', 'Increase')}">+</button></div>`);
  }

  function opacityRow(itemId = selectedId) {
    if (/^custom-pictogram-[1-3]$/.test(itemId)) {
      const opacity = Number(window.SmoofCustomPictogramTools?.getState?.(itemId)?.opacity);
      return row(t('Deckkraft', 'Opacity'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="opacity-minus" aria-label="${t('Deckkraft reduzieren', 'Decrease opacity')}">−</button><span data-smoof-ui-opacity-value>${Math.round((Number.isFinite(opacity) ? opacity : 1) * 100)}%</span><button type="button" data-smoof-ui-action="opacity-plus" aria-label="${t('Deckkraft erhöhen', 'Increase opacity')}">+</button></div>`);
    }
    if (/^custom-text-[1-3]$/.test(itemId)) {
      const opacity = Number(window.SmoofCustomTextTools?.getState?.(itemId)?.opacity);
      return row(t('Deckkraft', 'Opacity'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="opacity-minus" aria-label="${t('Deckkraft reduzieren', 'Decrease opacity')}">−</button><span data-smoof-ui-opacity-value>${Math.round((Number.isFinite(opacity) ? opacity : 1) * 100)}%</span><button type="button" data-smoof-ui-action="opacity-plus" aria-label="${t('Deckkraft erhöhen', 'Increase opacity')}">+</button></div>`);
    }
    if (!window.SmoofLayerOpacityTools?.supports?.(itemId)) return '';
    const opacity = window.SmoofLayerOpacityTools.get(itemId);
    return row(t('Deckkraft', 'Opacity'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="opacity-minus" aria-label="${t('Deckkraft reduzieren', 'Decrease opacity')}">−</button><span data-smoof-ui-opacity-value>${Math.round(opacity * 100)}%</span><button type="button" data-smoof-ui-action="opacity-plus" aria-label="${t('Deckkraft erhöhen', 'Increase opacity')}">+</button></div>`);
  }

  function logoColourRows(id) {
    const value = window.SmoofLogoColourTools?.get?.(id);
    if (!value?.isSvg) return '';
    return row(t('SVG-Farbe', 'SVG colour'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="logo-colour-toggle"><span>${value.enabled ? t('Einfarbig', 'Single colour') : t('Originalfarben', 'Original colours')}</span><small>${value.enabled ? t('Original verwenden', 'Use original') : t('Einfärben', 'Recolour')}</small></button>`) + hexColorRow(t(window.SmoofI18n.legacy('Farbe'), 'Colour'), 'logo-colour', value.color);
  }

  function logoBackgroundRows(itemId = selectedId) {
    const background = window.SmoofLogoBackgroundTools?.get?.(itemId);
    if (!background) return '';
    const shapeOptions = [
      ['rectangle', t('Rechteckig', 'Rectangular')],
      ['rounded', t('Abgerundete Ecken', 'Rounded corners')],
      ['circle', t('Rund', 'Round')]
    ].map(([value, label]) => `<option value="${value}"${background.shape === value ? ' selected' : ''}>${label}</option>`).join('');
    return row(t('Fläche', 'Fill'), stateButton('logo-background-toggle', t('Fläche', 'Fill'), background.enabled, t('An', 'On'), t('Aus', 'Off'))) +
      (background.enabled
        ? row(t('Form', 'Shape'), `<select data-smoof-ui-select="logo-background-shape" aria-label="${t('Hintergrundform', 'Background shape')}">${shapeOptions}</select>`) +
          colorRowValue(t('Flächenfarbe', 'Background colour'), 'logo-background-color', background.color) +
          row(t('Innenabstand', 'Padding'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="logo-background-padding-minus">−</button><span data-smoof-ui-logo-padding-value>${Math.round(background.padding * 100)}%</span><button type="button" data-smoof-ui-action="logo-background-padding-plus">+</button></div>`)
        : '');
  }

  function curvedTextRow(id) {
    const state=id.startsWith('custom-')?window.SmoofCustomTextTools?.getState(id):window.SmoofTextTools?.getPillState(Number(id.split('-')[1]));
    const mode=state?.textShape?.mode||'straight';
    const label = mode==='circle'?t('Kreis','Circle'):mode==='arc'?t('Bogen','Arc'):t('Gerade','Straight');
    return row(t('Textform','Text shape'),`<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="text-shape" aria-label="${escapeHtml(t('Textform anpassen','Adjust text shape') + ': ' + label)}"><span>${label}</span>${controlIcon('forward')}</button>`);
  }
  function originalColourRow(state, action) {
    const laser = window.SmoofBrandArtwork?.isLaser();
    return row(t('Markenfarben', 'Brand colours'), laser
      ? `<span data-smoof-ui-locked-note>${t('Laser · Schwarz', 'Laser · Black')}</span>`
      : state.originalColours === false
        ? `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="${action}">${t('Originalfarben verwenden', 'Use original colours')}</button>`
        : `<span data-smoof-ui-locked-note>${t('Originalfarben', 'Original colours')}</span>`);
  }

  function catalogueGroups(items) {
    const variants = {
      'google-wordmark': ['Google', 'text'], google: ['Google', 'symbol'],
      'paypal-wordmark': ['PayPal', 'text'], paypal: ['PayPal', 'symbol'],
      'mastercard-wordmark': ['Mastercard', 'logo'], mastercard: ['Mastercard', 'symbol'],
      'apple-pay-wordmark': ['Apple Pay', 'logo'], 'apple-pay': ['Apple Pay', 'card'],
      'twint-symbol': ['TWINT', 'symbol'], 'twint-logo': ['TWINT', 'logo'], twint: ['TWINT', 'text']
    };
    const groups = new Map();
    items.forEach(item => {
      const [brand, variant] = item.brand ? [item.brand, item.variant || ''] : variants[item.id] || [window.SmoofI18n.legacy(item.label), items.find(entry => entry.monochrome?.id === item.id)?.variant || ''];
      if (!groups.has(brand)) groups.set(brand, []);
      groups.get(brand).push({ item, variant });
    });
    const order = ['symbol', 'text', 'logo', 'card', ''];
    return [...groups].sort(([a], [b]) => a.localeCompare(b, 'de', { sensitivity: 'base' }))
      .map(([brand, choices]) => ({ brand, choices: choices.sort((a,b) => order.indexOf(a.variant) - order.indexOf(b.variant) || Number(Boolean(a.item.original)) - Number(Boolean(b.item.original))) }));
  }

  function cataloguePicker(items, selected, kind) {
    return `<div data-smoof-ui-catalogue>${catalogueGroups(items).map(({ brand, choices }) =>
      `<section data-smoof-ui-catalogue-brand="${escapeHtml(brand)}"><strong>${escapeHtml(brand)}</strong><div data-smoof-ui-catalogue-choices>${choices.map(({ item, variant }) => {
        const names = { symbol: t('Symbol', 'Symbol'), text: t('Text', 'Text'), logo: t('Logo', 'Logo'), card: t('Rahmen', 'Framed') };
        const full = { symbol: t('Symbol', 'Symbol'), text: t('Schriftzug', 'Wordmark'), logo: t('Symbol mit Schriftzug', 'Symbol and wordmark'), card: t('Logo mit Rahmen', 'Framed logo') };
        const title = brand + (variant ? ' – ' + full[variant] : '') + (item.original ? ' · ' + t('Originalfarben','Original colours') : '');
        const originalPreview = item.original ? window.SmoofBrandArtwork?.create(item, {}) : null;
        const previewItem = window.SmoofBrandArtwork?.resolve(item, {}) || item;
        const preview = originalPreview ? originalPreview.outerHTML : previewItem.path
          ? `<svg viewBox="${escapeHtml(previewItem.viewBox || '0 0 24 24')}" aria-hidden="true"><path d="${escapeHtml(previewItem.path)}" fill-rule="${previewItem.fillRule === 'evenodd' ? 'evenodd' : 'nonzero'}"/></svg>`
          : `<span data-smoof-ui-catalogue-word aria-hidden="true">${escapeHtml(item.label)}</span>`;
        return `<label data-smoof-ui-${kind}-option title="${escapeHtml(title)}"><input type="checkbox" data-smoof-ui-${kind === 'payment' ? 'payment-provider' : 'social-platform'}="${item.id}" aria-label="${escapeHtml(title)}"${selected.has(item.id) ? ' checked' : ''}><span data-smoof-ui-catalogue-preview${item.original ? ' data-smoof-original-preview' : ''}>${preview}</span>${choices.length > 1 ? `<small>${names[variant] || ''}${item.original ? `<span data-smoof-original-label>${t('Original','Original')}</span>` : ''}</small>` : ''}</label>`;
      }).join('')}</div></section>`
    ).join('')}</div>`;
  }

  function paymentProviderGrid(state) {
    return cataloguePicker(window.SmoofPaymentProviderLibrary?.providers || [], new Set(state.selected || []), 'payment');
  }

  function socialPlatformGrid() {
    const items = window.SmoofSocialPlatformLibrary?.items || [];
    const selected = new Set(Object.keys(window.SmoofSocialPlatformTools?.getState?.().objects || {}));
    return [['reviews', t('Bewertungen', 'Reviews')], ['social', t('Social Media', 'Social media')], ['platforms', t('Plattformen', 'Platforms')]]
      .map(([category, label]) => `<section data-smoof-ui-social-category><strong>${label}</strong>${cataloguePicker(items.filter(item => item.category === category), selected, 'social')}</section>`).join('');
  }

  function resetButton(kind) {
    return `<div data-smoof-ui-actions data-single="true"><button type="button" data-smoof-ui-icon-button data-smoof-ui-action="${kind}-reset">${icon('reset')} ${t('Position und Größe zurücksetzen', 'Reset position and size')}</button></div>`;
  }

  function detailBody(descriptor) {
    if (!descriptor) return '';
    if (descriptor.kind === 'guides') {
      const native = document.querySelector('[data-smoof-guide-visibility-button]');
      const guides = window.SmoofAlignmentGuides;
      const options = [
        ['measurements', t('Bemaßung und Sicherheitszonen', 'Measurements and safety zones'), native?.dataset.active === 'true' || native?.getAttribute('aria-pressed') === 'true', Boolean(native)],
        ['y', t('Horizontale Fanglinien', 'Horizontal snapping guides'), guides?.isAxisEnabled?.('y') !== false, Boolean(guides?.setAxisEnabled)],
        ['x', t('Vertikale Fanglinien', 'Vertical snapping guides'), guides?.isAxisEnabled?.('x') !== false, Boolean(guides?.setAxisEnabled)]
      ];
      return `<div data-smoof-ruler-options>${options.map(([key, label, checked, ready]) =>
        `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="guide-toggle:${key}" role="switch" aria-label="${label}" aria-checked="${checked}"${ready ? '' : ' disabled'}><span>${label}</span><span data-smoof-ui-state-switch aria-hidden="true"><span data-smoof-switch-knob></span></span></button>`
      ).join('')}</div><p data-smoof-ruler-hint>${t('Fanglinien rasten Elemente beim Ziehen ein. Wählen Sie ein Element und verschieben Sie es mit den Pfeiltasten fein; mit Umschalt in größeren Schritten.', 'Snapping guides align elements while dragging. Select an element and use the arrow keys for fine movement; hold Shift for larger steps.')}</p>`;
    }
    if (descriptor.kind === 'add') {
      const secondLogo = window.SmoofLogoDuplicateTools?.getState?.() || { hasLogo: false };
      const payments = window.SmoofPaymentTools?.getState?.() || { selected: [] };
      const customTextCount = Number(window.SmoofCustomTextTools?.count?.()) || 0;
      const customPictogramCount = Number(window.SmoofCustomPictogramTools?.count?.()) || 0;
      const items = [
        {
          id: 'logo-2',
          symbol: 'image',
          title: t('Zweites Logo', 'Second logo'),
          copy: t('Eine eigenständige Logodatei hinzufügen', 'Add an independent logo file'),
          available: Boolean(window.SmoofLogoDuplicateTools && !secondLogo.hasLogo)
        },
        {
          id: 'payments',
          symbol: 'payment',
          title: t('Zahlungsanbieter', 'Payment providers'),
          copy: payments.visible === false && payments.selected?.length
            ? t('Gespeicherte Logos wieder einblenden und bearbeiten', 'Show and edit saved provider logos')
            : t('Logos auswählen und gestalten', 'Choose and style provider logos'),
          available: Boolean(window.SmoofPaymentTools && (payments.visible === false || !payments.selected?.length))
        },
        {
          id: 'social-platforms',
          symbol: 'social',
          title: t('Social Media & Plattformen', 'Social media & platforms'),
          copy: t('Bewertungen, Netzwerke und Kontaktwege', 'Reviews, networks and contact channels'),
          available: Boolean(window.SmoofSocialPlatformTools)
        },
        {
          id: 'custom-text',
          symbol: 'text',
          title: t('Text hinzufügen', 'Add text'),
          copy: t('Bis zu drei zusätzliche Textbereiche', 'Up to three additional text areas'),
          available: Boolean(window.SmoofCustomTextTools && customTextCount < 3)
        },
        {
          id: 'custom-pictogram',
          symbol: 'arrows',
          title: t('Piktogramm hinzufügen', 'Add pictogram'),
          copy: `${customPictogramCount} / 3 ${t('zusätzliche Piktogramme verwendet','additional pictograms used')}`,
          disabled: customPictogramCount >= 3,
          available: Boolean(window.SmoofCustomPictogramTools)
        }
      ].filter(item => item.available);
      if (!items.length) {
        return `<div data-smoof-ui-locked-note>${t('Zurzeit sind keine zusätzlichen Elemente verfügbar.', 'No additional elements are currently available.')}</div>`;
      }
      return `<div data-smoof-ui-add-list>${items.map(item => `<button type="button" data-smoof-ui-add-item data-smoof-ui-action="add-open:${item.id}"${item.disabled ? ' disabled aria-disabled="true"' : ''}><span data-smoof-ui-add-symbol>${icon(item.symbol)}</span><span data-smoof-ui-add-copy><strong>${escapeHtml(item.title)}</strong><small>${escapeHtml(item.copy)}</small></span>${controlIcon(item.id === 'logo-2' ? 'upload' : item.id === 'custom-text' ? 'add' : 'forward')}</button>`).join('')}</div>`;
    }
    if (descriptor.kind === 'templates') {
      const library = window.SmoofTemplateLibrary;
      const language = window.SmoofI18n.locale();
      const languageGate = library?.languageSelectionEnabled === true;
      const languages = library?.listLanguages?.() || [];
      const selectedLanguage = languages.find(item => item.id === library?.selectedLanguage);
      if (languageGate && !selectedLanguage) {
        const options = languages.map(item => {
          const countLabel = item.count === 1 ? t('Vorlage', 'template') : t('Vorlagen', 'templates');
          return '<button type="button" data-smoof-ui-language-option data-smoof-ui-action="template-language:' + escapeHtml(item.id) + '"><span><strong>' +
            escapeHtml(window.SmoofI18n.label(item)) + '</strong><small>' + item.count + ' ' + countLabel +
            '</small></span>' + controlIcon('forward') + '</button>';
        }).join('');
        return '<div data-smoof-ui-language-step><strong>' + t('Sprache der Vorlage wählen', 'Choose the template language') +
          '</strong><p>' + t('In welcher Sprache soll Ihr Design sein?', 'Which language should your design use?') +
          '</p><div data-smoof-ui-language-options>' + options + '</div>' +
          (!options ? '<p role="status">' + t('Zurzeit sind keine Vorlagensprachen verfügbar.', 'No template languages are currently available.') + '</p>' : '') + '</div>';
      }
      const categories = library?.listCategories?.() || library?.categories || [];
      if (templateCategory && !categories.some(category => category.id === templateCategory)) templateCategory = '';
      const available = library?.list?.(templateCategory) || [];
      const categoryOptions = [
        { id: '', de: 'Alle', en: 'All' },
        ...categories
      ].map(category => `<option value="${escapeHtml(category.id)}"${templateCategory === category.id ? ' selected' : ''}>${escapeHtml(window.SmoofI18n.label(category))}</option>`).join('');
      const cards = available.map(template => {
        const title = typeof template.title === 'object' ? window.SmoofI18n.label(template.title) : template.title;
        const description = typeof template.description === 'object' ? window.SmoofI18n.label(template.description) : template.description;
        const preview = template.preview
          ? `<img src="${escapeHtml(template.preview)}" alt="" loading="lazy">`
          : `<span data-smoof-ui-template-placeholder>${icon('templates')}</span>`;
        return `<button type="button" data-smoof-ui-template-card data-smoof-ui-action="template-apply:${escapeHtml(template.id)}" aria-label="${escapeHtml(t('Vorlage verwenden', 'Use template') + ': ' + title)}">${preview}<span data-smoof-template-copy><strong>${escapeHtml(title)}</strong>${description ? `<small>${escapeHtml(description)}</small>` : ''}</span></button>`;
      }).join('');
      const customersEmpty = templateCategory === 'customers';
      const emptyTitle = languageGate ? t('Noch keine Vorlagen', 'No templates yet') : customersEmpty ? t('Kundenvorlagen folgen', 'Customer templates coming soon') : t('Vorlagen werden vorbereitet', 'Templates are being prepared');
      const emptyCopy = languageGate
        ? t('Für diese Sprache und Auswahl sind derzeit keine passenden Vorlagen verfügbar.', 'No matching templates are currently available for this language and selection.')
        : customersEmpty
        ? t('Hier finden Sie künftig die kundenspezifischen Vorlagen Ihres Partners.', 'Your partner’s customer-specific templates will appear here.')
        : t('Die ersten SMOOF-Designs erscheinen hier, sobald sie hinterlegt sind.', 'The first SMOOF designs will appear here as soon as they are added.');
      return `<label data-smoof-ui-category-field><span>${t('Kategorie', 'Category')}</span><span data-smoof-ui-select-wrap><select data-smoof-ui-select data-smoof-ui-template-category aria-label="${t('Vorlagenkategorie', 'Template category')}">${categoryOptions}</select><svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m6 9 6 6 6-6"/></svg></span></label>${cards ? `<p data-smoof-template-instruction>${escapeHtml(window.SmoofI18n.label({de:'Vorlage anklicken, um sie zu verwenden.',en:'Select a template to use it.',it:'Seleziona un modello per utilizzarlo.'}))}</p><div data-smoof-ui-template-grid>${cards}</div>` : `<div data-smoof-ui-template-empty>${icon('templates')}<strong>${emptyTitle}</strong><span>${emptyCopy}</span></div>`}`;
    }
    if (descriptor.kind === 'social-library') {
      return socialPlatformGrid() +
        `<div data-smoof-ui-locked-note>${t('Jedes Logo wird unabhängig positioniert. Originalvarianten behalten ihre Markenfarben.', 'Each logo is positioned independently. Original variants retain their brand colours.')}</div>`;
    }
    if (descriptor.kind === 'social-platform') {
      const object = window.SmoofSocialPlatformTools?.getObject?.(selectedId);
      if (!object) return '';
      return (window.SmoofSocialPlatformLibrary?.get(selectedId)?.original ? originalColourRow(object, 'social-original-colours') : hexColorRow(t(window.SmoofI18n.legacy('Farbe'), 'Colour'), 'social-platform-color', object.color)) +
        row(t('Größe', 'Size'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="social-platform-size-minus">−</button><span data-smoof-ui-social-scale>${Math.round(object.scale * 100)}%</span><button type="button" data-smoof-ui-action="social-platform-size-plus">+</button></div>`) +
        row(t('Deckkraft', 'Opacity'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="social-platform-opacity-minus">−</button><span data-smoof-ui-social-opacity>${Math.round(object.opacity * 100)}%</span><button type="button" data-smoof-ui-action="social-platform-opacity-plus">+</button></div>`) +
        resetButton('social-platform') +
        `<div data-smoof-ui-actions data-single="true"><button type="button" data-smoof-ui-icon-button data-smoof-ui-action="social-platform-delete">${icon('trash')} ${t('Logo entfernen', 'Remove logo')}</button></div>`;
    }
    if (descriptor.kind === 'downloads') {
      return row(t('Öffnen', 'Open'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="open-design"><span>${t('Datei öffnen', 'Open file')}</span><small data-smoof-ui-action-meta>.smoofdesign${controlIcon('open')}</small></button>`) +
        row(t('Design', 'Design'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="download-design"><span>${t('Design speichern', 'Save design')}</span><small data-smoof-ui-action-meta>.smoofdesign${controlIcon('download')}</small></button>`) +
        row(t('Mockup', 'Mockup'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="download-mockup"><span>${t('Mockup speichern', 'Save mockup')}</span><small data-smoof-ui-action-meta>PNG${controlIcon('download')}</small></button>`) +
        row(t('Freigabe', 'Approval'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="download-proof"><span>${t('Proof speichern', 'Save proof')}</span><small data-smoof-ui-action-meta>PDF${controlIcon('download')}</small></button>`) +
        row(t('Produktion', 'Production'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="download-production" ${window.SmoofProductionAccess?.allowed() ? '' : 'hidden disabled aria-disabled="true"'}><span>${t('Datei herunterladen', 'Download file')}</span>${controlIcon('download')}</button><div data-smoof-production-login-note ${window.SmoofProductionAccess?.allowed() ? 'hidden' : ''}><a hidden>${t('Zum Download anmelden', 'Sign in to download')}</a><p data-smoof-production-login-copy></p></div><small data-smoof-production-format></small><p role="status" aria-live="polite" data-smoof-production-status hidden></p><button type="button" data-smoof-production-login-refresh hidden>${t('Erneut prüfen', 'Check again')}</button>`);
    }
    if (descriptor.kind === 'qr') {
      const qr = window.SmoofQrGeometryTools?.getState?.() || { scale: 1 };
      const diameter = Number(window.SmoofProductVariant?.get?.()?.diameterMm) || 80;
      const sizeMm = Number(window.SmoofQrGeometryTools?.sizeMm?.(diameter)) || (29 * Number(qr.scale || 1));
      const unsafe = sizeMm < 18;
      const backingLocked = window.SmoofQrGeometryTools?.isBackingLocked?.() === true;
      const codeColorLocked = window.SmoofQrGeometryTools?.isCodeColorLocked?.() === true;
      const qrVisible = qr.visible !== false;
      const backingConfigured = !backingLocked && qr.backingVisible !== false;
      const backingVisible = qrVisible && backingConfigured;
      const backingDisabled = backingLocked || !qrVisible;
      return row('QR-Code', stateButton('qr-visibility-toggle', t('QR-Code sichtbar', 'QR code visible'), qrVisible, t('Sichtbar', 'Visible'), t('Ausgeblendet', 'Hidden'))) +
        hexColorRow(t('QR-Code-Farbe', 'QR code colour'), 'qr-code-color', codeColorLocked ? '#000000' : (qr.codeColor || '#000000'), codeColorLocked) +
        row(t('Hintergrundfläche', 'Backing panel'), stateButton('qr-backing-toggle', t('Hintergrundfläche sichtbar', 'Backing panel visible'), backingVisible, t('Sichtbar', 'Visible'), t('Ausgeblendet', 'Hidden'), backingDisabled, backingLocked ? t('Bei DOT ME fest transparent', 'Locked transparent for DOT ME') : !qrVisible ? t('Mit QR-Code ausgeblendet', 'Hidden with QR code') : '')) +
        (backingVisible ? hexColorRow(t('Flächenfarbe', 'Panel colour'), 'qr-backing-color', qr.backingColor || '#FFFFFF') : '') +
        `<div data-smoof-ui-locked-note data-smoof-ui-qr-contrast-note><strong>${t('Hinweis zur Scanbarkeit', 'Scanning guidance')}</strong><br>${t('Ein zu geringer Kontrast zwischen QR-Code und Hintergrund kann die Scanbarkeit auf einigen Geräten beeinträchtigen. Für die bestmögliche Scanbarkeit wird ein hoher Kontrast empfohlen, z. B. ein schwarzer QR-Code auf weißem Hintergrund.', 'Low contrast between the QR code and its background may affect scanning on some devices. For the best scan reliability, use high contrast, such as a black QR code on a white background.')}</div>` +
        row(t('Größe', 'Size'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="qr-scale-minus" aria-label="${t('Verkleinern', 'Decrease')}">−</button><span data-smoof-ui-qr-scale>${Math.round(Number(qr.scale || 1) * 100)}%</span><button type="button" data-smoof-ui-action="qr-scale-plus" aria-label="${t('Vergrößern', 'Increase')}">+</button></div>`) +
        `<div data-smoof-ui-locked-note${unsafe ? ' data-smoof-ui-warning="true"' : ''}><strong>${sizeMm.toFixed(1).replace('.', ',')} mm</strong>${unsafe
          ? t(' Sehr kleine QR-Codes können je nach Druck und Endgerät schlechter scanbar sein.', ' Very small QR codes may be harder to scan depending on print quality and device.')
          : t(' Wird der QR-Code ausgeblendet, verschwindet auch seine Fläche. Die Fläche kann separat ausgeblendet werden, ohne den QR-Code zu verbergen.', ' Hiding the QR code also hides its panel. The panel can be hidden separately without hiding the QR code.')}${codeColorLocked
            ? t(' Lasergravur gibt den QR-Code technisch bedingt immer schwarz aus.', ' Laser engraving always outputs the QR code in black.')
            : ''}</div>` +
        resetButton('qr');
    }
    if (!source) return `<div data-smoof-ui-locked-note>${t('Die Einstellungen dieses Elements sind momentan nicht verfügbar.', 'This element’s settings are currently unavailable.')}</div>`;
    if (descriptor.kind === 'custom-text') {
      const state = window.SmoofCustomTextTools?.getState?.(selectedId);
      if (!state) return '';
      const customFont = customFontSelected(selectedId);
      const rangeStyle=window.SmoofRichText?.selectedStyle?.(selectedId);
      const styles = sharedFontStyleOptions(rangeStyle?.fontStyle||state.fontStyle, customFont, rawFontForItem(selectedId));
      return richSelectionRow(selectedId) + row(t('Schrift', 'Font'), fontButton(fontForItem(selectedId))) +
        row(t('Schnitt', 'Style'), `<select data-smoof-ui-select="custom-text-style" aria-label="${t('Schriftschnitt', 'Font style')}"${customFont ? ' disabled' : ''}>${styles}</select>`) +
        hexColorRow(t(window.SmoofI18n.legacy('Farbe'), 'Colour'), 'custom-text-color', rangeStyle?.color||state.color) +
        curvedTextRow(selectedId) + textRotationRow(state.rotation) +
        sizeRow('custom-text') +
        letterSpacingRow(state.letterSpacing) + textAlignRow(state) +
        row(t('Pillenrahmen', 'Pill outline'), stateButton('pill-toggle', t('Pillenrahmen', 'Pill outline'), state.pillVisible, t('An', 'On'), t('Aus', 'Off'))) +
        (state.pillVisible ? hexColorRow(t('Konturfarbe', 'Outline colour'), 'pill-stroke-color', state.pillStrokeColor) +
          hexColorRow(t('Füllfarbe', 'Fill colour'), 'pill-fill-color', state.pillFillColor) +
          row(t('Füllung', 'Fill'), stateButton('pill-fill-toggle', t('Füllung farbig', 'Coloured fill'), state.pillFillVisible, t('Farbig', 'Coloured'), t('Transparent', 'Transparent'))) +
          row(t('Konturstärke', 'Outline width'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-stroke-minus">−</button><span>${Math.round(state.pillStrokeWidth * 100)}%</span><button type="button" data-smoof-ui-action="pill-stroke-plus">+</button></div>`) +
          row(t('Padding horizontal', 'Horizontal padding'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-padding-x-minus">−</button><span>${Math.round(state.pillPaddingX * 100)}%</span><button type="button" data-smoof-ui-action="pill-padding-x-plus">+</button></div>`) +
          row(t('Padding vertikal', 'Vertical padding'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-padding-y-minus">−</button><span>${Math.round(state.pillPaddingY * 100)}%</span><button type="button" data-smoof-ui-action="pill-padding-y-plus">+</button></div>`) : '') +
        opacityRow() +
        `<div data-smoof-ui-actions><button type="button" data-smoof-ui-icon-button data-smoof-ui-action="custom-text-reset">${icon('reset')} ${t('Zurücksetzen', 'Reset')}</button><button type="button" data-smoof-ui-icon-button data-smoof-ui-danger data-smoof-ui-action="custom-text-delete">${icon('trash')} ${t('Text entfernen', 'Remove text')}</button></div>`;
    }
    if (descriptor.kind === 'custom-pictogram') {
      const state = window.SmoofCustomPictogramTools?.getState?.(selectedId);
      if (!state) return '';
      const iconRecord = window.SmoofPictogramLibrary?.get?.(state.symbol);
      const isRaster = iconRecord?.raster === true;
      return customPictogramRow(state, selectedId) +
        (isRaster ? row(t('Darstellung', 'Appearance'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="custom-pictogram-color-mode"><span>${state.colorize ? t('Einfarbig', 'Single colour') : t('Originalfarben', 'Original colours')}</span><small>${state.colorize ? t('Original verwenden', 'Use original') : t('Einfarbig färben', 'Use single colour')}</small></button>`) : '') +
        (!isRaster || state.colorize ? hexColorRow(t(window.SmoofI18n.legacy('Farbe'), 'Colour'), 'custom-pictogram-color', state.color) : '') +
        row(t('Drehung', 'Rotation'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="custom-pictogram-rotation-minus">−</button><span data-smoof-ui-custom-pictogram-rotation>${Math.round(state.rotation)}°</span><button type="button" data-smoof-ui-action="custom-pictogram-rotation-plus">+</button></div>`) +
        sizeRow('custom-pictogram') +
        row(t('Spiegelung', 'Mirroring'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="custom-pictogram-mirror"><span>${state.mirrored ? t('Gespiegelt', 'Mirrored') : t('Original', 'Original')}</span><small>${t('Horizontal spiegeln', 'Mirror horizontally')}</small></button>`) +
        opacityRow() +
        `<div data-smoof-ui-actions><button type="button" data-smoof-ui-icon-button data-smoof-ui-action="custom-pictogram-reset">${icon('reset')} ${t('Zurücksetzen', 'Reset')}</button><button type="button" data-smoof-ui-icon-button data-smoof-ui-danger data-smoof-ui-action="custom-pictogram-delete">${icon('trash')} ${t('Piktogramm entfernen', 'Remove pictogram')}</button></div>`;
    }
    if (descriptor.kind === 'text') {
      const index = selectedId.split('-')[1];
      const currentFont = fontForItem(selectedId);
      const rangeStyle=window.SmoofRichText?.selectedStyle?.(selectedId);
      const customFont = customFontSelected(selectedId);
      const pill = window.SmoofTextTools?.getPillState?.(Number(index)) || { pillVisible: false, pillFillVisible: false, pillStrokeColor: '#000000', pillFillColor: '#ffffff', pillStrokeWidth: 0.05, pillPaddingX: 0.45, pillPaddingY: 0.22 };
      return richSelectionRow(selectedId) + row(t('Schrift', 'Font'), fontButton(currentFont)) +
        (rangeStyle ? row(t('Schnitt','Style'), `<select data-smoof-ui-select="text-style" aria-label="${t('Schriftschnitt','Font style')}"${customFont?' disabled':''}>${sharedFontStyleOptions(rangeStyle.fontStyle,customFont,rawFontForItem(selectedId))}</select>`) : styleRow('text-style', `[data-smoof-text-style-select="${index}"]`, customFont)) +
        (rangeStyle ? hexColorRow(t(window.SmoofI18n.legacy('Farbe'),'Colour'),'text-color',rangeStyle.color) : sourceHexColorRow(t(window.SmoofI18n.legacy('Farbe'), 'Colour'), 'text-color', `[data-smoof-text-color-input="${index}"]`)) +
        curvedTextRow(selectedId) + textRotationRow(pill.rotation) +
        sizeRow('text') +
        letterSpacingRow(pill.letterSpacing) + textAlignRow(pill) +
        row(t('Pillenrahmen', 'Pill outline'), stateButton('pill-toggle', t('Pillenrahmen', 'Pill outline'), pill.pillVisible, t('An', 'On'), t('Aus', 'Off'))) +
        (pill.pillVisible ? hexColorRow(t('Konturfarbe', 'Outline colour'), 'pill-stroke-color', pill.pillStrokeColor) +
          hexColorRow(t('Füllfarbe', 'Fill colour'), 'pill-fill-color', pill.pillFillColor) +
          row(t('Füllung', 'Fill'), stateButton('pill-fill-toggle', t('Füllung farbig', 'Coloured fill'), pill.pillFillVisible, t('Farbig', 'Coloured'), t('Transparent', 'Transparent'))) +
          row(t('Konturstärke', 'Outline width'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-stroke-minus">−</button><span>${Math.round(pill.pillStrokeWidth * 100)}%</span><button type="button" data-smoof-ui-action="pill-stroke-plus">+</button></div>`) +
          row(t('Padding horizontal', 'Horizontal padding'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-padding-x-minus">−</button><span>${Math.round(pill.pillPaddingX * 100)}%</span><button type="button" data-smoof-ui-action="pill-padding-x-plus">+</button></div>`) +
          row(t('Padding vertikal', 'Vertical padding'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-padding-y-minus">−</button><span>${Math.round(pill.pillPaddingY * 100)}%</span><button type="button" data-smoof-ui-action="pill-padding-y-plus">+</button></div>`) : '') +
        opacityRow() +
        resetButton('text');
    }
    if (descriptor.kind === 'logo') {
      const logo = window.SmoofLogoTools?.getState?.() || { hasLogo: false, fileName: '' };
      const logoCopy = window.SmoofLogoCopyTools?.getState?.() || { enabled: false };
      const logoCopyReady = Boolean(window.SmoofLogoCopyTools);
      const inverted = window.SmoofLogoInvertTools?.get?.('logo') === true;
      return (laserVectorLogoRequired()
          ? `<div data-smoof-ui-locked-note><strong>${t('SVG erforderlich', 'SVG required')}</strong><br>${t('Für die Lasergravur können ausschließlich Vektorlogos im SVG-Format hochgeladen werden.', 'Laser engraving only accepts vector logos in SVG format.')}</div>`
          : '') + sizeRow('logo') +
        (logo.hasLogo ? row(t('Darstellung', 'Appearance'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="logo-invert"><span>${inverted ? t('Farben invertiert', 'Colours inverted') : t('Originalfarben', 'Original colours')}</span><small>${inverted ? t('Original verwenden', 'Use original') : t('Invertieren', 'Invert')}</small></button>`) : '') +
        (logo.hasLogo && window.SmoofLogoCropTools?.canCrop?.() ? row(t('Ausschnitt', 'Crop'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="logo-crop"><span>${t('Logo zuschneiden', 'Crop logo')}</span>${controlIcon('forward')}</button>`) : '') +
        logoColourRows('logo') +
        (logo.hasLogo ? logoBackgroundRows('logo') : '') +
        row(t('Duplikat', 'Duplicate'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="add-open:logo-copy"${logo.hasLogo && logoCopyReady ? '' : ' disabled aria-disabled="true"'}><span>${logoCopy.enabled ? t('Duplikat bearbeiten', 'Edit duplicate') : t('Duplizieren', 'Duplicate')}</span><small data-smoof-ui-action-meta>${!logoCopyReady ? t('Lädt …', 'Loading …') : !logo.hasLogo ? t('Logo hochladen', 'Upload logo') : ''}${controlIcon(logoCopy.enabled ? 'forward' : 'add')}</small></button>`) +
        opacityRow() +
        `<div data-smoof-ui-actions><button type="button" data-smoof-ui-icon-button data-smoof-ui-action="logo-reset">${icon('reset')} ${t('Zurücksetzen', 'Reset')}</button><button type="button" data-smoof-ui-icon-button${logo.hasLogo ? ' data-smoof-ui-danger' : ''} data-smoof-ui-action="logo-file">${icon(logo.hasLogo ? 'trash' : 'image')} ${logo.hasLogo ? t('Entfernen', 'Remove') : t('Upload', 'Upload')}</button></div>`;
    }
    if (descriptor.kind === 'logo-copy') {
      const logoCopy = window.SmoofLogoCopyTools?.getState?.() || { enabled: false, hasLogo: false };
      const inverted = window.SmoofLogoInvertTools?.get?.('logo-copy') === true;
      return sizeRow('logo-copy') +
        (logoCopy.hasLogo ? row(t('Darstellung', 'Appearance'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="logo-copy-invert"><span>${inverted ? t('Farben invertiert', 'Colours inverted') : t('Originalfarben', 'Original colours')}</span><small>${inverted ? t('Original verwenden', 'Use original') : t('Invertieren', 'Invert')}</small></button>`) : '') +
        logoColourRows('logo-copy') +
        logoBackgroundRows('logo-copy') +
        opacityRow() +
        `<div data-smoof-ui-actions><button type="button" data-smoof-ui-icon-button data-smoof-ui-action="logo-copy-reset">${icon('reset')} ${t('Zurücksetzen', 'Reset')}</button><button type="button" data-smoof-ui-icon-button data-smoof-ui-danger data-smoof-ui-action="logo-copy-toggle">${icon('trash')} ${t('Duplikat entfernen', 'Remove duplicate')}</button></div>`;
    }
    if (descriptor.kind === 'logo-duplicate') {
      const secondLogo = window.SmoofLogoDuplicateTools?.getState?.() || { hasLogo: false, fileName: '' };
      const inverted = window.SmoofLogoInvertTools?.get?.('logo-2') === true;
      return (laserVectorLogoRequired()
          ? `<div data-smoof-ui-locked-note><strong>${t('SVG erforderlich', 'SVG required')}</strong><br>${t('Für die Lasergravur können ausschließlich Vektorlogos im SVG-Format hochgeladen werden.', 'Laser engraving only accepts vector logos in SVG format.')}</div>`
          : '') + sizeRow('logo-2') +
        (secondLogo.hasLogo ? row(t('Darstellung', 'Appearance'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="logo-2-invert"><span>${inverted ? t('Farben invertiert', 'Colours inverted') : t('Originalfarben', 'Original colours')}</span><small>${inverted ? t('Original verwenden', 'Use original') : t('Invertieren', 'Invert')}</small></button>`) : '') +
        logoColourRows('logo-2') +
        (secondLogo.hasLogo ? logoBackgroundRows('logo-2') : '') +
        opacityRow() + `<div data-smoof-ui-actions><button type="button" data-smoof-ui-icon-button data-smoof-ui-action="logo-2-reset">${icon('reset')} ${t('Zurücksetzen', 'Reset')}</button><button type="button" data-smoof-ui-icon-button${secondLogo.hasLogo ? ' data-smoof-ui-danger' : ''} data-smoof-ui-action="logo-2-file">${icon(secondLogo.hasLogo ? 'trash' : 'image')} ${secondLogo.hasLogo ? t('Entfernen', 'Remove') : t('Upload', 'Upload')}</button></div>`;
    }
    if (descriptor.kind === 'arrow') {
      const side = selectedId.split('-')[1];
      const state = window.SmoofArrowTools?.getState?.(side) || { rotation: 0, count: 4, symbol: 'dots', labelVisible: true, arrowColor: '#000000', labelColor: '#000000' };
      const isOriginalArrow = state.symbol === 'dots';
      const iconRecord = window.SmoofPictogramLibrary?.get?.(state.symbol);
      const isRasterPictogram = iconRecord?.raster === true;
      return `<section data-smoof-ui-control-group aria-label="${t('Motiv','Symbol')}">` + pictogramRow(state, side) +
        (isRasterPictogram ? row(t('Darstellung', 'Appearance'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="pictogram-color-mode"><span>${state.colorize ? t('Einfarbig', 'Single colour') : t('Originalfarben', 'Original colours')}</span><small>${state.colorize ? t('Original verwenden', 'Use original') : t('Einfarbig färben', 'Use single colour')}</small></button>`) : '') +
        (!isRasterPictogram || state.colorize ? hexColorRow(t('Piktogramm', 'Pictogram'), 'arrow-color', state.arrowColor) : '') +
        
        row(t('Drehung', 'Rotation'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="arrow-rotation-minus" aria-label="${t('Nach links drehen', 'Rotate left')}">−</button><span data-smoof-ui-arrow-rotation>${Math.round(state.rotation)}°</span><button type="button" data-smoof-ui-action="arrow-rotation-plus" aria-label="${t('Nach rechts drehen', 'Rotate right')}">+</button></div>`) +
        sizeRow('arrow-scale') +
        (isOriginalArrow ? row(t('Pfeilanzahl', 'Arrow count'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="arrow-count-minus" aria-label="${t('Weniger Pfeile', 'Fewer arrows')}">−</button><span data-smoof-ui-arrow-count>${state.count}</span><button type="button" data-smoof-ui-action="arrow-count-plus" aria-label="${t('Mehr Pfeile', 'More arrows')}">+</button></div>`) : '') +
        `</section>` + (isOriginalArrow ? `<section data-smoof-ui-control-group aria-label="${t('Beschriftung','Label')}">${arrowLabelRows(state,side)}</section>` : '') +
        `<section data-smoof-ui-control-group aria-label="${t('Allgemein','General')}">` + opacityRow() +
        resetButton('arrows') + `</section>`;
    }
    if (descriptor.kind === 'number') {
      const currentFont = fontForItem('table-number');
      const numberState = window.SmoofNumberHistory?.getState?.() || { letterSpacing: 0 };
      return row(t('Schrift', 'Font'), fontButton(currentFont)) +
        styleRow('number-style', '[data-smoof-number-style-select]', customFontSelected('table-number')) +
        sourceHexColorRow(t(window.SmoofI18n.legacy('Farbe'), 'Colour'), 'number-color', '[data-smoof-number-color-input]') +
        textRotationRow(numberState.rotation) +
        sizeRow('number') +
        letterSpacingRow(numberState.letterSpacing) +
        row(t('Pillenrahmen', 'Pill outline'), stateButton('pill-toggle', t('Pillenrahmen', 'Pill outline'), numberState.pillVisible, t('An', 'On'), t('Aus', 'Off'))) +
        (numberState.pillVisible ? hexColorRow(t('Konturfarbe', 'Outline colour'), 'pill-stroke-color', numberState.pillStrokeColor) +
          hexColorRow(t('Füllfarbe', 'Fill colour'), 'pill-fill-color', numberState.pillFillColor) +
          row(t('Füllung', 'Fill'), stateButton('pill-fill-toggle', t('Füllung farbig', 'Coloured fill'), numberState.pillFillVisible, t('Farbig', 'Coloured'), t('Transparent', 'Transparent'))) +
          row(t('Konturstärke', 'Outline width'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-stroke-minus">−</button><span>${Math.round(numberState.pillStrokeWidth * 100)}%</span><button type="button" data-smoof-ui-action="pill-stroke-plus">+</button></div>`) +
          row(t('Padding horizontal', 'Horizontal padding'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-padding-x-minus">−</button><span>${Math.round(numberState.pillPaddingX * 100)}%</span><button type="button" data-smoof-ui-action="pill-padding-x-plus">+</button></div>`) +
          row(t('Padding vertikal', 'Vertical padding'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="pill-padding-y-minus">−</button><span>${Math.round(numberState.pillPaddingY * 100)}%</span><button type="button" data-smoof-ui-action="pill-padding-y-plus">+</button></div>`) : '') +
        opacityRow() +
        resetButton('number');
    }
    if (descriptor.kind === 'brand') return colorRow(t(window.SmoofI18n.legacy('Farbe'), 'Colour'), 'brand-color', '[data-smoof-brand-color-input]') + opacityRow();
    if (descriptor.kind === 'nfc') {
      const nfc = window.SmoofNfcTools?.getState?.() || {
        iconColor: '#0d0d0d',
        circleColor: '#ffffff',
        circleTransparent: false
      };
      const nfcColor = (label, name, value) => colorRowValue(label, name, value);
      return nfcColor(t('Symbol', 'Icon'), 'nfc-icon-color', nfc.iconColor) +
        nfcColor(t('Kreisfläche', 'Circle fill'), 'nfc-circle-color', nfc.circleColor) +
        row(t('Hintergrund', 'Background'), nfcBackgroundChoice(!nfc.circleTransparent)) +
        opacityRow() +
        `<div data-smoof-ui-locked-note>${t('Im QR-Code rastet das NFC-Symbol ausschließlich exakt in der Mitte ein. Außerhalb der QR-Schutzzone ist es frei platzierbar.', 'Inside the QR code the NFC icon snaps exactly to the centre. Outside the QR protection zone it can be positioned freely.')}</div>` +
        resetButton('nfc');
    }
    if (descriptor.kind === 'payments') {
      const payments = window.SmoofPaymentTools?.getState?.() || {
        selected: [], color: '#000000', scale: 1
      };
      return row(t('Anbieter', 'Providers'), paymentProviderGrid(payments)) +
        (payments.selected?.some(id => window.SmoofPaymentProviderLibrary?.get(id)?.original) ? originalColourRow(payments, 'payment-original-colours') : '') +
        hexColorRow(t('Einfarbige Logos', 'Single-colour logos'), 'payment-color', payments.color) +
        row(t('Größe', 'Size'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="payment-size-minus" aria-label="${t('Verkleinern', 'Decrease')}">−</button><span data-smoof-ui-payment-scale>${Math.round(payments.scale * 100)}%</span><button type="button" data-smoof-ui-action="payment-size-plus" aria-label="${t('Vergrößern', 'Increase')}">+</button></div>`) +
        opacityRow() +
        resetButton('payment');
    }
    if (descriptor.kind === 'background') {
      if (backgroundLocked) {
        return `<div data-smoof-ui-locked-note><strong>${t('Für DOT ME gesperrt', 'Locked for DOT ME')}</strong><br>${t('Die Edelstahloberfläche gehört zum Produkt und kann nicht verändert, eingefärbt oder durch ein Bild ersetzt werden.', 'The stainless-steel surface belongs to the product and cannot be recoloured or replaced by an image.')}</div>`;
      }
      const bridgedImage = window.SmoofBackgroundImageBridge?.getState?.();
      const image = (bridgedImage?.hasImage ? bridgedImage : window.SmoofBackgroundImageTools?.getState?.()) || {
        hasImage: false,
        fileName: ''
      };
      const gradient = window.SmoofBackgroundGradientTools?.getState?.() || {
        enabled: false,
        color1: '#000000',
        color2: '#ffffff',
        angle: 0,
        overlayEnabled: false,
        overlayColor: '#000000',
        overlayOpacity: 0.3
      };
      const fileName = image.fileName || t('Kein Bild ausgewählt', 'No image selected');
      const imagePositionX = Math.max(0, Math.min(1, Number.isFinite((0.5 + Number(image.offsetX || 0) / 2)) ? (0.5 + Number(image.offsetX || 0) / 2) : 0.5));
      const imagePositionY = Math.max(0, Math.min(1, Number.isFinite((0.5 + Number(image.offsetY || 0) / 2)) ? (0.5 + Number(image.offsetY || 0) / 2) : 0.5));
      const imageScale = Math.max(0.05, Math.min(3, Number(image.scale) || 1));
      const safeFileName = escapeHtml(fileName);
      return backgroundColorRow(t('Grundfarbe', 'Base colour')) +
        opacityRow() +
        row(t('Verlauf', 'Gradient'), stateButton('background-gradient-toggle', t('Verlauf', 'Gradient'), gradient.enabled, t('An', 'On'), t('Aus', 'Off'))) +
        (gradient.enabled
          ? hexColorRow(t('Startfarbe', 'Start colour'), 'background-gradient-color-1', gradient.color1) +
            hexColorRow(t('Endfarbe', 'End colour'), 'background-gradient-color-2', gradient.color2) +
            row(t('Richtung', 'Direction'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="background-gradient-angle-minus" aria-label="${t('Nach links drehen', 'Rotate left')}">−</button><span data-smoof-ui-gradient-angle>${Math.round(gradient.angle)}°</span><button type="button" data-smoof-ui-action="background-gradient-angle-plus" aria-label="${t('Nach rechts drehen', 'Rotate right')}">+</button></div>`)
          : '') +
        row(t('Bild', 'Image'), `<button type="button" data-smoof-ui-wide-button data-smoof-ui-action="background-upload"><span>${image.hasImage ? t('Bild ersetzen', 'Replace image') : t('Bild hochladen', 'Upload image')}</span><small data-smoof-ui-action-meta>PNG, JPG, WebP${controlIcon('upload')}</small></button>`) +
        `<div data-smoof-ui-locked-note><strong data-smoof-ui-file-name title="${safeFileName}">${safeFileName}</strong>${window.SmoofI18n.label({de:'Verschieben, vergrößern oder drehen Sie Ihr Bild. Sichtbar bleibt der Bereich innerhalb der Druckfläche.',en:'Move, resize or rotate your image. Only the area inside the print surface is visible.',it:'Sposti, ridimensioni o ruoti l’immagine. Rimane visibile solo l’area all’interno della superficie di stampa.'})}</div>` +
        (image.hasImage
          ? row(t('Bildgröße', 'Image size'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="background-image-scale-minus">−</button><span>${Math.round(imageScale * 100)}%</span><button type="button" data-smoof-ui-action="background-image-scale-plus">+</button></div>`) +
            row(t('Drehung', 'Rotation'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="background-image-rotation-minus" aria-label="${t('Nach links drehen', 'Rotate left')}">−</button><span>${Math.round(image.rotation || 0)}°</span><button type="button" data-smoof-ui-action="background-image-rotation-plus" aria-label="${t('Nach rechts drehen', 'Rotate right')}">+</button></div>`) +
            backgroundFlipRow(image) +
            row(t('Horizontal', 'Horizontal'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="background-image-x-minus">−</button><span>${Math.round((imagePositionX - 0.5) * 200)}%</span><button type="button" data-smoof-ui-action="background-image-x-plus">+</button></div>`) +
            row(t('Vertikal', 'Vertical'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="background-image-y-minus">−</button><span>${Math.round((imagePositionY - 0.5) * 200)}%</span><button type="button" data-smoof-ui-action="background-image-y-plus">+</button></div>`) +
            `<div data-smoof-ui-actions data-single="true"><button type="button" data-smoof-ui-icon-button data-smoof-ui-action="background-image-position-reset">${icon('reset')} ${window.SmoofI18n.label({de:'Bild zurücksetzen',en:'Reset image',it:'Ripristina immagine'})}</button></div>`
          : '') +
        row(t('Overlay', 'Overlay'), stateButton('background-overlay-toggle', t('Overlay', 'Overlay'), gradient.overlayEnabled, t('An', 'On'), t('Aus', 'Off'))) +
        (gradient.overlayEnabled
          ? hexColorRow(t('Overlayfarbe', 'Overlay colour'), 'background-overlay-color', gradient.overlayColor) +
            row(t('Overlaystärke', 'Overlay strength'), `<div data-smoof-ui-stepper><button type="button" data-smoof-ui-action="background-overlay-opacity-minus" aria-label="${t('Overlay reduzieren', 'Reduce overlay')}">−</button><span data-smoof-ui-overlay-opacity>${Math.round(gradient.overlayOpacity * 100)}%</span><button type="button" data-smoof-ui-action="background-overlay-opacity-plus" aria-label="${t('Overlay verstärken', 'Increase overlay')}">+</button></div>`)
          : '') +
        (image.hasImage
          ? `<div data-smoof-ui-actions data-single="true"><button type="button" data-smoof-ui-icon-button data-smoof-ui-danger data-smoof-ui-action="background-remove">${icon('trash')} ${t('Hintergrundbild entfernen', 'Remove background image')}</button></div>`
          : '');
    }
    return '';
  }

  function panelHead(descriptor, mode) {
    const hideable = Boolean(descriptor && descriptor.hideable);
    const templateLanguage = descriptor.kind === 'templates' && window.SmoofTemplateLibrary?.languageSelectionEnabled
      ? window.SmoofTemplateLibrary.listLanguages().find(item => item.id === window.SmoofTemplateLibrary.selectedLanguage) : null;
    const copy = templateLanguage
      ? escapeHtml(t('Vorlagensprache', 'Template language') + ': ' + window.SmoofI18n.label(templateLanguage)) : descriptor.copy;
    const start = templateLanguage
      ? `<button type="button" data-smoof-ui-panel-back data-smoof-ui-action="template-language-change" aria-label="${t('Zurück', 'Back')}">${icon('back')}</button>`
      : panelRouteStack.at(-1)?.to === selectedId
      ? `<button type="button" data-smoof-ui-route-back aria-label="${t('Zurück', 'Back')}">${icon('back')}</button>`
      : mode === 'layers-detail'
      ? `<button type="button" data-smoof-ui-panel-back aria-label="${t('Zurück', 'Back')}">${icon('back')}</button>`
      : `<span data-smoof-ui-panel-symbol>${icon(descriptor.symbol)}</span>`;
    const visibility = hideable
      ? `<button type="button" data-smoof-ui-panel-visibility data-smoof-ui-action="item-visibility" aria-label="${isVisible(selectedId) ? t('Element ausblenden', 'Hide element') : t('Element einblenden', 'Show element')}">${icon(isVisible(selectedId) ? 'eye' : 'eyeOff')}</button>`
      : '';
    return `<header data-smoof-ui-panel-head data-has-visibility="${hideable}">${start}<span><strong data-smoof-ui-panel-title>${descriptor.title}</strong><small data-smoof-ui-panel-copy>${copy}</small></span>${visibility}<button type="button" data-smoof-ui-panel-close aria-label="${t('Schließen', 'Close')}">${icon('close')}</button></header>`;
  }

  // Shared select-only combobox. The hidden select remains the data/event adapter.
  function enhanceCategorySelect(select) {
    if (!select) return null;
    if (categoryDropdowns.has(select)) return categoryDropdowns.get(select);
    const isFontStyle = ['text-style', 'custom-text-style', 'number-style', 'arrow-label-style'].includes(select.dataset.smoofUiSelect);
    const isPropertySelect = isFontStyle || select.dataset.smoofUiSelect === 'logo-background-shape';
    let wrap = select.closest('[data-smoof-ui-select-wrap]');
    if (!wrap && isPropertySelect) {
      wrap = document.createElement('span');
      wrap.dataset.smoofUiSelectWrap = 'true';
      select.before(wrap); wrap.append(select);
      wrap.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m6 9 6 6 6-6"/></svg>');
    }
    if (!wrap) return null;
    const button = document.createElement('button');
    button.type = 'button';
    button.dataset.smoofUiDropdown = 'true';
    button.setAttribute('role', 'combobox');
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    const valueLabel = document.createElement('span');
    button.append(valueLabel);
    const popup = document.createElement('div');
    popup.dataset.smoofUiDropdownPopup = 'true';
    popup.dataset.smoofEditorItem = 'modern-ui-control';
    popup.hidden = true;
    const list = document.createElement('div');
    list.dataset.smoofUiDropdownList = 'true';
    list.id = `smoof-category-list-${++categoryDropdownSequence}`;
    list.setAttribute('role', 'listbox');
    popup.append(list);
    button.id = `smoof-category-trigger-${categoryDropdownSequence}`;
    const labelElement = select.closest('label');
    const previousFor = labelElement?.getAttribute('for');
    if (labelElement) labelElement.htmlFor = button.id;
    button.setAttribute('aria-controls', list.id);
    document.body.append(popup);
    const wasFocused = document.activeElement === select;
    select.hidden = true;
    select.dataset.smoofUiNativeSelect = 'true';
    select.after(button);
    let opened = false, active = -1, options = [], signature = '', search = '', searchTime = 0;
    let scrollCleanup = null;
    let positionFrame = 0;
    const enabled = () => options.map((option, index) => option.disabled ? -1 : index).filter(index => index >= 0);
    const selectedIndex = () => options.findIndex(option => option.value === select.value);
    const fold = value => String(value).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase();
    const syncActive = (reveal = true) => {
      [...list.children].forEach((node, index) => {
        node.dataset.active = String(index === active);
        node.setAttribute('aria-selected', String(index === selectedIndex()));
      });
      if (!opened || !list.children[active]) { button.removeAttribute('aria-activedescendant'); return; }
      const node = list.children[active];
      button.setAttribute('aria-activedescendant', node.id);
      if (reveal) {
        // Scroll this list only; scrollIntoView would also move its anchored page.
        if (node.offsetTop < list.scrollTop) list.scrollTop = node.offsetTop;
        else if (node.offsetTop + node.offsetHeight > list.scrollTop + list.clientHeight)
          list.scrollTop = node.offsetTop + node.offsetHeight - list.clientHeight;
      }
    };
    const position = () => {
      positionFrame = 0;
      if (!opened) return;
      if (!button.isConnected || !button.getClientRects().length || button.closest('[hidden]')) { close(false); return; }
      const r = button.getBoundingClientRect(), viewport = window.visualViewport;
      const left = viewport?.offsetLeft || 0, top = viewport?.offsetTop || 0;
      const width = viewport?.width || innerWidth, height = viewport?.height || innerHeight;
      if (r.bottom < top || r.top > top + height) { close(false); return; }
      const below = top + height - r.bottom - 14, above = r.top - top - 14;
      const down = below >= Math.min(240, above);
      const room = Math.max(below, above);
      const overlay = room < 120;
      popup.style.width = `${Math.min(Math.max(r.width, 240), width - 16)}px`;
      popup.style.maxHeight = `${Math.max(40, Math.min(340, overlay ? height - 16 : down ? below : above))}px`;
      popup.style.left = `${Math.max(left + 8, Math.min(r.left, left + width - popup.offsetWidth - 8))}px`;
      popup.style.top = `${overlay ? top + 8 : down ? r.bottom + 6 : r.top - popup.offsetHeight - 6}px`;
    };
    const schedulePosition = () => { if (opened && !positionFrame) positionFrame = requestAnimationFrame(position); };
    const close = (restoreFocus = true) => {
      if (!opened) return;
      opened = false;
      if (activeCategoryDropdown === api) activeCategoryDropdown = null;
      button.setAttribute('aria-expanded', 'false');
      button.removeAttribute('aria-activedescendant');
      scrollCleanup?.(); scrollCleanup = null;
      popup.hidden = true;
      if (typeof popup.hidePopover === 'function' && popup.matches(':popover-open')) popup.hidePopover();
      popup.removeAttribute('data-open');
      cancelAnimationFrame(positionFrame); positionFrame = 0;
      window.removeEventListener('resize', schedulePosition);
      window.removeEventListener('scroll', onScroll, true);
      window.visualViewport?.removeEventListener('resize', schedulePosition);
      window.visualViewport?.removeEventListener('scroll', schedulePosition);
      if (restoreFocus && button.isConnected) button.focus({ preventScroll: true });
    };
    const onScroll = event => { if (!popup.contains(event.target)) schedulePosition(); };
    const sync = () => {
      if (opened && (!button.isConnected || !button.getClientRects().length)) close(false);
      const next = [...select.options].map(option => ({ value: option.value, text: option.textContent, disabled: option.disabled || option.parentElement?.disabled === true }));
      const nextSignature = JSON.stringify(next);
      if (signature !== nextSignature) {
        if (opened) close(false);
        options = next; signature = nextSignature;
        list.replaceChildren(...options.map((option, index) => {
          const node = document.createElement('div');
          node.id = `${list.id}-${index}`;
          node.dataset.smoofUiDropdownOption = String(index);
          node.setAttribute('role', 'option');
          node.setAttribute('aria-disabled', String(option.disabled));
          const label = document.createElement('span'); label.textContent = option.text;
          const check = document.createElement('span'); check.dataset.smoofUiDropdownCheck = 'true'; check.setAttribute('aria-hidden', 'true'); check.textContent = '✓';
          node.append(label, check); return node;
        }));
      }
      const selected = options[selectedIndex()];
      if (valueLabel.textContent !== (selected?.text || '')) valueLabel.textContent = selected?.text || '';
      button.title = select.title || (isFontStyle && select.disabled ? t('Dieser Upload enthält nur den Schnitt Normal.', 'This upload contains only the Normal style.') : '');
      const label = select.getAttribute('aria-label') || t('Kategorie', 'Category');
      button.setAttribute('aria-label', label); list.setAttribute('aria-label', label);
      const disabled = select.disabled || !enabled().length;
      if (button.disabled !== disabled) button.disabled = disabled;
      if (disabled && opened) close(false);
      syncActive(false);
    };
    const open = () => {
      sync();
      if (button.disabled || opened) return;
      activeCategoryDropdown?.close(false);
      opened = true; activeCategoryDropdown = api;
      search = ''; searchTime = 0;
      active = enabled().includes(selectedIndex()) ? selectedIndex() : enabled()[0];
      popup.hidden = false; popup.dataset.open = 'true';
      if (typeof popup.showPopover === 'function') { popup.setAttribute('popover', 'manual'); popup.showPopover(); }
      button.setAttribute('aria-expanded', 'true'); button.focus({ preventScroll: true });
      position();
      scrollCleanup = installPanelScrollAffordance(popup, {
        scroller: list, collapseWhenContentFits: true, tabStop: false,
        label: isFontStyle ? t('Weitere Schriftschnitte anzeigen', 'Show more font styles') : isPropertySelect ? t('Weitere Formen anzeigen', 'Show more shapes') : t('Weitere Kategorien anzeigen', 'Show more categories')
      });
      scrollCleanup.update(); position(); syncActive();
      window.addEventListener('resize', schedulePosition, { passive: true });
      window.addEventListener('scroll', onScroll, true);
      window.visualViewport?.addEventListener('resize', schedulePosition, { passive: true });
      window.visualViewport?.addEventListener('scroll', schedulePosition, { passive: true });
    };
    const commit = () => {
      const choice = options[active];
      if (!opened || !choice || choice.disabled) return;
      const changed = select.value !== choice.value;
      close();
      select.value = choice.value;
      if (changed) select.dispatchEvent(new Event('change', { bubbles: true }));
      if (select.isConnected) sync();
    };
    const focusNext = backwards => {
      const replacement = button.isConnected ? button : document.querySelector(
        isPropertySelect ? `[data-smoof-ui-select="${select.dataset.smoofUiSelect}"]` : select.hasAttribute('data-smoof-ui-template-category') ? '[data-smoof-ui-template-category]' : '[data-smoof-picto-category]'
      )?.closest('[data-smoof-ui-select-wrap]')?.querySelector('[data-smoof-ui-dropdown]');
      const focusable = [...document.querySelectorAll('button, input, select, textarea, a[href], [tabindex]')].filter(node =>
        node.tabIndex >= 0 && !node.disabled && !node.closest('[hidden], [aria-hidden="true"], [data-smoof-ui-dropdown-popup]') &&
        node.getClientRects().length && getComputedStyle(node).visibility !== 'hidden'
      );
      const index = focusable.indexOf(replacement), next = index + (backwards ? -1 : 1);
      (focusable[next] || focusable[backwards ? focusable.length - 1 : 0])?.focus();
    };
    // Safari may blur a programmatically focused button on mouse-down.
    // Keep focus until click toggles the popup; otherwise blur closes it first
    // and the same click immediately opens it again. Keyboard/Tab stay native.
    button.addEventListener('mousedown', event => {
      if (event.button === 0) event.preventDefault();
    });
    button.addEventListener('click', () => opened ? close() : open());
    button.addEventListener('keydown', event => {
      if (event.isComposing || event.ctrlKey || event.metaKey) return;
      if (event.key === 'Tab') { if (opened) { event.preventDefault(); commit(); focusNext(event.shiftKey); } return; }
      if (event.key === 'Escape') { if (opened) { event.preventDefault(); event.stopPropagation(); close(); } return; }
      const keys = ['Enter', ' ', 'ArrowDown', 'ArrowUp', 'Home', 'End', 'PageDown', 'PageUp'];
      const printable = event.key.length === 1 && !event.altKey;
      if (!keys.includes(event.key) && !printable) return;
      event.preventDefault(); event.stopPropagation();
      const wasOpen = opened;
      if (!opened) open();
      if (!opened) return;
      const indices = enabled();
      if (event.altKey && event.key === 'ArrowUp') { commit(); return; }
      if (event.key === 'Enter' || event.key === ' ') { if (wasOpen) commit(); return; }
      if (event.key === 'Home') active = indices[0];
      else if (event.key === 'End') active = indices.at(-1);
      else if (['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp'].includes(event.key)) {
        if (wasOpen) {
          const step = event.key.startsWith('Page') ? 10 : 1;
          const direction = event.key.endsWith('Down') ? 1 : -1;
          active = indices[Math.max(0, Math.min(indices.length - 1, indices.indexOf(active) + step * direction))];
        }
      } else if (printable) {
        const now = Date.now(); search = now - searchTime > 700 ? event.key : search + event.key; searchTime = now;
        const chars = [...fold(search)], repeated = chars.every(char => char === chars[0]);
        const needle = repeated ? chars[0] : fold(search);
        const start = repeated ? indices.indexOf(active) + 1 : 0;
        const order = indices.slice(start).concat(indices.slice(0, start));
        const found = order.find(index => fold(options[index].text.trim()).startsWith(needle));
        if (found !== undefined) active = found;
      }
      syncActive();
    });
    popup.addEventListener('mousedown', event => event.preventDefault());
    list.addEventListener('click', event => {
      const option = event.target.closest('[data-smoof-ui-dropdown-option]');
      if (!option || options[Number(option.dataset.smoofUiDropdownOption)]?.disabled) return;
      active = Number(option.dataset.smoofUiDropdownOption); commit();
    });
    button.addEventListener('blur', () => { if (opened) close(false); });
    select.addEventListener('change', sync);
    const api = { button, open, close, sync, destroy() {
      close(false); select.removeEventListener('change', sync); button.remove(); popup.remove();
      if (labelElement) { if (previousFor === null) labelElement.removeAttribute('for'); else labelElement.setAttribute('for', previousFor); }
      select.hidden = false; delete select.dataset.smoofUiNativeSelect; categoryDropdowns.delete(select);
    } };
    categoryDropdowns.set(select, api);
    sync(); if (wasFocused) button.focus({ preventScroll: true });
    return api;
  }
  function captureDropdownFocus(panel) {
    const active = document.activeElement;
    return panel?.contains(active) && active.matches('[data-smoof-ui-dropdown]')
      ? active.closest('[data-smoof-ui-select-wrap]')?.querySelector('select')?.dataset.smoofUiSelect : null;
  }
  function restoreDropdownFocus(panel, proxy) {
    if (proxy) focusCategorySelect(panel.querySelector(`select[data-smoof-ui-select="${CSS.escape(proxy)}"]`));
  }
  function focusCategorySelect(select) { enhanceCategorySelect(select)?.button.focus({ preventScroll: true }); }
  // Keep the picker as category owner: its existing buttons remain the adapter.
  // This also works with cached inline picker markup during a staged upload.
  function enhanceFontCategories() {
    document.querySelectorAll('.smoof-font-categories').forEach(categories => {
      const buttons = [...categories.querySelectorAll('.smoof-font-category')];
      if (!buttons.length) return;
      let select = categories.querySelector('select[data-smoof-ui-select="font-category"]');
      if (!select) {
        const wrap = document.createElement('span');
        wrap.dataset.smoofUiSelectWrap = 'true';
        select = document.createElement('select');
        select.dataset.smoofUiSelect = 'font-category';
        select.setAttribute('aria-label', t('Schriftkategorie', 'Font category'));
        buttons.forEach(button => select.add(new Option(button.textContent.trim(), button.dataset.category)));
        wrap.append(select);
        wrap.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="m6 9 6 6 6-6"/></svg>');
        categories.append(wrap);
        categories.dataset.smoofUiFontCategories = 'true';
        buttons.forEach(button => { button.hidden = true; });
        select.addEventListener('change', () => {
          buttons.find(button => button.dataset.category === select.value)?.click();
          categoryDropdowns.get(select)?.sync();
        });
      }
      const current = buttons.find(button => button.getAttribute('aria-pressed') === 'true');
      if (current) select.value = current.dataset.category;
      enhanceCategorySelect(select)?.sync();
    });
  }

  function installCategoryDropdowns() {
    let scheduled = false;
    const refresh = () => {
      scheduled = false;
      enhanceFontCategories();
      for (const [select, api] of categoryDropdowns) {
        if (!select.isConnected) api.destroy(); else api.sync();
      }
      document.querySelectorAll('select[data-smoof-ui-select]').forEach(enhanceCategorySelect);
    };
    const scope = '[data-smoof-ui-select-wrap], [data-smoof-ui-context], [data-smoof-ui-layers], .smoof-font-categories';
    new MutationObserver(records => {
      const relevant = records.some(record => record.target instanceof Element && (record.target.closest(scope) ||
        [...record.addedNodes, ...record.removedNodes].some(node => node instanceof Element &&
          (node.matches(scope) || node.querySelector('select[data-smoof-ui-select]')))));
      if (relevant && !scheduled) { scheduled = true; requestAnimationFrame(refresh); }
    }).observe(document.body, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'hidden', 'data-open', 'aria-pressed']
    });
    document.addEventListener('pointerdown', event => {
      if (activeCategoryDropdown && !event.target.closest('[data-smoof-ui-dropdown-popup], [data-smoof-ui-select-wrap]')) activeCategoryDropdown.close(false);
    }, true);
    refresh();
  }

  function installPanelScrollAffordance(panel, options = {}) {
    panelScrollCleanups.get(panel)?.();
    panelScrollCleanups.delete(panel);

    const scroller = options.scroller || panel.querySelector(
      '[data-smoof-ui-panel-body], [data-smoof-ui-layer-list]'
    );
    if (!scroller) return;

    const horizontal = options.axis === 'x';
    scroller.dataset.smoofUiScrollAxis = horizontal ? 'x' : 'y';
    const footer = document.createElement('div');
    footer.dataset.smoofUiScrollAffordance = 'true';
    footer.innerHTML = `<button type="button" data-smoof-ui-scroll-more aria-label="${escapeHtml(options.label || t('Weitere Einstellungen anzeigen', 'Show more settings'))}"><span>${t('Mehr', 'More')}</span><span aria-hidden="true">${horizontal ? '→' : '↓'}</span></button>`;
    const host = options.host || panel;
    if (options.adjacent) scroller.after(footer);
    else host.appendChild(footer);

    const button = footer.querySelector('[data-smoof-ui-scroll-more]');
    let disposed = false;
    let previousHasMore = false;
    let moreFade = null;
    const cancelMoreFade = () => {
      if (moreFade) { moreFade.onfinish = null; moreFade.cancel(); moreFade = null; }
      delete footer.dataset.smoofUiMoreFading;
    };
    let observedContent = scroller.firstElementChild;
    const update = () => {
      if (disposed || !scroller.isConnected) return;
      if (observedContent !== scroller.firstElementChild) {
        if (observedContent) resizeObserver?.unobserve(observedContent);
        observedContent = scroller.firstElementChild;
        if (observedContent) resizeObserver?.observe(observedContent);
      }
      const maximum = Math.max(0, horizontal ? scroller.scrollWidth - scroller.clientWidth : scroller.scrollHeight - scroller.clientHeight);
      // A filtered result may fit once its obsolete footer gives space back.
      const footerSpace = options.collapseWhenContentFits && footer.offsetHeight
        ? (horizontal ? footer.offsetWidth : footer.offsetHeight) + (parseFloat(getComputedStyle(host)[horizontal ? 'columnGap' : 'rowGap']) || 0)
        : 0;
      const allowsScroll = !options.requireOverflow || /(auto|scroll)/.test(getComputedStyle(scroller)[horizontal ? 'overflowX' : 'overflowY']);
      const scrollable = allowsScroll && scroller.clientHeight > 0 && scroller.clientWidth > 0 && maximum > footerSpace + 2;
      const hasMore = scrollable && (horizontal ? scroller.scrollLeft : scroller.scrollTop) < maximum - 2;
      // Finish with display:none to avoid Safari's empty native-button remnant.
      // Only a real transition to the end fades; filtering to a fitting list does not.
      if (hasMore || !scrollable) cancelMoreFade();
      else if (previousHasMore && typeof button.animate === 'function' &&
          !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        footer.dataset.smoofUiMoreFading = 'true';
        moreFade = button.animate([{ opacity: 1 }, { opacity: 0 }], {
          duration: 220, easing: 'ease-out', fill: 'forwards'
        });
        moreFade.onfinish = () => { cancelMoreFade(); };
      }
      previousHasMore = hasMore;
      scroller.dataset.smoofUiScrollRemaining = String(hasMore);
      panel.dataset.smoofUiScrollable = String(scrollable);
      panel.dataset.smoofUiHasMore = String(hasMore);
      // The visible footer owns its state, including inside a temporary subview.
      footer.dataset.smoofUiScrollable = String(scrollable);
      footer.dataset.smoofUiHasMore = String(hasMore);
      button.tabIndex = hasMore && options.tabStop !== false ? 0 : -1;
      button.setAttribute('aria-hidden', String(!hasMore));
    };

    const scrollMore = () => {
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      scroller.scrollBy({
        [horizontal ? 'left' : 'top']: Math.max(80, Math.round((horizontal ? scroller.clientWidth : scroller.clientHeight) * 0.72)),
        behavior: reducedMotion ? 'auto' : 'smooth'
      });
    };

    scroller.addEventListener('scroll', update, { passive: true });
    button.addEventListener('click', scrollMore);

    const resizeObserver = typeof ResizeObserver === 'function'
      ? new ResizeObserver(update)
      : null;
    resizeObserver?.observe(scroller);
    if (scroller.firstElementChild) resizeObserver?.observe(scroller.firstElementChild);

    const cleanup = () => {
      disposed = true;
      cancelMoreFade();
      scroller.removeEventListener('scroll', update);
      button.removeEventListener('click', scrollMore);
      resizeObserver?.disconnect();
      footer.remove();
      delete scroller.dataset.smoofUiScrollRemaining;
      delete scroller.dataset.smoofUiScrollAxis;
      panelScrollCleanups.delete(panel);
    };
    panelScrollCleanups.set(panel, cleanup);

    requestAnimationFrame(() => requestAnimationFrame(update));
    cleanup.update = update;
    return cleanup;
  }

  // One scroll contract for editor-owned lists and dialogs. Never target the
  // storefront, text inputs or the design canvas. A component can opt in with
  // data-smoof-scroll-region="x|y"; keep its footer next to the real viewport.
  function installEditorScrollStandard() {
    const vertical = '.smoof-font-dialog, [data-smoof-ui-template-grid], [data-smoof-ui-pictogram-grid], [data-smoof-ui-payment-grid], [data-smoof-ui-legacy-body], [data-smoof-shape-panel], .smoof-font-grid, [data-smoof-own-font-panel], [data-smoof-font-batch-results], .smoof-font-status, [data-smoof-crop] .crop-body, [data-smoof-scroll-region="y"]';
    const horizontal = '[data-smoof-ui-template-categories], [data-smoof-ui-pictogram-tabs], [data-smoof-scroll-region="x"]';
    const dialogSelector = '[data-smoof-editor-tour-dialog], [data-smoof-login-draft-status], [data-smoof-nfc-controls]';
    const registered = new Map();
    let scheduled = false;
    const refresh = () => {
      scheduled = false;
      // Self-scrolling dialogs need an internal viewport: the More action must
      // stay inside native dialog top layers and outside the faded content.
      document.querySelectorAll(dialogSelector).forEach(dialog => {
        if (!dialog.checkVisibility() || dialog.querySelector(':scope > [data-smoof-scroll-dialog-body]')) return;
        const style = getComputedStyle(dialog);
        if (!dialog.hasAttribute('data-smoof-scroll-dialog') && !/(auto|scroll)/.test(style.overflowY)) return;
        const close = dialog.querySelector(':scope > [data-smoof-editor-tour-close]');
        close?.remove();
        const body = document.createElement('div');
        body.dataset.smoofScrollDialogBody = 'true';
        body.dataset.smoofScrollRegion = 'y';
        while (dialog.firstChild) body.appendChild(dialog.firstChild);
        dialog.appendChild(body);
        if (close) dialog.prepend(close);
        dialog.dataset.smoofScrollDialog = 'true';
      });
      for (const [scroller, cleanup] of registered) {
        if (!scroller.isConnected) { cleanup(); registered.delete(scroller); }
      }
      document.querySelectorAll(vertical + ', ' + horizontal).forEach(scroller => {
        if (registered.has(scroller) || !scroller.checkVisibility()) return;
        const axis = scroller.matches(horizontal) ? 'x' : 'y';
        if (!/(auto|scroll)/.test(getComputedStyle(scroller)[axis === 'x' ? 'overflowX' : 'overflowY'])) return;
        if (axis === 'x' && !scroller.parentElement.hasAttribute('data-smoof-ui-scroll-row')) {
          const row = document.createElement('div');
          row.dataset.smoofUiScrollRow = 'true';
          scroller.before(row);
          row.appendChild(scroller);
        }
        const cleanup = installPanelScrollAffordance(scroller, {
          scroller, host: scroller.parentElement, adjacent: true, axis, requireOverflow: true,
          collapseWhenContentFits: scroller.parentElement.matches('[data-smoof-ui-scroll-row], .smoof-font-dialog, .smoof-font-backdrop, [data-smoof-subview-body], [data-smoof-ui-legacy-shell], [data-smoof-scroll-dialog], [data-smoof-crop]'),
          label: axis === 'x' ? t('Weitere Einträge rechts anzeigen', 'Show more entries to the right') : t('Weitere Inhalte anzeigen', 'Show more content')
        });
        registered.set(scroller, cleanup);
      });
      registered.forEach(cleanup => cleanup.update());
    };
    const schedule = () => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(refresh);
    };
    const scope = '[data-smoof-ui-context], [data-smoof-ui-layers], [data-smoof-ui-legacy-shell], .smoof-font-backdrop, ' + dialogSelector + ', ' + vertical + ', ' + horizontal;
    new MutationObserver(records => {
      if (records.some(record => record.target instanceof Element && (
        record.target.closest(scope) || [...record.addedNodes, ...record.removedNodes].some(node => node instanceof Element && (node.matches(scope + ', ' + vertical + ', ' + horizontal) || node.querySelector(scope + ', ' + vertical + ', ' + horizontal)))
      ))) schedule();
    }).observe(document.body, {
      subtree: true, childList: true, attributes: true,
      attributeFilter: ['hidden', 'class', 'style', 'open', 'data-smoof-font-view']
    });
    window.addEventListener('resize', schedule, { passive: true });
    schedule();
  }

  function capturePanelScroll(panel, key) {
    const scroller = panel?.querySelector(
      '[data-smoof-ui-panel-body], [data-smoof-ui-layer-list]'
    );
    const sameView = panel?.dataset.smoofUiScrollKey === key;
    return {
      key,
      top: sameView && scroller ? Math.max(0, scroller.scrollTop) : 0
    };
  }

  function restorePanelScroll(panel, snapshot) {
    if (!panel || !snapshot) return;
    panel.dataset.smoofUiScrollKey = snapshot.key;
    const scroller = panel.querySelector(
      '[data-smoof-ui-panel-body], [data-smoof-ui-layer-list]'
    );
    if (!scroller) return;

    const restore = () => {
      if (!scroller.isConnected || panel.dataset.smoofUiScrollKey !== snapshot.key) return;
      const maximum = Math.max(0, scroller.scrollHeight - scroller.clientHeight);
      scroller.scrollTop = Math.min(snapshot.top, maximum);
    };

    restore();
    requestAnimationFrame(restore);
  }

  // Panel updates replace markup. Carry the visible thumb position across them
  // so a click can finish its motion without a jump or a loss of keyboard focus.
  function captureSwitchMotion(panel) {
    if (panel.dataset.smoofUiItemId !== selectedId) return new Map();
    return new Map([...panel.querySelectorAll('[role="switch"][data-smoof-ui-action]')].map(button => {
      const knob = button.querySelector('[data-smoof-switch-knob], [data-smoof-choice-indicator]');
      return [button.dataset.smoofUiAction, {checked:button.getAttribute('aria-checked'),
        transform:knob ? getComputedStyle(knob).transform : '',
        moving:knob?.getAnimations().some(animation => animation.playState === 'running')}];
    }));
  }
  function restoreSwitchMotion(panel, previous) {
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    panel.querySelectorAll('[role="switch"][data-smoof-ui-action]').forEach(button => {
      const old = previous.get(button.dataset.smoofUiAction);
      const knob = button.querySelector('[data-smoof-switch-knob], [data-smoof-choice-indicator]');
      if (!old || !knob || (!old.moving && old.checked === button.getAttribute('aria-checked'))) return;
      knob.animate([{transform:old.transform}, {transform:getComputedStyle(knob).transform}],
        {duration:old.moving ? 180 : 320, easing:'cubic-bezier(.22,1.2,.36,1)'});
    });
  }

  function captureStateControlFocus(panel) {
    const active = document.activeElement;
    if (panel.dataset.smoofUiItemId !== selectedId || !panel.contains(active) || !active?.matches('[data-smoof-ui-action][role="switch"], [data-smoof-background-flip] [data-smoof-ui-action]')) return '';
    return active.dataset.smoofUiAction;
  }
  function restoreStateControlFocus(panel, action) {
    if (action) panel.querySelector(`[data-smoof-ui-action="${CSS.escape(action)}"]:not(:disabled)`)?.focus({ preventScroll: true });
  }

  function activePercentageInputIn(panel) {
    const active = document.activeElement;
    return Boolean(
      panel &&
      active instanceof HTMLInputElement &&
      active.matches('[data-smoof-percent-input]') &&
      panel.contains(active)
    );
  }

  // One mounted subview: preserve the parent's DOM, scroll and selected owner.
  let panelSubview = null;
  function leavePanelSubview(cancel = false) {
    const view = panelSubview;
    if (!view) return;
    if (cancel) {
      if (view.onBack?.() === false) return;
      if (panelSubview !== view) return;
    }
    panelSubview = null;
    view.element.removeAttribute('data-smoof-panel-embedded');
    if (view.next?.parentNode === view.parent) view.parent.insertBefore(view.element, view.next);
    else view.parent?.append(view.element);
    view.panel.replaceChildren(...view.nodes);
    // The parent was detached during live editing: refresh its shape summary before animating back.
    if (view.kind === 'text-shape') {
      const button=view.panel.querySelector('[data-smoof-ui-action="text-shape"]');
      const row=button?.closest('[data-smoof-ui-row]');
      if (row) row.outerHTML=curvedTextRow(view.item);
      view.focus=view.panel.querySelector('[data-smoof-ui-action="text-shape"]');
    }
    if (view.kind === 'pictogram' && /^arrow-(left|right)$|^custom-pictogram-[1-3]$/.test(view.item)) {
      const primary=view.item.startsWith('arrow-'),side=view.item.split('-')[1];
      const row=view.panel.querySelector('[data-smoof-ui-pictogram-current]')?.closest('[data-smoof-ui-row]');
      const state=primary?window.SmoofArrowTools?.getState(side):window.SmoofCustomPictogramTools?.getState(view.item);
      if(row&&state)row.outerHTML=primary?pictogramRow(state,side):customPictogramRow(state,view.item);
      view.focus=view.panel.querySelector('[data-smoof-ui-pictogram-current]');
    }
    delete view.panel.dataset.smoofUiSubview;
    delete root.dataset.smoofPanelSubview;
    view.panel.style.height = view.height;
    view.panel.dataset.open = 'true';
    view.scroll.forEach(([node, top]) => { node.scrollTop = top; });
    view.element.querySelector('[aria-modal]')?.setAttribute('aria-modal', 'true');
    if (view.kind === 'text-shape') view.panel.dataset.smoofShapeMotion='true';
    animatePanel(view.panel, 'back');
    requestAnimationFrame(() => {
      if (selectedId === view.item && view.panel.dataset.open === 'true') view.focus?.focus?.({preventScroll:true});
      positionContext(); positionLayers();
    });
  }
  const panelTransitionTimers = new WeakMap();
  const panelRenderLocks = new WeakMap();
  function deferPanelRender(panel) {
    const lock = panelRenderLocks.get(panel);
    if (!lock) return false;
    if (lock.item === selectedId && (panel !== layers || lock.page === layersPage) && panel.dataset.open === 'true' && personalizedDesignSelected()) {
      lock.pending = true;
      return true;
    }
    delete panel.dataset.smoofShapeMotion;
    // A different selection or closed editor must take effect immediately.
    clearTimeout(panelTransitionTimers.get(panel));
    panelRenderLocks.delete(panel);
    delete panel.dataset.smoofUiTransition;
    return false;
  }
  function animatePanel(panel, direction = 'forward') {
    if (panel === layers) clearTimeout(layersTransitionTimer);
    clearTimeout(panelTransitionTimers.get(panel));
    delete panel.dataset.smoofUiTransition;
    panelRenderLocks.delete(panel);
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) {delete panel.dataset.smoofShapeMotion;return;}
    // Use exactly the same direction, distance and timing as the layer drill-in.
    void panel.offsetWidth;
    panel.dataset.smoofUiTransition = direction;
    const lock = {item:selectedId, page:layersPage, pending:false};
    panelRenderLocks.set(panel, lock);
    panelTransitionTimers.set(panel, setTimeout(() => {
      delete panel.dataset.smoofUiTransition;
      delete panel.dataset.smoofShapeMotion;
      if (panelRenderLocks.get(panel) !== lock) return;
      panelRenderLocks.delete(panel);
      if (lock.pending && !panelSubview && lock.item === selectedId && panel.dataset.open === 'true') {
        // Refresh once after the slide, without restarting animation on new nodes.
        const restoreShapeFocus=panel.contains(document.activeElement) && document.activeElement.matches('[data-smoof-ui-action="text-shape"], [data-smoof-ui-pictogram-current]');
        const focusSelector=document.activeElement?.matches('[data-smoof-ui-pictogram-current]')?'[data-smoof-ui-pictogram-current]':'[data-smoof-ui-action="text-shape"]';
        if (panel === layers) renderLayers(); else renderContext();
        if (restoreShapeFocus) panel.querySelector(focusSelector)?.focus({preventScroll:true});
      }
    }, mobile.matches ? 570 : 480));
  }
  function mountPanelSubview({element, title, kind, onBack}) {
    const panel = layersOpen ? layers : context;
    if (!panel || !element || !selectedId) return null;
    if (panelSubview) leavePanelSubview(true);
    if (panelSubview) return null;
    const view = {panel,element,kind,onBack,item:selectedId,parent:element.parentNode,next:element.nextSibling,nodes:[...panel.childNodes],height:panel.style.height,focus:document.activeElement,scroll:[...panel.querySelectorAll('*')].filter(n=>n.scrollTop).map(n=>[n,n.scrollTop])};
    // Freeze the object anchor for this editing session; scrolling still follows the page.
    if (kind === 'text-shape') {
      const anchor = visibleItemFor(selectedId);
      if (anchor) view.shapeAnchor = {anchor, rect:anchor.getBoundingClientRect(), x:scrollX, y:scrollY};
    }
    panelSubview=view;
    const currentHeight=panel.getBoundingClientRect().height;
    panel.dataset.open='true';
    panel.dataset.smoofUiSubview=kind;
    root.dataset.smoofPanelSubview=kind;
    // Keep the same footprint where possible; the subview's own content scrolls.
    panel.style.height=kind === "pictogram"
      ? `${Math.min(720, innerHeight * .86)}px`
      : `${Math.min((kind === "text-shape" ? 510 : Math.max(currentHeight, mobile.matches ? 440 : 510)), innerHeight * (mobile.matches ? .78 : .72),560)}px`;
    const head=document.createElement('header');head.dataset.smoofUiPanelHead='';
    head.innerHTML=`<button type="button" data-smoof-subview-back aria-label="${t('Zurück','Back')}">${icon('back')}</button><span><strong data-smoof-ui-panel-title>${escapeHtml(title)}</strong><small data-smoof-ui-panel-copy>${escapeHtml(descriptors()[selectedId]?.title || '')}</small></span><button type="button" data-smoof-subview-close aria-label="${t('Zurück zur Ebene','Back to layer')}">${icon('close')}</button>`;
    head.querySelectorAll('button').forEach(button=>button.addEventListener('click',()=>leavePanelSubview(true)));
    const body=document.createElement('div');body.dataset.smoofSubviewBody='';
    element.dataset.smoofPanelEmbedded=kind;
    element.querySelector('[aria-modal]')?.setAttribute('aria-modal','false');
    body.append(element);panel.replaceChildren(head,body);
    if (kind === 'text-shape') panel.dataset.smoofShapeMotion='true';
    animatePanel(panel);positionContext();positionLayers();
    return () => {if(panelSubview===view)leavePanelSubview(false);};
  }
  window.SmoofPanelNavigation=Object.freeze({mount:mountPanelSubview,back:()=>leavePanelSubview(true),isOpen:()=>Boolean(panelSubview)});
  // The topmost transient command list owns Escape before underlying selection/panel handlers.
  window.addEventListener('keydown', event => {
    if (event.target.closest?.('[data-smoof-design-name]')) return;
    if (event.key !== 'Escape' || !morePanel?.matches(':popover-open')) return;
    event.preventDefault(); event.stopImmediatePropagation(); closeMoreTools(true);
  }, true);
  document.addEventListener('keydown',event=>{
    if(event.target.closest?.('[data-smoof-design-name]'))return;
    if(event.key==='Escape'&&activeCategoryDropdown){event.preventDefault();event.stopImmediatePropagation();activeCategoryDropdown.close();return;}
    if(event.key==='Escape'&&panelSubview){event.preventDefault();event.stopImmediatePropagation();leavePanelSubview(true);}
  },true);
  document.addEventListener('pointerdown',event=>{
    if(panelSubview&&!panelSubview.panel.contains(event.target)&&!event.target.closest('.smoof-font-backdrop, [data-smoof-ui-dropdown-popup]'))leavePanelSubview(true);
  },true);
  window.addEventListener('smoof:surface-change',()=>leavePanelSubview(true));
  window.addEventListener('smoof:editor-reset-content',()=>leavePanelSubview(true));
  function embedFontPicker() {
    const element=document.querySelector('.smoof-font-backdrop[data-open="true"]');
    if(!element||panelSubview?.kind==='font')return;
    delete root.dataset.smoofFontPickerOpen;
    mountPanelSubview({element,title:t('Schrift auswählen','Choose font'),kind:'font',onBack:()=>{
      element.dataset.open='false';element.setAttribute('aria-hidden','true');
      resetFontPickerState();
    }});
  }
  function panelAnchorRect(anchor) {
    if(multiIds.size>1&&anchor===visibleItemFor(selectedId)){
      const rects=[...multiIds].filter(multiEligible).map(multiRect);
      if(rects.length>1){const r=multiUnion(rects);return {...r,width:r.right-r.left,height:r.bottom-r.top};}
    }
    const saved = panelSubview?.kind === 'text-shape' && panelSubview.shapeAnchor;
    if (!mobile.matches && saved?.anchor === anchor) {
      const {rect:r,x,y}=saved, dx=x-scrollX, dy=y-scrollY;
      return {left:r.left+dx,right:r.right+dx,top:r.top+dy,bottom:r.bottom+dy,width:r.width,height:r.height};
    }
    return anchor.getBoundingClientRect();
  }
  const panelAnchors = new Map();
  function updatePanelAnchor(panel, anchor) {
    anchor = visibleCommandAnchor(anchor);
    let skin = panelAnchors.get(panel);
    if (mobile.matches && (panel === context || panel === layers)) {
      if (skin) skin.hidden = true;
      delete panel.dataset.smoofUnifiedSkin;
      return;
    }
    if (!skin) {
      skin = document.createElement('div');
      skin.dataset.smoofPanelAnchor = '';
      skin.setAttribute('aria-hidden', 'true');
      const shadowId = `smoof-panel-shadow-${panelAnchors.size}`;
      skin.innerHTML = `<svg data-smoof-panel-shadow aria-hidden="true"><defs><filter id="${shadowId}" x="-30%" y="-30%" width="160%" height="160%"><feGaussianBlur in="SourceAlpha" stdDeviation="14"/><feOffset dy="10"/><feComponentTransfer><feFuncA type="linear" slope=".18"/></feComponentTransfer><feComposite in2="SourceAlpha" operator="out"/></filter></defs><path fill="#000" filter="url(#${shadowId})"/></svg><div data-smoof-panel-glass></div><svg aria-hidden="true"><path fill="none" stroke-width="1"/></svg>`;
      document.body.append(skin);
      panelAnchors.set(panel, skin);
    }
    const hide = () => { skin.hidden = true; delete panel.dataset.smoofUnifiedSkin; };
    const legacy = panel.dataset.smoofUiLegacyShell === 'true';
    const visible = legacy ? !panel.hidden && getComputedStyle(panel).display !== 'none' && getComputedStyle(panel).visibility !== 'hidden' : panel.dataset.open === 'true';
    skin.dataset.legacy = String(legacy);
    if (!visible || !anchor?.isConnected || !panel.getBoundingClientRect().width) return hide();
    const a = panelAnchorRect(anchor), b = panel.getBoundingClientRect();
    const x = a.left + a.width / 2, y = a.top + a.height / 2;
    if (x < 0 || x > innerWidth || y < 0 || y > innerHeight) return hide();
    let edge;
    if (a.right <= b.left - 5) edge = 'left';
    else if (a.left >= b.right + 5) edge = 'right';
    else if (a.bottom <= b.top - 5) edge = 'top';
    else if (a.top >= b.bottom + 5) edge = 'bottom';
    else return hide();
    // One silhouette and one backdrop sample for the body AND its pointer.
    // The outline goes around the pointer; there is no panel border across its base.
    const pad = 10, l = pad, t0 = pad, r = pad + b.width, bot = pad + b.height;
    const style = getComputedStyle(panel);
    const radius = Math.min(parseFloat(style.borderTopLeftRadius) || 22, b.width / 2, b.height / 2);
    const cx = pad + Math.max(radius + 12, Math.min(x - b.left, b.width - radius - 12));
    const cy = pad + Math.max(radius + 12, Math.min(y - b.top, b.height - radius - 12));
    let d = `M ${l + radius} ${t0}`;
    if (edge === 'top') d += ` L ${cx - 8} ${t0} L ${cx} ${t0 - 8} L ${cx + 8} ${t0}`;
    d += ` L ${r - radius} ${t0} Q ${r} ${t0} ${r} ${t0 + radius}`;
    if (edge === 'right') d += ` L ${r} ${cy - 8} L ${r + 8} ${cy} L ${r} ${cy + 8}`;
    d += ` L ${r} ${bot - radius} Q ${r} ${bot} ${r - radius} ${bot}`;
    if (edge === 'bottom') d += ` L ${cx + 8} ${bot} L ${cx} ${bot + 8} L ${cx - 8} ${bot}`;
    d += ` L ${l + radius} ${bot} Q ${l} ${bot} ${l} ${bot - radius}`;
    if (edge === 'left') d += ` L ${l} ${cy + 8} L ${l - 8} ${cy} L ${l} ${cy - 8}`;
    d += ` L ${l} ${t0 + radius} Q ${l} ${t0} ${l + radius} ${t0} Z`;
    Object.assign(skin.style, {left:`${b.left-pad}px`,top:`${b.top-pad}px`,width:`${b.width+pad*2}px`,height:`${b.height+pad*2}px`});
    const glass = skin.querySelector('[data-smoof-panel-glass]');
    const shadow = skin.firstElementChild;
    shadow.setAttribute('viewBox', `0 0 ${b.width+pad*2} ${b.height+pad*2}`);
    shadow.lastElementChild.setAttribute('d', d);
    glass.style.clipPath = `path("${d}")`;
    glass.style.background = style.getPropertyValue('--smoof-ui-panel-bg');
    const svg = skin.lastElementChild;
    svg.setAttribute('viewBox', `0 0 ${b.width+pad*2} ${b.height+pad*2}`);
    svg.firstElementChild.setAttribute('d', d);
    svg.firstElementChild.setAttribute('stroke', style.getPropertyValue('--smoof-ui-stroke').trim() || '#ddd');
    skin.dataset.edge = edge;
    skin.hidden = false;
    panel.dataset.smoofUnifiedSkin = 'true';
  }

  function renderContext() {
    if(context?.contains(document.activeElement)&&document.activeElement?.matches('[data-smoof-arrow-label-field]:not(select)'))return;
    if(personalizedDesignSelected()&&multiPanel(context))return;
    if (deferPanelRender(context)) return;
    if (panelSubview) { if(panelSubview.item===selectedId)return; leavePanelSubview(true); }
    if (activePercentageInputIn(context)) return;
    if (!personalizedDesignSelected()) {
      context.dataset.open = 'false';
      return;
    }
    if (selectedId === 'guides' && context?.dataset.open === 'true' && context.dataset.smoofUiItemId === 'guides') { syncGuideSwitches(); return; }
    const descriptor = descriptors()[selectedId];
    source = descriptor ? sourceFor(selectedId) : null;
    if (!descriptor || layersOpen) {
      context.dataset.open = 'false';
      return;
    }
    if (selectedId === 'templates' && (context.dataset.open !== 'true' || context.dataset.smoofUiItemId !== 'templates')) {
      templateCategory = '';
      window.SmoofTemplateLibrary?.selectLanguage?.('', { silent: true });
    }
    const templateStep = selectedId === 'templates' ? ':' + (window.SmoofTemplateLibrary?.selectedLanguage || 'choose') : '';
    const scrollSnapshot = capturePanelScroll(context, `context:${selectedId}${templateStep}`);
    const focused = selectedId === 'downloads' && context.contains(document.activeElement) ? document.activeElement : null;
    const downloadFocus = focused?.dataset.smoofUiAction ? `[data-smoof-ui-action="${CSS.escape(focused.dataset.smoofUiAction)}"]`
      : focused?.matches('[data-smoof-design-login]') ? '[data-smoof-design-login]'
      : focused?.matches('[data-smoof-production-login-refresh]') ? '[data-smoof-production-login-refresh]' : ''; 
    const templateFocusAction = selectedId === 'templates' && context.contains(document.activeElement)
      ? document.activeElement.dataset.smoofUiAction : '';
    const switchMotion = captureSwitchMotion(context);
    const stateControlFocus = captureStateControlFocus(context);
    const dropdownFocus = captureDropdownFocus(context);
    context.innerHTML = panelHead(descriptor, 'context') + `<div data-smoof-ui-panel-body>${detailBody(descriptor)}</div>`;
    context.querySelectorAll('select[data-smoof-ui-select]').forEach(enhanceCategorySelect);
    window.SmoofProductionAccess?.sync();
    context.dataset.smoofUiItemId = selectedId;
    context.dataset.open = 'true';
    restoreDropdownFocus(context, dropdownFocus);
    restoreStateControlFocus(context, stateControlFocus);
    restoreSwitchMotion(context, switchMotion);
    if (templateFocusAction) context.querySelector(`[data-smoof-ui-action="${CSS.escape(templateFocusAction)}"]`)?.focus({preventScroll:true});
    if (downloadFocus) context.querySelector(`${downloadFocus}:not([hidden]):not(:disabled)`)?.focus({ preventScroll: true });
    installPanelScrollAffordance(context);
    restorePanelScroll(context, scrollSnapshot);
    requestAnimationFrame(() => {
      positionContext();
    });
  }

  function layerRows() {
    const customTextIds = (window.SmoofCustomTextTools?.getStates?.() || []).filter(state => state.enabled).map(state => state.id);
    const customPictogramIds = (window.SmoofCustomPictogramTools?.getStates?.() || []).filter(state => state.enabled).map(state => state.id);
    const socialPlatformIds = Object.keys(window.SmoofSocialPlatformTools?.getState?.().objects || {}).map(id => `social-platform-${id}`);
    const order = ['text-0', 'text-1', 'text-2', ...customTextIds, 'arrow-left', 'arrow-right', ...customPictogramIds, 'logo', 'logo-copy', 'logo-2', 'payments', ...socialPlatformIds, 'table-number', 'branding-dot', 'nfc', 'qr', 'background'];
    const map = descriptors();
    return order.filter(id => {
      if (id === 'nfc') return window.SmoofNfcTools?.isActive?.();
      if (id === 'logo-copy') return window.SmoofLogoCopyTools?.getState?.()?.enabled;
      if (id === 'logo-2') return window.SmoofLogoDuplicateTools?.getState?.()?.hasLogo;
      if (id === 'payments') {
        const selected = window.SmoofPaymentTools?.getState?.()?.selected;
        return Array.isArray(selected) && selected.length > 0;
      }
      return true;
    }).map(id => {
      const item = map[id];
      const visibility = Boolean(item.hideable);
      const locked = item.locked;
      const action = visibility
        ? `<button type="button" data-smoof-ui-layer-action="${id}" aria-label="${t('Sichtbarkeit ändern', 'Change visibility')}">${icon(isVisible(id) ? 'eye' : 'eyeOff')}</button>`
        : `<span data-smoof-ui-layer-action>${icon(locked ? 'lock' : 'editor')}</span>`;
      const eligible = multiEligible(id);
      const reason = !isVisible(id) ? mt('Ausgeblendet · zum Auswählen einblenden','Hidden · show to select','Nascosto · mostra per selezionare') : mt('Nicht gemeinsam auswählbar','Not available for multiple selection','Non disponibile per la selezione multipla');
      const pick = `<button type="button" data-smoof-ui-multi-pick="${id}" role="checkbox" aria-checked="${multiIds.has(id)}" aria-label="${escapeHtml(item.title)}"${!eligible ? ` disabled aria-describedby="smoof-layer-reason-${id}"` : ''}><span data-smoof-ui-pick-mark aria-hidden="true">${multiIds.has(id) ? '✓' : ''}</span></button>`;
      return `<div data-smoof-ui-layer="${id}" data-editable="${String(!item.locked)}" data-multi-selected="${multiMode && multiIds.has(id)}" data-multi-unavailable="${multiMode && !eligible}"><span data-smoof-ui-layer-symbol>${multiMode ? pick : icon(item.symbol)}</span><span><strong data-smoof-ui-layer-name>${item.title}</strong><small data-smoof-ui-layer-copy${multiMode && !eligible ? ` id="smoof-layer-reason-${id}"` : ''}>${multiMode && !eligible ? reason : item.copy}</small></span>${action}</div>`;
    }).join('');
  }

  function layerSelectionControls() {
    const count = multiIds.size;
    const status = count === 1 ? mt('1 Element ausgewählt','1 element selected','1 elemento selezionato') : `${count} ${mt('Elemente ausgewählt','elements selected','elementi selezionati')}`;
    return `<div data-smoof-ui-layer-selection><div data-smoof-ui-layer-selection-bar><span role="status">${multiMode ? status : mt('Mehrfachauswahl','Multiple selection','Selezione multipla')}</span><button type="button" data-smoof-ui-wide-button data-smoof-multi-action="toggle" aria-pressed="${multiMode}">${multiMode ? mt('Fertig','Done','Fine') : mt('Auswählen','Select','Seleziona')}</button></div>${multiMode ? `<small data-smoof-ui-control-note>${mt('Wählen Sie die gewünschten Ebenen. Ausgeblendete Ebenen können Sie über das Auge einblenden.','Choose the layers you want. Use the eye to show hidden layers.','Selezioni i livelli desiderati. Usi l’occhio per mostrare i livelli nascosti.')}</small>${count > 1 ? `<button type="button" data-smoof-ui-wide-button data-smoof-multi-action="edit-layers">${mt('Auswahl bearbeiten','Edit selection','Modifica selezione')}${controlIcon('forward')}</button>` : ''}` : ''}</div>`;
  }

  function renderLayers() {
    if(layers?.contains(document.activeElement)&&document.activeElement?.matches('[data-smoof-arrow-label-field]:not(select)'))return;
    if (deferPanelRender(layers)) return;
    if (panelSubview) { if(panelSubview.item===selectedId)return; leavePanelSubview(true); }
    if (activePercentageInputIn(layers)) return;
    if (!layersOpen) return;
    for (const id of multiIds) if (!multiEligible(id)) multiIds.delete(id);
    const scrollKey = layersPage === 'detail'
      ? `layers:detail:${selectedId}`
      : 'layers:list';
    const scrollSnapshot = capturePanelScroll(layers, scrollKey);
    const layerFocus = layers.contains(document.activeElement) ? document.activeElement : null;
    const layerFocusSelector = layerFocus?.hasAttribute('data-smoof-ui-multi-pick') ? `[data-smoof-ui-multi-pick="${CSS.escape(layerFocus.dataset.smoofUiMultiPick)}"]`
      : layerFocus?.hasAttribute('data-smoof-ui-layer-action') ? `[data-smoof-ui-layer-action="${CSS.escape(layerFocus.dataset.smoofUiLayerAction)}"]`
      : layerFocus?.hasAttribute('data-smoof-multi-action') ? `[data-smoof-multi-action="${CSS.escape(layerFocus.dataset.smoofMultiAction)}"]` : '';
    const switchMotion = captureSwitchMotion(layers);
    const stateControlFocus = captureStateControlFocus(layers);
    const dropdownFocus = captureDropdownFocus(layers);
    if (layersPage === 'detail') {
      if(multiPanel(layers))return;
      const descriptor = descriptors()[selectedId];
      source = descriptor ? sourceFor(selectedId) : null;
      if (!descriptor) { layersPage = 'list'; renderLayers(); return; }
      layers.innerHTML = panelHead(descriptor, 'layers-detail') + `<div data-smoof-ui-panel-body>${detailBody(descriptor)}</div>`;
      window.SmoofProductionAccess?.sync();
      layers.dataset.smoofUiItemId = selectedId;
    } else {
      delete layers.dataset.smoofUiItemId;
      layers.innerHTML = `<header data-smoof-ui-panel-head><span data-smoof-ui-panel-symbol>${icon('layers')}</span><span><strong data-smoof-ui-panel-title>${t('Ebenen', 'Layers')}</strong><small data-smoof-ui-panel-copy>${t('Element auswählen und bearbeiten', 'Choose and edit an element')}</small></span><button type="button" data-smoof-ui-panel-close aria-label="${t('Schließen', 'Close')}">${icon('close')}</button></header><div data-smoof-ui-layer-list>${layerSelectionControls()}${layerRows()}</div>`;
    }
    layers.querySelectorAll('select[data-smoof-ui-select]').forEach(enhanceCategorySelect);
    restoreDropdownFocus(layers, dropdownFocus);
    restoreStateControlFocus(layers, stateControlFocus);
    restoreSwitchMotion(layers, switchMotion);
    if (layerFocusSelector) layers.querySelector(layerFocusSelector)?.focus({preventScroll:true});
    installPanelScrollAffordance(layers);
    restorePanelScroll(layers, scrollSnapshot);
    requestAnimationFrame(() => {
      positionLayers();
    });
  }

  // The toolbar silhouette owns vertical clearance; buttons still own pointer alignment.
  const toolbarPanelGap = 10;
  const panelViewportInset = 12;
  function toolbarPanelPlacement(panel) {
    const bar = commandbar.getBoundingClientRect();
    const belowTop = Math.max(panelViewportInset, bar.bottom + toolbarPanelGap);
    const aboveBottom = Math.min(innerHeight - panelViewportInset, bar.top - toolbarPanelGap);
    const below = Math.max(0, innerHeight - panelViewportInset - belowTop);
    const above = Math.max(0, aboveBottom - panelViewportInset);
    const placeAbove = below < 180 && above > below;
    const available = placeAbove ? above : below;
    panel.style.setProperty('--smoof-ui-available-height', `${available}px`);
    panel.style.maxHeight = `${available}px`;
    const height = panel.getBoundingClientRect().height;
    return placeAbove ? aboveBottom - height : belowTop;
  }

  function positionContext() {
    scheduleMobileWorkspace();
    if (!context) return;
    if (mobile.matches) { context.style.removeProperty('max-height'); context.style.removeProperty('--smoof-ui-available-height'); }
    if (context.dataset.open !== 'true' || mobile.matches) {updatePanelAnchor(context,visibleItemFor(selectedId));return;}
    const item = visibleItemFor(selectedId);
    const toolbarAction = selectedId === 'payments' || selectedId === 'add' || selectedId === 'social-library'
      ? 'add'
      : selectedId === 'templates'
        ? 'templates'
      : selectedId === 'guides'
        ? 'guides'
      : selectedId === 'downloads'
        ? 'save-design'
        : 'layers';
    const toolbarAnchor = commandbar?.querySelector(
      `[data-smoof-ui-command-action="${toolbarAction}"]`
    ) || commandbar;
    const anchor = item || toolbarAnchor;
    if (!anchor) return;
    const a = panelAnchorRect(anchor);
    const anchoredToToolbar = !item;
    context.style.removeProperty('--smoof-ui-available-height');
    context.style.maxHeight = `${Math.max(180, innerHeight - 24)}px`;
    const toolbarTop = anchoredToToolbar ? toolbarPanelPlacement(context) : null;
    const b = context.getBoundingClientRect();
    let left = anchoredToToolbar ? a.left + (a.width - b.width) / 2 : a.right + 14;
    if (!anchoredToToolbar && left + b.width > innerWidth - 12) left = a.left - b.width - 14;
    left = Math.max(12, Math.min(left, innerWidth - b.width - 12));
    let top = anchoredToToolbar ? toolbarTop : a.top + (a.height - b.height) / 2;
    if (!anchoredToToolbar) top = Math.max(12, Math.min(top, innerHeight - b.height - 12));
    context.style.left = `${Math.round(left)}px`;
    context.style.top = `${Math.round(top)}px`;
    updatePanelAnchor(context,anchor);
  }

  function positionLayers() {
    if (!layers || !commandbar) return;
    if (mobile.matches) {layers.style.removeProperty('max-height');layers.style.removeProperty('--smoof-ui-available-height');updatePanelAnchor(layers,layersPage==='detail'?visibleItemFor(selectedId):commandbar.querySelector('[data-smoof-ui-command-action=layers]'));return;}
    const a = commandbar.getBoundingClientRect();
    const top = toolbarPanelPlacement(layers);
    const b = layers.getBoundingClientRect();
    let left = a.left + (a.width - b.width) / 2;
    left = Math.max(12, Math.min(left, innerWidth - b.width - 12));
    layers.style.left = `${Math.round(left)}px`;
    layers.style.top = `${Math.round(top)}px`;
    updatePanelAnchor(layers,layersPage==='detail'?visibleItemFor(selectedId):commandbar.querySelector('[data-smoof-ui-command-action=layers]'));
  }

  function commandbarAnchor() {
    const candidates = Array.from(document.querySelectorAll(
      '.po-livePreview-root, media-gallery.product__gallery, .product__gallery'
    ));

    return candidates.find(candidate => {
      const rect = candidate.getBoundingClientRect();
      const style = getComputedStyle(candidate);
      return style.display !== 'none' && rect.width > 240 && rect.height > 240;
    }) || visibleItemFor('background');
  }

  function ensureCommandbarHost(anchor) {
    if (!anchor || !anchor.parentNode || !commandbar) return;

    const flowAnchor = anchor.matches('.po-livePreview-root')
      ? (anchor.closest('media-gallery.product__gallery, .product__gallery') || anchor)
      : anchor;

    if (!flowAnchor.parentNode) return;

    if (commandbarFlowParent && commandbarFlowParent !== flowAnchor.parentNode) {
      delete commandbarFlowParent.dataset.smoofUiGalleryFlow;
    }
    commandbarFlowParent = flowAnchor.parentNode;
    commandbarFlowParent.dataset.smoofUiGalleryFlow = 'true';

    if (!commandbarHost || !commandbarHost.isConnected) {
      commandbarHost = document.createElement('div');
      commandbarHost.dataset.smoofUiCommandbarHost = 'true';
      commandbarHost.dataset.smoofEditorItem = 'modern-ui-control';
    }

    if (
      commandbarHost.parentNode !== flowAnchor.parentNode ||
      commandbarHost.nextSibling !== flowAnchor
    ) {
      flowAnchor.parentNode.insertBefore(commandbarHost, flowAnchor);
    }

    if (commandbar.parentNode !== commandbarHost) {
      commandbarHost.append(commandbar);
    }
  }

  function positionCommandbar() {
    if (!commandbar) return;
    const anchor = commandbarAnchor();
    if (!anchor) return;
    ensureCommandbarHost(anchor);
    commandbar.style.removeProperty('left');
    commandbar.style.removeProperty('top');
  }

  function legacyPanel(action) {
    const selector = action === 'help' ? '[data-smoof-guide-legend]' : '[data-smoof-reset-menu]';
    return document.querySelector(selector);
  }

  function ensureLegacyPanelShell(action, panel) {
    if (!panel || panel.dataset.smoofUiLegacyShell === 'true') return;

    const isHelp = action === 'help';
    // The reset panel contains ordinary buttons and explanatory copy, rather
    // than menuitems with an application-menu keyboard contract.
    if (!isHelp) {
      panel.setAttribute('role', 'group');
      panel.setAttribute('aria-label', t('Zurücksetzen', 'Reset'));
      panel.removeAttribute('aria-labelledby');
      document.querySelector('[data-smoof-reset-button]')?.removeAttribute('aria-haspopup');
    }
    const header = document.createElement('header');
    header.dataset.smoofUiPanelHead = 'true';
    header.dataset.smoofUiLegacyHeader = action;
    header.innerHTML = [
      `<span data-smoof-ui-panel-symbol>${icon(isHelp ? 'help' : 'reset')}</span>`,
      '<span>',
      `<strong data-smoof-ui-panel-title>${isHelp ? t('Hilfe zum Editor', 'Editor help') : t('Zurücksetzen', 'Reset')}</strong>`,
      `<small data-smoof-ui-panel-copy>${isHelp ? t('Funktionen und Druckfläche', 'Features and print area') : t('Layout oder gesamtes Design wählen', 'Choose layout or entire design')}</small>`,
      '</span>',
      `<button type="button" data-smoof-ui-panel-close aria-label="${t('Schließen', 'Close')}">${icon('close')}</button>`
    ].join('');

    const body = document.createElement('div');
    body.dataset.smoofUiLegacyBody = action;
    while (panel.firstChild) body.append(panel.firstChild);

    if (isHelp) {
      const printHeading = document.createElement('strong');
      printHeading.textContent = t(window.SmoofI18n.legacy('Hinweise zur Druckfläche'), 'Print area guidance');
      body.prepend(printHeading);
      const onboarding = document.createElement('section');
      onboarding.dataset.smoofUiHelpOnboarding = 'true';
      onboarding.innerHTML = `<strong>${t('Einführung in den SMOOF DOTS Editor', 'Introduction to the SMOOF DOTS Editor')}</strong><p>${t('Lernen Sie die wichtigsten Bereiche kennen, ohne Ihr Design zu verändern.', 'Explore the most important areas without changing your design.')}</p><button type="button" data-smoof-editor-tour-restart>${t('Einführung erneut starten', 'Restart introduction')}</button>`;
      const reference = document.createElement('section');
      reference.dataset.smoofUiHelpReference = 'true';
      reference.innerHTML = `<details><summary>${t("Ihre Arbeitsfläche", "Your workspace")}</summary><p>${t("Wählen Sie ein Element auf der Druckfläche aus, um es zu verschieben oder seine Einstellungen zu öffnen. Auf Mobilgeräten genügt ein Antippen. Schriftwahl und Logo-Zuschnitt öffnen sich im selben Panel; der Zurück-Pfeil führt zu den Einstellungen.", "Select an element on the print area to move it or open its settings. On mobile, tap it. Font selection and logo cropping open within the same panel; use the back arrow to return to its settings.")}</p></details><details><summary>${t("Mit Vorlagen starten", "Start with templates")}</summary><p>${t("Wählen Sie zuerst eine verfügbare Sprache, dann eine Kategorie und ein Design. Das Angebot richtet sich nach Ihrem Produkt und dem jeweiligen Shopbereich. Vor dem Ersetzen Ihres Designs erscheint eine Bestätigung.", "Choose an available language, then a category and a design. Available templates depend on your product and shop area. You will be asked to confirm before your design is replaced.")}</p></details><details><summary>${t("Texte und Schriften", "Text and fonts")}</summary><p>${t("Markieren Sie in einem Textfeld einzelne Zeichen oder Wörter, um Schrift, verfügbaren Schriftschnitt und Farbe nur dort zu ändern. „Gesamter Text“ beendet die Auswahl. Größe, Laufweite und Drehung gelten weiterhin für das ganze Feld.", "Select characters or words within a text field to change their font, available font style and colour. “Whole text” clears the selection. Size, letter spacing and rotation still apply to the whole field.")}</p></details><details><summary>${t("Ihre Schriftbibliothek", "Your font library")}</summary><p>${t("Über die Schriftwahl finden Sie Standardschriften und bereits hochgeladene eigene Schriften. Über „Eigene Schrift hochladen“ können Sie mehrere WOFF-, WOFF2-, TTF- oder OTF-Dateien gemeinsam hinzufügen. Bestätigen Sie dafür Ihre Nutzungs- und Produktionsrechte.", "The font picker includes standard fonts and your previously uploaded fonts. Use “Upload custom font” to add several WOFF, WOFF2, TTF or OTF files together and confirm that you hold the required usage and production rights.")}</p></details><details><summary>${t("Logos und Ausschnitt", "Logos and cropping")}</summary><p>${t("Wählen Sie Ihr hochgeladenes Hauptlogo und öffnen Sie „Logo zuschneiden“. Bei PNG, JPG und WEBP im Farbdruck können Sie den Ausschnitt anpassen oder transparente Außenränder entfernen. „Ganzes Original“ stellt das vollständige Bild wieder her. SVG und Laser bleiben ausgenommen.", "Select your uploaded main logo and open the crop tool. For PNG, JPG and WEBP in colour printing, adjust the crop or remove transparent outer margins. Restore the full original at any time. Cropping is unavailable for SVG and laser engraving.")}</p></details><details><summary>${t("Alle Elemente im Blick", "Keep every element in view")}</summary><p>${t("Unter Ebenen können Sie Elemente auswählen, bearbeiten, ausblenden und wieder einblenden. Prozentwerte lassen sich auch direkt eingeben; Plus und Minus ermöglichen kleine Anpassungen.", "Use Layers to select, edit, hide and restore elements. You can enter percentage values directly or make small adjustments with the plus and minus controls.")}</p></details><details><summary>${t("Elemente hinzufügen", "Add elements")}</summary><p>${t("Über Plus ergänzen Sie verfügbare Texte, Logos, Piktogramme, Zahlungsanbieter und Social-Media-Elemente. Dazu gehören Bewertungssterne und Markenvarianten mit Originalfarben. Bei DOT ME im Lasermodus bleiben Motive schwarz; weitere Optionen richten sich nach Produkt und Design.", "Use Add for available text, logos, pictograms, payment providers and social elements, including rating stars and brand variants in original colours. DOT ME laser artwork stays black; other options depend on your product and design.")}</p></details><details><summary>${t("Präzise ausrichten", "Align precisely")}</summary><p>${t("Im Lineal-Menü steuern Sie Bemaßung sowie horizontales und vertikales Einrasten getrennt. Ausgewählte Elemente verschieben Sie mit den Pfeiltasten, mit Umschalt in größeren Schritten. Während der Texteingabe bleiben die Tasten für den Text verfügbar.", "The ruler menu controls measurements and horizontal and vertical snapping separately. Move selected elements with the arrow keys; hold Shift for larger steps. While typing, the keys continue to control the text.")}</p></details><details><summary>${t("Designs und Dateien", "Designs and files")}</summary><p>${t("Speichern Sie Ihr Design als .smoofdesign-Datei und öffnen Sie es später erneut. Bei beidseitigen Produkten enthält die Datei beide Seiten. Hier finden Sie auch die Produktvorschau sowie Proof- und Produktionsdownloads. Beim Laden auf ein anderes Produkt gelten dessen technische Möglichkeiten.", "Save your design as a .smoofdesign file and reopen it later. For double-sided products, the file includes both sides. This panel also offers a product preview and proof and production downloads. When loading on another product, that product’s technical capabilities apply.")}</p></details><details><summary>${t("Sicher bearbeiten", "Edit with confidence")}</summary><p>${t("Rückgängig und Wiederholen helfen bei Änderungen. Zurücksetzen öffnet immer zuerst eine Auswahl. Bei eigenen QR-Farben achten Sie auf starken Kontrast; Hinweise dazu finden Sie im QR-Panel.", "Use Undo and Redo to manage changes. Reset always opens a choice first. Choose strong contrast for custom QR colours; see the QR panel for scanning guidance.")}</p></details>`;
      const viewHelp = view360Help();
      const viewDetails = document.createElement('details');
      viewDetails.setAttribute('data-smoof-ui-help-360', 'true');
      const viewSummary = document.createElement('summary');
      const viewBody = document.createElement('p');
      viewSummary.textContent = viewHelp.title;
      viewBody.textContent = viewHelp.body;
      viewDetails.append(viewSummary, viewBody);
      const multiHelp=document.createElement('details');multiHelp.dataset.smoofHelpMulti='true';
      const multiSummary=document.createElement('summary'),multiCopy=document.createElement('p');
      multiSummary.textContent=mt('Mehrere Elemente bearbeiten','Edit multiple elements','Modifica più elementi');
      multiCopy.textContent=mt('Mit Umschalt + Klick wählen Sie mehrere Elemente aus. Über „Mehrfach auswählen“ können Sie Elemente auch nacheinander antippen oder einen Auswahlrahmen ziehen. In der Ebenenliste zeigen Häkchen Ihre Auswahl. Ziehen Sie ein markiertes Element, um alle gemeinsam zu bewegen. Das gemeinsame Menü richtet Gruppen und einzelne Elemente als Einheiten aus. Ab drei Einheiten können Sie diese gleichmäßig verteilen; die Anordnung innerhalb jeder Gruppe bleibt erhalten. Mit den Gruppenicons verbinden oder trennen Sie die Auswahl dauerhaft; ein Klick wählt später die ganze Gruppe. Bei Texten stehen Schrift, Farbe, Laufweite und relative Größe zur Verfügung; Deckkraft wird für unterstützte Elemente angeboten; 100 % entspricht den Größen beim Auswählen. Eine neue Textfarbe ersetzt auch vorhandene Wortfarben. Escape oder „Auswahl aufheben“ beendet die Auswahl. Rückgängig nimmt jede gemeinsame Änderung zusammen zurück.','Use Shift + click to select multiple elements. Turn on “Select multiple” to tap elements one by one or drag a selection box. Checkmarks in Layers show your selection. Drag a selected element to move them together. The shared menu aligns groups and individual elements as units. With three or more units, you can distribute them evenly while preserving the arrangement within each group. The group icons link or unlink the selection; a later click selects the whole group. Text selections also offer font, colour, letter spacing and relative size; opacity is available for supported elements; 100% means the sizes when selected. A new text colour also replaces existing word colours. Escape or “Clear selection” ends the selection. Undo reverses each shared change as one action.','Usa Maiusc + clic per selezionare più elementi. Attiva “Seleziona più elementi” per toccarli uno alla volta o trascinare un riquadro di selezione. Le spunte nei livelli indicano la selezione. Trascina un elemento selezionato per spostarli insieme. Il menu comune allinea gruppi e singoli elementi come unità. Con almeno tre unità, puoi distribuirle uniformemente mantenendo la disposizione interna di ogni gruppo. Le icone di raggruppamento uniscono o separano la selezione; un clic successivo seleziona tutto il gruppo. Per i testi offre carattere, colore, spaziatura e dimensione relativa; l’opacità è disponibile per gli elementi supportati; 100% corrisponde alle dimensioni alla selezione. Un nuovo colore sostituisce anche i colori delle singole parole. Esc o “Deseleziona tutto” termina la selezione. Annulla ripristina ogni modifica comune in un’unica operazione.');
      multiHelp.append(multiSummary,multiCopy);reference.append(multiHelp);
      reference.append(viewDetails);
      body.prepend(reference);
      body.prepend(onboarding);
    }

    panel.append(header, body);
    panel.dataset.smoofUiLegacyShell = 'true';
    new ResizeObserver(() => positionLegacyPopover(action)).observe(panel);
    new MutationObserver(() => {
      if (panel.hidden || getComputedStyle(panel).display === 'none' || getComputedStyle(panel).visibility === 'hidden') updatePanelAnchor(panel, null);
    }).observe(panel, {attributes:true, attributeFilter:['hidden', 'style']});

    header.querySelector('[data-smoof-ui-panel-close]')?.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      if (isHelp) closeLegacyHelp();
      else closeLegacyReset();
    });
  }

  function legacyPanelOpen(action) {
    const panel = legacyPanel(action);
    if (!panel || panel.hidden) return false;
    const style = getComputedStyle(panel);
    return style.display !== 'none' && style.visibility !== 'hidden';
  }

  function closeLegacyHelp() {
    const panel = legacyPanel('help');
    if (panel) {
      panel.style.removeProperty('display');
      panel.hidden = true;
      updatePanelAnchor(panel, null);
    }
    const native = document.querySelector('[data-smoof-guide-button]');
    if (native) native.setAttribute('aria-expanded', 'false');
    const modern = commandbar?.querySelector('[data-smoof-ui-command-action="help"]');
    if (modern) modern.setAttribute('aria-expanded', 'false');
    const previewRoot = document.querySelector('.po-livePreview-root[data-smoof-legend-open="true"]');
    if (previewRoot) previewRoot.removeAttribute('data-smoof-legend-open');
  }

  function openLegacyHelp() {
    const panel = legacyPanel('help');
    if (!panel) return;

    ensureLegacyPanelShell('help', panel);

    closeLegacyReset();
    if (layersOpen) setLayersOpen(false);
    if (context) context.dataset.open = 'false';

    panel.hidden = false;
    panel.dataset.smoofModernHelp = 'true';
    panel.style.setProperty('display', 'grid', 'important');

    const native = document.querySelector('[data-smoof-guide-button]');
    if (native) native.setAttribute('aria-expanded', 'true');

    const modern = commandbar?.querySelector('[data-smoof-ui-command-action="help"]');
    if (modern) modern.setAttribute('aria-expanded', 'true');

    const previewRoot = document.querySelector('.po-livePreview-root');
    if (previewRoot) previewRoot.dataset.smoofLegendOpen = 'true';

    window.dispatchEvent(new CustomEvent('smoof:editor-select', { detail: { id: '' } }));
    positionLegacyPopover('help');
    requestAnimationFrame(() => positionLegacyPopover('help'));
  }

  function closeLegacyReset() {
    const panel = legacyPanel('reset');
    if (panel) {
      panel.style.removeProperty('display');
      panel.style.removeProperty('visibility');
      panel.hidden = true;
      updatePanelAnchor(panel, null);
    }
    const native = document.querySelector('[data-smoof-reset-button]');
    if (native) native.setAttribute('aria-expanded', 'false');
    const modern = commandbar?.querySelector('[data-smoof-ui-command-action="reset"]');
    if (modern) modern.setAttribute('aria-expanded', 'false');
  }

  function openLegacyReset() {
    let panel = legacyPanel('reset');
    const native = document.querySelector('[data-smoof-reset-button]');

    /* Das stabile Reset-Liquid erzeugt sein Menü erst beim ersten Öffnen. */
    if (!panel && native) {
      native.click();
      panel = legacyPanel('reset');
    }
    if (!panel) return;

    ensureLegacyPanelShell('reset', panel);

    closeLegacyHelp();
    if (layersOpen) setLayersOpen(false);
    if (context) context.dataset.open = 'false';

    panel.dataset.smoofModernReset = 'true';
    panel.style.setProperty('visibility', 'hidden', 'important');
    panel.hidden = false;
    panel.style.setProperty('display', 'grid', 'important');

    if (native) native.setAttribute('aria-expanded', 'true');
    const modern = commandbar?.querySelector('[data-smoof-ui-command-action="reset"]');
    if (modern) modern.setAttribute('aria-expanded', 'true');

    positionLegacyPopover('reset');
    requestAnimationFrame(() => {
      if (!panel.hidden) {
        positionLegacyPopover('reset');
        panel.style.removeProperty('visibility');
        updatePanelAnchor(panel, commandbar?.querySelector('[data-smoof-ui-command-action=reset]'));
      }
    });
  }

  function positionLegacyPopover(action) {
    if (!commandbar) return;
    const panel = legacyPanel(action);
    if (!panel) return;
    const style = getComputedStyle(panel);
    const measuringReset = action === 'reset' && panel.dataset.smoofModernReset === 'true';
    if (panel.hidden || style.display === 'none' || (style.visibility === 'hidden' && !measuringReset)) { updatePanelAnchor(panel, null); return; }
    const anchor = commandbar.getBoundingClientRect();
    const box = panel.getBoundingClientRect();
    const button = visibleCommandAnchor(commandbar.querySelector(`[data-smoof-ui-command-action="${action}"]`));
    const buttonBox = button?.getBoundingClientRect();
    const pointerInset = (parseFloat(style.borderTopLeftRadius) || 22) + 12;
    let left = Math.max(anchor.right - box.width, buttonBox ? buttonBox.left + buttonBox.width / 2 - box.width + pointerInset : 0);
    left = Math.max(12, Math.min(left, innerWidth - box.width - 12));
    const top = Math.max(12, anchor.bottom + 10);
    const availableHeight = Math.max(180, innerHeight - top - 12);
    if (action === 'help') {
      panel.dataset.smoofModernHelp = 'true';
      panel.style.setProperty('--smoof-modern-help-left', `${Math.round(left)}px`);
      panel.style.setProperty('--smoof-modern-help-top', `${Math.round(top)}px`);
      panel.style.setProperty('--smoof-modern-help-height', `${Math.round(availableHeight)}px`);
    } else {
      panel.dataset.smoofModernReset = 'true';
      panel.style.setProperty('--smoof-modern-reset-left', `${Math.round(left)}px`);
      panel.style.setProperty('--smoof-modern-reset-top', `${Math.round(top)}px`);
      panel.style.setProperty('--smoof-modern-reset-height', `${Math.round(availableHeight)}px`);
    }
    updatePanelAnchor(panel, button);
  }

  function syncSelectionAppearance() {
    const item = personalizedDesignSelected() ? visibleItemFor(selectedId) : null;
    document.querySelectorAll('[data-smoof-ui-selected-object]').forEach(node => {
      if (node !== item) node.removeAttribute('data-smoof-ui-selected-object');
    });
    if (item && !item.hasAttribute('data-smoof-ui-selected-object')) item.setAttribute('data-smoof-ui-selected-object', 'true');
  }

  function syncCommandbar() {
    syncSelectionAppearance();
    if (!commandbar) return;
    if (!syncPersonalizationGate()) return;
    const layersButton = commandbar.querySelector('[data-smoof-ui-command-action="layers"]');
    if (layersButton) layersButton.setAttribute('aria-expanded', String(layersOpen));
    const addButton = commandbar.querySelector('[data-smoof-ui-command-action="add"]');
    if (addButton) {
      const addOpen = (selectedId === 'add' || selectedId === 'payments') && context?.dataset.open === 'true';
      addButton.setAttribute('aria-expanded', String(addOpen));
    }
    const downloadsButton = commandbar.querySelector('[data-smoof-ui-command-action="save-design"]');
    if (downloadsButton) {
      const downloadsOpen = selectedId === 'downloads' && context?.dataset.open === 'true';
      downloadsButton.setAttribute('aria-expanded', String(downloadsOpen));
    }
    const templatesButton = commandbar.querySelector('[data-smoof-ui-command-action="templates"]');
    if (templatesButton) {
      const templatesOpen = selectedId === 'templates' && context?.dataset.open === 'true';
      templatesButton.setAttribute('aria-expanded', String(templatesOpen));
    }
    const guideButton = commandbar.querySelector('[data-smoof-ui-command-action="guides"]');
    if (guideButton) {
      guideButton.removeAttribute('data-active');
      guideButton.removeAttribute('aria-pressed');
      guideButton.setAttribute('aria-expanded', String(selectedId === 'guides' && context?.dataset.open === 'true'));
      syncGuideSwitches();
    }
    const helpButton = commandbar.querySelector('[data-smoof-ui-command-action="help"]');
    if (helpButton) helpButton.setAttribute('aria-expanded', String(legacyPanelOpen('help')));
    const resetButton = commandbar.querySelector('[data-smoof-ui-command-action="reset"]');
    if (resetButton) resetButton.setAttribute('aria-expanded', String(legacyPanelOpen('reset')));
    syncHistoryButtons();
    positionCommandbar();
  }

  function proxy(selector) { return source ? source.querySelector(selector) : null; }
  function clickNative(selector) { const el = proxy(selector); if (el && !el.disabled) el.click(); }

  function finishFontSelection(family) {
    const clean = cleanFontFamily(family);
    const itemId = fontPickerTarget;
    if (!itemId || !clean || !/^[a-z0-9 ._-]+$/i.test(clean)) return false;
    if(multiFont&&multiIds.size>1){const applied=multiApplyFont(clean);multiFont=false;if(panelSubview?.kind==='font')leavePanelSubview(false);fontPickerTarget='';fontPickerInitialFamily='';root.removeAttribute('data-smoof-font-picker-active');setTimeout(multiRefresh,80);return applied;}
    const customFont = window.SmoofCustomFontRegistry?.isCustomFamily?.(clean);
    let applied = false;
    if (/^arrow-(left|right)$/.test(itemId)) {
      applied=window.SmoofArrowTools.setLabel(itemId.split('-')[1],{fontFamily:clean,style:'Normal'});
    } else if (/^text-[0-2]$/.test(itemId)) {
      if (customFont) window.SmoofTextTools?.setStyle?.(Number(itemId.split('-')[1]), 'Normal');
      applied = Boolean(window.SmoofTextTools?.setFont?.(Number(itemId.split('-')[1]), clean));
    } else if (/^custom-text-[1-3]$/.test(itemId)) {
      if (customFont) window.SmoofCustomTextTools?.setStyle?.(itemId, 'Normal');
      applied = Boolean(window.SmoofCustomTextTools?.setFont?.(itemId, clean));
    } else if (itemId === 'table-number') {
      if (customFont) {
        const styleSelect = document.querySelector('[data-smoof-number-style-select]');
        if (styleSelect) setNativeValue(styleSelect, 'Normal', true);
      }
      applied = Boolean(window.SmoofNumberHistory?.setFont?.(clean));
    }
    if (!applied) return false;
    window.SmoofRichText?.release?.();
    if(panelSubview?.kind==='font')leavePanelSubview(false);
    selectedId = itemId;
    fontPickerTarget = '';
    fontPickerInitialFamily = '';
    root.removeAttribute('data-smoof-font-picker-active');
    scheduleHistoryCapture(80);
    setTimeout(() => {
      if (layersOpen) renderLayers();
      else renderContext();
      syncCommandbar();
    }, 40);
    return true;
  }

  function resetFontPickerState() {
    multiFont=false;
    window.SmoofRichText?.release?.();
    if(panelSubview?.kind==='font')leavePanelSubview(false);
    const hadPendingState = Boolean(
      fontPickerTarget ||
      root.hasAttribute('data-smoof-font-picker-active')
    );
    fontPickerTarget = '';
    fontPickerInitialFamily = '';
    root.removeAttribute('data-smoof-font-picker-active');
    if (!hadPendingState) return;
    setTimeout(() => {
      if (layersOpen) renderLayers();
      else renderContext();
      syncCommandbar();
    }, 0);
  }

  function currentFontPickerTrigger() {
    const hook = document.querySelector('[data-smoof-font-tool]');
    const option = optionRoot(FONT_OPTION_ID);
    return (hook?.matches?.('button, [role="button"], [role="combobox"]') ? hook : null) ||
      hook?.querySelector?.('button, [role="button"], [role="combobox"]') ||
      option?.querySelector('button[aria-haspopup="listbox"], [role="combobox"], button') ||
      null;
  }

  function openFontPicker(itemId = selectedId) {
    if (!/^text-[0-2]$/.test(itemId) && !/^custom-text-[1-3]$/.test(itemId) && !/^arrow-(left|right)$/.test(itemId) && itemId !== 'table-number') return false;
    window.SmoofRichText?.hold?.(itemId);
    window.SmoofTextTools?.freezeFonts?.();
    window.SmoofNumberHistory?.freezeFont?.();
    fontPickerTarget = itemId;
    fontPickerInitialFamily = selectedGoogleFont();
    root.dataset.smoofFontPickerActive = 'true';
    const openExistingPicker = () => {
      if (fontPickerTarget !== itemId) return;
      window.SmoofCustomFontRegistry?.showPickerForFamily?.(rawFontForItem(itemId));
      const publicPicker = window.SmoofFontPicker || window.SmoofGoogleFontPicker;
      if (typeof publicPicker?.open === 'function') {
        publicPicker.open();
      } else {
        const trigger = currentFontPickerTrigger();
        if (!trigger || trigger.disabled) {
          resetFontPickerState();
          return;
        }
        trigger.click();
      }
      window.SmoofCustomFontRegistry?.showPickerForFamily?.(rawFontForItem(itemId));
      embedFontPicker();
      setTimeout(() => {
        if (fontPickerTarget !== itemId) return;
        const pickerOpen = Boolean(document.querySelector('.smoof-font-backdrop[data-open="true"]'));
        if (pickerOpen) return;
        resetFontPickerState();
      }, 160);
    };
    if (itemId === 'table-number') setTimeout(openExistingPicker, 80);
    else openExistingPicker();
    return true;
  }

  function panelItemId(panel) {
    return panel?.dataset.smoofUiItemId || selectedId;
  }

  function applySelect(name, value, panel) {
    const itemId = panelItemId(panel);
    const index = itemId.split('-')[1];
    suppressSelectionRenderId = itemId;
    suppressSelectionRenderUntil = Date.now() + 800;
    if (name === 'pictogram' && window.SmoofArrowTools?.setSymbol) {
      window.SmoofArrowTools.setSymbol(itemId.split('-')[1], value);
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (name === 'logo-background-shape' && window.SmoofLogoBackgroundTools?.setShape) {
      window.SmoofLogoBackgroundTools.setShape(itemId, value);
      selectedId = itemId;
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (name === 'custom-text-style' && window.SmoofCustomTextTools) {
      window.SmoofCustomTextTools.setStyle(itemId, value);
      const select = panel.querySelector(`[data-smoof-ui-select="${name}"]`);
      if (select) select.value = value;
      return;
    }
    if (name === 'text-style' && window.SmoofTextTools) {
      window.SmoofTextTools.setStyle(Number(index), value);
      const select = panel.querySelector(`[data-smoof-ui-select="${name}"]`);
      if (select) select.value = value;
      return;
    }
    const targetSource = sourceFor(itemId);
    const selector = name === 'text-style'
      ? `[data-smoof-text-style-select="${index}"]`
      : '[data-smoof-number-style-select]';
    const native = targetSource?.querySelector(selector);
    if (!native) return;
    setNativeValue(native, value, true);
    const select = panel.querySelector(`[data-smoof-ui-select="${name}"]`);
    if (select) select.value = value;
  }

  function applyColor(name, value, commit, container) {
    if (backgroundLocked && String(name || '').startsWith('background-')) return;
    if (laserMonochromeActive()) {
      const colorInput = container?.querySelector?.(`[data-smoof-ui-color="${name}"]`);
      const colorWrap = colorInput?.closest('[data-smoof-ui-color-wrap]');
      const label = colorWrap?.querySelector('[data-smoof-ui-color-value]');
      const swatch = colorWrap?.querySelector('[data-smoof-ui-color-swatch]');
      const hexInput = container?.querySelector?.(`[data-smoof-ui-hex-color="${name}"]`);
      if (colorInput) colorInput.value = '#000000';
      if (label) label.textContent = '#000000';
      if (swatch) swatch.style.backgroundColor = '#000000';
      if (hexInput) {
        hexInput.value = '#000000';
        hexInput.setAttribute('aria-invalid', 'false');
      }
      window.SmoofDotMePolicy?.enforceNow?.('theme-ui-colour-attempt');
      return false;
    }
    const itemId = panelItemId(container);
    const index = itemId.split('-')[1];
    suppressSelectionRenderId = itemId;
    suppressSelectionRenderUntil = Date.now() + 1200;
    if (name === 'logo-colour' && window.SmoofLogoColourTools) {
      window.SmoofLogoColourTools.set(itemId, { color: value, enabled: true }, commit);
      const toggle = container.querySelector('[data-smoof-ui-action="logo-colour-toggle"]');
      if (toggle) {
        toggle.querySelector('span').textContent = t('Einfarbig', 'Single colour');
        toggle.querySelector('small').textContent = t('Original verwenden', 'Use original');
      }
    } else if (name === 'custom-text-color' && window.SmoofCustomTextTools) {
      window.SmoofCustomTextTools.setColor(itemId, value, commit);
    } else if (name === 'custom-pictogram-color' && window.SmoofCustomPictogramTools) {
      window.SmoofCustomPictogramTools.setColor(itemId, value, commit);
    } else if ((name === 'pill-stroke-color' || name === 'pill-fill-color') && /^custom-text-[1-3]$/.test(itemId) && window.SmoofCustomTextTools) {
      window.SmoofCustomTextTools.setPillColor(itemId, name === 'pill-fill-color' ? 'fill' : 'stroke', value);
    } else if (name === 'text-color' && window.SmoofTextTools) {
      window.SmoofTextTools.setColor(Number(index), value, commit);
    } else if ((name === 'pill-stroke-color' || name === 'pill-fill-color') && itemId === 'table-number' && window.SmoofNumberHistory) {
      window.SmoofNumberHistory.setPillColor(name === 'pill-fill-color' ? 'fill' : 'stroke', value);
      if (commit) scheduleHistoryCapture(80);
    } else if ((name === 'pill-stroke-color' || name === 'pill-fill-color') && window.SmoofTextTools) {
      window.SmoofTextTools.setPillColor(Number(index), name === 'pill-fill-color' ? 'fill' : 'stroke', value);
    } else if (
      (name === 'arrow-color' || name === 'arrow-label-color') &&
      window.SmoofArrowTools
    ) {
      window.SmoofArrowTools.setColor(
        itemId.split('-')[1],
        name === 'arrow-label-color' ? 'label' : 'arrow',
        value,
        commit
      );
    } else if (
      (name === 'nfc-icon-color' || name === 'nfc-circle-color') &&
      window.SmoofNfcTools?.setColor
    ) {
      window.SmoofNfcTools.setColor(
        name === 'nfc-icon-color' ? 'icon' : 'circle',
        value,
        commit
      );
    } else if (
      (name === 'background-gradient-color-1' || name === 'background-gradient-color-2') &&
      window.SmoofBackgroundGradientTools?.setColor
    ) {
      window.SmoofBackgroundGradientTools.setColor(
        name === 'background-gradient-color-2' ? 'end' : 'start',
        value
      );
    } else if (
      name === 'background-overlay-color' &&
      window.SmoofBackgroundGradientTools?.setOverlayColor
    ) {
      window.SmoofBackgroundGradientTools.setOverlayColor(value);
    } else if (
      name === 'qr-code-color' &&
      window.SmoofQrGeometryTools?.setCodeColor
    ) {
      window.SmoofQrGeometryTools.setCodeColor(value, { commit });
    } else if (
      name === 'qr-backing-color' &&
      window.SmoofQrGeometryTools?.setBackingColor
    ) {
      window.SmoofQrGeometryTools.setBackingColor(value, { commit });
    } else if (
      name === 'payment-color' &&
      window.SmoofPaymentTools?.setColor
    ) {
      window.SmoofPaymentTools.setColor(value);
    } else if (
      name === 'social-platform-color' &&
      window.SmoofSocialPlatformTools?.setColor
    ) {
      window.SmoofSocialPlatformTools.setColor(itemId, value);
    } else if (
      name === 'logo-background-color' &&
      window.SmoofLogoBackgroundTools?.setColor
    ) {
      window.SmoofLogoBackgroundTools.setColor(itemId, value);
    } else {
      const targetSource = sourceFor(itemId);
    const selectors = {
      'text-color': `[data-smoof-text-color-input="${index}"]`,
      'arrow-color': '[data-smoof-arrow-color-input]',
      'arrow-label-color': '[data-smoof-arrow-label-color-input]',
      'number-color': '[data-smoof-number-color-input]',
      'brand-color': '[data-smoof-brand-color-input]',
      'background-color': 'input[type="color"]'
    };
      const native = targetSource?.querySelector(selectors[name]);
    if (!native) return;
    setNativeValue(native, value, commit);
    }
    const colorInput = container.querySelector(`[data-smoof-ui-color="${name}"]`);
    const colorWrap = colorInput?.closest('[data-smoof-ui-color-wrap]');
    const label = colorWrap?.querySelector('[data-smoof-ui-color-value]');
    const swatch = colorWrap?.querySelector('[data-smoof-ui-color-swatch]');
    const hexInput = container.querySelector(`[data-smoof-ui-hex-color="${name}"]`);
    if (colorInput && colorInput.value !== value) colorInput.value = value;
    if (label) label.textContent = value.toUpperCase();
    if (swatch) swatch.style.backgroundColor = value;
    if (hexInput) {
      hexInput.value = value.toUpperCase();
      hexInput.setAttribute('aria-invalid', 'false');
    }
  }

  function applyHexColor(input, commit, panel) {
    if (laserMonochromeActive()) {
      if (input) {
        input.value = '#000000';
        input.setAttribute('aria-invalid', 'false');
      }
      window.SmoofDotMePolicy?.enforceNow?.('theme-ui-hex-attempt');
      return false;
    }
    const value = normalizeHexColor(input?.value, commit);
    if (!value) {
      if (commit) input?.setAttribute('aria-invalid', 'true');
      return false;
    }
    input.setAttribute('aria-invalid', 'false');
    applyColor(input.dataset.smoofUiHexColor, value, commit, panel);
    return true;
  }

  function syncGuideSwitches() {
    if (selectedId !== 'guides' || context?.dataset.open !== 'true') return;
    const switchMotion = captureSwitchMotion(context);
    const native = document.querySelector('[data-smoof-guide-visibility-button]');
    context.querySelectorAll('[data-smoof-ui-action^="guide-toggle:"]').forEach(button => {
      const axis = button.dataset.smoofUiAction.split(':')[1];
      const checked = axis === 'measurements'
        ? native?.dataset.active === 'true' || native?.getAttribute('aria-pressed') === 'true'
        : window.SmoofAlignmentGuides?.isAxisEnabled?.(axis) !== false;
      button.setAttribute('aria-checked', String(checked));
      button.disabled = axis === 'measurements' ? !native : !window.SmoofAlignmentGuides?.setAxisEnabled;
    });
    restoreSwitchMotion(context, switchMotion);
  }
  window.addEventListener('smoof:snap-preferences-changed', syncGuideSwitches);

  let panelRouteStack=[];
  let routingPanel=false;
  function handleAction(action,panel){
    if (action.startsWith('download-') && mobileExportReady) {
      if (mobileExportPending) return;
      mobileExportPending=true;
      mobileExportReady.then(()=>{
        mobileExportPending=false;
        if(panel?.isConnected && panel.dataset.open==='true' && selectedId==='downloads') handleAction(action,panel);
      });
      return;
    }
    const drill=action.startsWith('add-open:')||action==='logo-2-open';
    const prior={id:selectedId,layers:layersOpen,page:layersPage,scroll:panel?.querySelector('[data-smoof-ui-panel-body]')?.scrollTop||0};
    routingPanel=drill;
    try{handleActionImpl(action,panel);}finally{routingPanel=false;}
    if(drill&&selectedId!==prior.id){
      panelRouteStack.push({...prior,to:selectedId});
      if(layersOpen)renderLayers();else renderContext();
      animatePanel(layersOpen?layers:context);
    }
  }
  function backPanelRoute(){
    const route=panelRouteStack.pop();if(!route)return;
    routingPanel=true;
    selectedId=route.id;layersOpen=route.layers;layersPage=route.page;
    if(layers)layers.dataset.open=String(layersOpen);
    dispatchSelection(selectedId,{openContext:true,forceContext:true});
    routingPanel=false;
    if(layersOpen)renderLayers();else renderContext();
    const panel=layersOpen?layers:context;
    const scroller=panel.querySelector('[data-smoof-ui-panel-body]');if(scroller)scroller.scrollTop=route.scroll;
    animatePanel(panel,'back');
  }

  function handleActionImpl(action, panel) {
    if(action === "text-shape"){window.SmoofCurvedText?.open(panelItemId(panel));return;}
    if (action.startsWith('guide-toggle:')) {
      const axis = action.split(':')[1];
      if (axis === 'measurements') document.querySelector('[data-smoof-guide-visibility-button]')?.click();
      else {
        const guides = window.SmoofAlignmentGuides;
        guides?.setAxisEnabled?.(axis, !guides.isAxisEnabled(axis));
      }
      syncGuideSwitches(); syncCommandbar();
      return;
    }
    if (backgroundLocked && String(action || '').startsWith('background-')) return;
    const itemId = panelItemId(panel);
    const targetSource = sourceFor(itemId);
    const map = {
      'text-minus': '[data-smoof-text-control-button="minus"]',
      'text-plus': '[data-smoof-text-control-button="plus"]',
      'text-reset': '[data-smoof-text-control-button="reset"]',
      'logo-minus': '[data-smoof-logo-control-button="control"]',
      'logo-plus': '[data-smoof-logo-control-button="plus"]',
      'logo-reset': '[data-smoof-logo-control-button="reset"]',
      'number-minus': '[data-smoof-number-control-button="minus"]',
      'number-plus': '[data-smoof-number-control-button="plus"]',
      'number-reset': '[data-smoof-number-control-button="reset"]'
    };
    if (action === 'payment-original-colours') { window.SmoofPaymentTools?.useOriginalColours?.(); renderContext(); return; }
    if (action === 'social-original-colours') { window.SmoofSocialPlatformTools?.useOriginalColours?.(selectedId); renderContext(); return; }
    if (action === 'add-open:payments') {
      if (!personalizedDesignSelected()) return;
      if (window.SmoofPaymentTools?.getState?.().visible === false) {
        window.SmoofPaymentTools.toggleVisibility();
      }
      togglePaymentsShortcut();
      return;
    }
    if (action === 'add-open:social-platforms') {
      selectedId = 'social-library';
      if (layersOpen) setLayersOpen(false);
      renderContext();
      dispatchSelection('social-library', { openContext: true });
      syncCommandbar();
      return;
    }
    if (action === 'add-open:custom-text') {
      const state = window.SmoofCustomTextTools?.add?.();
      if (!state?.id) return;
      selectedId = state.id;
      if (layersOpen) layersPage = 'detail';
      dispatchSelection(state.id, { openContext: true });
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      return;
    }
    if (action === 'add-open:custom-pictogram') { openPictogramPicker(itemId, true); return; }
    if (action === 'add-open:logo-copy') {
      const state = window.SmoofLogoCopyTools?.getState?.();
      if (!state?.enabled) window.SmoofLogoCopyTools?.toggleEnabled?.();
      selectedId = 'logo-copy';
      if (layersOpen) layersPage = 'detail';
      dispatchSelection('logo-copy', { openContext: true });
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      return;
    }
    if (action === 'add-open:logo-2') {
      selectedId = 'logo-2';
      if (layersOpen) layersPage = 'detail';
      dispatchSelection('logo-2', { openContext: true });
      window.SmoofLogoDuplicateTools?.openUpload?.();
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      return;
    }
    if (action === 'qr-scale-minus' || action === 'qr-scale-plus') {
      const qr = window.SmoofQrGeometryTools?.getState?.();
      if (!qr) return;
      window.SmoofQrGeometryTools.setScale(
        (Number(qr.scale) || 1) + (action.endsWith('plus') ? 0.1 : -0.1)
      );
      selectedId = 'qr';
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'qr-visibility-toggle') {
      window.SmoofQrGeometryTools?.toggleVisibility?.();
      selectedId = 'qr';
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'qr-backing-toggle') {
      window.SmoofQrGeometryTools?.toggleBackingVisibility?.();
      selectedId = 'qr';
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'qr-reset') {
      window.SmoofQrGeometryTools?.reset?.();
      selectedId = 'qr';
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'pictogram-picker-toggle') { openPictogramPicker(itemId); return; }
    if (action.startsWith('pictogram-category:')) {
      const side = itemId.split('-')[1] === 'right' ? 'right' : 'left';
      rememberPictogramCategoryScroll(panel, side);
      pictogramPickerOpenFor = side;
      pictogramPickerCategory[side] = action.slice('pictogram-category:'.length) || 'arrows';
      if (layersOpen) renderLayers(); else renderContext();
      restorePictogramCategoryScroll(panel, side);
      return;
    }
    if (action.startsWith('pictogram-select:')) {
      const side = itemId.split('-')[1] === 'right' ? 'right' : 'left';
      const symbol = action.slice('pictogram-select:'.length);
      const applied = window.SmoofArrowTools?.setSymbol?.(side, symbol);
      if (!applied) return;
      pictogramPickerOpenFor = '';
      selectedId = itemId;
      scheduleHistoryCapture(100);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'pictogram-upload') {
      panel.querySelector('[data-smoof-ui-pictogram-upload]')?.click?.();
      return;
    }
    if (action === 'pictogram-color-mode') {
      const side = itemId.split('-')[1] === 'right' ? 'right' : 'left';
      const state = window.SmoofArrowTools?.getState?.(side);
      const applied = window.SmoofArrowTools?.setColorize?.(side, !state?.colorize);
      if (applied == null) return;
      selectedId = `arrow-${side}`;
      scheduleHistoryCapture(100);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'custom-pictogram-picker-toggle') { openPictogramPicker(itemId); return; }
    if (action.startsWith('custom-pictogram-category:')) {
      rememberPictogramCategoryScroll(panel, itemId);
      pictogramPickerOpenFor = itemId;
      pictogramPickerCategory[itemId] = action.slice('custom-pictogram-category:'.length) || 'arrows';
      if (layersOpen) renderLayers(); else renderContext();
      restorePictogramCategoryScroll(panel, itemId);
      return;
    }
    if (action.startsWith('custom-pictogram-select:')) {
      const symbol = action.slice('custom-pictogram-select:'.length);
      if (!window.SmoofCustomPictogramTools?.setSymbol?.(itemId, symbol)) return;
      pictogramPickerOpenFor = '';
      selectedId = itemId;
      scheduleHistoryCapture(100);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'custom-pictogram-upload') {
      panel.querySelector('[data-smoof-ui-custom-pictogram-upload]')?.click?.();
      return;
    }
    if (action === 'custom-pictogram-color-mode') {
      const state = window.SmoofCustomPictogramTools?.getState?.(itemId);
      if (!state) return;
      window.SmoofCustomPictogramTools?.setColorize?.(itemId, !state.colorize);
      selectedId = itemId;
      scheduleHistoryCapture(100);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'open-design') {
      window.SmoofDesignFileTools?.open?.();
      return;
    }
    if (action === 'template-language-change' || action.startsWith('template-language:')) {
      // Language IDs are catalogue data, independent of the display locale.
      const id = action === 'template-language-change' ? '' : action.slice('template-language:'.length);
      templateCategory = '';
      if (!window.SmoofTemplateLibrary?.selectLanguage?.(id, { silent: true })) return;
      selectedId = 'templates';
      // Explicit navigation supersedes an in-flight slide; background updates stay deferred.
      clearTimeout(panelTransitionTimers.get(context));
      panelRenderLocks.delete(context);
      delete context.dataset.smoofUiTransition;
      renderContext();
      animatePanel(context, id ? 'forward' : 'back');
      if (id) focusCategorySelect(context?.querySelector('[data-smoof-ui-template-category]'));
      else context?.querySelector('[data-smoof-ui-language-option]')?.focus();
      return;
    }
    if (action.startsWith('template-category:')) {
      templateCategory = action.slice('template-category:'.length);
      selectedId = 'templates';
      renderContext();
      return;
    }
    if (action.startsWith('template-apply:')) {
      const templateId = action.slice('template-apply:'.length);
      Promise.resolve(window.SmoofTemplateLibrary?.apply?.(templateId)).then(applied => {
        if (!applied) return;
        selectedId = '';
        dispatchSelection('');
        scheduleHistoryCapture(420);
      });
      return;
    }
    if (action === 'download-design') {
      window.SmoofDesignFileTools?.save?.();
      return;
    }
    if (action === 'download-mockup') {
      const run = () => window.SmoofMockupDownload?.download?.();
      if (!run()) window.setTimeout(run, 300);
      return;
    }
    if (action === 'download-proof' || action === 'download-production') {
      const selector = action === 'download-proof'
        ? '[data-smoof-proof-test-button]'
        : '[data-smoof-production-test-button]';
      const trigger = document.querySelector(selector);
      if (trigger && !trigger.disabled) trigger.click();
      else window.setTimeout(() => { const retry = document.querySelector(selector); if (retry && !retry.disabled) retry.click(); }, 300);
      return;
    }
    if (action === 'text-font-all') {
      applyFontToAll(itemId);
      return;
    }
    if (action === 'text-font') {
      openFontPicker(itemId);
      return;
    }
    if (action.startsWith('text-align:')) {
      const value=action.split(':')[1];
      if (/^text-[0-2]$/.test(itemId)) window.SmoofTextTools?.setTextAlign(Number(itemId.split('-')[1]),value);
      else if (/^custom-text-[1-3]$/.test(itemId)) window.SmoofCustomTextTools?.setTextAlign(itemId,value);
      else return;
      panel.querySelectorAll('[data-smoof-text-align] button').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.smoofUiAction===action)));
      scheduleHistoryCapture(80); return;
    }
    if (action === 'letter-spacing-minus' || action === 'letter-spacing-plus') {
      const delta = action.endsWith('plus') ? 0.01 : -0.01;
      let value = 0;
      if (/^text-[0-2]$/.test(itemId)) {
        const index = Number(itemId.split('-')[1]);
        const state = window.SmoofTextTools?.getPillState?.(index);
        value = window.SmoofTextTools?.setLetterSpacing?.(
          index,
          Number(state?.letterSpacing || 0) + delta
        );
      } else if (/^custom-text-[1-3]$/.test(itemId)) {
        const state = window.SmoofCustomTextTools?.getState?.(itemId);
        value = window.SmoofCustomTextTools?.setLetterSpacing?.(
          itemId,
          Number(state?.letterSpacing || 0) + delta
        )?.letterSpacing;
      } else if (itemId === 'table-number') {
        const state = window.SmoofNumberHistory?.getState?.();
        value = window.SmoofNumberHistory?.setLetterSpacing?.(
          Number(state?.letterSpacing || 0) + delta
        );
      } else {
        return;
      }
      const output = panel.querySelector('[data-smoof-ui-letter-spacing]');
      if (output && Number.isFinite(Number(value))) {
        output.textContent = `${Math.round(Number(value) * 100)}%`;
      }
      scheduleHistoryCapture(80);
      return;
    }
    if (action === 'opacity-minus' || action === 'opacity-plus') {
      if (/^custom-pictogram-[1-3]$/.test(itemId)) {
        const state = window.SmoofCustomPictogramTools?.getState?.(itemId);
        if (!state) return;
        const next = Math.max(0.05, Math.min(1, Number(state.opacity || 1) + (action.endsWith('plus') ? 0.05 : -0.05)));
        window.SmoofCustomPictogramTools.setOpacity(itemId, next);
        const output = panel.querySelector('[data-smoof-ui-opacity-value]');
        if (output) output.textContent = `${Math.round(next * 100)}%`;
        return;
      }
      if (/^custom-text-[1-3]$/.test(itemId)) {
        const state = window.SmoofCustomTextTools?.getState?.(itemId);
        if (!state) return;
        const next = Math.max(0.05, Math.min(1, Number(state.opacity || 1) + (action.endsWith('plus') ? 0.05 : -0.05)));
        window.SmoofCustomTextTools.setOpacity(itemId, next);
        const output = panel.querySelector('[data-smoof-ui-opacity-value]');
        if (output) output.textContent = `${Math.round(next * 100)}%`;
        return;
      }
      const current = window.SmoofLayerOpacityTools?.get?.(itemId);
      if (!Number.isFinite(current)) return;
      const value = window.SmoofLayerOpacityTools.set(
        itemId,
        current + (action.endsWith('plus') ? 0.05 : -0.05)
      );
      const output = panel.querySelector('[data-smoof-ui-opacity-value]');
      if (output) output.textContent = `${Math.round(value * 100)}%`;
      scheduleHistoryCapture(80);
      return;
    }
    if (action === 'logo-colour-toggle') {
      const value = window.SmoofLogoColourTools?.get?.(itemId);
      window.SmoofLogoColourTools?.set?.(itemId, { enabled: !value?.enabled });
      if (layersOpen && layersPage === 'detail') renderLayers();
      else renderContext();
      return;
    }
    if (action === 'logo-invert' || action === 'logo-copy-invert' || action === 'logo-2-invert') {
      const logoId = action === 'logo-2-invert' ? 'logo-2' : action === 'logo-copy-invert' ? 'logo-copy' : 'logo';
      window.SmoofLogoColourTools?.set?.(logoId, { enabled: false });
      window.SmoofLogoInvertTools?.toggle?.(logoId);
      selectedId = logoId;
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'logo-copy-toggle') {
      const enabled = window.SmoofLogoCopyTools?.toggleEnabled?.();
      selectedId = enabled ? 'logo-copy' : 'logo';
      if (enabled) dispatchSelection('logo-copy');
      else dispatchSelection('logo');
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      return;
    }
    if (action === 'logo-copy-minus' || action === 'logo-copy-plus') {
      window.SmoofLogoCopyTools?.adjustScale?.(action.endsWith('plus') ? 0.1 : -0.1);
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      return;
    }
    if (action === 'logo-copy-reset') {
      window.SmoofLogoCopyTools?.resetPosition?.();
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      return;
    }
    if (action === 'logo-2-open') {
      selectedId = 'logo-2';
      if (layersOpen) layersPage = 'detail';
      dispatchSelection('logo-2');
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'logo-2-minus' || action === 'logo-2-plus') {
      window.SmoofLogoDuplicateTools?.adjustScale?.(action.endsWith('plus') ? 0.1 : -0.1);
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      return;
    }
    if (action === 'logo-2-reset') {
      window.SmoofLogoDuplicateTools?.resetPosition?.();
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      return;
    }
    if (action === 'logo-2-file') {
      const logo = window.SmoofLogoDuplicateTools?.getState?.() || {};
      if (logo.hasLogo) window.SmoofLogoDuplicateTools?.remove?.();
      else window.SmoofLogoDuplicateTools?.openUpload?.();
      selectedId = 'logo-2';
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 80);
      return;
    }
    if (action === 'logo-reset') {
      window.SmoofLogoTools?.resetPosition?.();
      selectedId = itemId;
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'logo-crop') {
      window.SmoofLogoCropTools?.open?.();
      return;
    }
    if (action === 'logo-file') {
      const logo = window.SmoofLogoTools?.getState?.() || {};
      if (logo.hasLogo) window.SmoofLogoTools?.remove?.();
      else window.SmoofLogoTools?.openUpload?.();
      selectedId = 'logo';
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 80);
      return;
    }
    if (action === 'logo-background-toggle') {
      window.SmoofLogoBackgroundTools?.toggle?.(itemId);
      selectedId = itemId;
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      return;
    }
    if (action === 'logo-background-padding-minus' || action === 'logo-background-padding-plus') {
      const background = window.SmoofLogoBackgroundTools?.get?.(itemId);
      if (!background) return;
      const value = window.SmoofLogoBackgroundTools.setPadding(
        itemId,
        background.padding + (action.endsWith('plus') ? 0.05 : -0.05)
      );
      const output = panel.querySelector('[data-smoof-ui-logo-padding-value]');
      if (output) output.textContent = `${Math.round(value * 100)}%`;
      scheduleHistoryCapture(80);
      return;
    }
    if (action === 'nfc-transparency') {
      window.SmoofNfcTools?.toggleTransparency?.();
      scheduleHistoryCapture(80);
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 60);
      return;
    }
    if (action === 'pill-toggle' || action === 'pill-fill-toggle') {
      if (itemId === 'table-number') {
        if (action === 'pill-toggle') window.SmoofNumberHistory?.togglePill?.();
        else window.SmoofNumberHistory?.togglePillFill?.();
        selectedId = itemId;
        scheduleHistoryCapture(80);
        setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
        return;
      }
      if (/^custom-text-[1-3]$/.test(itemId)) {
        if (action === 'pill-toggle') window.SmoofCustomTextTools?.togglePill?.(itemId);
        else window.SmoofCustomTextTools?.togglePillFill?.(itemId);
        selectedId = itemId;
        setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
        return;
      }
      const index = Number(itemId.split('-')[1]);
      if (action === 'pill-toggle') window.SmoofTextTools?.togglePill?.(index);
      else window.SmoofTextTools?.togglePillFill?.(index);
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (/^pill-(stroke|padding-x|padding-y)-(minus|plus)$/.test(action)) {
      const kind = action.includes('padding-x') ? 'paddingX' : action.includes('padding-y') ? 'paddingY' : 'stroke';
      const step = kind === 'stroke' ? 0.01 : 0.05;
      if (itemId === 'table-number') {
        window.SmoofNumberHistory?.adjustPill?.(kind, action.endsWith('plus') ? step : -step);
      } else if (/^custom-text-[1-3]$/.test(itemId)) {
        window.SmoofCustomTextTools?.adjustPill?.(itemId, kind, action.endsWith('plus') ? step : -step);
      } else {
        const index = Number(itemId.split('-')[1]);
        window.SmoofTextTools?.adjustPill?.(index, kind, action.endsWith('plus') ? step : -step);
      }
      selectedId = itemId;
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'nfc-reset') {
      window.SmoofNfcTools?.resetPosition?.();
      return;
    }
    if (action === 'payment-size-minus' || action === 'payment-size-plus') {
      const paymentState = window.SmoofPaymentTools?.getState?.();
      if (!paymentState) return;
      const value = window.SmoofPaymentTools.setScale(
        paymentState.scale + (action.endsWith('plus') ? 0.1 : -0.1)
      );
      const output = panel.querySelector('[data-smoof-ui-payment-scale]');
      if (output) output.textContent = `${Math.round(value * 100)}%`;
      scheduleHistoryCapture(80);
      return;
    }
    if (action === 'payment-reset') {
      window.SmoofPaymentTools?.resetPosition?.();
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'social-platform-size-minus' || action === 'social-platform-size-plus') {
      const object = window.SmoofSocialPlatformTools?.getObject?.(itemId);
      if (!object) return;
      window.SmoofSocialPlatformTools.setScale(itemId, object.scale + (action.endsWith('plus') ? .1 : -.1));
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'social-platform-opacity-minus' || action === 'social-platform-opacity-plus') {
      const object = window.SmoofSocialPlatformTools?.getObject?.(itemId);
      if (!object) return;
      window.SmoofSocialPlatformTools.setOpacity(itemId, object.opacity + (action.endsWith('plus') ? .05 : -.05));
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'social-platform-reset') {
      window.SmoofSocialPlatformTools?.resetPosition?.(itemId);
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'social-platform-delete') {
      window.SmoofSocialPlatformTools?.setEnabled?.(itemId, false);
      selectedId = 'social-library';
      dispatchSelection('social-library', { openContext: true });
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'arrows-reset') {
      window.SmoofArrowTools?.resetPosition?.(itemId.split('-')[1]);
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'rich-clear') {window.getSelection()?.removeAllRanges();window.SmoofRichText?.clear();renderContext();if(layersOpen)renderLayers();return;}
    if (action === 'text-rotation-minus' || action === 'text-rotation-plus') {
      const delta = action.endsWith('plus') ? 15 : -15;
      if (itemId.startsWith('custom-text-')) {
        const tools = window.SmoofCustomTextTools;
        tools?.setRotation?.(itemId, Number(tools.getState(itemId)?.rotation || 0) + delta);
      } else if (itemId === 'table-number') {
        const tools = window.SmoofNumberHistory;
        tools?.setRotation?.(Number(tools.getState()?.rotation || 0) + delta);
      } else if (/^text-[0-2]$/.test(itemId)) {
        const index = Number(itemId.split('-')[1]);
        const tools = window.SmoofTextTools;
        tools?.setRotation?.(index, Number(tools.getPillState(index)?.rotation || 0) + delta);
      }
      scheduleHistoryCapture(80);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'custom-text-minus' || action === 'custom-text-plus') {
      window.SmoofCustomTextTools?.adjustScale?.(itemId, action.endsWith('plus') ? 0.1 : -0.1);
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      return;
    }
    if (action === 'custom-text-reset') {
      window.SmoofCustomTextTools?.resetPosition?.(itemId);
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      return;
    }
    if (action === 'custom-text-delete') {
      window.SmoofCustomTextTools?.remove?.(itemId);
      selectedId = 'add';
      dispatchSelection('add', { openContext: true });
      if (layersOpen) layersPage = 'list';
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      return;
    }
    if (action === 'custom-pictogram-minus' || action === 'custom-pictogram-plus') {
      window.SmoofCustomPictogramTools?.adjustScale?.(itemId, action.endsWith('plus') ? 0.1 : -0.1);
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      return;
    }
    if (action === 'custom-pictogram-rotation-minus' || action === 'custom-pictogram-rotation-plus') {
      const state = window.SmoofCustomPictogramTools?.getState?.(itemId);
      if (!state) return;
      window.SmoofCustomPictogramTools.setRotation(itemId, Number(state.rotation || 0) + (action.endsWith('plus') ? 15 : -15));
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'custom-pictogram-mirror') {
      window.SmoofCustomPictogramTools?.toggleMirror?.(itemId);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'custom-pictogram-reset') {
      window.SmoofCustomPictogramTools?.resetPosition?.(itemId);
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'custom-pictogram-delete') {
      window.SmoofCustomPictogramTools?.remove?.(itemId);
      selectedId = 'add';
      dispatchSelection('add', { openContext: true });
      if (layersOpen) layersPage = 'list';
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      return;
    }
    if (action === 'arrow-scale-minus' || action === 'arrow-scale-plus') {
      const side = itemId.split('-')[1];
      const state = window.SmoofArrowTools?.getState?.(side);
      if (!state) return;
      window.SmoofArrowTools?.setScale?.(
        side,
        (Number(state.scale) || 1) + (action.endsWith('plus') ? 0.1 : -0.1)
      );
      selectedId = itemId;
      requestAnimationFrame(() => syncScaleReadout(panel, itemId));
      return;
    }
    if (/^arrow-(rotation|count)-(minus|plus)$/.test(action)) {
      const side = itemId.split('-')[1];
      const state = window.SmoofArrowTools?.getState?.(side);
      if (!state) return;
      if (action.startsWith('arrow-rotation')) {
        window.SmoofArrowTools.setRotation(side, state.rotation + (action.endsWith('plus') ? 15 : -15));
      } else {
        window.SmoofArrowTools.setCount(side, state.count + (action.endsWith('plus') ? 1 : -1));
      }
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (/^arrow-label-(size|letterSpacing)-(minus|plus)$/.test(action)) {
      const side=itemId.split('-')[1],field=action.includes('letterSpacing')?'letterSpacing':'size';
      const label=window.SmoofArrowLabels.resolve(window.SmoofArrowTools.getState(side),side);
      window.SmoofArrowTools.setLabel(side,{[field]:label[field]+(action.endsWith('plus')?1:-1)*(field==='size'?.05:.01)});
      scheduleHistoryCapture(80);setTimeout(()=>layersOpen?renderLayers():renderContext(),40);return;
    }
    if (action === 'arrow-label') {
      window.SmoofArrowTools?.toggleLabel?.(itemId.split('-')[1]);
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'background-upload') {
      if (!window.SmoofBackgroundImageBridge?.openPicker?.()) {
        window.SmoofBackgroundImageTools?.openPicker?.();
      }
      return;
    }
    if (action === 'background-gradient-toggle') {
      window.SmoofBackgroundGradientTools?.toggle?.();
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'background-image-flip-x' || action === 'background-image-flip-y') {
      const bridge = window.SmoofBackgroundImageBridge;
      if (!bridge?.getState?.()?.hasImage) return;
      bridge.toggleFlip?.(action.endsWith('-x') ? 'x' : 'y');
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (/^background-image-(?:scale|x|y|rotation)-(?:minus|plus)$/.test(action)) {
      const bridge = window.SmoofBackgroundImageBridge;
      const image = bridge?.getState?.();
      if (!image?.hasImage) return;
      const direction = action.endsWith('plus') ? 1 : -1;
      if (action.includes('-rotation-')) bridge.setRotation?.(Number(image.rotation || 0) + direction * 15);
      if (action.includes('-scale-')) {
        const currentScale = Math.max(0.05, Math.min(3, Number(image.scale) || 1));
        const step = currentScale < 0.1 ? 0.05 : 0.1;
        bridge.setScale?.(currentScale + direction * step);
      }
      const positionX = Number.isFinite((0.5 + Number(image.offsetX || 0) / 2)) ? (0.5 + Number(image.offsetX || 0) / 2) : 0.5;
      const positionY = Number.isFinite((0.5 + Number(image.offsetY || 0) / 2)) ? (0.5 + Number(image.offsetY || 0) / 2) : 0.5;
      if (action.includes('-x-')) bridge.setTranslation?.((positionX - 0.5) * 2 + direction * 0.1, (positionY - 0.5) * 2);
      if (action.includes('-y-')) bridge.setTranslation?.((positionX - 0.5) * 2, (positionY - 0.5) * 2 + direction * 0.1);
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'background-image-position-reset') {
      window.SmoofBackgroundImageBridge?.resetPlacement?.();
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'background-gradient-angle-minus' || action === 'background-gradient-angle-plus') {
      const gradient = window.SmoofBackgroundGradientTools?.getState?.();
      if (!gradient) return;
      window.SmoofBackgroundGradientTools.setAngle(
        gradient.angle + (action.endsWith('plus') ? 15 : -15)
      );
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'background-overlay-toggle') {
      window.SmoofBackgroundGradientTools?.toggleOverlay?.();
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'background-overlay-opacity-minus' || action === 'background-overlay-opacity-plus') {
      const gradient = window.SmoofBackgroundGradientTools?.getState?.();
      if (!gradient) return;
      window.SmoofBackgroundGradientTools.setOverlayOpacity(
        gradient.overlayOpacity + (action.endsWith('plus') ? 0.1 : -0.1)
      );
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 40);
      return;
    }
    if (action === 'background-remove') {
      if (window.SmoofBackgroundImageBridge?.remove) {
        window.SmoofBackgroundImageBridge.remove();
      } else {
        window.SmoofBackgroundImageTools?.remove?.();
      }
      selectedId = itemId;
      setTimeout(() => layersOpen ? renderLayers() : renderContext(), 60);
      return;
    }
    if (action === 'item-visibility') {
      suppressSelectionRenderId = itemId;
      suppressSelectionRenderUntil = Date.now() + 500;
      toggleVisibility(itemId);
      selectedId = itemId;
      setTimeout(() => {
        const button = panel.querySelector('[data-smoof-ui-action="item-visibility"]');
        const visible = isVisible(itemId);
        if (button) {
          button.innerHTML = icon(visible ? 'eye' : 'eyeOff');
          button.setAttribute(
            'aria-label',
            visible ? t('Element ausblenden', 'Hide element') : t('Element einblenden', 'Show element')
          );
        }
      }, 60);
      return;
    } else if (map[action]) {
      suppressSelectionRenderId = itemId;
      suppressSelectionRenderUntil = Date.now() + 800;
      const native = targetSource?.querySelector(map[action]);
      if (native && !native.disabled) {
        // Legacy controls reannounce selection. This is a panel action, not a
        // new mobile canvas selection; retain its panel and current button.
        panelActionDepth++;
        try { native.click(); } finally { panelActionDepth--; }
      }
      selectedId = itemId;
      if (/^(text|logo|number)-(minus|plus|reset)$/.test(action)) {
        const update = () => syncScaleReadout(panel, itemId);
        requestAnimationFrame(() => {
          update();
          requestAnimationFrame(update);
        });
        setTimeout(update, 90);
      }
      return;
    }
    selectedId = itemId;
    dispatchSelection(itemId);
    if (action !== 'text-font') setTimeout(() => layersOpen ? renderLayers() : renderContext(), 80);
  }

  function bindPanel(panel) {
    let pointerTarget = null;
    let pointerTime = 0;
    let touchPointerId = null;
    let touchTarget = null;
    let touchStartX = 0;
    let touchStartY = 0;
    let touchMoved = false;
    let suppressTouchClickUntil = 0;
    const panelControlSelector = [
      '[data-smoof-ui-action]',
      '[data-smoof-ui-panel-close]',
      '[data-smoof-ui-panel-back]',
      '[data-smoof-ui-route-back]',
      'button[data-smoof-ui-layer-action]',
      '[data-smoof-ui-payment-option]',
      '[data-smoof-ui-layer]'
    ].join(', ');

    function finishPercentageStepper(control) {
      const button = control?.closest?.(
        'button[data-smoof-ui-action$="-minus"], button[data-smoof-ui-action$="-plus"]'
      );
      const stepper = button?.closest?.('[data-smoof-ui-stepper]');
      const input = stepper?.querySelector?.('[data-smoof-percent-input]');
      if (!input || document.activeElement !== input) return;
      input.dataset.smoofPercentStepperFinish = 'true';
      input.blur();
      setTimeout(() => {
        if (panel === layers && layersOpen) renderLayers();
        else if (panel === context) renderContext();
      }, 0);
    }

    function runPanelControl(target) {
      const paymentOption = target.closest('[data-smoof-ui-payment-option]');
      if (paymentOption) {
        const payment = paymentOption.querySelector('[data-smoof-ui-payment-provider]');
        if (!payment || payment.disabled) return false;
        payment.checked = !payment.checked;
        payment.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
      if (panel === layers && layersPage === 'list') {
        const visibility = target.closest('button[data-smoof-ui-layer-action]');
        if (visibility) {
          toggleVisibility(visibility.dataset.smoofUiLayerAction);
          setTimeout(renderLayers, 70);
          return true;
        }
        const layer = target.closest('[data-smoof-ui-layer]');
        if (layer && layer.dataset.editable === 'true') {
          if(multiMode){const id=layer.dataset.smoofUiLayer;multiChoose(id);if(target.matches("[data-smoof-ui-multi-pick]"))layers.querySelector(`[data-smoof-ui-multi-pick="${id}"]`)?.focus({preventScroll:true});return true;}
          openLayer(layer.dataset.smoofUiLayer);
          return true;
        }
      }
      if(target.closest('[data-smoof-ui-route-back]')){backPanelRoute();return true;}
      const close = target.closest('[data-smoof-ui-panel-close]');
      if (close) {
        if (panel === layers) setLayersOpen(false); else dispatchSelection('');
        return true;
      }
      if (target.closest('[data-smoof-ui-panel-back]')) {
        if (target.closest('[data-smoof-ui-action="template-language-change"]')) {
          handleAction('template-language-change', panel);
          return true;
        }
        layersPage = 'list';
        startLayersTransition('back');
        renderLayers();
        (layers.querySelector('[data-smoof-multi-action=edit-layers]') || layers.querySelector('[data-smoof-multi-action=toggle]'))?.focus({preventScroll:true});
        return true;
      }
      const action = target.closest('[data-smoof-ui-action]');
      if (action) {
        handleAction(action.dataset.smoofUiAction, panel);
        return true;
      }
      return false;
    }

    panel.addEventListener('pointerdown', event => {
      const control = event.target.closest(panelControlSelector);

      if (event.pointerType === 'touch') {
        touchPointerId = event.pointerId;
        touchTarget = control;
        touchStartX = event.clientX;
        touchStartY = event.clientY;
        touchMoved = false;
        pointerTarget = null;
        event.stopPropagation();
        return;
      }

      if (control && runPanelControl(control)) {
        pointerTarget = control;
        pointerTime = Date.now();
        event.preventDefault();
      }
      event.stopPropagation();
    });

    panel.addEventListener('pointermove', event => {
      if (event.pointerId !== touchPointerId) return;
      const distance = Math.hypot(
        event.clientX - touchStartX,
        event.clientY - touchStartY
      );
      if (distance > 8) {
        touchMoved = true;
        suppressTouchClickUntil = Date.now() + 450;
      }
      event.stopPropagation();
    });

    panel.addEventListener('pointerup', event => {
      if (event.pointerId !== touchPointerId) return;
      const releaseTarget = event.target.closest(panelControlSelector);
      const sameControl = touchTarget && (
        releaseTarget === touchTarget ||
        touchTarget.contains(releaseTarget) ||
        releaseTarget?.contains(touchTarget)
      );
      const shouldRun = !touchMoved && sameControl;
      const control = touchTarget;

      touchPointerId = null;
      touchTarget = null;
      suppressTouchClickUntil = Date.now() + 450;

      // A live percentage draft must finish before the native step changes it.
      // Otherwise the ensuing blur/change restores the old draft over the step.
      if (shouldRun) finishPercentageStepper(control);
      if (shouldRun && runPanelControl(control)) event.preventDefault();
      event.stopPropagation();
    });

    panel.addEventListener('pointercancel', event => {
      if (event.pointerId !== touchPointerId) return;
      touchPointerId = null;
      touchTarget = null;
      touchMoved = true;
      suppressTouchClickUntil = Date.now() + 450;
    });

    panel.addEventListener('click', event => {
      // Keyboard activation already toggles the native checkbox.
      if (event.detail === 0 && event.target.matches('[data-smoof-ui-payment-provider]')) {
        event.stopPropagation();
        return;
      }
      const control = event.target.closest(panelControlSelector);
      // Keyboard/synthetic activation is independent of a pointer follow-up click.
      if (event.detail > 0 && Date.now() < suppressTouchClickUntil) {
        finishPercentageStepper(control);
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (
        event.detail > 0 &&
        control &&
        control === pointerTarget &&
        Date.now() - pointerTime < 800
      ) {
        finishPercentageStepper(control);
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      if (control && runPanelControl(control)) {
        finishPercentageStepper(control);
        event.preventDefault();
        event.stopPropagation();
      }
    });
    function updateArrowLabelInput(event) {
      const input=event.target.closest('[data-smoof-arrow-label-field]');
      if(!input||!/^arrow-(left|right)$/.test(selectedId))return false;
      const field=input.dataset.smoofArrowLabelField;
      if(event.type==='input'&&field==='style')return true;
      let value=input.value;
      if(field==='size'||field==='letterSpacing') { if(value===''||!Number.isFinite(Number(value))){if(event.type==='change')input.value=String(Math.round(window.SmoofArrowLabels.resolve(window.SmoofArrowTools.getState(selectedId.split('-')[1]),selectedId.split('-')[1])[field]*100));return true;}value=Number(value)/100; }
      window.SmoofArrowTools.setLabel(selectedId.split('-')[1],{[field]:value});
      if(event.type==='change'&&(field==='size'||field==='letterSpacing')) input.value=String(Math.round(window.SmoofArrowTools.getState(selectedId.split('-')[1]).label[field]*100));
      scheduleHistoryCapture(event.type==='input'?500:80);return true;
    }
    panel.addEventListener('input', event => {
      if(updateArrowLabelInput(event))return;
      if(event.target.matches('[data-smoof-multi-hex],[data-smoof-multi-color]'))return;
      const hexInput = event.target.closest('[data-smoof-ui-hex-color]');
      if (hexInput) {
        applyHexColor(hexInput, false, panel);
        return;
      }
      const input = event.target.closest('[data-smoof-ui-color]');
      if (input) applyColor(input.dataset.smoofUiColor, input.value, false, panel);
    });
    panel.addEventListener('change', event => {
      if(updateArrowLabelInput(event))return;
      const templateSelect = event.target.closest('select[data-smoof-ui-template-category]');
      if (templateSelect) {
        templateCategory = templateSelect.value;
        selectedId = 'templates';
        renderContext();
        focusCategorySelect(context?.querySelector('[data-smoof-ui-template-category]'));
        return;
      }
      if(event.target.matches('[data-smoof-multi-hex],[data-smoof-multi-color]'))return;
      const hexInput = event.target.closest('[data-smoof-ui-hex-color]');
      if (hexInput) {
        applyHexColor(hexInput, true, panel);
        return;
      }
      const customPictogramUpload = event.target.closest('[data-smoof-ui-custom-pictogram-upload]');
      if (customPictogramUpload) {
        const file = customPictogramUpload.files?.[0];
        if (!file) return;
        const status = panel.querySelector('[data-smoof-ui-pictogram-status]');
        const itemId = customPictogramUpload.dataset.smoofUiCustomPictogramUpload;
        const isSvg = /\.svg$/i.test(file.name || '') || file.type === 'image/svg+xml';
        const isPng = /\.png$/i.test(file.name || '') || file.type === 'image/png';
        const sizeValid = isSvg ? file.size <= 600000 : isPng ? file.size <= 500000 : false;
        if ((!isSvg && !isPng) || !sizeValid) {
          if (status) status.textContent = (!isSvg && !isPng)
            ? t('Bitte eine SVG- oder PNG-Datei auswählen.', 'Please select an SVG or PNG file.')
            : isPng
              ? t('Die PNG-Datei darf maximal 500 KB groß sein.', 'The PNG file may not exceed 500 KB.')
              : t('Die SVG-Datei darf maximal 600 KB groß sein.', 'The SVG file may not exceed 600 KB.');
          customPictogramUpload.value = '';
          return;
        }
        if (status) status.textContent = isPng ? t('PNG wird geprüft …', 'Checking PNG …') : t('SVG wird geprüft …', 'Checking SVG …');
        const readFile = isPng
          ? new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onload = () => resolve(String(reader.result || ''));
              reader.onerror = reject;
              reader.readAsDataURL(file);
            }).then(dataUrl => new Promise((resolve, reject) => {
              const image = new Image();
              image.onload = () => resolve({ dataUrl, width: image.naturalWidth || image.width, height: image.naturalHeight || image.height });
              image.onerror = reject;
              image.src = dataUrl;
            }))
          : file.text();
        Promise.resolve(readFile).then(fileData => {
          if (isPng && (fileData.width > 1000 || fileData.height > 1000)) {
            if (status) status.textContent = t('Das PNG darf maximal 1.000 × 1.000 Pixel groß sein.', 'The PNG may not exceed 1,000 × 1,000 pixels.');
            return;
          }
          const fileName = file.name.replace(/\.(?:svg|png)$/i, '');
          const applied = isPng
            ? window.SmoofCustomPictogramTools?.setCustomRaster?.(itemId, fileData.dataUrl, fileName, fileData.width, fileData.height)
            : window.SmoofCustomPictogramTools?.setCustomSymbol?.(itemId, fileData, fileName);
          if (!applied) {
            if (status) status.textContent = t('Diese Datei konnte nicht als Piktogramm verwendet werden.', 'This file could not be used as a pictogram.');
            return;
          }
          pictogramPickerCategory[itemId] = 'custom';
          pictogramPickerOpenFor = '';
          selectedId = itemId;
          scheduleHistoryCapture(120);
          setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
        }).catch(() => {
          if (status) status.textContent = t('Die Datei konnte nicht gelesen werden.', 'The file could not be read.');
        }).finally(() => { customPictogramUpload.value = ''; });
        return;
      }
      const pictogramUpload = event.target.closest('[data-smoof-ui-pictogram-upload]');
      if (pictogramUpload) {
        const file = pictogramUpload.files?.[0];
        if (!file) return;
        const status = panel.querySelector('[data-smoof-ui-pictogram-status]');
        const side = pictogramUpload.dataset.smoofUiPictogramUpload === 'right' ? 'right' : 'left';
        const isSvg = /\.svg$/i.test(file.name || '') || file.type === 'image/svg+xml';
        const isPng = /\.png$/i.test(file.name || '') || file.type === 'image/png';
        const sizeValid = isSvg ? file.size <= 600000 : isPng ? file.size <= 500000 : false;
        if ((!isSvg && !isPng) || !sizeValid) {
          if (status) status.textContent = (!isSvg && !isPng)
            ? t('Bitte eine SVG- oder PNG-Datei auswählen.', 'Please select an SVG or PNG file.')
            : isPng
              ? t('Die PNG-Datei darf maximal 500 KB groß sein.', 'The PNG file may not exceed 500 KB.')
              : t('Die SVG-Datei darf maximal 600 KB groß sein.', 'The SVG file may not exceed 600 KB.');
          pictogramUpload.value = '';
          return;
        }
        if (status) status.textContent = isPng
          ? t('PNG wird geprüft …', 'Checking PNG …')
          : t('SVG wird geprüft …', 'Checking SVG …');
        const readFile = isPng
          ? new Promise((resolve, reject) => {
              const reader = new FileReader();
              reader.onload = () => resolve(String(reader.result || ''));
              reader.onerror = reject;
              reader.readAsDataURL(file);
            }).then(dataUrl => new Promise((resolve, reject) => {
              const image = new Image();
              image.onload = () => resolve({
                dataUrl,
                width: image.naturalWidth || image.width,
                height: image.naturalHeight || image.height
              });
              image.onerror = reject;
              image.src = dataUrl;
            }))
          : (typeof file.text === 'function'
              ? file.text()
              : new Promise((resolve, reject) => {
                  const reader = new FileReader();
                  reader.onload = () => resolve(String(reader.result || ''));
                  reader.onerror = reject;
                  reader.readAsText(file);
                }));
        Promise.resolve(readFile).then(fileData => {
          if (isPng && (fileData.width > 1000 || fileData.height > 1000)) {
            if (status) status.textContent = t(
              'Das PNG darf maximal 1.000 × 1.000 Pixel groß sein.',
              'The PNG may not exceed 1,000 × 1,000 pixels.'
            );
            return;
          }
          const fileName = file.name.replace(/\.(?:svg|png)$/i, '');
          const applied = isPng
            ? window.SmoofArrowTools?.setCustomRaster?.(
                side,
                fileData.dataUrl,
                fileName,
                fileData.width,
                fileData.height
              )
            : window.SmoofArrowTools?.setCustomSymbol?.(side, fileData, fileName);
          if (!applied) {
            if (status) status.textContent = t(
              'Diese Datei konnte nicht als Piktogramm verwendet werden.',
              'This file could not be used as a pictogram.'
            );
            return;
          }
          pictogramPickerCategory[side] = 'custom';
          pictogramPickerOpenFor = '';
          selectedId = `arrow-${side}`;
          scheduleHistoryCapture(120);
          setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
        }).catch(() => {
          if (status) status.textContent = t('Die Datei konnte nicht gelesen werden.', 'The file could not be read.');
        }).finally(() => { pictogramUpload.value = ''; });
        return;
      }
      const payment = event.target.closest('[data-smoof-ui-payment-provider]');
      if (payment) {
        window.SmoofPaymentTools?.setProvider?.(
          payment.dataset.smoofUiPaymentProvider,
          payment.checked
        );
        selectedId = 'payments';
        scheduleHistoryCapture(80);
      }
      const socialPlatform = event.target.closest('[data-smoof-ui-social-platform]');
      if (socialPlatform) {
        const id = socialPlatform.dataset.smoofUiSocialPlatform;
        window.SmoofSocialPlatformTools?.setEnabled?.(id, socialPlatform.checked);
        selectedId = 'social-library';
        scheduleHistoryCapture(80);
        dispatchSelection('social-library', { openContext: true });
        setTimeout(() => layersOpen ? renderLayers() : renderContext(), 50);
      }
      const select = event.target.closest('[data-smoof-ui-select]');
      if (select) applySelect(select.dataset.smoofUiSelect, select.value, panel);
      const input = event.target.closest('[data-smoof-ui-color]');
      if (input) applyColor(input.dataset.smoofUiColor, input.value, true, panel);
    });
  }

  function setLayersOpen(open) {
    layersOpen = Boolean(open);
    if (layersOpen) {
      closeLegacyHelp();
      closeLegacyReset();
      layersPage = 'list';
      delete layers.dataset.smoofUiTransition;
      context.dataset.open = 'false';
      layers.dataset.open = 'true';
      renderLayers();
    } else {
      layers.dataset.open = 'false';
      layersPage = 'list';
    }
    syncCommandbar();
  }

  function togglePaymentsShortcut() {
    if (!personalizedDesignSelected() || !window.SmoofPaymentTools) return;
    const shouldOpen = !(selectedId === 'payments' && context?.dataset.open === 'true');

    if (layersOpen) setLayersOpen(false);
    closeLegacyHelp();
    closeLegacyReset();

    if (!shouldOpen) {
      selectedId = '';
      source = null;
      if (context) context.dataset.open = 'false';
      dispatchSelection('');
      syncCommandbar();
      return;
    }

    selectedId = 'payments';
    source = sourceFor('payments');
    renderContext();
    dispatchSelection('payments', { openContext: true });
    syncCommandbar();

    requestAnimationFrame(() => {
      if (selectedId !== 'payments' || layersOpen) return;
      source = sourceFor('payments');
      renderContext();
      syncCommandbar();
    });
  }

  function toggleAddShortcut() {
    if (!personalizedDesignSelected()) return;
    const shouldOpen = !(selectedId === 'add' && context?.dataset.open === 'true');

    if (layersOpen) setLayersOpen(false);
    closeLegacyHelp();
    closeLegacyReset();

    if (!shouldOpen) {
      selectedId = '';
      source = null;
      if (context) context.dataset.open = 'false';
      dispatchSelection('');
      syncCommandbar();
      return;
    }

    dispatchSelection('');
    selectedId = 'add';
    source = commandbar;
    renderContext();
    syncCommandbar();
  }

  function openLayer(id) {
    panelRouteStack=[];
    if (id === 'table-number' && !visibleItemFor(id)) {
      const toggle = document.querySelector('[data-smoof-number-toggle]');
      if (toggle && !toggle.hidden) toggle.click();
    }
    layersPage = 'detail';
    selectedId = id;
    suppressSelectionRenderId = id;
    suppressSelectionRenderUntil = Date.now() + 500;
    startLayersTransition('forward');
    renderLayers();
    dispatchSelection(id);
  }

  function startLayersTransition(direction) {
    if (!layers) return;
    clearTimeout(layersTransitionTimer);
    layers.dataset.smoofUiTransition = direction;
    layersTransitionTimer = setTimeout(() => {
      if (layers) delete layers.dataset.smoofUiTransition;
    }, mobile.matches ? 570 : 480);
  }

  function templateCoachmarkWasSeen() {
    if (templateCoachmarkAcknowledged) return true;
    try {
      return window.localStorage.getItem(TEMPLATE_COACHMARK_KEY) === 'seen';
    } catch (_error) {
      return false;
    }
  }

  function rememberTemplateCoachmark() {
    templateCoachmarkAcknowledged = true;
    try {
      window.localStorage.setItem(TEMPLATE_COACHMARK_KEY, 'seen');
    } catch (_error) {
      // The current page still stays dismissed when storage is unavailable.
    }
  }

  function positionTemplateCoachmark() {
    if (!templateCoachmark || templateCoachmark.hidden || !commandbar) return;
    const button = visibleCommandAnchor(commandbar.querySelector('[data-smoof-ui-command-action="templates"]'));
    if (!button) return;
    const anchor = button.getBoundingClientRect();
    const panel = templateCoachmark.getBoundingClientRect();
    const edge = 12;
    const gap = 13;
    const width = panel.width || 292;
    const height = panel.height || 230;
    const idealLeft = anchor.left + (anchor.width / 2) - (width / 2);
    const left = Math.max(edge, Math.min(idealLeft, window.innerWidth - width - edge));
    const fitsBelow = anchor.bottom + gap + height <= window.innerHeight - edge;
    const top = fitsBelow
      ? anchor.bottom + gap
      : Math.max(edge, anchor.top - height - gap);
    templateCoachmark.style.left = `${Math.round(left)}px`;
    templateCoachmark.style.top = `${Math.round(top)}px`;
    templateCoachmark.style.setProperty('--smoof-template-coachmark-arrow-x', `${Math.round(anchor.left + (anchor.width / 2) - left)}px`);
    templateCoachmark.dataset.placement = fitsBelow ? 'below' : 'above';
  }

  function dismissTemplateCoachmark(markSeen = true) {
    clearTimeout(templateCoachmarkTimer);
    templateCoachmarkTimer = 0;
    if (markSeen) rememberTemplateCoachmark();
    if (!templateCoachmark) return;
    templateCoachmark.dataset.open = 'false';
    templateCoachmark.hidden = true;
  }

  function ensureTemplateCoachmark() {
    if (templateCoachmark?.isConnected) return templateCoachmark;
    templateCoachmark = document.createElement('aside');
    templateCoachmark.dataset.smoofUiTemplateCoachmark = 'true';
    templateCoachmark.dataset.smoofEditorItem = 'modern-ui-control';
    templateCoachmark.dataset.open = 'false';
    templateCoachmark.hidden = true;
    templateCoachmark.setAttribute('role', 'dialog');
    templateCoachmark.setAttribute('aria-modal', 'false');
    templateCoachmark.setAttribute('aria-labelledby', 'smoof-template-coachmark-title');
    templateCoachmark.innerHTML = `<button type="button" data-smoof-ui-template-coachmark-close aria-label="${t('Hinweis schließen', 'Close hint')}">${icon('close')}</button><div data-smoof-ui-template-coachmark-preview aria-hidden="true"><span>${t('Order & Pay', 'Order & Pay')}</span><span>${t('Speisekarte', 'Menu')}</span><span>${t('Gästemappe', 'Guest directory')}</span></div><div data-smoof-ui-template-coachmark-body><span data-smoof-ui-template-coachmark-symbol>${icon('templates')}</span><div><strong id="smoof-template-coachmark-title">${t('Mit Vorlagen schneller starten', 'Start faster with templates')}</strong><p>${t('Wählen Sie ein vorbereitetes Design und passen Sie es direkt an Ihr Branding an.', 'Choose a prepared design and adapt it directly to your branding.')}</p></div><button type="button" data-smoof-ui-template-coachmark-open>${t('Vorlagen entdecken', 'Explore templates')}<span aria-hidden="true">→</span></button></div>`;
    templateCoachmark.addEventListener('pointerdown', event => event.stopPropagation());
    templateCoachmark.addEventListener('click', event => {
      if (event.target.closest('[data-smoof-ui-template-coachmark-close]')) {
        dismissTemplateCoachmark(true);
        return;
      }
      if (!event.target.closest('[data-smoof-ui-template-coachmark-open]')) return;
      dismissTemplateCoachmark(true);
      commandbar?.querySelector('[data-smoof-ui-command-action="templates"]')?.click();
    });
    document.body.append(templateCoachmark);
    return templateCoachmark;
  }

  function scheduleTemplateCoachmark() {
    if (
      templateCoachmarkTimer ||
      templateCoachmark?.dataset.open === 'true' ||
      templateCoachmarkWasSeen() ||
      !personalizedDesignSelected()
    ) return;
    templateCoachmarkTimer = window.setTimeout(() => {
      templateCoachmarkTimer = 0;
      if (templateCoachmarkWasSeen() || !personalizedDesignSelected()) return;
      const panel = ensureTemplateCoachmark();
      panel.hidden = false;
      panel.dataset.open = 'true';
      requestAnimationFrame(positionTemplateCoachmark);
    }, 900);
  }

  // Build419: transient mobile workspace; never writes design or product state.
  let mobileWorkspaceFrame = 0;
  let mobileWorkspace = null;
  let mobileExportReady = null;
  let mobileExportPending = false;
  const mobileObservedPanels = new WeakSet();
  function scheduleMobileWorkspace() {
    if (!mobileWorkspaceFrame) mobileWorkspaceFrame = requestAnimationFrame(syncMobileWorkspace);
  }
  function mobileStyle(element, name, value) {
    if (element.style.getPropertyValue(name) !== value) element.style.setProperty(name, value);
  }
  function releaseMobileWorkspace() {
    if (!mobileWorkspace) return;
    const {preview, spacer, backdrop, host} = mobileWorkspace;
    delete preview.dataset.smoofMobilePreview;
    delete host.dataset.smoofMobileToolbar;
    spacer.remove(); backdrop.remove();
    delete root.dataset.smoofMobileWorkspace;
    delete root.dataset.smoofMobileShort;
    for (const panel of [context,layers]) if (panel) {
      delete panel.dataset.smoofMobilePanel;
    }
    mobileWorkspace = null;
    // Existing owners recalculate their screen-space geometry at the restored size.
    window.dispatchEvent(new Event('resize'));
    // Export readers use DOM metrics. Let every owner finish at its original
    // layout size before a fast subsequent download can capture those metrics.
    const ready=new Promise(resolve=>requestAnimationFrame(()=>requestAnimationFrame(()=>requestAnimationFrame(resolve))));
    mobileExportReady=ready;
    ready.then(()=>{if(mobileExportReady===ready)mobileExportReady=null;});
  }
  function syncMobileWorkspace() {
    mobileWorkspaceFrame = 0;
    for (const panel of [context,layers]) if (panel && !mobileObservedPanels.has(panel)) {
      mobileObservedPanels.add(panel);
      new MutationObserver(scheduleMobileWorkspace).observe(panel,{childList:true,subtree:true,attributes:true,attributeFilter:['data-open','data-smoof-ui-subview']});
    }
    if (mobile.matches && commandbarHost && commandbar) {
      commandbarHost.dataset.smoofMobileOverflow=String(commandbar.scrollWidth>commandbar.clientWidth+2 && commandbar.scrollLeft<commandbar.scrollWidth-commandbar.clientWidth-2);
    }
    const panel = [layers,context].find(p=>p?.dataset.open==='true');
    const preview = document.querySelector('.po-livePreview-root');
    const stage = preview?.querySelector('.konvajs-content');
    const viewport = window.visualViewport;
    if (!mobile.matches || !panel || selectedId==='downloads' || !stage || !commandbarHost?.isConnected || !personalizedDesignSelected() || root.dataset.smoofEditorTourOpen==='true') {
      releaseMobileWorkspace(); return;
    }
    if (mobileWorkspace && (mobileWorkspace.preview!==preview || mobileWorkspace.host!==commandbarHost)) releaseMobileWorkspace();
    if (!mobileWorkspace) {
      const spacer=document.createElement('div');spacer.dataset.smoofMobileSpacer='';spacer.setAttribute('aria-hidden','true');
      spacer.style.height=commandbarHost.getBoundingClientRect().height+'px';commandbarHost.before(spacer);
      const backdrop=document.createElement('div');backdrop.dataset.smoofMobileBackdrop='';backdrop.setAttribute('aria-hidden','true');document.body.append(backdrop);
      mobileWorkspace={preview,spacer,backdrop,host:commandbarHost,size:0};
      preview.dataset.smoofMobilePreview='true';commandbarHost.dataset.smoofMobileToolbar='true';root.dataset.smoofMobileWorkspace='true';
    }
    for (const candidate of [context,layers]) {
      if(candidate!==panel) {delete candidate.dataset.smoofMobilePanel;continue;}
      candidate.dataset.smoofMobilePanel='true';
    }
    const subview=Boolean(panel.dataset.smoofUiSubview);
    // Keep all controls in the small scrollable panel; subviews retain their own height.
    const body=panel.querySelector(':scope > [data-smoof-ui-panel-body]');
    if(body && !subview){
      const kind=descriptors()[selectedId]?.kind;
      const textKind=['text','custom-text','number'].includes(kind) && multiIds.size<2;
      body.dataset.smoofMobileText=String(textKind);
      if(textKind)for(const row of body.querySelectorAll(':scope > [data-smoof-ui-row]')){
        const font=row.querySelector('[data-smoof-ui-font-button]');
        const size=row.querySelector('[data-smoof-ui-action="text-plus"],[data-smoof-ui-action="custom-text-plus"],[data-smoof-ui-action="number-plus"]');
        const color=row.querySelector('[data-smoof-ui-hex-color="text-color"],[data-smoof-ui-hex-color="custom-text-color"],[data-smoof-ui-hex-color="number-color"]');
        row.dataset.smoofMobilePriority=font?'1':size?'2':color?'3':'4';
      }
    }
    const top=viewport?.offsetTop||0, left=viewport?.offsetLeft||0;
    const width=viewport?.width||innerWidth, height=viewport?.height||innerHeight;
    root.dataset.smoofMobileShort=String(height<560);
    const header=document.querySelector('header[is="sticky-header"],header[is="custom-header"]')?.getBoundingClientRect();
    const headerBottom=header && header.bottom>top && header.top<top+height ? Math.min(header.bottom,top+height*.24):top;
    const toolbarTop=headerBottom+6;
    mobileStyle(root,'--smoof-mobile-left',`${left+8}px`);
    mobileStyle(root,'--smoof-mobile-width',`${width-16}px`);
    mobileStyle(root,'--smoof-mobile-toolbar-top',`${toolbarTop}px`);
    const toolbarHeight=commandbarHost.getBoundingClientRect().height;
    const workTop=toolbarTop+toolbarHeight+4;
    const available=Math.max(100,top+height-workTop);
    // Browsing motifs needs more rows; retain a visible product above the library.
    const pictogram=panel.dataset.smoofUiSubview==='pictogram';
    const sheetHeight=pictogram
      ? Math.min(620,available*.78)
      : Math.min(subview?460:320,available*(height<560?(subview?.70:.62):(subview?.64:.54)));
    const size=Math.max(40,Math.min(width-24,available-sheetHeight-12));
    mobileStyle(root,'--smoof-mobile-sheet-height',`${Math.round(sheetHeight)}px`);
    mobileStyle(root,'--smoof-mobile-bottom',`${Math.max(0,innerHeight-top-height)}px`);
    mobileStyle(root,'--smoof-mobile-preview-size',`${size}px`);
    mobileStyle(root,'--smoof-mobile-preview-left',`${left+(width-size)/2}px`);
    mobileStyle(root,'--smoof-mobile-preview-top',`${workTop+Math.max(0,(available-sheetHeight-size)/2)}px`);
    mobileStyle(mobileWorkspace.backdrop,'top',`${toolbarTop}px`);
    mobileStyle(mobileWorkspace.backdrop,'bottom',`${Math.max(0,innerHeight-top-height)}px`);
    if(Math.abs(mobileWorkspace.size-size)>.5){
      mobileWorkspace.size=size;
      // Reuse each owner's resize path at the real layout size, not a transform.
      requestAnimationFrame(()=>window.dispatchEvent(new Event('resize')));
    }
    const paintKey=[left,workTop,size,sheetHeight].join(':');
    if(mobileWorkspace.paintKey!==paintKey){mobileWorkspace.paintKey=paintKey;multiSchedulePaint();}
  }
  window.addEventListener('resize',scheduleMobileWorkspace,{passive:true});
  window.addEventListener('scroll',scheduleMobileWorkspace,{passive:true,capture:true});
  window.visualViewport?.addEventListener('resize',scheduleMobileWorkspace,{passive:true});
  window.visualViewport?.addEventListener('scroll',scheduleMobileWorkspace,{passive:true});

  // Build430: keep original action buttons and owners; only their mobile presentation changes.
  let morePanel = null;
  let moreButton = null;
  let toolbarButtons = [];
  const secondaryCommands = ['templates', 'save-design', 'guides', 'help', 'reset'];
  function closeMoreTools(restoreFocus = false) {
    if (!morePanel?.matches(':popover-open')) return;
    morePanel.hidePopover();
    moreButton.setAttribute('aria-expanded', 'false');
    if (restoreFocus) moreButton.focus({ preventScroll: true });
  }
  function visibleCommandAnchor(button) {
    return mobile.matches && button?.parentElement === morePanel && !morePanel.matches(':popover-open') ? moreButton : button;
  }
  function placeMoreTools() {
    if (!morePanel?.matches(':popover-open')) return;
    const a = moreButton.getBoundingClientRect();
    const vv = window.visualViewport;
    const left = vv?.offsetLeft || 0, top = vv?.offsetTop || 0;
    const width = vv?.width || innerWidth, height = vv?.height || innerHeight;
    morePanel.style.width = Math.min(304, width - 24) + 'px';
    morePanel.style.maxHeight = Math.max(44, height - 24) + 'px';
    const box = morePanel.getBoundingClientRect();
    const below = a.bottom + 8;
    const y = below + box.height <= top + height - 12 ? below : Math.max(top + 12, a.top - box.height - 8);
    morePanel.style.left = Math.max(left + 12, Math.min(a.right - box.width, left + width - box.width - 12)) + 'px';
    morePanel.style.top = y + 'px';
  }
  function syncMoreLayout() {
    if (!morePanel) return;
    const focus = document.activeElement;
    closeMoreTools(false);
    for (const button of toolbarButtons) commandbar.insertBefore(button, moreButton);
    if (mobile.matches) {
      for (const action of secondaryCommands) {
        const button = toolbarButtons.find(b => b.dataset.smoofUiCommandAction === action);
        morePanel.append(button);
      }
    }
    if (focus === moreButton && !mobile.matches) toolbarButtons[0].focus({ preventScroll: true });
    else if (morePanel.contains(focus)) moreButton.focus({ preventScroll: true });
    commandbar.scrollLeft = 0;
    scheduleMobileWorkspace();
  }
  function ensureMoreTools() {
    // Older browsers retain the complete scrolling toolbar as a functional fallback.
    if (!('showPopover' in HTMLElement.prototype)) return;
    toolbarButtons = [...commandbar.querySelectorAll('[data-smoof-ui-command-action]')];
    moreButton = document.createElement('button');
    moreButton.type = 'button';
    moreButton.dataset.smoofUiMore = 'true';
    moreButton.setAttribute('aria-label', mt('Weitere Werkzeuge', 'More tools', 'Altri strumenti'));
    moreButton.setAttribute('aria-expanded', 'false');
    moreButton.setAttribute('aria-controls', 'smoof-more-tools');
    moreButton.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor"><circle cx="5" cy="12" r="1.8"/><circle cx="12" cy="12" r="1.8"/><circle cx="19" cy="12" r="1.8"/></svg>';
    morePanel = document.createElement('div');
    morePanel.id = 'smoof-more-tools';
    morePanel.dataset.smoofUiMorePanel = 'true';
    morePanel.setAttribute('popover', 'auto');
    morePanel.setAttribute('role', 'group');
    morePanel.setAttribute('aria-label', moreButton.getAttribute('aria-label'));
    for (const button of toolbarButtons) {
      if (!secondaryCommands.includes(button.dataset.smoofUiCommandAction)) continue;
      const label = document.createElement('span');
      label.dataset.smoofUiMoreLabel = 'true';
      label.setAttribute('aria-hidden', 'true');
      label.textContent = button.getAttribute('aria-label');
      button.append(label);
    }
    commandbar.append(moreButton, morePanel);
    commandbar.dataset.smoofUiMoreReady = 'true';
    moreButton.setAttribute('popovertarget', morePanel.id);
    morePanel.addEventListener('beforetoggle', event => {
      if (event.newState !== 'open') return;
      closeLegacyHelp(); closeLegacyReset();
      for (const button of morePanel.querySelectorAll('button')) button.querySelector('[data-smoof-ui-more-label]').textContent = button.getAttribute('aria-label');
    });
    morePanel.addEventListener('toggle', () => {
      const open = morePanel.matches(':popover-open');
      moreButton.setAttribute('aria-expanded', String(open));
      if (open) {
        placeMoreTools();
        morePanel.querySelector('button:not(:disabled)')?.focus({ preventScroll: true });
      }
    });
    morePanel.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); closeMoreTools(true); return; }
      const buttons = [...morePanel.querySelectorAll('button:not(:disabled)')];
      const index = buttons.indexOf(document.activeElement);
      let next;
      if (event.key === 'ArrowDown') next = (index + 1) % buttons.length;
      if (event.key === 'ArrowUp') next = (index - 1 + buttons.length) % buttons.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = buttons.length - 1;
      if (next !== undefined) { event.preventDefault(); event.stopPropagation(); buttons[next]?.focus(); }
    });
    morePanel.addEventListener('focusout', () => setTimeout(() => {
      if (!morePanel.contains(document.activeElement)) closeMoreTools(false);
    }, 0));
    mobile.addEventListener('change', syncMoreLayout);
    window.addEventListener('resize', placeMoreTools);
    window.addEventListener('scroll', placeMoreTools, true);
    window.visualViewport?.addEventListener('resize', placeMoreTools);
    window.visualViewport?.addEventListener('scroll', placeMoreTools);
    syncMoreLayout();
  }

  function ensureShell() {
    if (commandbar && commandbar.isConnected) return;
    commandbar = document.createElement('nav');
    commandbar.dataset.smoofUiCommandbar = 'true';
    commandbar.dataset.smoofEditorItem = 'modern-ui-control';
    commandbar.innerHTML = `<button type="button" data-smoof-ui-command-action="templates" aria-label="${t('Vorlagen', 'Templates')}" title="${t('Vorlagen', 'Templates')}" aria-expanded="false">${icon('templates')}</button><button type="button" data-smoof-ui-command-action="layers" aria-label="${t('Ebenen', 'Layers')}" title="${t('Ebenen', 'Layers')}" aria-expanded="false">${icon('layers')}</button><button type="button" data-smoof-ui-command-action="multi" aria-label="${mt("Mehrfach auswählen","Select multiple","Seleziona più elementi")}" title="${mt("Mehrfach auswählen","Select multiple","Seleziona più elementi")}" aria-pressed="false"><svg viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M8 15H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v3"/><rect x="9" y="9" width="12" height="12" rx="2"/></svg></button><button type="button" data-smoof-ui-command-action="add" aria-label="${t('Hinzufügen', 'Add')}" title="${t('Hinzufügen', 'Add')}" aria-expanded="false">${icon('add')}</button><button type="button" data-smoof-ui-command-action="save-design" aria-label="${t('Uploads & Downloads', 'Uploads & Downloads')}" title="${t('Uploads & Downloads', 'Uploads & Downloads')}" aria-expanded="false">${icon('save')}</button><button type="button" data-smoof-ui-command-action="undo" aria-keyshortcuts="Meta+Z Control+Z" aria-label="${t('Rückgängig', 'Undo')}" title="${t('Rückgängig', 'Undo')} (⌘Z / Ctrl+Z)">${icon('undo')}</button><button type="button" data-smoof-ui-command-action="redo" aria-label="${t('Wiederholen', 'Redo')}" title="${t('Wiederholen', 'Redo')}">${icon('redo')}</button><button type="button" data-smoof-ui-command-action="guides" aria-label="${t('Bemaßung & Ausrichtung', 'Measurements & alignment')}" title="${t('Bemaßung & Ausrichtung', 'Measurements & alignment')}">${icon('ruler')}</button><button type="button" data-smoof-ui-command-action="reset" aria-label="${t('Design zurücksetzen', 'Reset design')}" title="${t('Design zurücksetzen', 'Reset design')}">${icon('reset')}</button><button type="button" data-smoof-ui-command-action="help" aria-label="${t('Hilfe', 'Help')}" title="${t('Hilfe', 'Help')}">${icon('help')}</button>`;
    context = document.createElement('section');
    context.dataset.smoofUiContext = 'true';
    context.dataset.smoofEditorItem = 'modern-ui-control';
    context.dataset.open = 'false';
    layers = document.createElement('aside');
    layers.dataset.smoofUiLayers = 'true';
    layers.dataset.smoofEditorItem = 'modern-ui-control';
    layers.dataset.open = 'false';
    document.body.append(commandbar, context, layers);
    root.dataset.smoofUiShellReady = 'true';
    ensureMoreTools();
    bindPanel(context);
    bindPanel(layers);

    commandbar.addEventListener('pointerdown', event => {
      event.stopPropagation();
    });
    commandbar.addEventListener('pointerup', event => {
      const addButton = event.target.closest('[data-smoof-ui-command-action="add"]');
      if (!addButton || (event.button !== undefined && event.button !== 0)) return;
      addShortcutPointerHandledUntil = Date.now() + 700;
      event.preventDefault();
      event.stopPropagation();
      closeMoreTools(false);
      toggleAddShortcut();
    });
    commandbar.addEventListener('click', event => {
      const button = event.target.closest('[data-smoof-ui-command-action]');
      if (!button) return;
      const action = button.dataset.smoofUiCommandAction;
      closeMoreTools(morePanel?.contains(button));
      if (action === 'multi') {multiMode=!multiMode;if(multiMode&&multiEligible(selectedId))multiIds.add(selectedId);if(layersOpen)setLayersOpen(false);multiRefresh();return;}
      if(!['layers','undo','redo'].includes(action)&&(multiMode||multiIds.size>1))multiClear(false);
      if (action === 'guides') {
        const shouldOpen = selectedId !== 'guides' || context?.dataset.open !== 'true';
        closeLegacyHelp(); closeLegacyReset();
        if (layersOpen) setLayersOpen(false);
        dispatchSelection(shouldOpen ? 'guides' : '', { openContext: shouldOpen });
        if (shouldOpen) {
          renderContext();
          context.querySelector('[role="switch"]')?.focus({ preventScroll: true });
        }
        syncCommandbar();
        return;
      }
      if (action === 'layers') { setLayersOpen(!layersOpen); return; }
      if (action === 'templates') {
        dismissTemplateCoachmark(true);
        const shouldOpen = selectedId !== 'templates' || context?.dataset.open !== 'true';
        closeLegacyHelp();
        closeLegacyReset();
        if (layersOpen) setLayersOpen(false);
        if (shouldOpen) {
          selectedId = 'templates';
          source = commandbar;
          renderContext();
        } else {
          dispatchSelection('');
        }
        syncCommandbar();
        return;
      }
      if (action === 'save-design') {
        const shouldOpen = selectedId !== 'downloads' || context?.dataset.open !== 'true';
        closeLegacyHelp();
        closeLegacyReset();
        if (layersOpen) setLayersOpen(false);
        if (shouldOpen) {
          selectedId = 'downloads';
          source = commandbar;
          renderContext();
        } else {
          dispatchSelection('');
        }
        syncCommandbar();
        return;
      }
      if (action === 'add') {
        if (Date.now() < addShortcutPointerHandledUntil) return;
        toggleAddShortcut();
        return;
      }
      if (action === 'undo') { undoHistory(); return; }
      if (action === 'redo') { redoHistory(); return; }
      if (action === 'help') {
        const shouldOpen = !helpWasOpenOnPointerDown;
        helpWasOpenOnPointerDown = false;
        if (shouldOpen) openLegacyHelp();
        else closeLegacyHelp();
        syncCommandbar();
        return;
      }
      if (action === 'reset') {
        const shouldOpen = !resetWasOpenOnPointerDown;
        resetWasOpenOnPointerDown = false;
        if (shouldOpen) openLegacyReset();
        else closeLegacyReset();
        syncCommandbar();
        return;
      }
      const selectors = { guides: '[data-smoof-guide-visibility-button]' };
      const native = document.querySelector(selectors[action]);
      if (native) native.click();
      setTimeout(() => {
        syncCommandbar();
        if (action === 'help') positionLegacyPopover(action);
      }, 80);
      helpWasOpenOnPointerDown = false;
      resetWasOpenOnPointerDown = false;
    });

    syncCommandbar();
  }

  window.addEventListener(SELECT_EVENT, event => {
    if(multiInternal || multiGesture?.started || multiFont)return;
    const groupedId=String(event.detail?.id||''),members=multiGroupMembers(groupedId);
    if(members.length>1){multiIds.clear();members.forEach(id=>multiIds.add(id));selectedId=groupedId;multiRefresh();return;}
    if(!multiMode&&multiIds.size>1)multiIds.clear();
    multiSchedulePaint();
    const nextId=String(event.detail && event.detail.id ? event.detail.id : '');
    if (panelActionDepth && nextId === selectedId && context?.dataset.open === 'true' && !layersOpen) return;
    if(!routingPanel&&nextId!==selectedId&&nextId!==panelRouteStack.at(-1)?.to)panelRouteStack=[];
    if (selectedId === 'templates' && nextId !== selectedId && context) {
      clearTimeout(panelTransitionTimers.get(context));
      panelRenderLocks.delete(context);
      delete context.dataset.smoofUiTransition;
      context.dataset.open = 'false';
    }
    selectedId = nextId;
    // A style owner reselects its item after applying the value. Keep the
    // current mobile panel open for this already-suppressed control update.
    if (
      selectedId === suppressSelectionRenderId &&
      Date.now() < suppressSelectionRenderUntil
    ) {
      return;
    }
    if (
      mobile.matches &&
      !layersOpen &&
      event.detail?.openContext !== true
    ) {
      source = selectedId ? sourceFor(selectedId) : null;
      if (context) context.dataset.open = 'false';
      syncCommandbar();
      return;
    }
    setTimeout(() => {
      if (layersOpen && layersPage === 'detail') renderLayers();
      else renderContext();
      syncCommandbar();
    }, 0);
  });

  window.addEventListener('smoof:font-styles-ready', () => {
    setTimeout(() => { if (layersOpen && layersPage === 'detail') renderLayers(); else renderContext(); }, 0);
  });

  window.addEventListener('smoof:background-image-changed', () => {
    if (selectedId !== 'background') return;
    setTimeout(() => {
      if (layersOpen && layersPage === 'detail') renderLayers();
      else renderContext();
    }, 0);
  });

  window.addEventListener('smoof:qr-geometry-change', () => {
    if (selectedId !== 'qr') return;
    setTimeout(() => {
      if (layersOpen && layersPage === 'detail') renderLayers();
      else renderContext();
    }, 0);
  });

  window.addEventListener('smoof:custom-pictogram-change', () => {
    if (!/^custom-pictogram-[1-3]$/.test(selectedId) && !layersOpen && selectedId !== 'add') return;
    setTimeout(() => {
      if (layersOpen) renderLayers();
      else renderContext();
    }, 0);
  });

  window.addEventListener('smoof:template-library-changed', () => {
    if (selectedId !== 'templates' || context?.dataset.open !== 'true') return;
    setTimeout(() => {
      renderContext();
      syncCommandbar();
    }, 0);
  });

  window.addEventListener('smoof:logo-crop-applied', () => scheduleHistoryCapture(350));
  window.addEventListener('smoof:logo-crop-ready', () => { if (selectedId === 'logo') renderContext(); });
  window.addEventListener('smoof:logo-file-changed', () => {
    if (selectedId !== 'logo') return;
    setTimeout(() => {
      if (layersOpen && layersPage === 'detail') renderLayers();
      else renderContext();
    }, 0);
  });

  window.addEventListener('smoof:logo-copy-ready', () => {
    if (selectedId !== 'logo') return;
    setTimeout(() => {
      if (layersOpen && layersPage === 'detail') renderLayers();
      else renderContext();
    }, 0);
  });

  window.addEventListener('smoof:logo-2-file-changed', () => {
    if (selectedId !== 'logo-2' && selectedId !== 'logo') return;
    setTimeout(() => {
      if (layersOpen && layersPage === 'detail') renderLayers();
      else renderContext();
    }, 0);
  });

  window.addEventListener('smoof:logo-colour-changed', event => {
    if (event.detail?.commit !== false) scheduleHistoryCapture(180);
  });

  ['smoof:logo-copy-changed', 'smoof:logo-background-changed', 'smoof:logo-colour-ready'].forEach(eventName => {
    window.addEventListener(eventName, () => {
      if (!['logo', 'logo-copy', 'logo-2'].includes(selectedId)) return;
      setTimeout(() => {
        if (layersOpen && layersPage === 'detail') renderLayers();
        else renderContext();
      }, 0);
    });
  });

  window.addEventListener('smoof:editor-reset-content', () => {
    ['left', 'right'].forEach(side => {
      if (window.SmoofArrowTools?.isVisible?.(side) === false) {
        window.SmoofArrowTools?.toggleVisibility?.(side);
      }
    });
  });

  window.addEventListener('pointerdown', event => {
    const target = event.target instanceof Element ? event.target : null;
    const layersToggle = target?.closest('[data-smoof-ui-command-action="layers"]');
    const insideLayers = target?.closest('[data-smoof-ui-layers]');
    const canvasItem = target?.closest('[data-smoof-editor-item]');
    if (layersOpen && !layersToggle && !insideLayers && !canvasItem) setLayersOpen(false);

    const resetToggle = target?.closest('[data-smoof-ui-command-action="reset"], [data-smoof-reset-button]');
    const insideReset = target?.closest('[data-smoof-reset-menu]');
    if (legacyPanelOpen('reset') && !resetToggle && !insideReset) closeLegacyReset();

    if (target?.closest('[data-smoof-ui-command-action="help"]')) {
      helpWasOpenOnPointerDown = legacyPanelOpen('help');
    } else if (target?.closest('[data-smoof-ui-command-action="reset"]')) {
      resetWasOpenOnPointerDown = legacyPanelOpen('reset');
    } else if (legacyPanelOpen('help')) {
      setTimeout(syncCommandbar, 0);
    } else if (legacyPanelOpen('reset')) {
      setTimeout(syncCommandbar, 0);
    }
  }, true);

  document.addEventListener('pointerdown', event => {
    const target = event.target instanceof Element ? event.target : null;
    const editorItem = target?.closest('[data-smoof-editor-item]');
    const itemId = editorItem?.dataset.smoofEditorItem || '';
    const closestButton = target?.closest('button');
    const directControl = target?.closest('input, select, textarea, [data-smoof-ui-context], [data-smoof-ui-layers], [data-smoof-ui-commandbar]') ||
      (closestButton && closestButton !== editorItem);
    if (
      mobile.matches &&
      itemId &&
      descriptors()[itemId] &&
      !directControl
    ) {
      mobileCanvasPointer = {
        pointerId: event.pointerId,
        itemId,
        startX: event.clientX,
        startY: event.clientY,
        moved: false,
        wasSelected: selectedId === itemId,
        contextWasOpen: context?.dataset.open === 'true'
      };
      // Keep the panel mounted so the shared drag fade preserves its scroll/layout.
    }
    const descriptor = itemId ? descriptors()[itemId] : null;
    const nestedControl = target?.closest([
      'input',
      'select',
      'textarea',
      '[data-smoof-text-controls]',
      '[data-smoof-logo-controls]',
      '[data-smoof-logo-copy-controls]',
      '[data-smoof-logo-duplicate-controls]',
      '[data-smoof-arrow-controls]',
      '[data-smoof-number-controls]',
      '[data-smoof-brand-controls]',
      '[data-smoof-ui-context]',
      '[data-smoof-ui-layers]',
      '[data-smoof-ui-commandbar]'
    ].join(','));
    const button = target?.closest('button');
    const canvasButton = button && button === editorItem;
    if (editorItem && descriptor && !descriptor.locked && !nestedControl && (!button || canvasButton)) {
      root.dataset.smoofUiDragging = 'true';
    }
  }, true);

  window.addEventListener('pointermove', event => {
    if (!mobileCanvasPointer || mobileCanvasPointer.pointerId !== event.pointerId) return;
    if (Math.hypot(
      event.clientX - mobileCanvasPointer.startX,
      event.clientY - mobileCanvasPointer.startY
    ) > 7) {
      mobileCanvasPointer.moved = true;
    }
  }, true);

  function finishMobileCanvasPointer(event, cancelled = false) {
    if (!mobileCanvasPointer || mobileCanvasPointer.pointerId !== event.pointerId) return;
    const interaction = mobileCanvasPointer;
    mobileCanvasPointer = null;
    if (cancelled || !interaction.wasSelected) return;
    setTimeout(() => {
      if (
        mobile.matches &&
        !layersOpen &&
        selectedId === interaction.itemId &&
        (!interaction.moved || interaction.contextWasOpen)
      ) {
        renderContext();
        syncCommandbar();
      }
    }, 0);
  }

  window.addEventListener('pointerup', event => finishMobileCanvasPointer(event), true);
  window.addEventListener('pointercancel', event => finishMobileCanvasPointer(event, true), true);

  const finishUiDrag = () => {
    root.removeAttribute('data-smoof-ui-dragging');
    scheduleHistoryCapture(180);
  };
  window.addEventListener('pointerup', finishUiDrag, true);
  window.addEventListener('pointercancel', finishUiDrag, true);
  window.addEventListener('blur', () => {
    mobileCanvasPointer = null;
    finishUiDrag();
  });

  window.addEventListener('resize', () => { positionCommandbar(); positionContext(); positionLayers(); positionLegacyPopover('help'); positionLegacyPopover('reset'); positionTemplateCoachmark(); });
  window.addEventListener('scroll', () => { positionCommandbar(); positionContext(); positionLayers(); positionLegacyPopover('help'); positionLegacyPopover('reset'); positionTemplateCoachmark(); }, true);
  window.addEventListener('smoof:product-variant-change', () => {
    if (layersOpen) renderLayers();
    else if (selectedId) renderContext();
    syncCommandbar();
  });

  let frame = 0;
  function reconcile() {
    frame = 0;
    ensureShell();
    syncPersonalizationGate();
    syncCommandbar();
    positionContext();positionLayers();
    if (selectedId && source && !source.isConnected) {
      source = sourceFor(selectedId);
      const visibilityTransition =
        selectedId === suppressSelectionRenderId &&
        Date.now() < suppressSelectionRenderUntil;
      if (!visibilityTransition) {
        if (layersOpen && layersPage === 'detail') renderLayers(); else renderContext();
      }
    }
  }
  const observer = new MutationObserver(() => {
    if (frame) return;
    frame = requestAnimationFrame(reconcile);
  });
  observer.observe(document.body, { childList: true, subtree: true });
  const fontPickerCloseObserver = new MutationObserver(records => {
    // Closed panels must never leave a detached decorative anchor behind.
    for (const record of records) {
      if ((record.target === context || record.target === layers) && record.target.dataset.open !== 'true') {
        const tip = panelAnchors.get(record.target);
        if (tip) tip.hidden = true;
        delete record.target.dataset.smoofUnifiedSkin;
      }
    }
    if(panelSubview?.kind==='font'&&!document.querySelector('.smoof-font-backdrop[data-open="true"]'))leavePanelSubview(false);
    if (!fontPickerTarget) return;
    const pickerClosed = records.some(record =>
      record.target instanceof Element &&
      record.target.matches('.smoof-font-backdrop') &&
      record.target.dataset.open === 'false'
    );
    if (!pickerClosed) return;
    setTimeout(() => {
      if (!fontPickerTarget) return;
      if (document.querySelector('.smoof-font-backdrop[data-open="true"]')) return;
      resetFontPickerState();
    }, 0);
  });
  fontPickerCloseObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['data-open'],
    subtree: true
  });
  function detectFontSelection(event) {
    if (!fontPickerTarget) return;
    const changed = event?.target instanceof Element ? event.target : null;
    const fontOption = optionRoot(FONT_OPTION_ID);
    if (changed && fontOption && !fontOption.contains(changed)) return;
    const family = selectedGoogleFont();
    if (!family) return;
    const explicitSelection = Boolean(changed?.matches?.('select, input[type="hidden"]'));
    if (family !== fontPickerInitialFamily || explicitSelection) finishFontSelection(family);
  }

  let richSelectionTimer=0;
  window.addEventListener('smoof:rich-selection',()=>{
    clearTimeout(richSelectionTimer);
    richSelectionTimer=setTimeout(()=>{if(!panelSubview){if(layersOpen)renderLayers();else renderContext();}scheduleHistoryCapture(80);},120);
  });
  window.addEventListener('smoof:font-selected', event => {
    if (!fontPickerTarget) return;
    const family = cleanFontFamily(event.detail?.font);
    if (family) finishFontSelection(family);
  });

  window.setInterval(() => {
    if (!fontPickerTarget) return;
    const family = selectedGoogleFont();
    if (family && family !== fontPickerInitialFamily) finishFontSelection(family);
  }, 180);

  // Movement is dispatched to the owning component, never to CSS or history restore.
  function movementFor(id) {
    if (/^text-[0-2]$/.test(id)) return [window.SmoofTextTools, Number(id.split('-')[1])];
    if (/^arrow-(left|right)$/.test(id)) return [window.SmoofArrowTools, id.split('-')[1]];
    if (/^custom-text-[1-3]$/.test(id)) return [window.SmoofCustomTextTools, id];
    if (/^custom-pictogram-[1-3]$/.test(id)) return [window.SmoofCustomPictogramTools, id];
    if (/^social-platform-/.test(id)) return [window.SmoofSocialPlatformTools, id];
    return [{
      logo: window.SmoofLogoHistory, 'logo-copy': window.SmoofLogoCopyTools,
      'logo-2': window.SmoofLogoDuplicateTools, 'table-number': window.SmoofNumberHistory,
      'branding-dot': window.SmoofBrandTools, qr: window.SmoofQrGeometryTools,
      nfc: window.SmoofNfcTools, payments: window.SmoofPaymentTools
    }[id]];
  }
  // A short quiet period keeps successive keyboard nudges visually calm.
  function setKeyboardPanelMoving(active, immediate = false) {
    clearTimeout(keyboardPanelReturnTimer);
    keyboardPanelReturnTimer = 0;
    if (active) {
      if (root.dataset.smoofUiKeyboardMoving !== 'true') root.dataset.smoofUiKeyboardMoving = 'true';
    } else if (immediate) {
      delete root.dataset.smoofUiKeyboardMoving;
    } else if (root.dataset.smoofUiKeyboardMoving === 'true') {
      keyboardPanelReturnTimer = setTimeout(() => {
        keyboardPanelReturnTimer = 0;
        delete root.dataset.smoofUiKeyboardMoving;
      }, 250);
    }
  }
  function finishKeyboardMove() {
    heldArrows.clear();
    if (!keyboardMove) return;
    keyboardMove = false;
    setKeyboardPanelMoving(false);
    // Include dependent constraint/render updates in the same Undo entry.
    scheduleHistoryCapture(320);
  }
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && selectedId === 'guides') {
      event.preventDefault();
      dispatchSelection('');
      context.dataset.open = 'false'; syncCommandbar();
      visibleCommandAnchor(commandbar?.querySelector('[data-smoof-ui-command-action="guides"]'))?.focus();
      return;
    }
    if(multiIds.size>1)return; // The group keyboard controller is authoritative.
    const directions = { ArrowLeft: [-1, 0], ArrowRight: [1, 0], ArrowUp: [0, -1], ArrowDown: [0, 1] };
    const direction = directions[event.key];
    if (!direction) return;
    const target = event.target instanceof Element ? event.target : null;
    const blocked = event.defaultPrevented || event.isComposing || event.altKey || event.ctrlKey || event.metaKey ||
      heldPointers.size > 0 || historyRestoring || !personalizedDesignSelected() || fontPickerTarget ||
      root.hasAttribute('data-smoof-font-picker-active') || root.dataset.smoofEditorTourOpen === 'true' ||
      root.hasAttribute('data-smoof-surface-session') || root.hasAttribute('data-smoof-surface-external-apply') ||
      root.dataset.smoofUiDragging === 'true' || root.dataset.smoofQhsMode === 'three-quarter' ||
      target?.isContentEditable || target?.closest('input, textarea, select, button, [contenteditable="true"], [role="textbox"], [role="slider"], [role="spinbutton"], [role="combobox"]') ||
      [...document.querySelectorAll('dialog[open], [role="dialog"][open], [aria-modal="true"]')].some(el => {
        if (!el.getClientRects().length) return false;
        for (let node = el; node instanceof Element; node = node.parentElement) {
          const css = getComputedStyle(node);
          if (node.hidden || node.getAttribute('aria-hidden') === 'true' || css.display === 'none' || css.visibility === 'hidden' || css.opacity === '0') return false;
        }
        return true;
      });
    const [owner, argument] = movementFor(selectedId);
    if (blocked || !owner?.nudge || !isVisible(selectedId) || !visibleItemFor(selectedId)) {
      finishKeyboardMove(); return;
    }
    if (!keyboardMove) {
      clearTimeout(historyTimer); clearTimeout(historyBaselineTimer);
      commitHistorySnapshot(); keyboardMove = true;
    }
    const step = event.shiftKey ? 0.01 : 0.001;
    const args = [direction[0] * step, direction[1] * step];
    if (argument !== undefined) args.unshift(argument);
    if (owner.nudge(...args) === false) { finishKeyboardMove(); return; }
    heldArrows.add(event.key);
    setKeyboardPanelMoving(true);
    window.SmoofAlignmentGuides?.hideAll?.();
    event.preventDefault(); event.stopPropagation();
  });
  // Use the same history as the toolbar, preserving native undo while typing.
  document.addEventListener('keydown', event => {
    if (event.key.toLowerCase() !== 'z' || !(event.metaKey || event.ctrlKey) ||
        event.shiftKey || event.altKey || event.isComposing || event.defaultPrevented) return;
    const target = event.target instanceof Element ? event.target : null;
    const active = document.activeElement;
    const editing = node => node instanceof Element && (node.isContentEditable ||
      node.closest('input, textarea, select, [contenteditable="true"], [role="textbox"], [role="slider"], [role="spinbutton"], [role="combobox"]'));
    if (editing(target) || editing(active)) return;
    if (!commandbar?.isConnected || !commandbar.getClientRects().length || !personalizedDesignSelected() ||
        historyRestoring || multiBusy || multiGesture || keyboardMove || heldPointers.size ||
        fontPickerTarget || root.hasAttribute('data-smoof-font-picker-active') ||
        root.dataset.smoofEditorTourOpen === 'true' || root.dataset.smoofUiDragging === 'true' ||
        root.dataset.smoofQhsMode === 'three-quarter' ||
        root.hasAttribute('data-smoof-surface-session') || root.hasAttribute('data-smoof-surface-external-apply')) return;
    // Body focus is normal after selecting canvas artwork. Other controls must belong to the editor.
    if (target && target !== document.body && target !== root &&
        ![multiStage(), commandbar, context, layers].some(node => node?.contains(target))) return;
    if ([...document.querySelectorAll('dialog[open], [role="dialog"], [aria-modal="true"]')].some(el => {
      if (!el.getClientRects().length) return false;
      for (let node = el; node instanceof Element; node = node.parentElement) {
        const css = getComputedStyle(node);
        if (node.hidden || node.getAttribute('aria-hidden') === 'true' || css.display === 'none' || css.visibility === 'hidden' || css.opacity === '0') return false;
      }
      return true;
    })) return;
    // Consume repeats without stepping through the whole history when a key is held.
    if (event.repeat) { event.preventDefault(); return; }
    // Flush pending captures, just like undoHistory(), before checking availability.
    commitHistorySnapshot();
    if (!historyPast.length || !historyCurrent) return;
    event.preventDefault();
    event.stopPropagation();
    undoHistory();
  });

  document.addEventListener('keyup', event => {
    heldArrows.delete(event.key);
    if (!heldArrows.size) finishKeyboardMove();
  });
  window.addEventListener('blur', () => { heldPointers.clear(); finishKeyboardMove(); });
  document.addEventListener('pointerdown', event => { heldPointers.add(event.pointerId); finishKeyboardMove(); }, true);
  window.addEventListener('pointerup', event => heldPointers.delete(event.pointerId), true);
  window.addEventListener('pointercancel', event => heldPointers.delete(event.pointerId), true);
  document.addEventListener('focusin', finishKeyboardMove);
  window.addEventListener(SELECT_EVENT, finishKeyboardMove);
  window.addEventListener('smoof:surface-change', () => {
    // SurfaceController already captured the old side and reset the history.
    keyboardMove = false; heldArrows.clear(); setKeyboardPanelMoving(false, true);
  });

  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || !fontPickerTarget) return;
    fontPickerTarget = '';
    fontPickerInitialFamily = '';
    root.removeAttribute('data-smoof-font-picker-active');
    setTimeout(() => layersOpen ? renderLayers() : renderContext(), 0);
  }, true);

  document.addEventListener('input', event => {
    detectFontSelection(event);
    scheduleHistoryCapture(380);
  }, true);
  document.addEventListener('change', event => {
    const changed = event.target instanceof Element ? event.target : null;
    detectFontSelection(event);
    scheduleHistoryCapture(320);
    if (changed?.matches('input[type="file"]')) scheduleHistoryCapture(1400);
    setTimeout(() => {
      syncPersonalizationGate();
      syncCommandbar();
    }, 40);
  }, true);
  document.addEventListener('click', () => scheduleHistoryCapture(260), true);

  function view360Help() {
    return {
      title: window.SmoofI18n.label({"de": "Ihr Design in 360°", "en": "Your design in 360°", "it": "Il suo design a 360°"}),
      body: window.SmoofI18n.label({"de": "Wenn die 360°-Ansicht für Ihre Variante verfügbar ist, öffnen Sie sie über „360°“. Ziehen Sie das Produkt mit der Maus oder dem Finger, wählen Sie einen Blickwinkel oder schalten Sie die automatische Drehung ein. Über „Zurück zum Editor“ kehren Sie zur Bearbeitung zurück. Ihr Design bleibt unverändert. Ein Mockup speichern Sie separat unter „Uploads & Downloads“.", "en": "When the 360° view is available for your variant, open it with “360°”. Drag the product with your mouse or finger, choose a viewing angle or turn on automatic rotation. Select “Back to editor” to continue editing. Your design stays unchanged. Save a mockup separately under “Uploads & Downloads”.", "it": "Se la vista a 360° è disponibile per la variante scelta, la apra con “360°”. Trascini il prodotto con il mouse o con un dito, scelga un’angolazione oppure attivi la rotazione automatica. Selezioni “Torna all’editor” per continuare a modificare il design. Il design rimane invariato. Per salvare un mockup, utilizzi la sezione “Caricamenti e download”."})
    };
  }

  function view360Anchor() {
    const selectors = ['rhl', 'rhs', 'qhs', 'qhl', 'rml', 'dot-gl', 'dot-ma', 'dot-me']
      .map(product => `[data-smoof-${product}-360-open]`).join(',');
    return [...document.querySelectorAll(selectors)].find(button =>
      !button.disabled && button.getClientRects().length > 0 && getComputedStyle(button).visibility !== 'hidden'
    ) || null;
  }

  function tourAnchor(name) {
    const command = action => visibleCommandAnchor(commandbar?.querySelector(`[data-smoof-ui-command-action="${action}"]`)) || null;
    const anchors = {
      workspace: () => commandbarAnchor(),
      text: () => context?.dataset.open === 'true' ? context : null,
      fonts: () => context?.dataset.open === 'true' ? context.querySelector('[data-smoof-ui-font-button]') : null,
      logos: () => context?.dataset.open === 'true' ? context : null,
      alignment: () => command('guides'),
      templates: () => context?.dataset.open === 'true' && selectedId === 'templates' ? context : command('templates'),
      layers: () => layers?.dataset.open === 'true' ? layers : command('layers'),
      add: () => context?.dataset.open === 'true' && selectedId === 'add' ? context : command('add'),
      downloads: () => context?.dataset.open === 'true' && selectedId === 'downloads' ? context : command('save-design'),
      safety: () => commandbar,
      surfaces: () => document.querySelector('[data-smoof-surface-switcher]:not([data-smoof-single-surface-presentation])'),
      views: () => document.querySelector('[data-smoof-qhs-3d-toggle]'),
      view360: view360Anchor,
      help: () => command('help')
    };
    return anchors[name]?.() || null;
  }

  function captureTourUi() {
    return {
      selectedId,
      layersOpen,
      layersPage,
      contextOpen: context?.dataset.open === 'true',
      helpOpen: legacyPanelOpen('help'),
      resetOpen: legacyPanelOpen('reset'),
      focus: document.activeElement instanceof HTMLElement ? document.activeElement : null
    };
  }

  function closeTourPanels() {
    closeLegacyHelp();
    closeLegacyReset();
    if (layersOpen) setLayersOpen(false);
    if (context) context.dataset.open = 'false';
  }

  function prepareTourStep(name) {
    if (!personalizedDesignSelected()) return false;
    closeMoreTools(false);
    dismissTemplateCoachmark(true);
    closeTourPanels();

    if (name === 'text' || name === 'fonts' || name === 'logos') {
      // Open real settings without input/change events, font freezing or uploads.
      const map = descriptors();
      const textId = Object.keys(map).find(id =>
        (map[id].kind === 'text' || map[id].kind === 'custom-text') && visibleItemFor(id)
      ) || 'text-0';
      selectedId = name === 'logos' ? 'logo' : textId;
      source = sourceFor(selectedId);
      renderContext();
      positionContext();
    } else if (name === 'templates' || name === 'add' || name === 'downloads') {
      selectedId = name;
      source = commandbar;
      renderContext();
    } else if (name === 'layers') {
      setLayersOpen(true);
    }

    syncCommandbar();
    return true;
  }

  function restoreTourUi(snapshot) {
    closeTourPanels();
    if (!snapshot || !personalizedDesignSelected()) {
      syncCommandbar();
      return;
    }

    selectedId = String(snapshot.selectedId || '');
    layersPage = snapshot.layersPage === 'detail' ? 'detail' : 'list';
    source = selectedId ? sourceFor(selectedId) : null;

    if (snapshot.layersOpen) {
      layersOpen = true;
      layers.dataset.open = 'true';
      renderLayers();
    } else if (snapshot.contextOpen && selectedId) {
      renderContext();
    }

    if (snapshot.helpOpen) openLegacyHelp();
    else if (snapshot.resetOpen) openLegacyReset();
    syncCommandbar();
  }

  window.SmoofEditorTourBridge = Object.freeze({
    version: '1.0.0',
    enabled: personalizedDesignSelected,
    captureUi: captureTourUi,
    restoreUi: restoreTourUi,
    prepareStep: prepareTourStep,
    resolveAnchor: tourAnchor,
    closePanels: closeTourPanels,
    surfaceCount: () => Number(profile?.surfaceCount || root.dataset.smoofSurfaceCount || 1),
    view360Help,
    has360View: () => Boolean(view360Anchor()),
    hasThreeQuarter: () => Boolean(profile?.scene?.presentation?.views?.includes?.('threeQuarter') || tourAnchor('views'))
  });
  window.dispatchEvent(new CustomEvent('smoof:editor-tour-bridge-ready'));

  /*
   * Versionierte Zustandsgrenze fuer Produkte mit mehreren Druckflaechen.
   * Die einzelnen Editormodule bleiben Singletons; ein Surface-Controller
   * speichert und aktiviert genau einen vollstaendigen Snapshot zur Zeit.
   */
  window.SmoofEditorState = Object.freeze({
    version: '1.0.0',
    capture: captureHistorySnapshot,
    apply: applyHistorySnapshot,
    resetHistory() {
      multiClear(false);
      clearHistory();
      historyBaselineTimer = setTimeout(() => {
        historyBaselineTimer = 0;
        commitHistorySnapshot();
      }, 320);
    },
    deselect() {
      window.dispatchEvent(new CustomEvent('smoof:editor-select', { detail: { id: '' } }));
    }
  });

  // Transient selection; canonical values remain owned by the individual editors.
  const multiIds = new Set();
  let multiGroups=[];
  let multiMode=false, multiBusy=false, multiInternal=false, multiGesture=null, multiPaint=0, multiOverlay=null, multiFont=false;
  let multiMessage='', multiSwallowUntil=0, multiKeyboard=false, multiScaleBase=null;
  const multiKeys=new Set();
  const mt=(de,en,it)=>window.SmoofI18n.label({de,en,it});
  const multiText=id=>/^(text-[0-2]|custom-text-[1-3]|table-number)$/.test(id);
  const multiGroupId=id=>/^(text-[0-2]|custom-text-[1-3]|custom-pictogram-[1-3]|table-number|branding-dot|arrow-(left|right)|qr|nfc|logo|logo-copy|logo-2|payments|social-platform-[a-z0-9_-]+)$/.test(id);
  function multiRestoreGroups(value){
    const seen=new Set();multiGroups=[];
    if(!Array.isArray(value))return;
    for(const group of value.slice(0,64)){if(!Array.isArray(group))continue;const ids=[...new Set(group.filter(id=>typeof id==='string'&&multiGroupId(id)&&!seen.has(id)))].slice(0,64);if(ids.length>1){multiGroups.push(ids);ids.forEach(id=>seen.add(id));}}
  }
  function multiGroupSnapshot(){
    multiGroups=multiGroups.map(group=>group.filter(id=>!/^custom-(text|pictogram)-/.test(id)||multiState(id)?.enabled)).filter(group=>group.length>1);
    return multiGroups.map(group=>[...group]);
  }
  function multiGroupMembers(id){return (multiGroupSnapshot().find(group=>group.includes(id))||[id]).filter(multiEligible);}
  function multiGroupAction(ungroup=false){
    if(multiIds.size<2||!multiStart())return;
    const selected=new Set(multiIds),groups=multiGroupSnapshot();
    const joined=groups.filter(group=>group.some(id=>selected.has(id)));
    multiGroups=groups.filter(group=>!group.some(id=>selected.has(id)));
    if(!ungroup){joined.flat().forEach(id=>selected.add(id));multiGroups.push([...selected]);}
    multiMessage='';multiFinish();
  }
  function multiState(id){
    if(/^text-/.test(id))return window.SmoofTextTools?.getHistoryState?.()[Number(id.split('-')[1])];
    const [owner,arg]=movementFor(id);
    let state=/^social-platform-/.test(id)?owner?.getObject?.(id):owner?.getState?.(arg);
    if(id==='nfc'&&state)state={...state,x:state.x/1000,y:state.y/1000};
    return state;
  }
  function multiEligible(id){const [owner]=movementFor(id);return Boolean(owner?.previewNudge&&owner?.nudge&&isVisible(id)&&visibleItemFor(id)&&multiState(id)&&multiRead(id,0,0));}
  function multiCandidates(){return [...new Set([...document.querySelectorAll('[data-smoof-editor-item]')].map(n=>n.dataset.smoofEditorItem))].filter(multiEligible);}
  function multiStage(){return document.querySelector('.po-livePreview-stage .konvajs-content');}
  function multiRead(id,dx,dy){const [o,a]=movementFor(id);return a===undefined?o.previewNudge(dx,dy):o.previewNudge(a,dx,dy);}
  function multiNudge(id,dx,dy){const [o,a]=movementFor(id);return a===undefined?o.nudge(dx,dy):o.nudge(a,dx,dy);}
  function multiRect(id){
    const el=visibleItemFor(id);if(!el)return null;
    // Optical outlines are transformed together with their owning frame.
    const curve=[...el.querySelectorAll('[data-smoof-curve-target]')].map(n=>n.getBoundingClientRect()).filter(r=>r.width&&r.height);
    const optical=el.querySelector('[data-smoof-text-visual-outline]:not([hidden])');
    const pill=el.querySelector('[data-smoof-text-pill],[data-smoof-number-pill]');
    const geometry=optical?.getBoundingClientRect().width?optical:pill?.getBoundingClientRect().width?pill:el;
    const r=curve.length?multiUnion(curve):geometry.getBoundingClientRect();
    return {left:r.left,top:r.top,right:r.right,bottom:r.bottom,width:r.right-r.left,height:r.bottom-r.top};
  }
  function multiPlane(){
    const stage=multiStage(),text=visibleItemFor("text-0")||visibleItemFor("text-1");
    let plane=text?.parentElement;
    while(plane&&plane.parentElement!==stage&&plane!==stage)plane=plane.parentElement;
    return (plane||stage).getBoundingClientRect();
  }
  const multiUnion=rects=>({left:Math.min(...rects.map(r=>r.left)),top:Math.min(...rects.map(r=>r.top)),right:Math.max(...rects.map(r=>r.right)),bottom:Math.max(...rects.map(r=>r.bottom))});
  // One source of truth for layout, outline rendering and command availability.
  // A partial internal selection stays explicit; normal picking expands whole groups.
  function multiUnits(ids=[...multiIds]){
    ids=ids.filter(multiEligible);
    const selected=new Set(ids),claimed=new Set(),units=[];
    for(const group of multiGroupSnapshot()){
      const members=group.filter(multiEligible);
      if(members.length>1&&members.every(id=>selected.has(id))){
        units.push({ids:members,rect:multiUnion(members.map(multiRect)),group:true});
        members.forEach(id=>claimed.add(id));
      }
    }
    for(const id of ids)if(!claimed.has(id))units.push({ids:[id],rect:multiRect(id),group:false});
    return units;
  }
  function multiRefresh(){
    for(const id of multiIds)if(!multiEligible(id))multiIds.delete(id);
    root.dataset.smoofMultiMode=String(multiMode);
    commandbar?.querySelector('[data-smoof-ui-command-action="multi"]')?.setAttribute('aria-pressed',String(multiMode));
    if(layersOpen)renderLayers();else renderContext();
    multiSchedulePaint();
  }
  function multiClear(render=true){
    if(multiGesture)multiEnd(null,true);
    if(multiKeyboard)multiFinish();
    multiIds.clear();multiMode=false;multiMessage='';multiFont=false;multiScaleBase=null;
    root.dataset.smoofMultiMode='false';
    if(render)multiRefresh();else multiSchedulePaint();
  }
  function multiChoose(id,toggle=true){
    window.getSelection()?.removeAllRanges();window.SmoofRichText?.clear?.();
    if(!multiEligible(id))return;
    multiScaleBase=null;
    const members=multiGroupMembers(id),remove=toggle&&members.every(member=>multiIds.has(member));
    for(const member of members){if(remove)multiIds.delete(member);else multiIds.add(member);}
    selectedId=[...multiIds].at(-1)||'';multiMessage='';multiRefresh();
  }
  function multiStart(){
    if(multiBusy||historyRestoring)return false;
    finishFontBatchHistory();finishKeyboardMove();clearTimeout(historyTimer);commitHistorySnapshot();multiBusy=true;return true;
  }
  function multiFinish(font=false){
    if(multiKeyboard)setKeyboardPanelMoving(false);
    multiBusy=false;multiKeyboard=false;multiKeys.clear();
    if(font)fontBatchHistory={key:fontBatchSignature(captureHistorySnapshot()),committed:false};
    scheduleHistoryCapture(320);multiRefresh();
  }
  function multiValid(moves){
    const qrMove=moves.find(m=>m.id==='qr');
    if(qrMove){const p=multiRead('qr',qrMove.dx,qrMove.dy),s=multiState('qr');if(!p||Math.abs(p.x-s.x-qrMove.dx)>1e-7||Math.abs(p.y-s.y-qrMove.dy)>1e-7)return false;}
    const qr=qrMove?{x:multiState('qr').x+qrMove.dx,y:multiState('qr').y+qrMove.dy}:null;
    return window.SmoofQrGeometryTools.withPosition(qr,()=>{
      const check=qrMove?[...moves,...multiCandidates().filter(id=>id!=='qr'&&!moves.some(m=>m.id===id)).map(id=>({id,dx:0,dy:0}))]:moves;
      return check.every(m=>{
        if(m.id==='qr')return true;
        const s=multiState(m.id),p=multiRead(m.id,m.dx,m.dy);
        return p&&p.valid!==false&&Math.abs(p.x-s.x-m.dx)<1e-7&&Math.abs(p.y-s.y-m.dy)<1e-7&&
          (p.scale==null||s.scale==null||Math.abs(p.scale-s.scale)<1e-8);
      });
    });
  }
  // Check the swept path in small canonical steps, stopping at the first obstacle.
  function multiApply(moves,partial=false){
    const distance=Math.max(...moves.map(m=>Math.hypot(m.dx,m.dy)),0);
    const steps=Math.max(1,Math.ceil(distance/.001));let fraction=0;
    for(let i=1;i<=steps;i++){
      const f=i/steps;if(!multiValid(moves.map(m=>({...m,dx:m.dx*f,dy:m.dy*f}))))break;fraction=f;
    }
    if(fraction<1&&!partial)return false;
    if(!fraction)return false;
    multiInternal=true;
    try{for(const m of [...moves].sort((a,b)=>Number(b.id==='qr')-Number(a.id==='qr')))multiNudge(m.id,m.dx*fraction,m.dy*fraction);}
    finally{multiInternal=false;}
    multiSchedulePaint();return true;
  }
  function multiAlign(direction){
    const units=multiUnits();if(units.length<2||!multiStart())return;
    const u=multiUnion(units.map(unit=>unit.rect)),stage=multiPlane();
    const horizontal=['left','center','right','justify'].includes(direction);
    const point=r=>direction==='center'?(r.left+r.right)/2:direction==='middle'?(r.top+r.bottom)/2:r[direction];
    const target=point(u);
    const moves=units.flatMap(unit=>unit.ids.map(id=>({id,dx:horizontal?(target-point(unit.rect))/stage.width:0,dy:horizontal?0:(target-point(unit.rect))/stage.height})));
    multiMessage=multiApply(moves)?'':mt('Diese Ausrichtung passt nicht in die freie Druckfläche.','This alignment does not fit in the available print area.','Questo allineamento non rientra nell’area di stampa libera.');multiFinish();
  }
  function multiDistribute(axis){
    const units=multiUnits();if(units.length<3||!multiStart())return;
    const horizontal=axis==='horizontal',start=horizontal?'left':'top',end=horizontal?'right':'bottom';
    const items=units.sort((a,b)=>a.rect[start]-b.rect[start]);
    const first=items[0].rect,last=items.at(-1).rect,span=last[end]-first[start];
    const gap=(span-items.reduce((sum,item)=>sum+item.rect[end]-item.rect[start],0))/(items.length-1);
    const plane=multiPlane();let cursor=first[start];
    const moves=items.flatMap((item,index)=>{const delta=index===0||index===items.length-1?0:cursor-item.rect[start];cursor+=item.rect[end]-item.rect[start]+gap;return item.ids.map(id=>({id,dx:horizontal?delta/plane.width:0,dy:horizontal?0:delta/plane.height}));});
    multiMessage=gap<0||!multiApply(moves)?mt('Die Auswahl lässt sich hier nicht mit gleichen Abständen verteilen.','The selection cannot be evenly spaced here.','La selezione non può essere distribuita uniformemente qui.'):'';
    multiFinish();
  }
  function multiColour(id){
    if(/^text-/.test(id)){const s=window.SmoofTextTools.richState(Number(id.split('-')[1]));return [...new Set([s.base.color,...s.runs.map(r=>r.color).filter(Boolean)])];}
    if(/^custom-text-/.test(id)){const s=multiState(id);return [...new Set([s.color,...(s.runs||[]).map(r=>r.color).filter(Boolean)])];}
    return [sourceFor(id)?.querySelector('input[type=color]')?.value||'#000000'];
  }
  function multiSetColour(value){
    if(laserMonochromeActive()||!/^#[0-9a-f]{6}$/i.test(value)||![...multiIds].every(multiText)||!multiStart())return;
    window.getSelection()?.removeAllRanges();window.SmoofRichText?.clear?.();multiInternal=true;
    try{for(const id of multiIds){
      if(/^text-/.test(id))window.SmoofTextTools.setColor(Number(id.split('-')[1]),value,true);
      else if(/^custom-text-/.test(id))window.SmoofCustomTextTools.setColor(id,value,true);
      else {const input=sourceFor(id)?.querySelector('input[type=color]');if(input)setNativeValue(input,value,true);}
    }}finally{multiInternal=false;}
    multiFinish();
  }
  function multiScalePercent(){
    const ids=[...multiIds].sort(),key=ids.join('|'),values=ids.map(id=>Number(multiState(id)?.scale));
    if(!multiScaleBase||multiScaleBase.key!==key){multiScaleBase={key,values};return 100;}
    const ratios=values.map((value,i)=>value/multiScaleBase.values[i]);
    if(!ratios.length||ratios.some(value=>!Number.isFinite(value)||Math.abs(value-ratios[0])>1e-5)){multiScaleBase={key,values};return 100;}
    return Math.round(ratios[0]*10000)/100;
  }
  async function multiScale(percent){
    const factor=percent/multiScalePercent();
    if(!Number.isFinite(factor)||factor<=0||factor>10||![...multiIds].every(multiText)||!multiStart())return;
    const ids=[...multiIds],before=captureHistorySnapshot(),states=ids.map(multiState);
    multiInternal=true;let okay=true;
    try{ids.forEach((id,i)=>{const value=states[i].scale*factor;
      if(/^text-/.test(id))okay=window.SmoofTextTools.setGroupScale(Number(id.split('-')[1]),value)!==false&&okay;
      else if(/^custom-text-/.test(id))okay=window.SmoofCustomTextTools.setScale(id,value)!==false&&okay;
      else okay=window.SmoofNumberHistory.setGroupScale(value)!==false&&okay;
    });}finally{multiInternal=false;}
    await new Promise(resolve=>setTimeout(resolve,360));
    if(!ids.every(id=>multiIds.has(id))){multiFinish();return;}
    okay=okay&&ids.every((id,i)=>{const s=multiState(id),old=states[i];return Math.abs(s.scale-old.scale*factor)<1e-6&&Math.abs(s.x-old.x)<1e-6&&Math.abs(s.y-old.y)<1e-6&&Math.abs((s.fitScale??1)-(old.fitScale??1))<1e-6;});
    if(!okay){applyHistorySnapshot(before);await new Promise(resolve=>setTimeout(resolve,260));multiMessage=mt('Die Auswahl kann an dieser Position nicht gemeinsam skaliert werden.','The selection cannot be scaled together at this position.','La selezione non può essere ridimensionata insieme in questa posizione.');}
    else multiMessage='';
    document.querySelectorAll('[data-smoof-multi-scale]').forEach(input=>input.value=String(multiScalePercent()));
    multiFinish(true);
  }
  function multiApplyFont(family){
    const ids=[...multiIds];if(ids.length<2||!ids.every(multiText)||!multiStart())return false;
    window.getSelection()?.removeAllRanges();window.SmoofRichText?.clear?.();multiInternal=true;
    try{for(const id of ids){if(/^text-/.test(id))window.SmoofTextTools.setFont(Number(id.split('-')[1]),family);else if(/^custom-text-/.test(id))window.SmoofCustomTextTools.setFont(id,family);else window.SmoofNumberHistory.setFont(family);}}
    finally{multiInternal=false;}
    multiFinish(true);return true;
  }
  function multiOpacityOwner(id){
    if(/^custom-text-/.test(id))return window.SmoofCustomTextTools;
    if(/^custom-pictogram-/.test(id))return window.SmoofCustomPictogramTools;
    if(/^social-platform-/.test(id))return window.SmoofSocialPlatformTools;
    return window.SmoofLayerOpacityTools?.supports?.(id)?window.SmoofLayerOpacityTools:null;
  }
  function multiValue(id,kind){
    if(kind==='spacing')return Number(multiState(id)?.letterSpacing||0);
    const owner=multiOpacityOwner(id);if(!owner)return null;
    return owner===window.SmoofLayerOpacityTools?owner.get(id):Number(multiState(id)?.opacity??1);
  }
  function multiPropertyRow(kind,label){
    const values=[...multiIds].map(id=>Math.round(multiValue(id,kind)*100)),same=values.every(v=>v===values[0]);
    const min=kind==='spacing'?-10:5,max=kind==='spacing'?50:100,step=kind==='spacing'?1:5;
    return row(label,`<div data-smoof-ui-stepper><button type="button" data-smoof-multi-action="${kind}:-${step}" aria-label="${label}: ${mt('verringern','decrease','riduci')}"${multiBusy?' disabled':''}>−</button><span data-smoof-multi-scale-value><input type="number" data-smoof-multi-value="${kind}" min="${min}" max="${max}" step="${step}" value="${same?values[0]:''}" placeholder="${mt('Gemischt','Mixed','Misto')}" aria-label="${label} (%)" aria-invalid="false"><small>%</small></span><button type="button" data-smoof-multi-action="${kind}:${step}" aria-label="${label}: ${mt('erhöhen','increase','aumenta')}"${multiBusy?' disabled':''}>+</button></div>`);
  }
  function multiSetProperty(kind,value,relative=false){
    const ids=[...multiIds],spacing=kind==='spacing',min=spacing?-.1:.05,max=spacing?.5:1;
    if(ids.length<2||!Number.isFinite(value)||(!relative&&(value<min||value>max))||!ids.every(id=>spacing?multiText(id):multiOpacityOwner(id))||!multiStart())return false;
    if(spacing){window.getSelection()?.removeAllRanges();window.SmoofRichText?.clear?.();}
    multiInternal=true;
    try{for(const id of ids){const next=Math.round(Math.max(min,Math.min(max,relative?multiValue(id,kind)+value:value))*100)/100;
      if(spacing){if(/^text-/.test(id))window.SmoofTextTools.setLetterSpacing(Number(id.split('-')[1]),next);else if(/^custom-text-/.test(id))window.SmoofCustomTextTools.setLetterSpacing(id,next);else window.SmoofNumberHistory.setLetterSpacing(next);}
      else {const owner=multiOpacityOwner(id);if(owner===window.SmoofLayerOpacityTools)owner.set(id,next);else owner.setOpacity(id,next);}
    }}finally{multiInternal=false;}
    multiFinish(spacing);return true;
  }
  function multiAlignIcon(direction){
    const bars={
      left:'<path d="M4 3v18"/><rect x="7" y="5" width="10" height="5"/><rect x="7" y="14" width="14" height="5"/>',
      center:'<path d="M12 3v18"/><rect x="7" y="5" width="10" height="5"/><rect x="4" y="14" width="16" height="5"/>',
      right:'<path d="M20 3v18"/><rect x="7" y="5" width="10" height="5"/><rect x="3" y="14" width="14" height="5"/>',
      top:'<path d="M3 4h18"/><rect x="5" y="7" width="5" height="14"/><rect x="14" y="7" width="5" height="10"/>',
      middle:'<path d="M3 12h18"/><rect x="5" y="4" width="5" height="16"/><rect x="14" y="7" width="5" height="10"/>',
      bottom:'<path d="M3 20h18"/><rect x="5" y="3" width="5" height="14"/><rect x="14" y="7" width="5" height="10"/>'
    };
    return `<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" focusable="false" fill="currentColor" stroke="currentColor" stroke-width="1.5" stroke-linecap="square">${bars[direction]}</svg>`;
  }
  function multiBody(){
    const ids=[...multiIds],unitCount=multiUnits().length,mixed=mt('Gemischt','Mixed','Misto'),allText=ids.length>1&&ids.every(multiText);
    const directions=[['left','Links','Left','Sinistra'],['center','Horizontal mittig','Horizontal centre','Centro orizzontale'],['right','Rechts','Right','Destra'],['top','Oben','Top','In alto'],['middle','Vertikal mittig','Vertical centre','Centro verticale'],['bottom','Unten','Bottom','In basso']];
    let html=`<div data-smoof-ui-text-scope><div data-smoof-ui-scope-copy><span data-smoof-ui-scope-label>${mt("Mehrfachauswahl","Multiple selection","Selezione multipla")}</span><span data-smoof-ui-control-note>${mt('Tippen Sie Elemente an oder ziehen Sie einen Auswahlrahmen. Am Computer auch mit Umschalt + Klick.','Tap elements or drag a selection box. On a computer, you can also use Shift + click.','Tocca gli elementi o trascina un riquadro di selezione. Sul computer puoi anche usare Maiusc + clic.')}</span></div></div>`;
    if(ids.length>1)html+=`<div data-smoof-multi-align>${directions.map(([a,de,en,it])=>`<button type="button" data-smoof-ui-icon-button data-smoof-multi-action="align:${a}" aria-label="${mt(de,en,it)}" title="${mt(de,en,it)}"${unitCount<2||multiBusy?' disabled':''}>${multiAlignIcon(a)}</button>`).join('')}</div>`;
    if(ids.length>1)html+=`<div data-smoof-multi-distribute>${[['horizontal',mt('Horizontal gleichmäßig verteilen','Distribute horizontally','Distribuisci orizzontalmente')],['vertical',mt('Vertikal gleichmäßig verteilen','Distribute vertically','Distribuisci verticalmente')]].map(([axis,label])=>`<button type="button" data-smoof-ui-icon-button data-smoof-multi-action="distribute:${axis}" title="${label}" aria-label="${label}"${unitCount<3||multiBusy?' disabled':''}><svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" fill="currentColor"><g${axis==='vertical'?' transform="rotate(90 12 12)"':''}><path d="M2 3h1v18H2zM21 3h1v18h-1z"/><rect x="5" y="7" width="3" height="10"/><rect x="10" y="5" width="4" height="14"/><rect x="16" y="7" width="3" height="10"/></g></svg></button>`).join('')}</div>`;
    if(ids.length>1){
      const grouped=multiGroupSnapshot().some(group=>group.some(id=>multiIds.has(id))),single=multiGroupSnapshot().some(group=>group.length===ids.length&&group.every(id=>multiIds.has(id)));
      const controls=[['group',mt('Gruppieren','Group','Raggruppa'),single,'<rect x="3" y="3" width="18" height="18" rx="2"/><rect x="6" y="6" width="7" height="7"/><rect x="11" y="11" width="7" height="7"/>'],['ungroup',mt('Gruppierung aufheben','Ungroup','Separa'),!grouped,'<rect x="3" y="3" width="8" height="8"/><rect x="13" y="13" width="8" height="8"/><path stroke-dasharray="2 2" d="M15 3h6v6M3 15v6h6"/>']].map(([action,label,disabled,paths])=>`<button type="button" data-smoof-ui-icon-button data-smoof-multi-action="${action}" title="${label}" aria-label="${label}"${disabled||multiBusy?' disabled':''}><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">${paths}</svg></button>`).join('');
      const end=html.lastIndexOf('</div>');html=html.slice(0,end)+controls+html.slice(end);
    }
    if(allText){
      const colours=[...new Set(ids.flatMap(multiColour).map(v=>v.toUpperCase()))],colour=colours.length===1?colours[0]:null;
      const families=[...new Set(ids.flatMap(id=>[rawFontForItem(id),...(multiState(id)?.runs||[]).map(r=>r.fontFamily).filter(Boolean)]))];
      html+=row(mt('Schrift','Font','Carattere'),`<button type="button" data-smoof-ui-wide-button data-smoof-multi-action="font"><span>${escapeHtml(families.length===1?fontForItem(ids[0]):mixed)}</span>${controlIcon('forward')}</button>`);
      html+=hexColorRow(mt('Farbe','Colour','Colore'),'multi',colour||'#000000')
        .replace('data-smoof-ui-color="multi"','data-smoof-ui-color="multi" data-smoof-multi-color')
        .replace('data-smoof-ui-hex-color="multi"','data-smoof-ui-hex-color="multi" data-smoof-multi-hex')
        .replace(/value="#000000" maxlength/,`value="${colour||''}" placeholder="${mixed}" maxlength`);
      html+=row(mt('Größe','Size','Dimensione'),`<div data-smoof-ui-stepper data-smoof-multi-scale-row><button type="button" data-smoof-multi-action="scale:0.9" aria-label="${mt('10 % kleiner','10% smaller','Riduci del 10%')}"${multiBusy?' disabled':''}>−</button><span data-smoof-multi-scale-value><input type="number" min="1" max="1000" step="1" value="${multiScalePercent()}" data-smoof-multi-scale aria-label="${mt('Relativer Größenfaktor in Prozent','Relative scale in percent','Scala relativa in percentuale')}"><small>%</small></span><button type="button" data-smoof-multi-action="scale:1.1" aria-label="${mt('10 % größer','10% larger','Ingrandisci del 10%')}"${multiBusy?' disabled':''}>+</button></div><small data-smoof-ui-control-note>${mt('100 % entspricht den Größen beim Auswählen. Die Größenverhältnisse bleiben erhalten.','100% means the sizes when selected. Size ratios are preserved.','100% corrisponde alle dimensioni alla selezione. Le proporzioni vengono mantenute.')}</small>`);
    }
    if(allText)html+=multiPropertyRow('spacing',mt('Laufweite','Letter spacing','Spaziatura'));
    if(ids.length>1&&ids.every(multiOpacityOwner))html+=multiPropertyRow('opacity',mt('Deckkraft','Opacity','Opacità'));
    return html+`<p role="status" data-smoof-multi-status>${escapeHtml(multiMessage)}</p><button type="button" data-smoof-ui-wide-button data-smoof-multi-action="clear">${mt('Auswahl aufheben','Clear selection','Deseleziona tutto')}</button>`;
  }
  function multiPanel(panel){
    if(!panel||panelSubview)return false;
    if(!multiMode&&multiIds.size<2)return false;
    if(panel.contains(document.activeElement)&&document.activeElement.matches('[data-smoof-multi-hex],[data-smoof-multi-scale],[data-smoof-multi-value]'))return true;
    if(panel===context&&layersOpen)return false;
    const isGroup=multiGroupSnapshot().some(group=>group.length===multiIds.size&&group.every(id=>multiIds.has(id)));
    panel.innerHTML=`<header data-smoof-ui-panel-head>${panel===layers ? `<button type="button" data-smoof-ui-panel-back aria-label="${t('Zurück','Back')}">${icon('back')}</button>` : `<span data-smoof-ui-panel-symbol>${icon('layers')}</span>`}<span><strong data-smoof-ui-panel-title>${multiIds.size} ${mt('Elemente ausgewählt','elements selected','elementi selezionati')}</strong><small data-smoof-ui-panel-copy>${isGroup?mt('Gruppe','Group','Gruppo'):mt('Mehrfachauswahl','Multiple selection','Selezione multipla')}</small></span><button type="button" data-smoof-multi-action="clear" aria-label="${mt('Auswahl aufheben','Clear selection','Deseleziona tutto')}">${icon('close')}</button></header><div data-smoof-ui-panel-body>${multiBody()}</div>`;
    panel.dataset.open='true';panel.dataset.smoofUiItemId=selectedId;
    installPanelScrollAffordance(panel);requestAnimationFrame(()=>panel===context?positionContext():positionLayers());return true;
  }
  function multiSchedulePaint(){if(!multiPaint)multiPaint=requestAnimationFrame(multiDraw);}
  function multiDraw(){
    multiPaint=0;
    if(!multiOverlay){multiOverlay=document.createElement('div');multiOverlay.dataset.smoofMultiOverlay='';document.body.append(multiOverlay);}
    const ids=[...multiIds].filter(multiEligible),rects=ids.map(multiRect);
    const managed=ids.length>1||multiMode;
    document.querySelectorAll('[data-smoof-multi-managed]').forEach(node=>node.removeAttribute('data-smoof-multi-managed'));
    if(managed)ids.forEach(id=>{visibleItemFor(id)?.setAttribute('data-smoof-multi-managed','true');if(/^arrow-(left|right)$/.test(id))document.querySelector(`[data-smoof-arrow-selection-frame="${id.split('-')[1]}"]`)?.setAttribute('data-smoof-multi-managed','true');});
    let html='';const draw=(r,kind='item')=>`<div data-smoof-multi-outline="${kind}" style="left:${r.left}px;top:${r.top}px;width:${r.right-r.left}px;height:${r.bottom-r.top}px"></div>`;
    if(managed){
      const units=multiUnits(ids);
      for(const unit of units)html+=draw(unit.rect,unit.group?'group':'item');
      if(units.length>1)html+=draw(multiUnion(rects),'selection');
    }
    if(multiGesture?.box)html+=draw(multiGesture.box,'marquee');
    const modeButton=commandbar?.querySelector('[data-smoof-ui-command-action=multi]');
    if(modeButton)modeButton.title=multiMode?mt('Auswahlmodus aktiv – zum Beenden klicken','Selection mode active – click to exit','Modalità selezione attiva – clicca per uscire'):mt('Mehrfach auswählen','Select multiple','Seleziona più elementi');
    multiOverlay.innerHTML=html;
    if(ids.length>1&&context?.dataset.open==='true'&&!layersOpen)positionContext();
    commandbar?.querySelector('[data-smoof-ui-command-action=multi]')?.setAttribute('aria-pressed',String(multiMode));
  }
  function multiSnap(dx,dy){
    const guides=window.SmoofAlignmentGuides,plane=multiPlane(),rects=[...multiIds].map(multiRect);
    if(!rects.length||!guides)return {dx,dy};
    const box=multiUnion(rects),u={x:(box.left+box.right)/2,y:(box.top+box.bottom)/2};
    const targetX=multiIds.has('qr')?[.5]:guides.targetsX,targetY=multiIds.has('qr')?[.5]:guides.targetsY;
    const snap=(value,targets)=>targets.map(t=>({t,d:Math.abs(t-value)})).sort((a,b)=>a.d-b.d)[0];
    const x=(u.x-plane.left)/plane.width+dx,y=(u.y-plane.top)/plane.height+dy;
    const sx=guides.isAxisEnabled('x')?snap(x,targetX):null,sy=guides.isAxisEnabled('y')?snap(y,targetY):null;
    const out={dx,dy};guides.hideAll();
    if(sx?.d<guides.threshold){out.dx+=sx.t-x;guides.showX(sx.t);}
    if(sy?.d<guides.threshold){out.dy+=sy.t-y;guides.showY(sy.t);}
    return multiValid([...multiIds].map(id=>({id,...out})))?out:{dx,dy};
  }
  function multiEnd(event,cancel=false){
    const gesture=multiGesture;if(!gesture||event&&event.pointerId!==gesture.pointerId)return;
    multiGesture=null;window.SmoofAlignmentGuides?.hideAll?.();delete root.dataset.smoofUiDragging;
    if(gesture.started){if(cancel){applyHistorySnapshot(gesture.before);multiBusy=false;}else multiFinish();}
    else if(!cancel&&gesture.id){
      if(multiMode||gesture.shift)multiChoose(gesture.id,true);
      else {multiIds.clear();multiGroupMembers(gesture.id).forEach(id=>multiIds.add(id));selectedId=gesture.id;multiRefresh();}
    }else if(!cancel&&gesture.box){
      for(const unit of multiUnits(multiCandidates())){const r=unit.rect,b=gesture.box;if(r.left>=b.left&&r.right<=b.right&&r.top>=b.top&&r.bottom<=b.bottom)unit.ids.forEach(id=>multiIds.add(id));}
      selectedId=[...multiIds].at(-1)||'';multiRefresh();
    }else if(!cancel&&!gesture.id){multiIds.clear();selectedId='';multiRefresh();}
    multiSwallowUntil=Date.now()+500;multiSchedulePaint();
    if(event){event.preventDefault();event.stopImmediatePropagation();}
  }
  window.addEventListener('pointerdown',event=>{
    const target=event.target instanceof Element?event.target:null;
    if(multiKeyboard)multiFinish();
    if(multiBusy&&!multiGesture&&target?.closest('.po-livePreview-root,[data-smoof-ui-commandbar],[data-smoof-ui-context],[data-smoof-ui-layers],[data-smoof-surface-toolbar]')){event.preventDefault();event.stopImmediatePropagation();return;}
    if(!target||event.isPrimary===false||event.button!==0||!personalizedDesignSelected()||historyRestoring||multiBusy||fontPickerTarget||root.hasAttribute('data-smoof-surface-session')||root.dataset.smoofEditorTourOpen==='true')return;
    if(target.closest('[data-smoof-ui-context],[data-smoof-ui-layers],[data-smoof-ui-commandbar],input,textarea,select,[contenteditable=true]'))return;
    if(!multiStage()?.contains(target))return;
    const id=target.closest('[data-smoof-editor-item]')?.dataset.smoofEditorItem;
    if(id&&multiEligible(id)&&!event.shiftKey&&!multiMode){const members=multiGroupMembers(id);if(members.length>1&&!members.every(member=>multiIds.has(member))){multiIds.clear();members.forEach(member=>multiIds.add(member));selectedId=id;multiRefresh();}}
    if(id&&multiEligible(id)&&(multiMode||event.shiftKey||multiIds.size>1&&multiIds.has(id))){
      if(!multiIds.size&&multiEligible(selectedId))multiGroupMembers(selectedId).forEach(member=>multiIds.add(member));
      multiGesture={id,shift:event.shiftKey,pointerId:event.pointerId,x:event.clientX,y:event.clientY,lastX:event.clientX,lastY:event.clientY,started:false};
      event.preventDefault();event.stopImmediatePropagation();
    }else if(multiMode&&!multiEligible(id)){
      if(!event.shiftKey)multiIds.clear();multiGesture={pointerId:event.pointerId,x:event.clientX,y:event.clientY,box:{left:event.clientX,right:event.clientX,top:event.clientY,bottom:event.clientY}};event.preventDefault();event.stopImmediatePropagation();
    }else if(multiIds.size>1){multiClear(false);}
  },true);
  window.addEventListener('pointermove',event=>{
    const g=multiGesture;if(!g||g.pointerId!==event.pointerId)return;
    if(g.box){g.box={left:Math.min(g.x,event.clientX),right:Math.max(g.x,event.clientX),top:Math.min(g.y,event.clientY),bottom:Math.max(g.y,event.clientY)};multiSchedulePaint();}
    else if(Math.hypot(event.clientX-g.x,event.clientY-g.y)>5||g.started){
      if(!g.started){if(!multiIds.has(g.id))multiGroupMembers(g.id).forEach(id=>multiIds.add(id));if(!multiStart())return;g.started=true;g.before=captureHistorySnapshot();g.anchor=multiState(g.id);root.dataset.smoofUiDragging='true';}
      const r=multiPlane(),current=multiState(g.id),dx=(event.clientX-g.x)/r.width-(current.x-g.anchor.x),dy=(event.clientY-g.y)/r.height-(current.y-g.anchor.y);
      const snapped=multiSnap(dx,dy);multiApply([...multiIds].map(id=>({id,...snapped})),true);g.lastX=event.clientX;g.lastY=event.clientY;
    }
    event.preventDefault();event.stopImmediatePropagation();
  },true);
  window.addEventListener('pointerup',e=>multiEnd(e),true);
  window.addEventListener('pointercancel',e=>multiEnd(e,true),true);
  window.addEventListener('blur',()=>{multiEnd(null,true);if(multiKeyboard)multiFinish();});
  window.addEventListener('click',event=>{
    if(Date.now()<multiSwallowUntil&&multiStage()?.contains(event.target)){event.preventDefault();event.stopImmediatePropagation();return;}
    const button=event.target.closest?.('[data-smoof-multi-action]');if(!button)return;
    event.preventDefault();event.stopImmediatePropagation();if(button.disabled)return;
    const action=button.dataset.smoofMultiAction;
    if(action==='toggle'){multiMode=!multiMode;if(multiMode&&multiEligible(selectedId))multiIds.add(selectedId);multiRefresh();layers.querySelector('[data-smoof-multi-action=toggle]')?.focus({preventScroll:true});}
    else if(action==='edit-layers'){layersPage='detail';renderLayers();layers.querySelector('[data-smoof-ui-panel-back]')?.focus({preventScroll:true});}
    else if(action==='clear'){multiClear();selectedId='';dispatchSelection('');}
    else if(action==='group'||action==='ungroup')multiGroupAction(action==='ungroup');
    else if(action==='font'){multiFont=true;window.getSelection()?.removeAllRanges();window.SmoofRichText?.clear?.();openFontPicker([...multiIds][0]);}
    else if(action.startsWith('distribute:'))multiDistribute(action.split(':')[1]);
    else if(action.startsWith('align:'))multiAlign(action.split(':')[1]);
    else if(/^(spacing|opacity):/.test(action)){const [kind,value]=action.split(':');multiSetProperty(kind,Number(value)/100,true);}
    else if(action.startsWith('scale:'))multiScale(multiScalePercent()+(Number(action.split(':')[1])<1?-10:10));
  },true);
  document.addEventListener('change',event=>{
    const el=event.target;
    if(el.matches('[data-smoof-multi-color],[data-smoof-multi-hex]')){const value=el.value.startsWith('#')?el.value:'#'+el.value;el.setAttribute('aria-invalid',String(!/^#[0-9a-f]{6}$/i.test(value)));multiSetColour(value);}
    if(el.matches('[data-smoof-multi-scale]'))multiScale(Number(el.value));
    if(el.matches('[data-smoof-multi-value]')){const valid=el.value!==''&&multiSetProperty(el.dataset.smoofMultiValue,Number(el.value)/100);el.setAttribute('aria-invalid',String(!valid));}
  });
  window.addEventListener('keydown',event=>{
    if(event.target.closest?.('[data-smoof-design-name]'))return;
    const layer=event.target.closest?.('[data-smoof-ui-layer][role=checkbox]');if(layer&&(event.key===' '||event.key==='Enter')){event.preventDefault();event.stopImmediatePropagation();const id=layer.dataset.smoofUiLayer;multiChoose(id);layers.querySelector(`[data-smoof-ui-layer="${id}"]`)?.focus();return;}
    if(event.key==='Escape'&&!panelSubview&&(multiMode||multiIds.size>1)){event.preventDefault();event.stopImmediatePropagation();if(multiGesture)multiEnd(null,true);else {multiClear();selectedId='';dispatchSelection('');}return;}
    const vectors={ArrowLeft:[-1,0],ArrowRight:[1,0],ArrowUp:[0,-1],ArrowDown:[0,1]};
    if(!vectors[event.key]||multiIds.size<2||event.altKey||event.metaKey||event.ctrlKey||event.isComposing||event.defaultPrevented||event.target.closest?.('input,textarea,select,button,[contenteditable=true],[role=dialog]')||fontPickerTarget||historyRestoring||multiGesture||root.hasAttribute('data-smoof-surface-session')||root.hasAttribute('data-smoof-surface-external-apply')||root.dataset.smoofEditorTourOpen==='true'||root.dataset.smoofQhsMode==='three-quarter'||!personalizedDesignSelected())return;
    if([...document.querySelectorAll('[aria-modal=true],dialog[open],[role=dialog][open]')].some(n=>{
      if(!n.getClientRects().length)return false;
      for(let node=n;node instanceof Element;node=node.parentElement){const css=getComputedStyle(node);if(node.hidden||node.getAttribute('aria-hidden')==='true'||css.display==='none'||css.visibility==='hidden'||css.opacity==='0')return false;}
      return true;
    }))return;
    if(multiBusy&&!multiKeyboard)return;
    if(!multiBusy&&!multiStart())return;
    multiKeyboard=true;multiKeys.add(event.key);
    const [x,y]=vectors[event.key],step=event.shiftKey?.01:.001;
    if(multiApply([...multiIds].map(id=>({id,dx:x*step,dy:y*step})),true))setKeyboardPanelMoving(true);
    event.preventDefault();event.stopImmediatePropagation();
  },true);
  window.addEventListener('keyup',event=>{multiKeys.delete(event.key);if(multiKeyboard&&!multiKeys.size)multiFinish();},true);
  // End transient keyboard presentation through the existing history owners.
  document.addEventListener('focusin',()=>{if(multiKeyboard)multiFinish();});
  window.addEventListener('keydown',event=>{if(event.key==='Escape'){finishKeyboardMove();if(multiKeyboard)multiFinish();}},true);
  document.addEventListener('visibilitychange',()=>{if(document.hidden){finishKeyboardMove();if(multiKeyboard)multiFinish();}});
  window.addEventListener('dblclick',event=>{if(multiStage()?.contains(event.target)){multiClear(false);}},true);
  for(const name of ['smoof:editor-reset-content','smoof:editor-reset-all'])window.addEventListener(name,()=>{multiGroups=[];});
  for(const name of ['smoof:surface-change','smoof:design-file-loaded','smoof:editor-reset-content','smoof:editor-reset-layout','smoof:product-variant-change'])window.addEventListener(name,()=>multiClear(false));
  window.addEventListener('resize',multiSchedulePaint);
  document.addEventListener('smoof:curved-ready',multiSchedulePaint);
  new MutationObserver(()=>{if((multiMode||multiIds.size)&&(!personalizedDesignSelected()||root.dataset.smoofQhsMode==='three-quarter'||root.hasAttribute('data-smoof-surface-session')))multiClear(false);}).observe(root,{attributes:true,attributeFilter:['data-smoof-design-mode','data-smoof-qhs-mode','data-smoof-surface-session']});
  window.addEventListener('scroll',multiSchedulePaint,true);
  window.SmoofMultiSelection=Object.freeze({version:'435',get ids(){return [...multiIds];},get active(){return multiMode;},getGroups:multiGroupSnapshot,restoreGroups:multiRestoreGroups,clear:()=>multiClear(),select(ids){multiScaleBase=null;multiIds.clear();ids.filter(multiEligible).flatMap(multiGroupMembers).forEach(id=>multiIds.add(id));selectedId=[...multiIds].at(-1)||'';multiRefresh();},align:multiAlign});

  {const style=document.createElement('style');style.dataset.smoofMultiStyle='418';style.textContent='[data-smoof-multi-mode=true] .konvajs-content,[data-smoof-multi-mode=true] .konvajs-content *{touch-action:none!important}[data-smoof-ui-multi-pick]{display:grid;place-items:center;width:30px;height:30px;border:1px solid #999;border-radius:7px;color:inherit;background:transparent}[data-smoof-ui-multi-pick][aria-checked=true]{background:#e5007d;color:white;border-color:#e5007d}[data-smoof-multi-overlay]{position:fixed;inset:0;pointer-events:none;z-index:2147482450}[data-smoof-multi-outline]{display:block!important;position:absolute;border:1.5px solid #e5007d;border-radius:3px;box-sizing:border-box;pointer-events:none}[data-smoof-multi-outline="selection"]{border-style:solid;border-color:#1686d9}[data-smoof-multi-outline="group"],[data-smoof-multi-outline="marquee"]{border-style:dashed;border-color:#1686d9}html[data-smoof-ui-enabled=true] [data-smoof-multi-managed],html[data-smoof-ui-enabled=true] [data-smoof-multi-managed] [data-smoof-text-visual-outline],html[data-smoof-ui-enabled=true] [data-smoof-multi-managed] [data-smoof-arrow-selection-frame]{border-color:transparent!important;outline:none!important;box-shadow:none!important}html[data-smoof-ui-enabled=true] [data-smoof-multi-managed][data-smoof-number-frame]::after{display:none!important}html[data-smoof-ui-enabled=true] [data-smoof-multi-managed] [data-smoof-curve-selection]{stroke:none!important}html[data-smoof-proof-capture=true] [data-smoof-multi-overlay]{display:none!important}[data-smoof-multi-distribute]{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:4px}[data-smoof-multi-distribute] button{width:100%}[data-smoof-multi-align]{display:grid;grid-template-columns:repeat(6,minmax(0,1fr));gap:4px}[data-smoof-multi-align] button{width:100%;min-width:0;padding:6px}[data-smoof-multi-align] svg,[data-smoof-multi-distribute] svg{width:22px;height:22px;pointer-events:none}[data-smoof-multi-scale-value]{display:flex!important;align-items:center;justify-content:center;min-width:0;padding:0 4px;gap:0}[data-smoof-multi-value],[data-smoof-multi-scale]{appearance:textfield;-moz-appearance:textfield;box-sizing:border-box;width:5.5ch;max-width:calc(100% - 1.4em);min-width:3ch;height:32px;padding:0 2px;border:0;border-radius:7px;background:transparent;color:var(--smoof-ui-text);font:inherit;font-variant-numeric:tabular-nums;text-align:center}[data-smoof-multi-value]::-webkit-inner-spin-button,[data-smoof-multi-value]::-webkit-outer-spin-button,[data-smoof-multi-scale]::-webkit-inner-spin-button,[data-smoof-multi-scale]::-webkit-outer-spin-button{appearance:none;margin:0}[data-smoof-multi-value]:placeholder-shown{width:8ch}[data-smoof-multi-value][aria-invalid=true]{outline:2px solid #d92d20}[data-smoof-multi-value]:focus-visible{outline:2px solid var(--smoof-ui-accent)}[data-smoof-multi-scale-value] small{display:block;padding-left:2px;border:0;pointer-events:none;font-size:11px}@media(max-width:749px){[data-smoof-multi-value],[data-smoof-multi-scale]{height:38px}}[data-smoof-multi-scale]:focus-visible{outline:2px solid var(--smoof-ui-accent);outline-offset:2px}[data-smoof-multi-status]:empty{display:none}[data-smoof-ui-command-action=multi][aria-pressed=true]{background:rgb(31,31,33)!important;color:#fff!important;box-shadow:0 3px 9px rgba(0,0,0,.14)}@media(prefers-color-scheme:dark){[data-smoof-ui-command-action=multi][aria-pressed=true]{background:rgba(255,255,255,.14)!important;color:#fff!important}}[data-smoof-ui-command-action=multi]:focus-visible{outline:2px solid var(--smoof-ui-accent)!important;outline-offset:2px}[data-smoof-multi-action]:focus-visible,[data-smoof-multi-align] button:focus-visible{outline:2px solid #e5007d;outline-offset:2px}';document.head.append(style);}
  ensureShell();
  installEditorScrollStandard();
  installCategoryDropdowns();
  syncPersonalizationGate();
  if (personalizedDesignSelected() && !historyCurrent) {
    historyBaselineTimer = setTimeout(() => {
      historyBaselineTimer = 0;
      commitHistorySnapshot();
    }, 420);
  }
  function returnToProductionDownload() {
    prepareTourStep('downloads');
    requestAnimationFrame(() => {
      const target = context?.querySelector('[data-smoof-ui-action="download-production"]:not([hidden]):not(:disabled), [data-smoof-production-login-refresh]:not([hidden]), [data-smoof-production-login-note]:not([hidden]) a:not([hidden])');
      target?.focus({ preventScroll: true });
      const status = context?.querySelector('[data-smoof-production-status]:not([hidden])');
      (status || target)?.scrollIntoView({ block: 'nearest' });
    });
  }
  window.addEventListener('smoof:login-draft-restored', returnToProductionDownload);
  if (window.SmoofLoginDraft?.restored?.()) returnToProductionDownload();
  window.addEventListener('smoof:brand-policy-change', () => { if (selectedId) renderContext(); });
})();
